import { __awaiter, __decorate, __param, __metadata } from 'tslib';
import { ɵɵinject, ɵɵdefineInjectable, ɵsetClassMetadata, Injectable, Optional, ɵɵdefineComponent, ɵɵprojectionDef, ɵɵprojection, Component, ɵɵelementStart, ɵɵelement, ɵɵelementEnd, ɵɵnextContext, ɵɵclassMapInterpolate1, ɵɵdirectiveInject, ChangeDetectorRef, ɵɵtemplate, ɵɵadvance, ɵɵproperty, Input, ɵɵpureFunction1, forwardRef, ɵɵProvidersFeature, ɵɵNgOnChangesFeature, ɵɵlistener, ɵɵpipe, ɵɵpipeBind1, ɵɵsanitizeHtml, ɵɵgetCurrentView, ɵɵrestoreView, ɵɵtext, ɵɵtextInterpolate1, ɵɵclassProp, ɵɵelementContainer, ɵɵreference, ɵɵelementContainerStart, ɵɵelementContainerEnd, ɵɵclassMap, ɵɵpureFunction2, ɵɵattribute, ɵɵclassMapInterpolate2, ɵɵpureFunction3, ɵɵpipeBind2, ɵɵsanitizeUrl, EventEmitter, ɵɵtemplateRefExtractor, Output, ɵɵdefinePipe, Pipe, ɵɵpipeBind3, ɵɵdefineDirective, Directive, ɵɵcontentQuery, TemplateRef, ɵɵqueryRefresh, ɵɵloadQuery, ContentChildren, ɵɵdefineNgModule, ɵɵdefineInjector, ɵɵsetNgModuleScope, NgModule, SkipSelf } from '@angular/core';
import { LocalService } from '@akeela/local-storage';
import { first, map, shareReplay, takeUntil, share } from 'rxjs/operators';
import { Router, ActivatedRoute, RouterOutlet, RouterModule } from '@angular/router';
import { Subject, BehaviorSubject, Observable } from 'rxjs';
import { HttpService, PathService, AkeelaPropertiesModule } from '@akeela/properties';
import { isNullOrUndefined } from 'util';
import { HttpClient, HttpHeaders, HttpClientModule } from '@angular/common/http';
import { Validators, FormControl, FormGroup, NG_VALUE_ACCESSOR, NgControlStatus, NgModel, ɵangular_packages_forms_forms_y, NgControlStatusGroup, FormGroupDirective, DefaultValueAccessor, FormControlName, MaxLengthValidator, CheckboxControlValueAccessor, RadioControlValueAccessor, SelectMultipleControlValueAccessor, NgSelectOption, ɵangular_packages_forms_forms_x, SelectControlValueAccessor, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DatePipe, NgIf, NgClass, NgForOf, NgTemplateOutlet, NgStyle, AsyncPipe, DecimalPipe, JsonPipe, CommonModule } from '@angular/common';
import { CreditService, ErrorService } from '@akeela/common';
import { AuthService, AkeelaAuthModule } from '@akeela/auth';
import { I18nPipe, NumberI18nPipe, I18nModule } from '@akeela/i18n';
import { AlertService } from '@akeela/alert';
import { NativeElementInjectorDirective, SearchCountryField, CountryISO, PhoneNumberFormat, NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { CurrencyMaskDirective, CurrencyMaskModule } from 'ng2-currency-mask';
import { MaskedInputDirective, TextMaskModule } from 'angular2-text-mask';
import { MultiSelectComponent as MultiSelectComponent$1, NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { MyDatePickerModule } from 'mydatepicker';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

class RouteUtilsService {
    constructor(localStorage, router, route) {
        this.localStorage = localStorage;
        this.router = router;
        this.route = route;
    }
    getWorkflowCode(params) {
        return params.workflowCode;
    }
    getStageCode(params) {
        return params.stageCode;
    }
    getStepCode(params) {
        return params.stepCode;
    }
    getRole(params) {
        return params.role || this.localStorage.getItem('role');
    }
    getParamAsync(route, key) {
        return __awaiter(this, void 0, void 0, function* () {
            return ((yield this.route.queryParamMap.pipe(first()).toPromise()).get(key)) || this.localStorage.getItem(key);
        });
    }
    getAudience(params) {
        let la = this.localStorage.getItem('clientaudience') == 'null' ? null : this.localStorage.getItem('clientaudience');
        let lp = params && params.audience;
        let la2 = this.localStorage.getItem('audience') == 'null' ? null : this.localStorage.getItem('audience');
        let resp = la || lp || la2;
        return resp;
    }
    getProfile(params) {
        return params.profile || (this.localStorage.getItem('profile') ? this.localStorage.getItem('profile') : 'guest');
    }
    getInputPoint(params) {
        return params.input_point;
    }
    getTransactionNumber(params) {
        return params.transactionNumber || this.localStorage.getItem('transactionNumber');
    }
}
/** @nocollapse */ RouteUtilsService.ɵfac = function RouteUtilsService_Factory(t) { return new (t || RouteUtilsService)(ɵɵinject(LocalService), ɵɵinject(Router), ɵɵinject(ActivatedRoute)); };
/** @nocollapse */ RouteUtilsService.ɵprov = ɵɵdefineInjectable({ token: RouteUtilsService, factory: RouteUtilsService.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(RouteUtilsService, [{
        type: Injectable
    }], function () { return [{ type: LocalService }, { type: Router }, { type: ActivatedRoute }]; }, null); })();

class JsonService {
    constructor() { }
    isObject(item) {
        return (item && typeof item === 'object' && !Array.isArray(item));
    }
    mergeDeep(target, source) {
        let output = Object.assign({}, target);
        if (this.isObject(target) && this.isObject(source)) {
            Object.keys(source).forEach(key => {
                if (this.isObject(source[key])) {
                    if (!(key in target))
                        Object.assign(output, { [key]: source[key] });
                    else
                        output[key] = this.mergeDeep(target[key], source[key]);
                }
                else {
                    Object.assign(output, { [key]: source[key] });
                }
            });
        }
        return output;
    }
}
/** @nocollapse */ JsonService.ɵfac = function JsonService_Factory(t) { return new (t || JsonService)(); };
/** @nocollapse */ JsonService.ɵprov = ɵɵdefineInjectable({ token: JsonService, factory: JsonService.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(JsonService, [{
        type: Injectable
    }], function () { return []; }, null); })();

class AkeelaWorkflowConfig {
}

class AkeelaConfigConst {
}
AkeelaConfigConst.urlApi = 'http://54.225.6.218:8080';
AkeelaConfigConst.urlFront = 'http://akcredit.akeela.co';
AkeelaConfigConst.uriWorkflowPrefix = 'AkWflowManager';
AkeelaConfigConst.uriWorkflow = 'workflows';
AkeelaConfigConst.uriStep = 'multiproduct/step_multiproduct_configuration';
AkeelaConfigConst.useMock = false;
AkeelaConfigConst.mockTimeDelay = 300;
AkeelaConfigConst.openDelimiter = '{';
AkeelaConfigConst.closeDelimiter = '}';
AkeelaConfigConst.initiallyOpenSections = false;
AkeelaConfigConst.currency = {
    prefix: '',
    thousands: '.',
    decimal: ','
};
AkeelaConfigConst.autoSave = false;
AkeelaConfigConst.autoSaveTime = 15000;
AkeelaConfigConst.mask = null;

class AkeelaWorkflowConfigService {
    constructor(config) {
        this.akeelaWorkflowConfig = new AkeelaWorkflowConfig();
        if (config) {
            this.options = config;
        }
    }
    set options(opt) {
        this.akeelaWorkflowConfig.autoSave = (opt && opt.autoSave) ? opt.autoSave : AkeelaConfigConst.autoSave;
        this.akeelaWorkflowConfig.autoSaveTime = (opt && opt.autoSaveTime) ? opt.autoSaveTime : AkeelaConfigConst.autoSaveTime;
        this.akeelaWorkflowConfig.urlApi = (opt && opt.urlApi) ? opt.urlApi : AkeelaConfigConst.urlApi;
        this.akeelaWorkflowConfig.urlFront = (opt && opt.urlFront) ? opt.urlFront : AkeelaConfigConst.urlFront;
        this.akeelaWorkflowConfig.uriWorkflow = (opt && opt.uriWorkflow) ? opt.uriWorkflow : AkeelaConfigConst.uriWorkflow;
        this.akeelaWorkflowConfig.uriStep = (opt && opt.uriStep) ? opt.uriStep : AkeelaConfigConst.uriStep;
        this.akeelaWorkflowConfig.uriWorkflowPrefix = (opt && opt.uriWorkflowPrefix) ?
            opt.uriWorkflowPrefix : AkeelaConfigConst.uriWorkflowPrefix;
        this.akeelaWorkflowConfig.useMock = (opt && opt.useMock) ? opt.useMock : AkeelaConfigConst.useMock;
        this.akeelaWorkflowConfig.mockTimeDelay = (opt && opt.mockTimeDelay) ? opt.mockTimeDelay : AkeelaConfigConst.mockTimeDelay;
        this.akeelaWorkflowConfig.openDelimiter = (opt && opt.openDelimiter) ? opt.openDelimiter : AkeelaConfigConst.openDelimiter;
        this.akeelaWorkflowConfig.closeDelimiter = (opt && opt.closeDelimiter) ? opt.closeDelimiter : AkeelaConfigConst.closeDelimiter;
        this.akeelaWorkflowConfig.initiallyOpenSections =
            (opt && !isNullOrUndefined(opt.initiallyOpenSections)) ? opt.initiallyOpenSections : AkeelaConfigConst.initiallyOpenSections;
        this.akeelaWorkflowConfig.currency = (opt && opt.currency) ? opt.currency : AkeelaConfigConst.currency;
        this.akeelaWorkflowConfig.mask = (opt && opt.mask) ? opt.mask : AkeelaConfigConst.mask;
    }
    get urlApi() {
        return this.akeelaWorkflowConfig.urlApi + this.akeelaWorkflowConfig.uriWorkflowPrefix;
    }
    get urlFront() {
        return this.akeelaWorkflowConfig.urlFront;
    }
    get uriWorkflow() {
        return this.akeelaWorkflowConfig.uriWorkflow;
    }
    get uriStep() {
        return this.akeelaWorkflowConfig.uriStep;
    }
    get useMock() {
        return this.akeelaWorkflowConfig.useMock;
    }
    get mockTimeDelay() {
        return this.akeelaWorkflowConfig.mockTimeDelay;
    }
    get openDelimiter() {
        return this.akeelaWorkflowConfig.openDelimiter;
    }
    get closeDelimiter() {
        return this.akeelaWorkflowConfig.closeDelimiter;
    }
    get initiallyOpenSections() {
        return this.akeelaWorkflowConfig.initiallyOpenSections;
    }
    get currency() {
        return this.akeelaWorkflowConfig.currency;
    }
    get mask() {
        return this.akeelaWorkflowConfig.mask;
    }
    get autoSave() {
        return this.akeelaWorkflowConfig.autoSave;
    }
    get autoSaveTime() {
        return this.akeelaWorkflowConfig.autoSaveTime;
    }
}
/** @nocollapse */ AkeelaWorkflowConfigService.ɵfac = function AkeelaWorkflowConfigService_Factory(t) { return new (t || AkeelaWorkflowConfigService)(ɵɵinject(AkeelaWorkflowConfig, 8)); };
/** @nocollapse */ AkeelaWorkflowConfigService.ɵprov = ɵɵdefineInjectable({ token: AkeelaWorkflowConfigService, factory: AkeelaWorkflowConfigService.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AkeelaWorkflowConfigService, [{
        type: Injectable
    }], function () { return [{ type: AkeelaWorkflowConfig, decorators: [{
                type: Optional
            }] }]; }, null); })();

class MockService {
    constructor(config) {
        this.config = config;
    }
}
/** @nocollapse */ MockService.ɵfac = function MockService_Factory(t) { return new (t || MockService)(ɵɵinject(AkeelaWorkflowConfigService)); };
/** @nocollapse */ MockService.ɵprov = ɵɵdefineInjectable({ token: MockService, factory: MockService.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(MockService, [{
        type: Injectable
    }], function () { return [{ type: AkeelaWorkflowConfigService }]; }, null); })();

class AkeelaWorkflowStructureService {
    constructor() {
        this.workflows = {};
        this.workflowHasStages$ = {}; // obsevable to workflow has stages loaded.
        this.stageHasSteps$ = {}; // observable to stage has steps loaded.
        this.temporal = {};
        this.updatedSteps = {};
    }
    addStepsToTemporal(workflowName, stageName, steps) {
        this.temporal[workflowName] = {};
        this.temporal[workflowName].stages = {};
        this.temporal[workflowName].stages[stageName] = {};
        this.temporal[workflowName].stages[stageName].steps = steps;
    }
    hasTemporalSteps(workflowName, stageName) {
        return this.temporal[workflowName] && this.temporal[workflowName].stages[stageName];
    }
    getStepsFromTemporal(workflowName, stageName) {
        let steps = [];
        if (this.hasTemporalSteps(workflowName, stageName)) {
            steps = this.temporal[workflowName].stages[stageName].steps;
            delete this.temporal[workflowName].stages[stageName];
            if (this.temporal[workflowName].stages && Object.keys(this.temporal[workflowName].stages).length === 0) {
                delete this.temporal[workflowName];
            }
        }
        return steps;
    }
    createWorkflow(workflowName) {
        if (isNullOrUndefined(this.workflows[workflowName])) {
            this.workflows[workflowName] = {};
            this.createWorkflowHasStagesObservable(workflowName);
        }
        return this.workflows[workflowName];
    }
    createWorkflowHasStagesObservable(workflowName) {
        if (isNullOrUndefined(this.workflowHasStages$[workflowName])) {
            this.workflowHasStages$[workflowName] = new Subject();
        }
        return this.workflowHasStages$[workflowName];
    }
    createStageHasStepsObservable(stageName) {
        if (isNullOrUndefined(this.stageHasSteps$[stageName])) {
            this.stageHasSteps$[stageName] = new BehaviorSubject(false);
        }
        return this.stageHasSteps$[stageName];
    }
    workflowHasStages(workflowName) {
        this.createWorkflowHasStagesObservable(workflowName);
        return this.workflowHasStages$[workflowName];
    }
    stageHasSteps(workflowName, stageName) {
        this.createStageHasStepsObservable(workflowName + stageName);
        return this.stageHasSteps$[workflowName + stageName];
    }
    sendNotificationWorkflowHasStages(workflowName) {
        this.workflowHasStages$[workflowName].next(true);
    }
    sendNotificationStageHasSteps(stageName) {
        if (!isNullOrUndefined(this.stageHasSteps$[stageName])) {
            this.stageHasSteps$[stageName].next(true);
        }
    }
    getWorkflow(workflowName) {
        return this.workflows[workflowName];
    }
    addStages(workflowName, stages) {
        this.createWorkflow(workflowName);
        this.workflows[workflowName].stages = {};
        stages.forEach(stage => {
            if (this.hasTemporalSteps(workflowName, stage.alternateName)) {
                stage.howToSteps = this.getStepsFromTemporal(workflowName, stage.alternateName);
                this.sendNotificationStageHasSteps(workflowName + stage.alternateName);
            }
            this.workflows[workflowName].stages[stage.alternateName] = stage;
            this.createStageHasStepsObservable(workflowName + stage.alternateName);
        });
        this.sendNotificationWorkflowHasStages(workflowName);
    }
    getStages(workflowName) {
        if (isNullOrUndefined(this.workflows[workflowName])) {
            return null;
        }
        const stages = [];
        Object.keys(this.workflows[workflowName].stages)
            .forEach(stage => stages.push(this.workflows[workflowName].stages[stage]));
        return stages.sort((stageA, stageB) => stageA.orderStage - stageB.orderStage);
    }
    getStage(workflowName, stageName) {
        if (isNullOrUndefined(this.workflows[workflowName])) {
            return null;
        }
        return this.workflows[workflowName].stages[stageName];
    }
    addSteps(workflowName, stageName, steps) {
        const stage = this.getStage(workflowName, stageName);
        if (!isNullOrUndefined(stage)) {
            stage.howToSteps = steps;
            this.sendNotificationStageHasSteps(workflowName + stageName);
        }
        else {
            this.addStepsToTemporal(workflowName, stageName, steps);
        }
    }
    getSteps(workflowName, stageName) {
        const stage = this.getStage(workflowName, stageName);
        if (!isNullOrUndefined(stage) && !isNullOrUndefined(stage.howToSteps)) {
            return stage.howToSteps.sort((stepA, stepB) => stepA.orderOfItem - stepB.orderOfItem);
        }
        return null;
    }
    updateStep(workflowName, stageName, step) {
        const stage = this.getStage(workflowName, stageName);
        if (isNullOrUndefined(stage) || isNullOrUndefined(stage.howToSteps)) {
            return;
        }
        const _step = stage.howToSteps.find(__step => __step.alternateName === step.alternateName);
        if (!isNullOrUndefined(_step)) {
            _step.sections = step.sections;
            const stepName = `${workflowName}_${stageName}_${step.alternateName}`;
            this.updatedSteps[stepName] = true;
        }
    }
    getStep(workflowName, stageName, stepName) {
        const steps = this.getSteps(workflowName, stageName);
        if (isNullOrUndefined(steps)) {
            return null;
        }
        const step = steps.find(_step => _step.alternateName === stepName);
        const compositeStepName = `${workflowName}_${stageName}_${step ? step.alternateName : ''}`;
        if (isNullOrUndefined(this.updatedSteps[compositeStepName])) {
            return null;
        }
        return step;
    }
    getFirstStep(workflowName, stageName) {
        const steps = this.getSteps(workflowName, stageName);
        if (isNullOrUndefined(steps)) {
            return null;
        }
        return steps.find(_step => _step.firstStepInStage);
    }
}
/** @nocollapse */ AkeelaWorkflowStructureService.ɵfac = function AkeelaWorkflowStructureService_Factory(t) { return new (t || AkeelaWorkflowStructureService)(); };
/** @nocollapse */ AkeelaWorkflowStructureService.ɵprov = ɵɵdefineInjectable({ token: AkeelaWorkflowStructureService, factory: AkeelaWorkflowStructureService.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AkeelaWorkflowStructureService, [{
        type: Injectable
    }], function () { return []; }, null); })();

class AkeelaStageService {
    constructor(akeelaWorkflowStructureService, http, config, httpMock) {
        this.akeelaWorkflowStructureService = akeelaWorkflowStructureService;
        this.http = http;
        this.config = config;
        this.httpMock = httpMock;
        this.currentStage$ = new BehaviorSubject(null);
        this.styleStage$ = new BehaviorSubject({});
        this.showHeaderStage$ = new BehaviorSubject(false);
        this.endpointStageState$ = new BehaviorSubject({});
    }
    getStages(workflowCode, profile, role, audience) {
        if (this.config.useMock) {
            // buscamos los stages desde el mockService
            // return this.httpMock.getStages(workflowCode);
        }
        else {
            return new Observable(subscriber => {
                const workflowName = `${workflowCode}_${profile}_${role}_${audience}`;
                const stages = this.akeelaWorkflowStructureService.getStages(workflowName);
                if (!isNullOrUndefined(stages)) {
                    subscriber.next(stages.sort((stageA, stageB) => stageA.orderStage - stageB.orderStage));
                    subscriber.complete();
                }
                else {
                    // buscamos los stages en el backend
                    const url = `${this.config.urlApi}/${this.config.uriWorkflow}/${workflowCode}/stages`;
                    const params = {
                        steps_include: 'FALSE',
                        role,
                        audience,
                        profile
                    };
                    // GUEST, ANALIST, SALES_MANAGER, CLIENT
                    this.http.get(url, { params })
                        .subscribe(_stages => {
                        this.akeelaWorkflowStructureService.addStages(workflowName, _stages);
                        subscriber.next(_stages.sort((stageA, stageB) => stageA.orderStage - stageB.orderStage));
                        subscriber.complete();
                    });
                }
            });
        }
    }
    getStage(workflowCode, stageCode, profile, role, audience) {
        if (this.config.useMock) {
        }
        else {
            return new Observable(subscriber => {
                const workflowName = `${workflowCode}_${profile}_${role}_${audience}`;
                this.akeelaWorkflowStructureService.workflowHasStages(workflowName).subscribe(hasStages => {
                    if (hasStages) {
                        const stage = this.akeelaWorkflowStructureService.getStage(workflowName, stageCode);
                        subscriber.next(stage);
                        subscriber.complete();
                    }
                    else {
                        // buscamos el stage en el backend
                        const url = `${this.config.urlApi}/${this.config.uriWorkflow}/${workflowCode}/stages/${stageCode}`;
                        const params = {
                            steps_include: 'FALSE',
                            role,
                            audience,
                            profile // GUEST, ANALIST, SALES_MANAGER, CLIENT
                        };
                        this.http.get(url, { params })
                            .subscribe(_stage => {
                            // this.akeelaWorkflowStructureService.addStages(workflowName, _stage);
                            subscriber.next(_stage);
                            subscriber.complete();
                        });
                    }
                });
            });
        }
    }
    getFirstStageByInputCode(workflowCode, inputCode, profile, role, audience) {
        if (this.config.useMock) {
        }
        else {
            return new Observable(subscriber => {
                const url = `${this.config.urlApi}/stages`;
                const params = {
                    steps_include: 'FALSE',
                    role,
                    audience,
                    profile,
                    input_point: inputCode
                };
                this.http.get(url, { params })
                    .subscribe(_stage => {
                    subscriber.next(_stage);
                    subscriber.complete();
                });
            });
        }
    }
    setCurrentStageCode(stageCode) {
        this.currentStage$.next(stageCode);
    }
    setStyleStage(styleStage) {
        this.styleStage$.next(styleStage);
    }
    get styleStage() {
        return this.styleStage$;
    }
    setshowHeaderStage(showHeaderStage) {
        this.showHeaderStage$.next(showHeaderStage);
    }
    get showHeaderStage() {
        return this.showHeaderStage$;
    }
    setendpointStageState(endpointStageState) {
        this.endpointStageState$.next(endpointStageState);
    }
    get endpointStageState() {
        return this.endpointStageState$;
    }
}
/** @nocollapse */ AkeelaStageService.ɵfac = function AkeelaStageService_Factory(t) { return new (t || AkeelaStageService)(ɵɵinject(AkeelaWorkflowStructureService), ɵɵinject(HttpClient), ɵɵinject(AkeelaWorkflowConfigService), ɵɵinject(MockService)); };
/** @nocollapse */ AkeelaStageService.ɵprov = ɵɵdefineInjectable({ token: AkeelaStageService, factory: AkeelaStageService.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AkeelaStageService, [{
        type: Injectable
    }], function () { return [{ type: AkeelaWorkflowStructureService }, { type: HttpClient }, { type: AkeelaWorkflowConfigService }, { type: MockService }]; }, null); })();

class AkeelaStepService {
    constructor(http, stageService, workflowStructureService, config, httpMock, localStorage) {
        this.http = http;
        this.stageService = stageService;
        this.workflowStructureService = workflowStructureService;
        this.config = config;
        this.httpMock = httpMock;
        this.localStorage = localStorage;
        this.currentStep$ = new BehaviorSubject('do nothing');
        this.currentStepMode$ = new BehaviorSubject(false);
        this.styleStep$ = new BehaviorSubject({});
        this.showHeaderStep$ = new BehaviorSubject(false);
        this.showSubHeaderStep$ = new BehaviorSubject(false);
        this.showFooterStep$ = new BehaviorSubject(false);
        this.endpointStepState$ = new BehaviorSubject({});
        this.endpointTransitions$ = new BehaviorSubject({});
        this.endpointSectionsState$ = new BehaviorSubject({});
        this.breadcrumbStep$ = new BehaviorSubject(null);
        this.onDestroy$ = new Subject();
    }
    setCurrentStep(stepCode) {
        this.currentStep$.next(stepCode);
    }
    setModeCurrentStep(readonly) {
        if (readonly != this.currentStepMode$.getValue()) {
            this.currentStepMode$.next(readonly);
        }
    }
    get currentStepMode() {
        var isTrueSet = (this.localStorage.getItem("currentStepMode") == 'true');
        if (isTrueSet && !this.currentStepMode$.getValue()) {
            this.setModeCurrentStep(isTrueSet);
        }
        return this.currentStepMode$;
    }
    getStepTitles(workflowCode, stageCode, profile, role, audience) {
        if (this.config.useMock) {
            //  return this.httpMock.getStepTitles(workflowCode, stageCode);
        }
        else {
            return new Observable(subscriber => {
                const workflowName = `${workflowCode}_${profile}_${role}_${audience}`;
                const steps = this.workflowStructureService.getSteps(workflowName, stageCode);
                if (!isNullOrUndefined(steps)) {
                    subscriber.next(steps);
                    subscriber.complete();
                }
                else {
                    // buscamos los steps en el backend
                    const url = `${this.config.urlApi}/stages/${stageCode}/steps`;
                    const params = {
                        role,
                        audience,
                        profile,
                        include_section: 'FALSE'
                    };
                    this.http.get(url, { params }).subscribe(_steps => {
                        this.workflowStructureService.addSteps(workflowName, stageCode, _steps);
                        subscriber.next(_steps);
                        subscriber.complete();
                    });
                }
            });
        }
    }
    getStep(workflowCode, stageCode, stepCode, profile, role, audience) {
        if (this.config.useMock) {
            // return this.httpMock.getStep(stageCode, stepCode);
        }
        else {
            return new Observable(subscriber => {
                const workflowName = `${workflowCode}_${profile}_${role}_${audience}`;
                const step = this.workflowStructureService.getStep(workflowName, stageCode, stepCode);
                if (!isNullOrUndefined(step)) {
                    subscriber.next(step);
                    subscriber.complete();
                }
                else {
                    // buscamos el step en el backend
                    const url = `${this.config.urlApi}/stages/${stageCode}/steps/${stepCode}`;
                    const params = {
                        role,
                        audience,
                        profile,
                        include_section: 'ALL'
                    };
                    this.http.get(url, { params: params })
                        .pipe(map(this.mappingStep))
                        .subscribe(_step => {
                        this.workflowStructureService.updateStep(workflowName, stageCode, _step);
                        subscriber.next(_step);
                        subscriber.complete();
                    });
                }
            });
        }
    }
    getFirstStep(workflowCode, stageCode, profile, role, audience) {
        if (this.config.useMock) {
        }
        else {
            return new Observable(subscriber => {
                const workflowName = `${workflowCode}_${profile}_${role}_${audience}`;
                this.workflowStructureService.stageHasSteps(workflowName, stageCode).subscribe(hasSteps => {
                    if (hasSteps) {
                        const step = this.workflowStructureService.getFirstStep(workflowName, stageCode);
                        subscriber.next(step);
                        subscriber.complete();
                    }
                });
            });
        }
    }
    mappingStep(step) {
        step.sections = step === null || step === void 0 ? void 0 : step.sections.filter((section) => {
            return section === null || section === void 0 ? void 0 : section.sections.filter((subSection) => {
                return subSection.fields.length > 0;
            });
            //|| !isNullOrUndefined(subSection.componentName) y .length>0
        });
        step.sections = step.sections.sort(((a, b) => a.orderOfItem - b.orderOfItem));
        step.sections.forEach(section => {
            section.sections = section.sections.sort((a, b) => a.orderOfItem - b.orderOfItem);
            section.sections.forEach(subSection => {
                if (subSection.fields.length > 0) {
                    subSection.fields = subSection.fields.sort((a, b) => a.orderAttribute - b.orderAttribute);
                }
            });
        });
        return step;
    }
    setStyleStep(styleStep) {
        this.styleStep$.next(styleStep);
    }
    get styleStep() {
        return this.styleStep$;
    }
    setshowHeaderStep(showHeaderStep) {
        this.showHeaderStep$.next(showHeaderStep);
    }
    setshowSubHeaderStep(showSubHeaderStep) {
        this.showSubHeaderStep$.next(showSubHeaderStep);
    }
    setshowFooterStep(showFooterStep) {
        this.showFooterStep$.next(showFooterStep);
    }
    get showFooterStep() {
        return this.showFooterStep$;
    }
    setendpointStepState(endpointStepState) {
        this.endpointStepState$.next(endpointStepState);
    }
    get endpointStepState() {
        return this.endpointStepState$;
    }
    setendpointTransitions(endpointTransitions) {
        this.endpointTransitions$.next(endpointTransitions);
    }
    get endpointTransitions() {
        return this.endpointTransitions$;
    }
    setendpointSectionsState(endpointSectionsState) {
        this.endpointSectionsState$.next(endpointSectionsState);
    }
    get endpointSectionsState() {
        return this.endpointSectionsState$;
    }
    setbreadcrumbStep(breadcrumbStep) {
        this.breadcrumbStep$.next(breadcrumbStep);
    }
}
/** @nocollapse */ AkeelaStepService.ɵfac = function AkeelaStepService_Factory(t) { return new (t || AkeelaStepService)(ɵɵinject(HttpClient), ɵɵinject(AkeelaStageService), ɵɵinject(AkeelaWorkflowStructureService), ɵɵinject(AkeelaWorkflowConfigService), ɵɵinject(MockService), ɵɵinject(LocalService)); };
/** @nocollapse */ AkeelaStepService.ɵprov = ɵɵdefineInjectable({ token: AkeelaStepService, factory: AkeelaStepService.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AkeelaStepService, [{
        type: Injectable
    }], function () { return [{ type: HttpClient }, { type: AkeelaStageService }, { type: AkeelaWorkflowStructureService }, { type: AkeelaWorkflowConfigService }, { type: MockService }, { type: LocalService }]; }, null); })();

class AkeelaWorkflowService {
    constructor(_httpService, route, router, _path, stepService, stageService, localStorage, routeUtilsService) {
        this._httpService = _httpService;
        this.route = route;
        this.router = router;
        this._path = _path;
        this.stepService = stepService;
        this.stageService = stageService;
        this.localStorage = localStorage;
        this.routeUtilsService = routeUtilsService;
        this.currentWorkflow$ = new BehaviorSubject(null);
        this.transactionData$ = new BehaviorSubject(null);
        this.hiddenSection$ = new BehaviorSubject(null);
        this.queryParams$ = new BehaviorSubject(null);
        this.showHeaders$ = new BehaviorSubject(false);
        this.worflowEvents$ = new BehaviorSubject(null);
        this.transactionNumber$ = new BehaviorSubject(null);
        this.endpointTransactioData$ = new BehaviorSubject(null);
        this.resetEstatus$ = new BehaviorSubject(true);
        this.workflowStatus$ = new BehaviorSubject({});
        this.endpointWorkflowState$ = new BehaviorSubject({});
        this.wfFormFields$ = new BehaviorSubject([]);
        this.indexSections$ = new BehaviorSubject([]);
        this.saveSectios$ = new BehaviorSubject(null);
        this.hideSections$ = new BehaviorSubject([]);
        this.fieldsNotRequired$ = new BehaviorSubject(false);
        this.currentWorkflowActive$ = new BehaviorSubject(null);
        this.wfTransitions$ = new BehaviorSubject([]);
        this.wfTransitionsActive$ = new BehaviorSubject(false);
        this.wfNoUpdateSection$ = new BehaviorSubject(false);
        this.hiddeFieldOptional$ = new BehaviorSubject(false);
        this.showValidateTel$ = new BehaviorSubject(false);
        this.tlfValidates$ = new BehaviorSubject({});
        this.tlfValidatesWfReq$ = new BehaviorSubject([]);
        this.showValidateEmail$ = new BehaviorSubject(false);
        this.emailValidates$ = new BehaviorSubject({});
        this.emailValidatesWfReq$ = new BehaviorSubject([]);
        this.showSuggestion$ = new BehaviorSubject(false);
        this.showSuggestionObj$ = new BehaviorSubject({});
        this.esperaTransactioData$ = new BehaviorSubject(false);
        this.resetEstatusStep$ = new BehaviorSubject(false);
        this.numberTransaction = null;
        this.getShowValidateTel = () => __awaiter(this, void 0, void 0, function* () {
            return this.showValidateTel$;
        });
        this.getShowValidateEmail = () => __awaiter(this, void 0, void 0, function* () {
            return this.showValidateEmail$;
        });
        this.setShowSuggestion = (_setShowSuggestion) => {
            this.showSuggestion$.next(_setShowSuggestion);
        };
        this.event = 'DEFAULT_FLOW_EVENT';
    }
    setTlfValidates(tlfValidates) {
        this.tlfValidates$.next(tlfValidates);
    }
    setTlfValidatesWfReq(tlfValidatesWfReq) {
        this.tlfValidatesWfReq$.next(tlfValidatesWfReq);
    }
    setShowValidateTel(showValidateTel) {
        this.showValidateTel$.next(showValidateTel);
    }
    setEmailValidates(emailValidates) {
        this.emailValidates$.next(emailValidates);
    }
    setEmailValidatesWfReq(emailValidatesWfReq) {
        this.emailValidatesWfReq$.next(emailValidatesWfReq);
    }
    setShowValidateEmail(showValidateEmail) {
        this.showValidateEmail$.next(showValidateEmail);
    }
    setFieldsNotRequired(fieldsNotRequired) {
        this.fieldsNotRequired$.next(fieldsNotRequired);
    }
    setIndexSections(indexSections) {
        if (!isNullOrUndefined(indexSections)) {
            this.indexSections$.next(indexSections);
        }
        ;
    }
    setSaveSectios(saveSectios) {
        this.saveSectios$.next(saveSectios);
    }
    setHideSections(hideSections) {
        this.hideSections$.next(hideSections);
    }
    setWfFormFields() {
        let wfFormFields = [];
        if (!isNullOrUndefined(this.localStorage.getItem('wfFormFields'))) {
            wfFormFields = JSON.parse(this.localStorage.getItem('wfFormFields'));
        }
        ;
        this.wfFormFields$.next(wfFormFields);
    }
    setWfTransitions(wfTransitions) {
        this.wfTransitions$.next(wfTransitions);
    }
    setWfTransitionsActive(wfTransitionsActive) {
        this.wfTransitionsActive$.next(wfTransitionsActive);
    }
    setWfNoUpdateSection(wfNoUpdateSection) {
        this.wfNoUpdateSection$.next(wfNoUpdateSection);
    }
    addWfFormField(wfFormField) {
        let wfFormFields = [];
        if (!isNullOrUndefined(this.localStorage.getItem('wfFormFields'))) {
            wfFormFields = JSON.parse(this.localStorage.getItem('wfFormFields'));
        }
        ;
        let wfFormFieldTemp = wfFormFields.findIndex(e => e.name === wfFormField.name);
        if (wfFormFieldTemp > -1) {
            wfFormFields.splice(wfFormFieldTemp, 1);
        }
        wfFormFields.push(wfFormField);
        this.wfFormFields$.next(wfFormFields);
        this.localStorage.setItem('wfFormFields', JSON.stringify(wfFormFields));
    }
    deleteWfFormField(wfFormFieldName) {
        let wfFormFields = [];
        if (!isNullOrUndefined(this.localStorage.getItem('wfFormFields'))) {
            wfFormFields = JSON.parse(this.localStorage.getItem('wfFormFields'));
        }
        ;
        let wfFormFieldTemp = wfFormFields.findIndex(e => e.name === wfFormFieldName);
        if (wfFormFieldTemp > -1) {
            wfFormFields.splice(wfFormFieldTemp, 1);
            this.wfFormFields$.next(wfFormFields);
            this.localStorage.setItem('wfFormFields', JSON.stringify(wfFormFields));
        }
    }
    resetWfFormFields() {
        this.wfFormFields$.next([]);
    }
    setEndpointWorkflowState(endpointWorkflowState) {
        this.endpointWorkflowState$.next(endpointWorkflowState);
    }
    setHiddeFieldOptional(hiddeFieldOptional) {
        this.hiddeFieldOptional$.next(hiddeFieldOptional);
    }
    setWorkflowStatus(workflowStatus) {
        this.workflowStatus$.next(workflowStatus);
    }
    setResetEstatusStep(resetEstatusStep) {
        this.resetEstatusStep$.next(resetEstatusStep);
    }
    setResetEstatus(resetEstatus) {
        this.resetEstatus$.next(resetEstatus);
    }
    setCurrentWorkflowCode(workflowCode) {
        this.currentWorkflow$.next(workflowCode);
    }
    setCurrentWorkflowCodeActive(currentWorkflowActive) {
        this.currentWorkflowActive$.next(currentWorkflowActive);
    }
    setTransactionNumber(value) {
        this.transactionNumber$.next(value);
        this.numberTransaction = value;
        this.localStorage.setItem('transactionNumber', value);
        if (this.transactionData$.getValue() != null) {
            const temp = this.transactionData$.getValue();
            if (temp.numberTransaction !== value) {
                this.setTransactionData().subscribe();
            }
        }
        else {
            this.setTransactionData().subscribe();
        }
    }
    get transactionData() {
        if (!isNullOrUndefined(this.transactionNumber.getValue()) && isNullOrUndefined(this.transactionData$.getValue())) {
            return this.setTransactionData();
        }
        else {
            return this.transactionData$;
        }
    }
    setTransactionData(update = false) {
        return new Observable(resolve => {
            if (!isNullOrUndefined(this.transactionNumber$.getValue())) {
                this.endpointTransactioData.subscribe((endpointTransactioData) => {
                    if (endpointTransactioData != null) {
                        this.workflowCode = this.currentWorkflow$.getValue();
                        this.stageCode = this.stageService.currentStage$.getValue();
                        this.stepCode = this.stepService.currentStep$.getValue();
                        // this.route.queryParams.subscribe(queryParams => {
                        this.audience = this.localStorage.getItem('audience');
                        this.role = this.localStorage.getItem('role');
                        this.profile = this.localStorage.getItem('profile');
                        const paramsData = this._path.getAdditionalType(this, this.endpointTransactioData.getValue().additionalType);
                        const params = {
                            configuration: {
                                name: endpointTransactioData.name,
                                params: paramsData.params
                            }
                        };
                        console.log('ESTE ES EL TRANSACTION DATA ENDPOINT');
                        this._httpService.executeRequest(params.configuration.name, params.configuration.params, true).subscribe((transactionData) => {
                            const temp = this.transactionData$.getValue();
                            let bandera;
                            if (temp) {
                                if (temp.transactionNumber === this.numberTransaction) {
                                    if (temp.identifier === transactionData.identifier) {
                                        bandera = true;
                                    }
                                }
                            }
                            if (!update || (update && !bandera)) {
                                this.transactionData$.next(transactionData);
                            }
                            else {
                            }
                            resolve.next(transactionData);
                            resolve.complete();
                        }, (error) => {
                            resolve.next(null);
                            resolve.complete();
                        });
                        // });
                    }
                });
            }
            else {
                resolve.next(null);
                resolve.complete();
            }
        });
    }
    get transactionNumber() {
        this.route.params.subscribe(params => {
            if (params.transactionNumber) {
                if (this.transactionNumber$.getValue() !== params.transactionNumber) {
                    this.setTransactionNumber(params.transactionNumber);
                }
            }
            else if (this.localStorage.getItem('transactionNumber')) {
                if (this.localStorage.getItem('transactionNumber') !== this.transactionNumber$.getValue()) {
                    this.setTransactionNumber(this.localStorage.getItem('transactionNumber'));
                }
            }
        });
        return this.transactionNumber$;
    }
    setendpointTransactioData(endpointTransactioData) {
        this.endpointTransactioData$.next(endpointTransactioData);
    }
    get endpointTransactioData() {
        return this.endpointTransactioData$;
    }
}
/** @nocollapse */ AkeelaWorkflowService.ɵfac = function AkeelaWorkflowService_Factory(t) { return new (t || AkeelaWorkflowService)(ɵɵinject(HttpService), ɵɵinject(ActivatedRoute), ɵɵinject(Router), ɵɵinject(PathService), ɵɵinject(AkeelaStepService), ɵɵinject(AkeelaStageService), ɵɵinject(LocalService), ɵɵinject(RouteUtilsService)); };
/** @nocollapse */ AkeelaWorkflowService.ɵprov = ɵɵdefineInjectable({ token: AkeelaWorkflowService, factory: AkeelaWorkflowService.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AkeelaWorkflowService, [{
        type: Injectable
    }], function () { return [{ type: HttpService }, { type: ActivatedRoute }, { type: Router }, { type: PathService }, { type: AkeelaStepService }, { type: AkeelaStageService }, { type: LocalService }, { type: RouteUtilsService }]; }, null); })();

class UtilsService {
    constructor(jsonService, akeelaWorkflowService) {
        this.jsonService = jsonService;
        this.akeelaWorkflowService = akeelaWorkflowService;
        this.aux_value_input = '';
        this.akeelaWorkflowService.transactionData$.subscribe((transactionData) => {
            if (!isNullOrUndefined(transactionData)) {
                this.transactionData = transactionData;
            }
        });
    }
    getObjectReplaceParamsObj(fn, value, form = null) {
        if (form) {
            this.tempForm = form;
        }
        this.aux_value_input = value;
        const params_path = fn.o.params ? (fn.o.params.path ? fn.o.params.path : {}) : {};
        const params_body = fn.o.params ? (fn.o.params.body ? fn.o.params.body : {}) : {};
        const params_request = fn.o.params ? (fn.o.params.request ? fn.o.params.request : {}) : {};
        fn.o.params = {};
        // BODY JSON
        for (const element of Object.keys(params_body)) {
            const elementos = element.split('.');
            let obj = {};
            let temp;
            for (let i = elementos.length - 1; i >= 0; i--) {
                if (i === (elementos.length - 1)) {
                    obj = temp = {
                        [elementos[i]]: this.getValObjectResult(params_body[element])
                    };
                }
                else {
                    obj = temp = {
                        [elementos[i]]: temp
                    };
                }
            }
            if (isNullOrUndefined(obj.objResult)) {
                obj.objResult = {};
            }
            const aux = this.jsonService.mergeDeep(obj.objResult, obj); // Mario: para agregar elementos al body, en el caso de que fue requerido
            fn.o.objResult = this.jsonService.mergeDeep(fn.o.objResult, aux); // Mario: antes obj.objResult
        }
        // QUERY PARAMS
        for (const element of Object.keys(params_request)) {
            const elements = element.split('.');
            if (elements.length > 1) {
                elements.forEach((el, index) => {
                    fn.o[el];
                    if (element.split('.').length === index + 1) {
                        fn.o[el] = this.getValObjectResult(params_request[element]);
                    }
                });
            }
            else {
                if (isNullOrUndefined(fn.o[element])) {
                    fn.o[element] = {};
                }
                const params_i = params_request[element], i = 0;
                for (const param of Object.keys(params_i)) {
                    if (isNullOrUndefined(fn.o[element][param])) {
                        fn.o[element][param] = {};
                    }
                    fn.o[element][param] = this.getValObjectResult(params_i[param]);
                }
            }
        }
        // PATH PARAMS
        for (const element of Object.keys(params_path)) {
            const elements = element.split('.');
            if (elements.length > 1) {
                elements.forEach((el, index) => {
                    fn.o[el];
                    if (element.split('.').length === index + 1) {
                        fn.o[el] = this.getValObjectResult(params_path[element]);
                    }
                });
            }
            else {
                fn.o[element] = this.getValObjectResult(params_path[element]);
            }
        }
        return fn.o;
    }
    getObjectReplaceParams(fn, value) {
        const params_path = fn.o.params.path ? fn.o.params.path : {};
        const params_body = fn.o.params.body ? fn.o.params.body : {};
        const params_request = fn.o.params.request ? fn.o.params.request : {};
        fn.o.params = {};
        // BODY JSON
        for (const element of Object.keys(params_body)) {
            const elementos = element.split('.');
            let obj = {};
            let temp;
            for (let i = elementos.length - 1; i >= 0; i--) {
                if (i === (elementos.length - 1)) {
                    obj = temp = {
                        [elementos[i]]: value
                    };
                }
                else {
                    obj = temp = {
                        [elementos[i]]: temp
                    };
                }
            }
            fn.o.objResult = this.jsonService.mergeDeep(fn.o.objResult, obj.objResult);
        }
        // QUERY PARAMS
        for (const element of Object.keys(params_request)) {
            const elements = element.split('.');
            if (elements.length > 1) {
                elements.forEach((el, index) => {
                    fn.o[el];
                    if (element.split('.').length === index + 1) {
                        fn.o[el] = value;
                    }
                });
            }
            else {
                if (isNullOrUndefined(fn.o[element])) {
                    fn.o[element] = {};
                }
                const params_i = params_request[element], i = 0;
                for (const param of Object.keys(params_i)) {
                    if (isNullOrUndefined(fn.o[element][param])) {
                        fn.o[element][param] = {};
                    }
                    fn.o[element][param] = value;
                }
            }
        }
        // PATH PARAMS
        for (const element of Object.keys(params_path)) {
            const elements = element.split('.');
            if (elements.length > 1) {
                elements.forEach((el, index) => {
                    fn.o[el];
                    if (element.split('.').length === index + 1) {
                        fn.o[el] = value;
                    }
                });
            }
            else {
                fn.o[element] = value;
            }
        }
        return fn.o;
    }
    getValObjectResult(attributevalue) {
        if (attributevalue.startsWith('this.')) {
            const attribute = attributevalue.replace('this.', '').split('.');
            if (attribute.length > 1) {
                let prov;
                attribute.forEach((element, index) => {
                    if (index === 0) {
                        prov = this[element];
                    }
                    else {
                        prov = prov[element];
                    }
                });
                return prov;
            }
            else {
                return this[attributevalue.replace('this.', '')];
            }
        }
        else {
            return attributevalue;
        }
    }
    concatValues(data, keys) {
    }
    extractValueOfObject(data, key) {
        let response = '';
        const indexs = key.split('.');
        if (indexs.length > 0) {
            let auxiliar = data, i = 0;
            for (const index of indexs) {
                auxiliar = auxiliar[index];
                i++;
            }
            response = auxiliar;
        }
        else {
            if (!isNullOrUndefined(data[key])) {
                response = data[key];
            }
        }
        return response;
    }
}
/** @nocollapse */ UtilsService.ɵfac = function UtilsService_Factory(t) { return new (t || UtilsService)(ɵɵinject(JsonService), ɵɵinject(AkeelaWorkflowService)); };
/** @nocollapse */ UtilsService.ɵprov = ɵɵdefineInjectable({ token: UtilsService, factory: UtilsService.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(UtilsService, [{
        type: Injectable
    }], function () { return [{ type: JsonService }, { type: AkeelaWorkflowService }]; }, null); })();

const jsEventOutputs = {
    setLocalities: 'app_properties$localities$get',
    setEconomicActivities: 'product_plan_rate$economic_activities$get',
    saveAcreditedLegal: 'loan_credit$legal_accredited$post',
    saveAcreditedNatural: 'loan_credit$natural_accredited$post',
    saveDestinationOfFunds: 'loan_credit_request$credit$put',
    saveIncome: 'financial$income$put',
    saveExpenses: 'financial$expenses$put'
};
class OutputMockService {
    constructor() {
    }
    static parsePropertyUrl(output) {
        if (isNullOrUndefined(jsEventOutputs[output])) {
            return output;
        }
        return jsEventOutputs[output];
    }
}
/** @nocollapse */ OutputMockService.ɵfac = function OutputMockService_Factory(t) { return new (t || OutputMockService)(); };
/** @nocollapse */ OutputMockService.ɵprov = ɵɵdefineInjectable({ token: OutputMockService, factory: OutputMockService.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(OutputMockService, [{
        type: Injectable
    }], function () { return []; }, null); })();

const delimitersWithPrefix = ['{', '}', '(', ')', '[', ']'];
class AkeelaUrlService {
    constructor(config) {
        this.config = config;
    }
    parseDelimiter(delimiter) {
        const prefix = '\\';
        if (delimitersWithPrefix.indexOf(delimiter) >= 0) {
            delimiter = prefix + delimiter;
        }
        return delimiter;
    }
    getUrlParams(url) {
        const openDelimiter = this.parseDelimiter(this.config.openDelimiter);
        const closeDelimiter = this.parseDelimiter(this.config.closeDelimiter);
        const patternStr = `${openDelimiter}\\w+${closeDelimiter}`;
        const regExpr = new RegExp(patternStr, 'g');
        if (url) {
            return url.match(regExpr);
        }
        else {
            return [];
        }
    }
    replace(url, param, value) {
        return url.replace(param, value.toString());
    }
    replaceAll(url, params, values) {
        if (!isNullOrUndefined(params)) {
            params.forEach(param => {
                const paramName = param.replace(this.config.openDelimiter, '').replace(this.config.closeDelimiter, '');
                const value = values[paramName];
                url = url.replace(param, value);
            });
        }
        return url;
    }
}
/** @nocollapse */ AkeelaUrlService.ɵfac = function AkeelaUrlService_Factory(t) { return new (t || AkeelaUrlService)(ɵɵinject(AkeelaWorkflowConfigService)); };
/** @nocollapse */ AkeelaUrlService.ɵprov = ɵɵdefineInjectable({ token: AkeelaUrlService, factory: AkeelaUrlService.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AkeelaUrlService, [{
        type: Injectable
    }], function () { return [{ type: AkeelaWorkflowConfigService }]; }, null); })();

class AkeelaFormService {
    constructor(datePipe, http, httpService, path, urlService, utilsService, localStorage, akeelaWorkflowService) {
        this.datePipe = datePipe;
        this.http = http;
        this.httpService = httpService;
        this.path = path;
        this.urlService = urlService;
        this.utilsService = utilsService;
        this.localStorage = localStorage;
        this.akeelaWorkflowService = akeelaWorkflowService;
        this.tempDefaultValue = null;
        this._defaultValues = {};
        this.akeelaWorkflowService.transactionData$.subscribe((transactionData) => {
            if (!isNullOrUndefined(transactionData)) {
                this.transactionData = transactionData;
            }
        });
    }
    get defaultValues() { return this._defaultValues; }
    static createInputFormControlValidators(field) {
        const validators = [];
        if (field.valueRequired) {
            validators.push(Validators.required);
        }
        if (field.maxValue) {
            validators.push(Validators.max(field.maxValue));
        }
        if (field.minValue) {
            validators.push(Validators.min(field.minValue));
        }
        if (field.dataFieldItem.length) {
            if (field.dataFieldItem.length.maxValue) {
                validators.push(Validators.maxLength(field.dataFieldItem.length.maxValue));
            }
            if (field.dataFieldItem.length.minValue) {
                validators.push(Validators.minLength(field.dataFieldItem.length.minValue));
            }
        }
        if (field.dataFieldItem.pattern) {
            validators.push(Validators.pattern(field.dataFieldItem.pattern));
        }
        if (field.dataFieldItem.typeInput === 'email') {
            validators.push(Validators.email);
        }
        return validators;
    }
    static createSelectFormControlValidators(field) {
        const validators = [];
        if (field.valueRequired) {
            validators.push(Validators.required);
        }
        return validators;
    }
    static createCheckboxFormControlValidators(field) {
        const validators = [];
        if (field.valueRequired) {
            validators.push(Validators.required);
        }
        return validators;
    }
    static getFieldIdentifier(fieldName) {
        if (!isNullOrUndefined(fieldName)) {
            const fieldIdentifierArray = fieldName.split('.');
            return fieldIdentifierArray[fieldIdentifierArray.length - 1];
        }
        else {
            return '';
        }
    }
    static getPrefixFieldIdentifier(fieldName) {
        if (!isNullOrUndefined(fieldName)) {
            const fieldIdentifierArray = fieldName.split('.');
            return fieldIdentifierArray.slice(0, fieldIdentifierArray.length - 1);
        }
        else {
            return [];
        }
    }
    createAsyncValidators(formGroupField, field) {
        const asyncValidators = [];
        // return this.getValidatorFn(fn);
        const obj = field.jsEvents ? field.jsEvents : null;
        if (obj) {
            const data = JSON.parse(obj);
            if (data.length > 0) {
                for (const fn of data) {
                    if (fn.sub_e === 'validation') {
                        asyncValidators.push(this.getValidatorFn(fn));
                    }
                    else if (fn.sub_e === 'validationExist') {
                        asyncValidators.push(this.getValidatorExistFn(formGroupField, fn));
                    }
                    else if (fn.sub_e === 'validationPassword') {
                        asyncValidators.push(this.validationPasswordFn(formGroupField, fn));
                    }
                    else if (fn.sub_e === 'ValidateDate') {
                        asyncValidators.push(this.validationDateFn(formGroupField, fn));
                    }
                    else if (fn.sub_e === 'ValidateDateUpper') {
                        asyncValidators.push(this.validationDateUpperFn(formGroupField, fn));
                    }
                    else if (fn.sub_e === 'ValidateDateLower') {
                        asyncValidators.push(this.validationDateLowerFn(formGroupField, fn));
                    }
                    else if (fn.sub_e === 'ValidateDateLower') {
                        asyncValidators.push(this.validationDateLowerFn(formGroupField, fn));
                    }
                    else if (fn.sub_e === 'ValidateDate18') {
                        asyncValidators.push(this.validationDate18Fn(formGroupField, fn));
                    }
                    else if (fn.sub_e === 'ValidatePhone') {
                        asyncValidators.push(this.validatePhoneFn(formGroupField, fn));
                    }
                    else if (fn.sub_e === 'ValidateEmail') {
                        asyncValidators.push(this.validateEmailFn(formGroupField, fn));
                    }
                    else if (fn.sub_e === 'ValidateRangeValueProducts') {
                        asyncValidators.push(this.ValidateRangeValueProductFn(formGroupField, fn));
                    }
                }
            }
        }
        return asyncValidators;
    }
    validationPasswordFn(formGroupField, fn) {
        return (control) => {
            return new Promise((resolve, reject) => {
                const fn_aux = JSON.parse(JSON.stringify(fn));
                let controlField = this.getControl(formGroupField, fn_aux.o.listNameRelated);
                if (control.value !== controlField.value) {
                    resolve({ passwordDistinct: true });
                }
                else {
                    resolve(null);
                }
            });
        };
    }
    validationDateFn(formGroupField, fn) {
        return (control) => {
            return new Promise((resolve, reject) => {
                if (this.lowerCurrentDate(control, fn.o.date)) {
                    resolve({ ValidateDate: true });
                }
                else {
                    resolve(null);
                }
            });
        };
    }
    validatePhoneFn(formGroupField, fn) {
        return (control) => {
            return new Promise((resolve, reject) => {
                if (!this.isValidPhone(control)) {
                    resolve({ ValidatePhone: true });
                }
                else {
                    resolve(null);
                }
            });
        };
    }
    validateEmailFn(formGroupField, fn) {
        return (control) => {
            return new Promise((resolve, reject) => {
                if (!this.isValidEmail(control)) {
                    resolve({ ValidateEmail: true });
                }
                else {
                    resolve(null);
                }
            });
        };
    }
    ValidateRangeValueProductFn(formGroupField, fn) {
        return (control) => {
            return new Promise((resolve, reject) => {
                const resp = this.isValidateRangeValueProduct(control);
                if (resp) {
                    resolve({ ValidateRangeValueProduct: resp });
                }
                else {
                    resolve(null);
                }
            });
        };
    }
    validationDate18Fn(formGroupField, fn) {
        return (control) => {
            return new Promise((resolve, reject) => {
                if (this.currentDate18(control)) {
                    resolve({ ValidateDate18: true });
                }
                else {
                    resolve(null);
                }
            });
        };
    }
    validationDateUpperFn(formGroupField, fn) {
        return (control) => {
            return new Promise((resolve, reject) => {
                if (this.UpperCurrentDate(control)) {
                    resolve({ ValidateDateUpper: true });
                }
                else {
                    resolve(null);
                }
            });
        };
    }
    validationDateLowerFn(formGroupField, fn) {
        return (control) => {
            return new Promise((resolve, reject) => {
                if (this.LowerCurrentDate(control)) {
                    resolve({ ValidateDateLower: true });
                }
                else {
                    resolve(null);
                }
            });
        };
    }
    getValidatorFn(fn) {
        return (control) => {
            return new Promise((resolve, reject) => {
                var _a;
                const fn_aux = JSON.parse(JSON.stringify(fn));
                // console.log(fn);
                // fn = this.utilsService.getObjectReplaceParams(fn, control.value);
                let data;
                if (((_a = fn_aux === null || fn_aux === void 0 ? void 0 : fn_aux.o) === null || _a === void 0 ? void 0 : _a.type) == 'getClientExist') {
                    data = 'V' + control.value;
                }
                else {
                    data = control.value;
                }
                const params = {
                    request: this.utilsService.getObjectReplaceParamsObj(fn, data).params,
                    path: {},
                    body: {}
                };
                fn = JSON.parse(JSON.stringify(fn_aux));
                this.httpService.executeRequest(fn_aux.f, params, true).subscribe((data) => {
                    var _a;
                    if (((_a = fn_aux === null || fn_aux === void 0 ? void 0 : fn_aux.o) === null || _a === void 0 ? void 0 : _a.type) == 'getClientExist') {
                        if (data && Object.keys(data).length > 0) {
                            resolve({ existe: true });
                        }
                        else {
                            resolve(null);
                        }
                    }
                    else {
                        if (data) {
                            resolve({ existe: true });
                        }
                        else {
                            resolve(null);
                        }
                    }
                });
            });
        };
    }
    getValidatorExistFn(formGroupField, fn) {
        return (control) => {
            return new Promise((resolve, reject) => {
                let fn_aux = JSON.parse(JSON.stringify(fn));
                // console.log(fn);
                // fn = this.utilsService.getObjectReplaceParams(fn, control.value);
                fn_aux = this.utilsService.getObjectReplaceParamsObj(fn_aux, control.value, formGroupField.getRawValue()).params;
                const params = {
                    request: fn_aux,
                    path: {},
                    body: {}
                };
                let fn_aux2 = JSON.parse(JSON.stringify(fn));
                const current_value = !isNullOrUndefined(this.transactionData.organization) ? this.transactionData.organization.taxID : null;
                if (current_value !== control.value && !isNullOrUndefined(control.value)) {
                    this.httpService.executeRequest(fn_aux2.f, params, true).subscribe((data) => {
                        if (!isNullOrUndefined(data)) {
                            if (data === true) {
                                resolve({ valid: true });
                            }
                            else {
                                resolve(null);
                            }
                        }
                        else {
                            resolve(null);
                        }
                    });
                }
                else {
                    resolve(null);
                }
            });
        };
    }
    createFormControl(formGroupField, field) {
        let defaultValue = '';
        if (field.defaultValue) {
            defaultValue = field.defaultValue;
        }
        else if (field.defaultProperty) {
            defaultValue = field.defaultProperty;
        }
        let validators = [];
        let fieldIdentifier = AkeelaFormService.getFieldIdentifier(field.dataFieldItem.name);
        if (field.dataFieldItem.type === 'input' || field.dataFieldItem.type === 'textarea') {
            validators = AkeelaFormService.createInputFormControlValidators(field);
        }
        if (field.dataFieldItem.type === 'select') {
            validators = AkeelaFormService.createSelectFormControlValidators(field);
        }
        if (field.dataFieldItem.type === 'checkbox') {
            fieldIdentifier += '-' + field.dataFieldItem;
            validators = AkeelaFormService.createCheckboxFormControlValidators(field);
        }
        const asyncValidators = this.createAsyncValidators(formGroupField, field);
        const validatorObj = {};
        if (!isNullOrUndefined(validators) && validators.length > 0) {
            validatorObj.validators = validators;
        }
        if (!isNullOrUndefined(asyncValidators) && asyncValidators.length > 0) {
            validatorObj.asyncValidators = asyncValidators;
        }
        // todo: add async validators to fields
        const formControl = new FormControl(defaultValue, validatorObj);
        if (isNullOrUndefined(this.tempDefaultValue)) {
            this.tempDefaultValue = {};
        }
        this.tempDefaultValue[field.dataFieldItem.alternateName] = defaultValue;
        formControl.setValue(defaultValue);
        formControl.patchValue(defaultValue);
        return formControl;
    }
    /**
     * Crea un FormGroup a partir de una lista de campos
     * @param fields: lista de campos de donde se parte para generar el FormGroup
     * @Return FormGroup con los campos definidos en fields.
     */
    createFormGroup(fields) {
        const formGroup = new FormGroup({});
        fields.forEach(field => {
            if (field.dataFieldItem.type !== 'button') {
                const fieldIdentifier = AkeelaFormService.getFieldIdentifier(field.dataFieldItem.alternateName);
                const prefixField = AkeelaFormService.getPrefixFieldIdentifier(field.dataFieldItem.alternateName);
                let control = formGroup;
                prefixField.forEach(groupName => {
                    if (isNullOrUndefined(control.get(groupName))) {
                        control.addControl(groupName, new FormGroup({}));
                    }
                    control = control.get(groupName);
                });
                control.addControl(fieldIdentifier, this.createFormControl(control, field));
            }
        });
        return Object.keys(formGroup.controls).length > 0 ? formGroup : null;
    }
    addFormControls(formGroup, fields) {
        fields.forEach(field => {
            if (field.dataFieldItem.type !== 'button') {
                const fieldIdentifier = AkeelaFormService.getFieldIdentifier(field.dataFieldItem.alternateName);
                const prefixField = AkeelaFormService.getPrefixFieldIdentifier(field.dataFieldItem.alternateName);
                let control = formGroup;
                prefixField.forEach(groupName => {
                    if (isNullOrUndefined(control.get(groupName))) {
                        control.addControl(groupName, new FormGroup({}));
                    }
                    control = control.get(groupName);
                });
                control.addControl(fieldIdentifier, this.createFormControl(formGroup, field));
            }
        });
    }
    /**
     * Crea un FormGroup para cada una de las sub_secciones definidas en el parametro section
     * @param section: Seccion para la que se generan los FormGroups.
     * @Return Un objeto con todos los FormGroup de las sub_secciones de section.
     */
    createFormGroups(section) {
        const forms = new FormGroup({});
        this.tempDefaultValue = {};
        section.sections.forEach(subSection => {
            // const subSectionIdentifier = AkeelaFormService.getFieldIdentifier(subSection.name);
            // const formGroup = this.createFormGroup(subSection.fields);
            // if (formGroup) {
            //     forms.addControl(subSectionIdentifier, formGroup);
            // }
            this.addFormControls(forms, subSection.fields);
        });
        this.createDefaultValues(section.identifier, this.tempDefaultValue);
        this.tempDefaultValue = null;
        return forms;
    }
    save(obj) {
        return new Observable(resolve => {
            setTimeout(() => {
                const urlPath = OutputMockService.parsePropertyUrl(obj.urlBackend);
                this.path.getPathService(urlPath).subscribe(pathResponse => {
                    let httpMethod;
                    // replace date string to timestamp...
                    obj.objResult = this.replaceDatestringToTimestamp(obj.objResult, '-');
                    const urlParams = this.urlService.getUrlParams(pathResponse.url);
                    const url = this.urlService.replaceAll(pathResponse.url, urlParams, obj);
                    /*HEADERS*/
                    let headers = null;
                    if (obj.headers) {
                        if (obj.headers.role[this.localStorage.getItem('role')]) {
                            headers = new HttpHeaders(obj.headers.role[this.localStorage.getItem('role')]);
                        }
                    }
                    /*if (Object.keys(obj.objResult).length < 2) {
                        Object.keys(obj.objResult).forEach(key => obj.objResult = obj.objResult[key]);
                    }*/
                    switch (pathResponse.httpMethod.toLowerCase()) {
                        case 'get':
                            httpMethod = this.http.get(url, { headers: headers });
                            break;
                        case 'post':
                            httpMethod = this.http.post(url, obj.objResult, { headers: headers, params: obj.params });
                            break;
                        case 'put':
                            httpMethod = this.http.put(url, obj.objResult, { headers: headers, params: obj.params });
                            break;
                        case 'delete':
                            httpMethod = this.http.delete(url, { headers: headers });
                            break;
                    }
                    let httpMethodResult = httpMethod.pipe(map((event) => {
                        this.httpService.setHttpUpdate(pathResponse.httpMethod.toLowerCase());
                        return event;
                    }));
                    httpMethodResult.subscribe(response => {
                        this.replaceDatesTimestampToString(response, 'yyyy-MM-dd');
                        resolve.next(response);
                        resolve.complete();
                    }, error => {
                        resolve.error(error);
                        resolve.complete();
                        console.log(error);
                    });
                });
            }, 10);
        });
    }
    // crear el enabled que reciba el nombre del grupo y true o false.
    setDisableFormGroup(group) {
        group.disable({ onlySelf: true });
    }
    setEnableFormGroup(group) {
        group.enable({ onlySelf: true });
    }
    replaceDatesTimestampToString(obj, format) {
        //Se debe consultar el tipo de dato pora no tener que hacer subString del nombre del campo para saver si es tipo Date
        if (isNullOrUndefined(obj)) {
            return '';
        }
        let objString = JSON.stringify(obj);
        const queryText = 'Date":';
        const patternStr = `${queryText}\[0-9]{10,}`;
        const regExpr = new RegExp(patternStr, 'g');
        let result = [];
        result = objString.match(regExpr);
        const queryText2 = 'Date":-';
        const patternStr2 = `${queryText2}\[0-9]{10,}`;
        const regExpr2 = new RegExp(patternStr2, 'g');
        let result2 = [];
        result2 = objString.match(regExpr2);
        let result3 = null;
        if (!isNullOrUndefined(result)) {
            result3 = result.concat(result2);
        }
        if (result3) {
            result3.forEach((element) => {
                if (!isNullOrUndefined(element)) {
                    const date_timestamp = new Date(Number(element.replace(queryText, '')));
                    const date_string = this.datePipe.transform(date_timestamp, format, '+0700');
                    objString = objString.replace(element, queryText + '\"' + date_string + '\"');
                }
            });
        }
        return JSON.parse(objString);
    }
    replaceTimestampToString(value, format) {
        const date_timestamp = new Date(Number(value));
        return this.datePipe.transform(date_timestamp, format, '+0700');
    }
    replaceDatestringToTimestamp(obj, delimitador) {
        let objString = JSON.stringify(obj);
        const patternStr = `\[0-9]{4}${delimitador}\[0-9]{2}${delimitador}\[0-9]{2}`;
        const regExpr = new RegExp(patternStr, 'g');
        const result = objString.match(regExpr);
        if (result) {
            for (const key of result) {
                objString = objString.replace(new RegExp(key, 'g'), ((new Date(key).getTime())).toString());
            }
        }
        return JSON.parse(objString);
    }
    getControl(formGroup, name) {
        if (isNullOrUndefined(name)) {
            name = '';
        }
        const fieldNameArray = name.split('.');
        let component = formGroup;
        fieldNameArray.forEach(nFieldName => {
            if (component) {
                component = component.get(nFieldName);
            }
        });
        return component;
    }
    createDefaultValues(identifier, defaulValues) {
        if (Object.keys(defaulValues).length > 0) {
            Object.keys(defaulValues).forEach(key => {
                if (isNullOrUndefined(this._defaultValues[identifier])) {
                    this._defaultValues[identifier] = {};
                }
                const keyArray = key.split('.');
                const prefixes = keyArray.slice(0, keyArray.length - 1);
                const paramKey = keyArray[keyArray.length - 1];
                let defaultObject = this._defaultValues[identifier];
                prefixes.forEach(property => {
                    if (isNullOrUndefined(defaultObject[property])) {
                        defaultObject[property] = {};
                    }
                    defaultObject = defaultObject[property];
                });
                defaultObject[paramKey] = defaulValues[key];
            });
        }
    }
    LowerSimpleText(control) {
        if (!isNullOrUndefined(control) && control.value !== '') {
            // Patron de entrada, en este caso solo acepta numeros y letras
            const patron = /[A-Za-z0-9]/;
            const tecla_final = String.fromCharCode(control.value);
            //alert(patron.test(tecla_final));
            return patron.test(tecla_final);
        }
    }
    lowerCurrentDate(control, date) {
        const dateoll = new Date(date);
        if (!isNullOrUndefined(control) && control.value != '') {
            const dateMinor = new Date(control.value);
            if (dateMinor.getTime() < dateoll.getTime()) {
                return true;
            }
        }
    }
    currentDate18(control) {
        const dateoll = new Date();
        if (!isNullOrUndefined(control) && control.value != '') {
            //  const dateMinor = new Date(control.value);
            if (this.calcularEdad(control === null || control === void 0 ? void 0 : control.value) < 18) {
                return true;
            }
        }
    }
    isValidPhone(control) {
        var _a;
        if ((control === null || control === void 0 ? void 0 : control.value) != '') {
            let objTlfValidatesWfReq = this.akeelaWorkflowService.tlfValidatesWfReq$.getValue();
            let resp;
            let temp = objTlfValidatesWfReq.filter(item => (item === null || item === void 0 ? void 0 : item.num) == (control === null || control === void 0 ? void 0 : control.value));
            if (temp.length > 0) {
                if ((_a = temp[0]) === null || _a === void 0 ? void 0 : _a.valid) {
                    resp = true;
                }
                else {
                    resp = false;
                }
            }
            return resp;
        }
    }
    isValidEmail(control) {
        var _a;
        if ((control === null || control === void 0 ? void 0 : control.value) != '') {
            let objEmailValidatesWfReq = this.akeelaWorkflowService.emailValidatesWfReq$.getValue();
            let resp;
            let temp = objEmailValidatesWfReq.filter(item => (item === null || item === void 0 ? void 0 : item.email) == (control === null || control === void 0 ? void 0 : control.value));
            if (temp.length > 0) {
                if ((_a = temp[0]) === null || _a === void 0 ? void 0 : _a.valid) {
                    resp = true;
                }
                else {
                    resp = false;
                }
            }
            return resp;
        }
    }
    isValidateRangeValueProduct(control) {
        var _a, _b, _c;
        let resp;
        if (control === null || control === void 0 ? void 0 : control.value) {
            let tmp = control.value;
            const additionalPropertys = ((_c = (_b = (_a = this.transactionData) === null || _a === void 0 ? void 0 : _a.plan) === null || _b === void 0 ? void 0 : _b.financialProduct) === null || _c === void 0 ? void 0 : _c.additionalProperty) || [];
            additionalPropertys.forEach((additionalProperty) => {
                const { propertyID, value } = additionalProperty;
                if (propertyID == "min_amount" && tmp < value) {
                    resp = `Monto mínimo ${value}`;
                }
                if (propertyID == "max_amount" && value < tmp) {
                    resp = `Monto máximo ${value}`;
                }
            });
            return resp;
        }
    }
    calcularEdad(fecha) {
        var hoy = new Date();
        var cumpleanos = new Date(fecha);
        var edad = hoy.getFullYear() - cumpleanos.getFullYear();
        var m = hoy.getMonth() - cumpleanos.getMonth();
        if (m < 0 || (m === 0 && hoy.getDate() < cumpleanos.getDate())) {
            edad--;
        }
        // console.log("edad: ",edad);
        return edad;
    }
    UpperCurrentDate(control) {
        let date = new Date();
        let day = date.getDate();
        let month = date.getMonth() + 1;
        let year = date.getFullYear();
        const dateNow = new Date(year + "-" + month + "-" + day);
        if (!isNullOrUndefined(control) && control.value != '') {
            const dateMinor = new Date(control.value);
            if (dateNow.getTime() < dateMinor.getTime()) {
                return true;
            }
        }
    }
    LowerCurrentDate(control) {
        let date = new Date();
        let day = date.getDate();
        let month = date.getMonth() + 1;
        let year = date.getFullYear();
        const dateNow = new Date();
        dateNow.setMinutes(dateNow.getMinutes() + dateNow.getTimezoneOffset());
        dateNow.setDate(date.getDate() - 1);
        if (!isNullOrUndefined(control) && control.value != '') {
            const dateMinor = new Date(control.value);
            dateMinor.setMinutes(dateMinor.getMinutes() + dateMinor.getTimezoneOffset());
            if (dateMinor.getTime() < dateNow.getTime()) {
                return true;
            }
        }
    }
}
/** @nocollapse */ AkeelaFormService.ɵfac = function AkeelaFormService_Factory(t) { return new (t || AkeelaFormService)(ɵɵinject(DatePipe), ɵɵinject(HttpClient), ɵɵinject(HttpService), ɵɵinject(PathService), ɵɵinject(AkeelaUrlService), ɵɵinject(UtilsService), ɵɵinject(LocalService), ɵɵinject(AkeelaWorkflowService)); };
/** @nocollapse */ AkeelaFormService.ɵprov = ɵɵdefineInjectable({ token: AkeelaFormService, factory: AkeelaFormService.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AkeelaFormService, [{
        type: Injectable
    }], function () { return [{ type: DatePipe }, { type: HttpClient }, { type: HttpService }, { type: PathService }, { type: AkeelaUrlService }, { type: UtilsService }, { type: LocalService }, { type: AkeelaWorkflowService }]; }, null); })();

class AkeelaSectionService {
    constructor(akeelaFormService) {
        this.akeelaFormService = akeelaFormService;
        this.modalChildList = {};
        this.resetForm$ = {};
        this.modalsFormValue$ = [];
        this.externalUpdateSectionForm$ = new BehaviorSubject(null);
        this.externalResetSectionForm$ = new BehaviorSubject(null);
        this.background$ = new BehaviorSubject(null);
        this.sumSharePercentage$ = new BehaviorSubject(0);
        this.sharePercentageField$ = new BehaviorSubject(0);
        this.shareMaxPercentage$ = new BehaviorSubject(100);
        this.readonlySelectDepnd$ = new BehaviorSubject([]);
        this.backAndUrl$ = new BehaviorSubject(null);
        this.modalShowedCount = 0;
        this.modalFather = null;
    }
    setBackAndUrl(backAndUrl) {
        this.backAndUrl$.next(backAndUrl);
    }
    setreadonlySelectDepnd(readonlySelectDepnd) {
        this.readonlySelectDepnd$.next(readonlySelectDepnd);
    }
    setShareMaxPercentage(shareMaxPercentage) {
        this.shareMaxPercentage$.next(shareMaxPercentage);
    }
    setSharePercentageField(sharePercentageField) {
        this.sharePercentageField$.next(sharePercentageField);
    }
    setSumSharePercentage(sumSharePercentage) {
        this.sumSharePercentage$.next(sumSharePercentage);
    }
    resetModalForm(sectionModalName) {
        if (isNullOrUndefined(this.resetForm$[sectionModalName])) {
            this.resetForm$[sectionModalName] = new BehaviorSubject(false);
        }
        return this.resetForm$[sectionModalName];
    }
    addModalSection(sectionModal) {
        if (isNullOrUndefined(this.modalSections)) {
            this.modalSections = [];
        }
        if (isNullOrUndefined(this.resetForm$[sectionModal.name])) {
            this.resetForm$[sectionModal.name] = new BehaviorSubject(true);
        }
        if (isNullOrUndefined(this.modalsFormValue$[sectionModal.name])) {
            this.modalsFormValue$[sectionModal.name] = new BehaviorSubject(null);
        }
        this.modalSections.push(sectionModal);
    }
    setModalFormValue(sectionModalName, value) {
        if (value) {
            const response = this.akeelaFormService.replaceDatesTimestampToString(value, 'yyyy-MM-dd');
            this.modalsFormValue$[sectionModalName].next(response);
            if (this.modalShowedCount === 1) {
                this.setModalFather(response);
            }
        }
        if (this.modalShowedCount === 1) {
            this.modalChildList = [];
        }
    }
    setModalFather(value) {
        this.modalFather = value;
    }
    getModalFather() {
        return this.modalFather;
    }
    addModalChild(listName, value) {
        if (isNullOrUndefined(this.modalChildList[listName])) {
            this.modalChildList[listName] = [];
        }
        this.modalChildList[listName].push(value);
    }
    updateModalChild(listName, value) {
        if (!isNullOrUndefined(this.modalChildList[listName])) {
            this.modalChildList[listName].forEach((element, i, arr) => {
                if (element.tempIdentifier === value.tempIdentifier) {
                    arr[i] = value;
                }
            });
        }
    }
    getModalChildList(listName) {
        return this.modalChildList[listName];
    }
    countModalChildList(listName) {
        return isNullOrUndefined(this.modalChildList[listName]) ? 0 : this.modalChildList[listName].length;
    }
    resetModalChildList(listName) {
        this.modalChildList[listName] = [];
    }
    getModalFormValue(sectionModalName) {
        if (isNullOrUndefined(this.modalsFormValue$[sectionModalName])) {
            this.modalsFormValue$[sectionModalName] = new BehaviorSubject(null);
        }
        return this.modalsFormValue$[sectionModalName];
    }
    getZindex(sectionModalName) {
        const modal = this.getModalSection(sectionModalName);
        if (isNullOrUndefined(modal)) {
            return 1000;
        }
        return modal.zIndex;
    }
    showModalSection(sectionModalName, reset = false) {
        const modal = this.getModalSection(sectionModalName);
        if (!isNullOrUndefined(modal)) {
            this.modalShowedCount++;
            modal.zIndex = this.modalShowedCount * 500 + 500;
            this.resetForm$[sectionModalName].next(reset);
            setTimeout(() => {
                modal.prevVisible = modal.visible;
                modal.visible = true;
            }, 30);
        }
    }
    hideModalSection(sectionModalName) {
        this.setSharePercentageField(0);
        const modal = this.getModalSection(sectionModalName);
        if (!isNullOrUndefined(modal)) {
            this.modalShowedCount = this.modalShowedCount <= 0 ? 0 : this.modalShowedCount - 1;
            setTimeout(() => {
                modal.prevVisible = modal.visible;
                modal.visible = false;
                //   this.resetForm$[sectionModalName].next(true);
            }, 30);
            modal.zIndex = 1000;
        }
    }
    modalExist(sectionModalName) {
        const modal = this.getModalSection(sectionModalName);
        return !isNullOrUndefined(modal);
    }
    modalIsVisible(sectionModalName) {
        const modal = this.getModalSection(sectionModalName);
        if (isNullOrUndefined(modal)) {
            return false;
        }
        return modal.visible;
    }
    getModalSection(sectionModalName) {
        if (isNullOrUndefined(this.modalSections)) {
            return null;
        }
        return this.modalSections.find(_modal => _modal.name === sectionModalName);
    }
    resetAllModals() {
    }
}
/** @nocollapse */ AkeelaSectionService.ɵfac = function AkeelaSectionService_Factory(t) { return new (t || AkeelaSectionService)(ɵɵinject(AkeelaFormService)); };
/** @nocollapse */ AkeelaSectionService.ɵprov = ɵɵdefineInjectable({ token: AkeelaSectionService, factory: AkeelaSectionService.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AkeelaSectionService, [{
        type: Injectable
    }], function () { return [{ type: AkeelaFormService }]; }, null); })();

class AkeelaDatamodelService {
    constructor(config, urlService, http, mock, path, akeelaFormService) {
        this.config = config;
        this.urlService = urlService;
        this.http = http;
        this.mock = mock;
        this.path = path;
        this.akeelaFormService = akeelaFormService;
        this.tem_request$ = {};
        this.datasources$ = [];
        this.currentDatamodel = {};
        this.currentDatamodel$ = new BehaviorSubject({});
    }
    set datamodel(model) {
        this.currentDatamodel = model;
        this.currentDatamodel$.next(this.currentDatamodel);
    }
    get datamodel() {
        return this.currentDatamodel$;
    }
    updateDatamodel(value) {
        this.currentDatamodel = Object.assign(this.currentDatamodel, value);
        this.currentDatamodel$.next(this.currentDatamodel);
    }
    getDataModelObj(urlKey, params, force) {
        return new Observable(subscriber => {
            const urlPath = OutputMockService.parsePropertyUrl(urlKey);
            this.path.getPathService(urlPath).subscribe(pathResponse => {
                subscriber.next(pathResponse);
                subscriber.complete();
            });
        });
    }
    getDataModel(urlKey, params, force) {
        return new Observable(subscriber => {
            const urlPath = OutputMockService.parsePropertyUrl(urlKey);
            this.path.getPathService(urlPath).subscribe(pathResponse => {
                const urlParams = this.urlService.getUrlParams(pathResponse.url);
                const url = this.urlService.replaceAll(pathResponse.url, urlParams, params.path);
                const datasourceName = this.getName(urlKey, params);
                let httpMethod = this.http.get(url, { params: params.request });
                if (this.tem_request$.hasOwnProperty(datasourceName)) {
                    httpMethod = this.tem_request$[datasourceName];
                }
                else {
                    /*
                    console.log("pathResponse.name: ",pathResponse.name);
                    console.log("pathResponse.url",pathResponse.url);
 */
                    this.tem_request$[datasourceName] = httpMethod.pipe(shareReplay());
                    setTimeout(() => {
                        let temp = datasourceName;
                        delete this.tem_request$[temp];
                    }, 5000);
                }
                if (isNullOrUndefined(this.datasources$[datasourceName])) {
                    this.datasources$[datasourceName] = httpMethod.pipe(shareReplay());
                }
                if (!force) {
                    httpMethod = this.datasources$[datasourceName];
                }
                else {
                    this.datasources$[datasourceName] = httpMethod.pipe(shareReplay());
                }
                httpMethod.subscribe(response => {
                    response = this.akeelaFormService.replaceDatesTimestampToString(response, 'yyyy-MM-dd');
                    subscriber.next(response);
                    subscriber.complete();
                }, error => {
                    subscriber.error(error);
                    subscriber.complete();
                });
            });
        });
    }
    getName(urlKey, params) {
        const nameArray = [];
        nameArray.push(urlKey);
        Object.keys(params).forEach(key => {
            if (Object.keys(params[key]).length > 0) {
                Object.keys(params[key]).forEach(sKey => {
                    nameArray.push(sKey + '_' + params[key][sKey]);
                });
            }
            else {
                nameArray.push(key + '_' + params[key]);
            }
        });
        return nameArray.join('_');
    }
}
/** @nocollapse */ AkeelaDatamodelService.ɵfac = function AkeelaDatamodelService_Factory(t) { return new (t || AkeelaDatamodelService)(ɵɵinject(AkeelaWorkflowConfigService), ɵɵinject(AkeelaUrlService), ɵɵinject(HttpClient), ɵɵinject(MockService), ɵɵinject(PathService), ɵɵinject(AkeelaFormService)); };
/** @nocollapse */ AkeelaDatamodelService.ɵprov = ɵɵdefineInjectable({ token: AkeelaDatamodelService, factory: AkeelaDatamodelService.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AkeelaDatamodelService, [{
        type: Injectable
    }], function () { return [{ type: AkeelaWorkflowConfigService }, { type: AkeelaUrlService }, { type: HttpClient }, { type: MockService }, { type: PathService }, { type: AkeelaFormService }]; }, null); })();

class LoadingService {
    constructor() {
        this.loading$ = new BehaviorSubject(false);
    }
    set loading(value) {
        this.loading$.next(value);
    }
    get loadingObservable() {
        return this.loading$;
    }
}
/** @nocollapse */ LoadingService.ɵfac = function LoadingService_Factory(t) { return new (t || LoadingService)(); };
/** @nocollapse */ LoadingService.ɵprov = ɵɵdefineInjectable({ token: LoadingService, factory: LoadingService.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(LoadingService, [{
        type: Injectable
    }], null, null); })();

class AkeelaTemplateService {
    constructor() {
        this.templates = {};
    }
    addTemplate(componentName, template) {
        this.templates[componentName] = template;
    }
    getTemplates() {
        return this.templates;
    }
    getTemplate(componentName) {
        return this.templates[componentName];
    }
}
/** @nocollapse */ AkeelaTemplateService.ɵfac = function AkeelaTemplateService_Factory(t) { return new (t || AkeelaTemplateService)(); };
/** @nocollapse */ AkeelaTemplateService.ɵprov = ɵɵdefineInjectable({ token: AkeelaTemplateService, factory: AkeelaTemplateService.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AkeelaTemplateService, [{
        type: Injectable
    }], function () { return []; }, null); })();

// @dynamic
class AkeelaRoutes {
}
AkeelaRoutes.workflow = '';
AkeelaRoutes.stage = 'stages';
AkeelaRoutes.step = 'steps';

const _c0 = ["*"];
class FooterComponent {
    constructor() {
    }
    ngOnInit() {
    }
}
/** @nocollapse */ FooterComponent.ɵfac = function FooterComponent_Factory(t) { return new (t || FooterComponent)(); };
/** @nocollapse */ FooterComponent.ɵcmp = ɵɵdefineComponent({ type: FooterComponent, selectors: [["akeela-footer"]], ngContentSelectors: _c0, decls: 1, vars: 0, template: function FooterComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵprojectionDef();
        ɵɵprojection(0);
    } }, styles: [""] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(FooterComponent, [{
        type: Component,
        args: [{
                selector: 'akeela-footer',
                templateUrl: './footer.component.html',
                styleUrls: ['./footer.component.css']
            }]
    }], function () { return []; }, null); })();

const _c0$1 = ["*"];
class HeaderComponent {
    constructor() {
    }
    ngOnInit() {
    }
}
/** @nocollapse */ HeaderComponent.ɵfac = function HeaderComponent_Factory(t) { return new (t || HeaderComponent)(); };
/** @nocollapse */ HeaderComponent.ɵcmp = ɵɵdefineComponent({ type: HeaderComponent, selectors: [["akeela-header"]], ngContentSelectors: _c0$1, decls: 1, vars: 0, template: function HeaderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵprojectionDef();
        ɵɵprojection(0);
    } }, styles: ["[_nghost-%COMP%]{display:flex;flex:1;flex-direction:column}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(HeaderComponent, [{
        type: Component,
        args: [{
                selector: 'akeela-header',
                templateUrl: './header.component.html',
                styleUrls: ['./header.component.css']
            }]
    }], function () { return []; }, null); })();

function AkeelaWorkflowComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 4);
    ɵɵelement(1, "br");
    ɵɵelement(2, "br");
    ɵɵelementStart(3, "div", 5);
    ɵɵelement(4, "img", 6);
    ɵɵelementEnd();
    ɵɵelement(5, "br");
    ɵɵelement(6, "br");
    ɵɵelementEnd();
} }
function AkeelaWorkflowComponent_akeela_header_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "akeela-header");
} if (rf & 2) {
    const ctx_r1 = ɵɵnextContext();
    ɵɵclassMapInterpolate1("let-rig-sm ", ctx_r1.showHeader && ctx_r1.stages.length >= 1 ? "d-block" : "d-none", "");
} }
function AkeelaWorkflowComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 7);
    ɵɵelement(1, "router-outlet");
    ɵɵelementEnd();
} }
class AkeelaWorkflowComponent {
    constructor(route, router, datamodelService, loadingService, routeService, workflowService, stageService, templateService, creditService, _httpService, _path, cdr) {
        this.route = route;
        this.router = router;
        this.datamodelService = datamodelService;
        this.loadingService = loadingService;
        this.routeService = routeService;
        this.workflowService = workflowService;
        this.stageService = stageService;
        this.templateService = templateService;
        this.creditService = creditService;
        this._httpService = _httpService;
        this._path = _path;
        this.cdr = cdr;
        this.haderComponentName = 'stages';
        this.linkHoverActive = {};
        this.templates = {};
        this.showHeader = false;
        this.stageStatus = {};
        this.showView = false;
        this.numScrollVar = 0;
        this.subscriptions = [];
        this.workflowStatus = {};
        this.onDestroy$ = new Subject();
        this.loadWorkflowState = false;
    }
    ngAfterViewInit() {
        setTimeout(() => {
            this.templates = this.templateService.getTemplates();
            this.showView = true;
        }, 1);
    }
    ngOnInit() {
        this.getStatus();
        // this.stageService.setshowHeaderStage(false);
        this.stageService.showHeaderStage$.pipe(takeUntil(this.onDestroy$)).pipe(takeUntil(this.onDestroy$)).subscribe(data => {
            this.showHeader = data;
        });
        this.workflowService.workflowStatus$.pipe(takeUntil(this.onDestroy$)).pipe(takeUntil(this.onDestroy$)).subscribe(data => {
            this.workflowStatus = data;
        });
        const style = { 'styles': { 'background': '#005cbf' }, stylesHoverActive: { 'background': 'black' } };
        this.stageService.setStyleStage(style);
        this.stageService.styleStage.pipe(takeUntil(this.onDestroy$)).subscribe(params => {
            this.styleStage = params;
        });
        /*Comentado por Mario, 04 de Agosto del 2020:
          Este código causa en el componente una repetición constante de llamada de servicios y hace que comience a pestañar la aplicación en distintas funcionalidades
          Dejo este comentario acá, porque no se cual es el objetivo del código, y si puede afectar en algo o si tiene un equivalente que no cause el error
        */
        /*.pipe(
                mergeMap(params => this.route.queryParams
                    .pipe(
                        map(queryParams => {
                            return { ...params, ...queryParams };
                        })
                    )
                )
            )
        */
        this.route.params.subscribe(params => {
            this.role = this.routeService.getRole(params);
            this.audience = this.routeService.getAudience(params);
            this.profile = this.routeService.getProfile(params);
            this.inputPoint = this.routeService.getInputPoint(params);
            this.workflowCode = this.routeService.getWorkflowCode(params);
            this.transactionNumber = this.routeService.getTransactionNumber(params);
            this.workflowService.setCurrentWorkflowCode(this.workflowCode);
            this.workflowService.queryParams$.next({
                'audience': this.audience,
            });
            this.createStagesSubscription();
        });
        // this.subscriptions.push(this.route.params.pipe(
        //     mergeMap(params => this.route.queryParams
        //         .pipe(
        //             map(queryParams => {
        //                 return { ...params, ...queryParams };
        //             })
        //         )
        //     )
        // ).subscribe(params => {
        //     this.role = RouteUtilsService.getRole(params);
        //     this.audience = RouteUtilsService.getAudience(params);
        //     this.profile = RouteUtilsService.getProfile(params);
        //     this.inputPoint = RouteUtilsService.getInputPoint(params);
        //     this.workflowCode = RouteUtilsService.getWorkflowCode(params);
        //     this.transactionNumber = RouteUtilsService.getTransactionNumber(params);
        //     this.workflowService.setCurrentWorkflowCode(this.workflowCode);
        //     this.workflowService.queryParams$.next({
        //         'audience': this.audience,
        //     });
        //     this.createStagesSubscription();
        // }));
    }
    ngAfterContentChecked() {
        if (!isNullOrUndefined(this.cdr)) {
            this.cdr.detectChanges();
        }
    }
    createStagesSubscription() {
        this.deleteWorkflowSubscription();
        this.workflowSubscription = this.stageService.getStages(this.workflowCode, this.profile, this.role, this.audience)
            .pipe(takeUntil(this.onDestroy$))
            .subscribe(stages => {
            this.stages = stages;
            this.createCurrentStageSubscription();
        });
    }
    createCurrentStageSubscription() {
        this.deleteCurrentStageSubscription();
        this.currentStageSubscription = this.stageService.currentStage$.pipe(takeUntil(this.onDestroy$)).subscribe(currentStageCode => {
            setTimeout(() => {
                this.currentStageCode = currentStageCode;
                if (this.stages && this.stages.length > 0) {
                    const temp = this.stages.filter((item) => item.alternateName === currentStageCode);
                    if (!isNullOrUndefined(temp[0])) {
                        this.stageService.setshowHeaderStage(temp[0].showHeader);
                        let i = 0;
                        for (const stage of this.stages) {
                            if (this.currentStageCode === stage.alternateName) {
                                this.moveScrollVar = 'stageList' + i;
                                this.moveScroll(this.moveScrollVar);
                            }
                            i = i + 1;
                        }
                    }
                    else {
                        this.stageService.setshowHeaderStage(false);
                    }
                }
            }, 1);
        });
    }
    getStatus() {
        /*
        this.subscriptions.push(this.workflowService.resetEstatus$.pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {

            this.transactionDataSubscriptor = this.workflowService.transactionData$.pipe(takeUntil(this.onDestroy$)).subscribe((transactionData: any) => {
                this.transactionData = transactionData;

                if (!isNullOrUndefined(this.transactionData) && this.transactionData !== undefined && !this.loadWorkflowState) {

                    this.transactionNumber = this.transactionData.transactionNumber;

                    this.subscriptions.push(this.workflowService.endpointWorkflowState$.pipe(takeUntil(this.onDestroy$)).subscribe(endpointWorkflowState => {

                        if (!(Object.keys(endpointWorkflowState).length === 0)) {
                            //   this.figure = this.creditService.figure$.getValue();

                            if (this.stages && this.stages.length > 0) {
                                let params;
                                this.audience = this.routeService.getAudience(params);

                                const paramsData: any = this._path.getAdditionalType(this, endpointWorkflowState.additionalType);

                                params = {
                                    configuration: {

                                        name: endpointWorkflowState.name,
                                        params: paramsData.params

                                    }
                                };

                                this.loadWorkflowState = true;
                                this.subscriptions.push(
                                    this._httpService.executeRequest(params.configuration.name, params.configuration.params, true).pipe(takeUntil(this.onDestroy$)).subscribe((result: any) => {
                                        if (result) {
                                            this.loadWorkflowState = false;

                                            let WorkflowStatus = [];
                                            let stepsStates;
                                            let sectionsStates;

                                            for (const dataStage of result) {
                                                if (dataStage) {
                                                    stepsStates = [];
                                                    if (dataStage.howToSteps) {
                                                        for (const dataStep of dataStage.howToSteps) {
                                                            sectionsStates = [];

                                                            if (dataStep.sections) {

                                                                for (const dataSection of dataStep.sections) {

                                                                    sectionsStates[dataSection.alternateName] = {
                                                                        code: dataSection.alternateName,
                                                                        state: dataSection.status,
                                                                    };
                                                                }
                                                            }

                                                            stepsStates[dataStep.alternateName] = {
                                                                code: dataStep.alternateName,
                                                                state: dataStep.status,
                                                                sections: sectionsStates
                                                            };

                                                        }
                                                    }
                                                }

                                                WorkflowStatus[dataStage.alternateName] = {
                                                    code: dataStage.alternateName,
                                                    state: dataStage.status,
                                                    steps: stepsStates
                                                };

                                            }

                                          //  this.workflowService.setWorkflowStatus(WorkflowStatus);

                                        }

                                    }, (error) => {
                                        this.loadWorkflowState = false;

                                    }));

                            }
                        }
                    }));
                }
            });
        })
        );*/
    }
    gotoStage(stageName, doNothing) {
        if (doNothing) {
            return;
        }
        const queryParams = {
            role: this.role,
            audience: this.audience,
            profile: this.profile
        };
        // if (!isNullOrUndefined(this.transactionNumber)) {
        //     queryParams.transactionNumber = this.transactionNumber;
        // }
        if (!isNullOrUndefined(this.inputPoint)) {
            queryParams.input_point = this.inputPoint;
        }
        if (!isNullOrUndefined(stageName)) {
            this.currentStageCode = stageName;
        }
        this.router.navigate([AkeelaRoutes.stage, this.currentStageCode], { queryParams, relativeTo: this.route });
    }
    deleteWorkflowSubscription() {
        if (this.workflowSubscription) {
            this.workflowSubscription.unsubscribe();
        }
    }
    deleteCurrentStageSubscription() {
        if (this.currentStageSubscription) {
            this.currentStageSubscription.unsubscribe();
        }
    }
    ngOnDestroy() {
        this.deleteCurrentStageSubscription();
        this.deleteWorkflowSubscription();
        if (this.transactionDataSubscriptor) {
            this.transactionDataSubscriptor.unsubscribe();
        }
        if (this.subscriptions) {
            // prevent memory leak when component destroyed
            this.subscriptions.forEach(s => s.unsubscribe());
        }
        this.onDestroy$.next();
        this.onDestroy$.complete();
    }
    moveScroll(id) {
        const element = document.getElementById(id);
        if (!isNullOrUndefined(element)) {
            element.scrollLeft = 0;
            element.scrollIntoView({
                behavior: 'smooth',
                block: 'nearest',
                inline: 'start'
            });
        }
    }
    lastLoading() {
        if ((this.numScrollVar === 150) && this.moveScrollVar) {
            this.moveScroll(this.moveScrollVar);
        }
        this.numScrollVar += 1;
        return '';
    }
}
/** @nocollapse */ AkeelaWorkflowComponent.ɵfac = function AkeelaWorkflowComponent_Factory(t) { return new (t || AkeelaWorkflowComponent)(ɵɵdirectiveInject(ActivatedRoute), ɵɵdirectiveInject(Router), ɵɵdirectiveInject(AkeelaDatamodelService), ɵɵdirectiveInject(LoadingService), ɵɵdirectiveInject(RouteUtilsService), ɵɵdirectiveInject(AkeelaWorkflowService), ɵɵdirectiveInject(AkeelaStageService), ɵɵdirectiveInject(AkeelaTemplateService), ɵɵdirectiveInject(CreditService), ɵɵdirectiveInject(HttpService), ɵɵdirectiveInject(PathService), ɵɵdirectiveInject(ChangeDetectorRef)); };
/** @nocollapse */ AkeelaWorkflowComponent.ɵcmp = ɵɵdefineComponent({ type: AkeelaWorkflowComponent, selectors: [["akeela-workflow"]], inputs: { datamodel: "datamodel", workflowCode: "workflowCode", inputPoint: "inputPoint", profile: "profile", audience: "audience", role: "role", transactionNumber: "transactionNumber", loading: "loading" }, decls: 5, vars: 3, consts: [[1, "animated"], ["class", "box", 4, "ngIf"], [3, "class", 4, "ngIf"], ["class", "pbs-1 animated fadIn", 4, "ngIf"], [1, "box"], [1, "text-left"], ["src", "./assets/public/images/loading.gif", "alt", " "], [1, "pbs-1", "animated", "fadIn"]], template: function AkeelaWorkflowComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", 0);
        ɵɵtemplate(1, AkeelaWorkflowComponent_div_1_Template, 7, 0, "div", 1);
        ɵɵelementEnd();
        ɵɵtemplate(2, AkeelaWorkflowComponent_akeela_header_2_Template, 1, 3, "akeela-header", 2);
        ɵɵtemplate(3, AkeelaWorkflowComponent_div_3_Template, 2, 0, "div", 3);
        ɵɵelement(4, "akeela-footer");
    } if (rf & 2) {
        ɵɵadvance(1);
        ɵɵproperty("ngIf", !ctx.showView);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.showView);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.showView);
    } }, directives: [NgIf, FooterComponent, HeaderComponent, RouterOutlet], styles: ["[_nghost-%COMP%]     .ak-circle{border-radius:50%;display:inline-block;font-size:1.4rem!important;height:2rem;margin-right:15px;min-width:32px;padding:0;position:relative;text-align:center;width:2.2rem}@media (max-width:768px){.ak-circle[_ngcontent-%COMP%]{width:2.6rem}}[_nghost-%COMP%]     .ak-badge{border-radius:50%;font-size:1rem;position:absolute;right:-5px;z-index:20}[_nghost-%COMP%]   .active[_ngcontent-%COMP%]{cursor:auto}.full-modal[_ngcontent-%COMP%]{height:100%;overflow:auto;top:0;z-index:100}.full-modal[_ngcontent-%COMP%], .full-modal[_ngcontent-%COMP%]   .header[_ngcontent-%COMP%]{background:#fff;position:fixed;width:100%}.full-modal[_ngcontent-%COMP%]   .header[_ngcontent-%COMP%]{box-shadow:0 1px 0 rgba(0,0,0,.10196078);margin-bottom:1rem;min-height:3.3rem;padding:.7rem;z-index:1}.full-modal.compleat-modal[_ngcontent-%COMP%]{padding:0!important}.full-modal.compleat-modal[_ngcontent-%COMP%]   .body[_ngcontent-%COMP%]{height:clac(100% - 11px)!important}ul.scrollmenu[_ngcontent-%COMP%]{overflow:hidden;white-space:nowrap}@media (min-width:768px){ul.scrollmenu[_ngcontent-%COMP%]:focus, ul.scrollmenu[_ngcontent-%COMP%]:hover{overflow:auto;white-space:nowrap}[_ngcontent-%COMP%]::-webkit-scrollbar{height:7px!important;width:.5px!important}}@media (max-width:768px){ul.scrollmenu[_ngcontent-%COMP%]{overflow:auto}ul.scrollmenu[_ngcontent-%COMP%]::-webkit-scrollbar{height:0!important;width:0!important}}ul.scrollmenu[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{display:inline-block;text-align:center;text-decoration:none}[_ngcontent-%COMP%]::-webkit-scrollbar-track{background:#f1f1f1}[_ngcontent-%COMP%]::-webkit-scrollbar-thumb{background:#888}[_ngcontent-%COMP%]::-webkit-scrollbar-thumb:hover{background:#555}[_nghost-%COMP%]{--ak-stage-nav-background:#fff;--ak-stage-nav-item-borderBottom-a:var(--ak-color-2);--ak-stage-nav-item-borderTop:#fff;--ak-stage-nav-item-borderTop-a:#fff;--ak-stage-nav-item-nav-item-a:#9b9b9b;--ak-stage-nav-item-nav-item-hover:#fff;--ak-stage-nav-item-nav-item-hover-a:var(--ak-color-4);--ak-stage-nav-item-nav-item-pendiente:var(--ak-color-2);--ak-stage-nav-item-nav-item-pendiente-a:var(--ak-color-4)}.nav[_ngcontent-%COMP%]{align-items:center;border-radius:5 5 0 0;display:block;flex-wrap:nowrap;height:61px;list-style:none;margin-bottom:0;padding:5px 0 0}.nav[_ngcontent-%COMP%], .nav-item[_ngcontent-%COMP%]{background:var(--ak-stage-nav-background)}.nav-item[_ngcontent-%COMP%]{border-top:2px solid var(--ak-stage-nav-item-borderTop);height:52px;padding-top:3px}.nav-item[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{color:var(--ak-stage-nav-item-nav-item-a)}.nav-item[_ngcontent-%COMP%]:hover   a[_ngcontent-%COMP%]{cursor:pointer}.nav-item.active[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{color:var(--ak-stage-nav-item-nav-item-hover-a)}.nav-item[_ngcontent-%COMP%]:hover{cursor:pointer}.nav-item.active[_ngcontent-%COMP%]{background:var(--ak-stage-nav-item-nav-item-hover);border-bottom:2px solid var(--ak-stage-nav-item-borderBottom-a);border-top:2px solid var(--ak-stage-nav-item-borderTop-a);font-weight:400}.nav-item[_ngcontent-%COMP%]   .pendiente[_ngcontent-%COMP%]:before{color:var(--ak-stage-nav-item-nav-item-pendiente);content:\u201D\u2022 \u201D;font-size:2rem}.nav-item[_ngcontent-%COMP%]   .pendiente[_ngcontent-%COMP%]:active{color:var(--ak-stage-nav-item-nav-item-pendiente-a)}.nav-item[_ngcontent-%COMP%]   .nav-link.bg-disabled[_ngcontent-%COMP%]{color:#ccc!important}.nav-item[_ngcontent-%COMP%]:hover   .nav-link.bg-disabled[_ngcontent-%COMP%]{cursor:pointer}.nav-item.active[_ngcontent-%COMP%]   .nav-link.bg-disabled[_ngcontent-%COMP%]{background:transparent!important}.bg-disabled.nav-item[_ngcontent-%COMP%]:hover   a[_ngcontent-%COMP%]{cursor:pointer}.bg-disabled.nav-item.active[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{color:transparent!important}.bg-disabled.nav-item[_ngcontent-%COMP%]:hover{cursor:pointer}.bg-disabled.nav-item.active[_ngcontent-%COMP%]{background:transparent!important;border-top:3px solid transparent!important;font-weight:400}.box-principal[_ngcontent-%COMP%]{background:#fff;box-shadow:0 0 8px -4px rgba(0,0,0,.59);min-height:auto;padding:0!important}@media (max-width:768px){.let-rig-sm[_ngcontent-%COMP%]{margin-left:-15px;width:calc(100% + 30px)}}.size-icon[_ngcontent-%COMP%]{font-size:19px}.next[_ngcontent-%COMP%]{color:#ccc}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AkeelaWorkflowComponent, [{
        type: Component,
        args: [{
                selector: 'akeela-workflow',
                templateUrl: './akeela-workflow.component.html',
                styleUrls: ['./akeela-workflow.component.css']
            }]
    }], function () { return [{ type: ActivatedRoute }, { type: Router }, { type: AkeelaDatamodelService }, { type: LoadingService }, { type: RouteUtilsService }, { type: AkeelaWorkflowService }, { type: AkeelaStageService }, { type: AkeelaTemplateService }, { type: CreditService }, { type: HttpService }, { type: PathService }, { type: ChangeDetectorRef }]; }, { datamodel: [{
            type: Input
        }], workflowCode: [{
            type: Input
        }], inputPoint: [{
            type: Input
        }], profile: [{
            type: Input
        }], audience: [{
            type: Input
        }], role: [{
            type: Input
        }], transactionNumber: [{
            type: Input
        }], loading: [{
            type: Input
        }] }); })();

const _c0$2 = function (a0) { return { "d-block": a0 }; };
function AkeelaStageComponent_akeela_header_0_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "akeela-header", 2);
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵproperty("ngClass", ɵɵpureFunction1(1, _c0$2, ctx_r0.showHeader && (ctx_r0.steps == null ? null : ctx_r0.steps.length) > 1));
} }
function AkeelaStageComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵelement(1, "router-outlet");
    ɵɵelementEnd();
} }
class AkeelaStageComponent {
    constructor(route, stageService, stepService, routeUtils, router, workflowService, templateService, creditService, _httpService, _path, cdr) {
        this.route = route;
        this.stageService = stageService;
        this.stepService = stepService;
        this.routeUtils = routeUtils;
        this.router = router;
        this.workflowService = workflowService;
        this.templateService = templateService;
        this.creditService = creditService;
        this._httpService = _httpService;
        this._path = _path;
        this.cdr = cdr;
        this.haderComponentName = 'steps';
        this.showView = false;
        this.numScrollVar = 0;
        this.prevValue = 0;
        this.steps = [];
        this.templates = {};
        this.stepStatus = {};
        this.showHeader = false;
        this.linkHoverActive = {};
        this.tempStep = false;
        this.onDestroy$ = new Subject();
    }
    ngAfterViewInit() {
        setTimeout(() => {
            this.templates = this.templateService.getTemplates();
            this.showView = true;
        }, 1);
    }
    noneIsEmpty() {
        return !isNullOrUndefined(this.transactionNumber) &&
            !isNullOrUndefined(this.role) &&
            !isNullOrUndefined(this.audience) &&
            !isNullOrUndefined(this.profile) &&
            !isNullOrUndefined(this.stageCode) &&
            !isNullOrUndefined(this.workflowCode);
    }
    ngOnInit() {
        this.route.params.subscribe(params => {
            let hasChanges = false;
            this.prevValue++;
            if (this.routeUtils.getTransactionNumber(params) !== this.transactionNumber) {
                this.transactionNumber = this.routeUtils.getTransactionNumber(params);
                hasChanges = true;
            }
            if (this.routeUtils.getRole(params) !== this.role) {
                this.role = this.routeUtils.getRole(params);
                hasChanges = true;
            }
            if (this.routeUtils.getAudience(params) !== this.audience) {
                this.audience = this.routeUtils.getAudience(params);
                hasChanges = true;
            }
            if (this.profile !== this.routeUtils.getProfile(params)) {
                this.profile = this.routeUtils.getProfile(params);
                hasChanges = true;
            }
            if (this.inputPoint !== this.routeUtils.getInputPoint(params)) {
                this.inputPoint = this.routeUtils.getInputPoint(params);
                hasChanges = true;
            }
            if (this.currentStepCode !== this.routeUtils.getStepCode(params)) {
                this.currentStepCode = this.routeUtils.getStepCode(params);
                hasChanges = true;
            }
            if (this.stageCode !== this.routeUtils.getStageCode(params)) {
                this.stageCode = this.routeUtils.getStageCode(params);
                hasChanges = true;
            }
            hasChanges = true;
            if (this.workflowCode !== this.route.pathFromRoot.map((path) => path.url.value.map(value => value.path)[0])[2]) {
                this.workflowCode = this.route.pathFromRoot.map((path) => path.url.value.map(value => value.path)[0])[2];
                hasChanges = true;
            }
            this.stageService.setCurrentStageCode(this.stageCode);
            if (hasChanges) {
                if (isNullOrUndefined(this.stageCode)) {
                    this.getStage();
                }
                else {
                    this.createStepsSubscription();
                }
            }
        });
        this.stepService.showHeaderStep$.pipe(takeUntil(this.onDestroy$)).subscribe(data => {
            this.showHeader = !isNullOrUndefined(data) ? data : false;
        });
        this.stepService.currentStep$.pipe(takeUntil(this.onDestroy$)).subscribe(currentStepCode => {
            setTimeout(() => this.currentStepCode = currentStepCode, 10);
        });
        this.workflowService.workflowStatus$.pipe(takeUntil(this.onDestroy$)).pipe(takeUntil(this.onDestroy$)).subscribe(workflowStatus => {
            this.transactionData = this.workflowService.transactionData$.getValue();
            if (!isNullOrUndefined(this.stageCode) && !(Object.keys(workflowStatus).length === 0)) {
                if (!isNullOrUndefined(workflowStatus[this.stageCode])) {
                    this.stepStatus = workflowStatus[this.stageCode].steps;
                }
                else {
                    this.stepStatus = {};
                }
            }
        });
    }
    ngAfterContentChecked() {
        if (!isNullOrUndefined(this.cdr)) {
            this.cdr.detectChanges();
        }
    }
    getStage() {
        if (isNullOrUndefined(this.inputPoint)) {
            // TODO: cambiar el hardcode por la linea comentada
            // this.currentStageCode = this.stages[0].alternateName;
            this.stageCode = 'searh';
            this.gotoStage();
        }
        else {
            this.stageService.getFirstStageByInputCode(this.workflowCode, this.inputPoint, this.profile, this.role, this.audience).pipe(takeUntil(this.onDestroy$))
                .subscribe(_stage => {
                this.stage = _stage;
                this.gotoStage();
            });
        }
    }
    createStepsSubscription() {
        this.deleteStepsSubscription();
        if (isNullOrUndefined(this.workflowCode)) {
            return;
        }
        this.stepsSubscription = this.stepService
            .getStepTitles(this.workflowCode, this.stageCode, this.profile, this.role, this.audience)
            .pipe(takeUntil(this.onDestroy$))
            .subscribe(steps => {
            this.steps = steps;
            this.createCurrentStepSubscription();
            this.getStatus();
        }, error => {
        });
    }
    getStatus() {
        let workflowStatus = this.workflowService.workflowStatus$.getValue();
        if (!isNullOrUndefined(this.stageCode) && !(Object.keys(workflowStatus).length === 0)) {
            if (!isNullOrUndefined(workflowStatus[this.stageCode])) {
                this.stepStatus = workflowStatus[this.stageCode].steps;
            }
            else {
                this.stepStatus = {};
            }
        }
    }
    createCurrentStepSubscription() {
        this.currentStepSubscription = this.stepService.currentStep$.pipe(takeUntil(this.onDestroy$)).subscribe(currentStepCode => {
            setTimeout(() => {
                this.deleteCurrentStepSubscription();
                if (((!isNullOrUndefined(currentStepCode) && currentStepCode !== 'do nothing'))) {
                    this.currentStepCode = currentStepCode;
                    let i = 0;
                    for (const step of this.steps) {
                        if (this.currentStepCode === step.alternateName) {
                            this.numScrollVar += 1;
                            this.moveScrollVar = 'stepList' + i;
                            this.moveScroll(this.moveScrollVar);
                            if (step.breadcrumb) {
                                try {
                                    const data = JSON.parse(step.breadcrumb);
                                    if (data) {
                                        this.stepService.setbreadcrumbStep(data);
                                    }
                                    else {
                                        this.stepService.setbreadcrumbStep(null);
                                    }
                                }
                                catch (error) {
                                    console.log(error);
                                }
                            }
                        }
                        i = i + 1;
                    }
                }
                let temp = this.steps.filter((item) => item.alternateName === currentStepCode);
                if (temp.length > 0) {
                    this.stepService.setshowSubHeaderStep(temp[0]['showSubHeader']);
                }
            }, 10);
        });
        this.currentStepSubscription = this.stageService.currentStage$.subscribe(currentStageCode => {
            setTimeout(() => {
                this.stageService.getStages(this.workflowCode, this.profile, this.role, this.audience)
                    .subscribe(stages => {
                    let temp = stages.filter((item) => item.alternateName === currentStageCode);
                    if (temp.length > 0) {
                        this.stepService.setshowHeaderStep(temp[0]['showHeader']);
                    }
                });
            }, 10);
        });
    }
    deleteStepsSubscription() {
        if (this.stepsSubscription) {
            this.stepsSubscription.unsubscribe();
        }
    }
    deleteCurrentStepSubscription() {
        if (this.currentStepSubscription) {
            this.currentStepSubscription.unsubscribe();
        }
        if (this.transactionDataSubscriptor) {
            this.transactionDataSubscriptor.unsubscribe();
        }
    }
    ngOnDestroy() {
        this.deleteStepsSubscription();
        this.onDestroy$.next();
        this.onDestroy$.complete();
    }
    gotoStage() {
        const uri = AkeelaRoutes.stage;
        const queryParams = {
            role: this.role,
            audience: this.audience,
            profile: this.profile,
            input_point: this.inputPoint
        };
        // MARIO - 05/DIC/2019
        // if (!isNullOrUndefined(this.transactionNumber)) {
        //     queryParams.transactionNumber = this.transactionNumber;
        // }
        // this.createStepsSubscription();
        this.router.navigate([uri, this.stageCode], { queryParams, relativeTo: this.route });
    }
    gotoStep(stepCode) {
        const prefixed = this.route.routeConfig.path.indexOf('/steps/') > 0 ? '../../' : '';
        const uri = prefixed + AkeelaRoutes.step;
        const queryParams = {
            role: this.role,
            audience: this.audience,
            profile: this.profile
        };
        // MARIO - 05/DIC/2019
        // if (!isNullOrUndefined(this.transactionNumber)) {
        //     queryParams.transactionNumber = this.transactionNumber;
        // }
        this.stepService.setCurrentStep(stepCode);
        const commands = [uri];
        if (!isNullOrUndefined(stepCode)) {
            commands.push(stepCode);
        }
        this.router.navigate(commands, { queryParams, relativeTo: this.route });
    }
    moveScroll(id) {
        let element = document.getElementById(id);
        if (!isNullOrUndefined(element)) {
            element.scrollIntoView({
                behavior: "smooth",
                block: "nearest",
                inline: "start"
            });
        }
    }
    lastLoading() {
        if ((this.numScrollVar === 150) && this.moveScrollVar) {
            this.moveScroll(this.moveScrollVar);
        }
        this.numScrollVar += 1;
        return '';
    }
}
/** @nocollapse */ AkeelaStageComponent.ɵfac = function AkeelaStageComponent_Factory(t) { return new (t || AkeelaStageComponent)(ɵɵdirectiveInject(ActivatedRoute), ɵɵdirectiveInject(AkeelaStageService), ɵɵdirectiveInject(AkeelaStepService), ɵɵdirectiveInject(RouteUtilsService), ɵɵdirectiveInject(Router), ɵɵdirectiveInject(AkeelaWorkflowService), ɵɵdirectiveInject(AkeelaTemplateService), ɵɵdirectiveInject(CreditService), ɵɵdirectiveInject(HttpService), ɵɵdirectiveInject(PathService), ɵɵdirectiveInject(ChangeDetectorRef)); };
/** @nocollapse */ AkeelaStageComponent.ɵcmp = ɵɵdefineComponent({ type: AkeelaStageComponent, selectors: [["akeela-stage"]], inputs: { workflowCode: "workflowCode", stageCode: "stageCode", inputPoint: "inputPoint", profile: "profile", role: "role", transactionNumber: "transactionNumber", audience: "audience" }, decls: 2, vars: 2, consts: [["class", "let-rig-sm d-none ", 3, "ngClass", 4, "ngIf"], [4, "ngIf"], [1, "let-rig-sm", "d-none", 3, "ngClass"]], template: function AkeelaStageComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵtemplate(0, AkeelaStageComponent_akeela_header_0_Template, 1, 3, "akeela-header", 0);
        ɵɵtemplate(1, AkeelaStageComponent_div_1_Template, 2, 0, "div", 1);
    } if (rf & 2) {
        ɵɵproperty("ngIf", ctx.showView);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.showView);
    } }, directives: [NgIf, HeaderComponent, NgClass, RouterOutlet], styles: ["[_nghost-%COMP%]{display:block}akeela-header[_ngcontent-%COMP%]     .header{background-color:transparent;border:1px solid #ccc;box-shadow:0 2px 4px 0 rgba(0,0,0,.2)}.step-title[_ngcontent-%COMP%]{flex:1;font-size:.8rem;margin-left:auto;margin-right:auto;padding-bottom:25px;text-align:center}.step-title.active-link[_ngcontent-%COMP%]{border-bottom:2px solid #000;border-radius:0}.btn[_ngcontent-%COMP%]{cursor:pointer}.btn[_ngcontent-%COMP%]   .ak-circle[_ngcontent-%COMP%]{margin-right:5px}ul.scrollmenu[_ngcontent-%COMP%]{overflow:hidden;white-space:nowrap}@media (min-width:768px){ul.scrollmenu[_ngcontent-%COMP%]:focus, ul.scrollmenu[_ngcontent-%COMP%]:hover{overflow:auto;white-space:nowrap}[_ngcontent-%COMP%]::-webkit-scrollbar{height:7px!important;width:.5px!important}}@media (max-width:768px){ul.scrollmenu[_ngcontent-%COMP%]{overflow:auto}[_ngcontent-%COMP%]::-webkit-scrollbar{height:0!important;width:0!important}}ul.scrollmenu[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{display:inline-block;text-align:center;text-decoration:none}[_nghost-%COMP%]{--ak-step-borderTop:#ddd;--ak-step-nav-background:#fff;--ak-step-nav-borderColor:#ddd;--ak-step-nav-item-borderTop:#fff;--ak-step-nav-item-borderTopActive:var(--ak-color-4);--ak-step-nav-link-background:#fff;--ak-step-nav-link-backgroundActive:#fff;--ak-step-nav-link-borderColor:#ddd;--ak-step-nav-link-borderColor-hover:#7e7e7e;--ak-step-nav-link-color:#7e7e7e;--ak-step-nav-link-color-hover:var(--ak-color-2)}.nav[_ngcontent-%COMP%]{align-items:center;background:var(--ak-step-nav-background);border-radius:5 5 0 0;border-top:1px solid var(--ak-step-borderTop);display:block;flex-wrap:nowrap;height:70px;list-style:none;margin-bottom:0;padding-top:8px}.nav-item[_ngcontent-%COMP%]{border-top:3px solid var(--ak-step-nav-borderTop);margin-right:1.2rem;padding-top:3px}.nav-item[_ngcontent-%COMP%]   .nav-link[_ngcontent-%COMP%]{background:var(--ak-step-nav-link-background);border:1px solid var(--ak-step-nav-borderColor);border-radius:3rem;color:var(--ak-step-nav-link-color);font-size:.9rem;margin-top:5px;padding:3px 15px}.nav-item[_ngcontent-%COMP%]   button.nav-link[_ngcontent-%COMP%]{padding:10px}.nav-item[_ngcontent-%COMP%]:hover   .nav-link[_ngcontent-%COMP%]{cursor:pointer}.nav-item.active[_ngcontent-%COMP%]   .nav-link[_ngcontent-%COMP%], .nav-item[_ngcontent-%COMP%]:hover   .nav-link[_ngcontent-%COMP%]{background:var(--ak-step-nav-link-backgroundActive);border:1px solid var(--ak-step-nav-link-borderColor-hover);color:var(--ak-step-nav-link-color-hover)}.nav-item[_ngcontent-%COMP%]   .nav-link.bg-disabled[_ngcontent-%COMP%]{background:#fff!important;color:#999!important;cursor:auto}.box-principal[_ngcontent-%COMP%]{background:#fff;box-shadow:0 0 8px -4px rgba(0,0,0,.59);min-height:auto;padding:0!important}@media (max-width:768px){.let-rig-sm[_ngcontent-%COMP%]{margin-left:-15px;width:calc(100% + 30px)}}.next[_ngcontent-%COMP%]{color:#ccc}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AkeelaStageComponent, [{
        type: Component,
        args: [{
                selector: 'akeela-stage',
                templateUrl: './akeela-stage.component.html',
                styleUrls: ['./akeela-stage.component.css']
            }]
    }], function () { return [{ type: ActivatedRoute }, { type: AkeelaStageService }, { type: AkeelaStepService }, { type: RouteUtilsService }, { type: Router }, { type: AkeelaWorkflowService }, { type: AkeelaTemplateService }, { type: CreditService }, { type: HttpService }, { type: PathService }, { type: ChangeDetectorRef }]; }, { workflowCode: [{
            type: Input
        }], stageCode: [{
            type: Input
        }], inputPoint: [{
            type: Input
        }], profile: [{
            type: Input
        }], role: [{
            type: Input
        }], transactionNumber: [{
            type: Input
        }], audience: [{
            type: Input
        }] }); })();

// @dynamic
class Mask {
    static getMask(identifier) {
        if (!isNullOrUndefined(identifier)) {
            return this[identifier];
        }
        else {
            return this.mask_tlf; // si no lo ubico me voy por default
        }
    }
}
Mask.mask_tlf = [
    /[+0-9]/,
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    /\d/
];
Mask.mask_tlf_2 = [
    /[+-/(/)0-9]/,
    /[+-/(/)0-9]/,
    /[+-/(/)0-9]/,
    /[+-/(/)0-9]/,
    /[+-/(/)0-9]/,
    /[+-/(/)0-9]/,
    /[+-/(/)0-9]/,
    /[+-/(/)0-9]/,
    /[+-/(/)0-9]/,
    /[+-/(/)0-9]/,
    /[+-/(/)0-9]/,
    /[+-/(/)0-9]/,
    /[+-/(/)0-9]/,
    /[+-/(/)0-9]/,
    /[+-/(/)0-9]/
];
Mask.mask_tlf_3 = [
    /[+-/(/)0-9]/,
    /[+-/(/)0-9]/,
    /[+-/(/)0-9]/,
    /[+-/(/)0-9]/,
    /[+-/(/)0-9]/,
    /[+-/(/)0-9]/,
    /[+-/(/)0-9]/,
    /[+-/(/)0-9]/,
    /[+-/(/)0-9]/,
    /[+-/(/)0-9]/,
    /[+-/(/)0-9]/,
    /[+-/(/)0-9]/,
    /[+-/(/)0-9]/,
    /[+-/(/)0-9]/,
    /[+-/(/)0-9]/,
    /[+-/(/)0-9]/
];
// public static mask_tlf = /(
//     /([1-9]{1})/,
//     /([0-9]{2})/,
//     '-',
//     /([0-9]{7,15})/
//     )/;
Mask.mask_rif = [
    /[V,v,E,e,P,p,G,g,J,j,C,c]/,
    '-',
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    /\d/
];
Mask.mask_identification = [
    /[V,v,E,e,P,p]/,
    '-',
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    /\d/
];
Mask.mask_passport = [
    /[P,p]/,
    '-',
    /[a-zA-Z0-9]/,
    /[a-zA-Z0-9]/,
    /[a-zA-Z0-9]/,
    /[a-zA-Z0-9]/,
    /[a-zA-Z0-9]/,
    /[a-zA-Z0-9]/,
    /[a-zA-Z0-9]/,
    /[a-zA-Z0-9]/,
    /[a-zA-Z0-9]/,
    /[a-zA-Z0-9]/
];
Mask.mask_date = [
    /[0-3]/,
    /[0-9]/,
    '/',
    /[0-9]/,
    /[0-9]/,
    '/',
    /[0-9]/,
    /[0-9]/,
    /[0-9]/,
    /[0-9]/
];
Mask.mask_year = [
    /[1-2]/,
    /[0-9]/,
    /[0-9]/,
    /[0-9]/
];

class AkeelaConditionService {
    constructor(formService, akeelaStepService) {
        this.formService = formService;
        this.akeelaStepService = akeelaStepService;
    }
    applyDependCondition2(formGroup, item) {
        if (item.dataFieldItemDepend) {
            const nameDepend = item.dataFieldItemDepend.alternateName;
            const component = this.formService.getControl(formGroup, nameDepend);
            if (component) {
                this.dataprocess(formGroup, item, component.value);
            }
        }
    }
    applyDependCondition(formGroup, item) {
        if (item.dataFieldItemDepend) {
            const nameDepend = item.dataFieldItemDepend.alternateName;
            const component = this.formService.getControl(formGroup, nameDepend);
            if (component) {
                component.valueChanges.subscribe(value => {
                    this.dataprocess(formGroup, item, value);
                });
            }
        }
    }
    setValue(tmp) {
        if (tmp == 'true' || tmp === true) {
            return true;
        }
        else if (tmp == 'false' || tmp === false) {
            return false;
        }
        else {
            return tmp;
        }
    }
    dataprocess(formGroup, item, value) {
        let conditionValue = false;
        const valueDepend = this.setValue(item.valueDepend);
        const data = this.setValue(value);
        if (!isNullOrUndefined(valueDepend)) {
            if (value instanceof Array) {
                conditionValue = !isNullOrUndefined(data) && data.find(val => val === valueDepend);
            }
            else {
                conditionValue = (data === valueDepend ? true : false);
            }
            const control = this.formService.getControl(formGroup, item.dataFieldItem.alternateName);
            switch (item.actionDepend) {
                case 'SHOW':
                    if (conditionValue) {
                        this.enableControl(formGroup, control, item);
                    }
                    else {
                        this.disableControl(control);
                    }
                    item.hidden = !conditionValue;
                    break;
                case 'HIDE':
                    if (conditionValue) {
                        this.disableControl(control);
                        this.setResetValueField(control, item);
                    }
                    else {
                        this.enableControl(formGroup, control, item);
                    }
                    item.hidden = conditionValue;
                    break;
                case 'DISABLE':
                    if (conditionValue) {
                        control.disable({ onlySelf: true });
                    }
                    else {
                        control.enable();
                        if (this.akeelaStepService.currentStepMode$.getValue()) {
                            let value = control.value;
                            control.patchValue(value);
                            control.disable({ onlySelf: true });
                        }
                    }
                    break;
            }
        }
    }
    disableControl(control) {
        if (!isNullOrUndefined(control)) {
            control.clearValidators();
            control.clearAsyncValidators();
            control.updateValueAndValidity();
        }
    }
    enableControl(formGroup, control, field) {
        let validators = [];
        if (field.dataFieldItem.type === 'input' || field.dataFieldItem.type === 'textarea') {
            validators = AkeelaFormService.createInputFormControlValidators(field);
        }
        if (field.dataFieldItem.type === 'select' || field.dataFieldItem.type === 'select') {
            validators = AkeelaFormService.createSelectFormControlValidators(field);
        }
        if (field.dataFieldItem.type === 'checkbox') {
            validators = AkeelaFormService.createCheckboxFormControlValidators(field);
        }
        const asyncValidators = this.formService.createAsyncValidators(formGroup, field);
        if (!isNullOrUndefined(validators) && !isNullOrUndefined(control)) {
            control.setValidators(validators);
            if (asyncValidators.length > 0) {
                control.setAsyncValidators(asyncValidators);
            }
            control.updateValueAndValidity();
        }
    }
    setResetValueField(control, item) {
        if (!isNullOrUndefined(control)) {
            if (item.defaultProperty) {
                control.setValue(item.defaultProperty);
                control.patchValue(item.defaultProperty);
            }
            else if (item.defaultValue) {
                control.setValue(item.defaultValue);
                control.patchValue(item.defaultValue);
            }
            else {
                control.setValue('');
                control.patchValue('');
            }
        }
    }
}
/** @nocollapse */ AkeelaConditionService.ɵfac = function AkeelaConditionService_Factory(t) { return new (t || AkeelaConditionService)(ɵɵinject(AkeelaFormService), ɵɵinject(AkeelaStepService)); };
/** @nocollapse */ AkeelaConditionService.ɵprov = ɵɵdefineInjectable({ token: AkeelaConditionService, factory: AkeelaConditionService.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AkeelaConditionService, [{
        type: Injectable
    }], function () { return [{ type: AkeelaFormService }, { type: AkeelaStepService }]; }, null); })();

class AkeelaConnectionService {
    constructor(http, urlService, i18nPipe, _util) {
        this.http = http;
        this.urlService = urlService;
        this.i18nPipe = i18nPipe;
        this._util = _util;
        this.request$ = {};
    }
    connect(pathResponse, obj, force) {
        let httpMethod;
        const urlParams = this.urlService.getUrlParams(pathResponse.url);
        const url = this.urlService.replaceAll(pathResponse.url, urlParams, pathResponse.obj);
        const js_event = JSON.parse(pathResponse.jsEvents).find(event => event.f === pathResponse.name);
        switch (pathResponse.httpMethod.toLowerCase()) {
            case 'get':
                httpMethod = this.http.get(url);
                /*
                 console.log("pathResponseawf: ",pathResponse.name);
                 console.log("pathResponseawfurl: ",pathResponse.url);
                 */
                if (!force || (pathResponse.alternateName && pathResponse.alternateName == '$')) {
                    var nameRequest = this.getName(pathResponse.name, urlParams ? urlParams : []);
                    if (isNullOrUndefined(this.request$[nameRequest])) {
                        this.request$[nameRequest] = httpMethod.pipe(shareReplay());
                    }
                    httpMethod = this.request$[nameRequest];
                }
                break;
            case 'post':
                httpMethod = this.http.post(url, obj.objResult);
                break;
            case 'put':
                httpMethod = this.http.put(url, obj.objResult);
                break;
            case 'delete':
                httpMethod = this.http.delete(url);
                break;
        }
        return httpMethod.pipe(map((response) => {
            return response.map(value => {
                return {
                    value: js_event.o.fieldsData ? this._util.extractValueOfObject(value, js_event.o.fieldsData.value) : value.identifier,
                    label: js_event.o.fieldsData ? this.i18nPipe.transform(this._util.extractValueOfObject(value, js_event.o.fieldsData.label)) : this.i18nPipe.transform(value.name),
                    status: !isNullOrUndefined(value.showInList) ? value.showInList : true
                };
            });
        }));
    }
    getName(urlKey, params) {
        const nameArray = [];
        nameArray.push(urlKey);
        Object.keys(params).forEach(key => {
            if (Object.keys(params[key]).length > 0) {
                Object.keys(params[key]).forEach(sKey => {
                    nameArray.push(sKey + '_' + params[key][sKey]);
                });
            }
            else {
                nameArray.push(key + '_' + params[key]);
            }
        });
        return nameArray.join('_');
    }
}
/** @nocollapse */ AkeelaConnectionService.ɵfac = function AkeelaConnectionService_Factory(t) { return new (t || AkeelaConnectionService)(ɵɵinject(HttpClient), ɵɵinject(AkeelaUrlService), ɵɵinject(I18nPipe), ɵɵinject(UtilsService)); };
/** @nocollapse */ AkeelaConnectionService.ɵprov = ɵɵdefineInjectable({ token: AkeelaConnectionService, factory: AkeelaConnectionService.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AkeelaConnectionService, [{
        type: Injectable
    }], function () { return [{ type: HttpClient }, { type: AkeelaUrlService }, { type: I18nPipe }, { type: UtilsService }]; }, null); })();

class AkeelaDatasourceService {
    constructor(akeelaWorkflowService, i18nPipe, connection, path, httpService, _util, localStorage, _auth) {
        this.akeelaWorkflowService = akeelaWorkflowService;
        this.i18nPipe = i18nPipe;
        this.connection = connection;
        this.path = path;
        this.httpService = httpService;
        this._util = _util;
        this.localStorage = localStorage;
        this._auth = _auth;
        this.urlEventResults = {};
        this.urlObservableCache = {};
        this.clientaudience = null;
        this.transactionData = null;
        this.loadSelect$ = new BehaviorSubject({});
    }
    static next(resolve, response) {
        resolve.next(response);
        resolve.complete();
    }
    selectDatasource(field, force) {
        const observableName = field.identifier + '_datasource';
        if (isNullOrUndefined(this.urlObservableCache[observableName])) {
            this.urlObservableCache[observableName] = new Observable(resolve => {
                let dataTemp = this.loadSelect$.getValue();
                dataTemp[field.dataFieldItem.alternateName] = false;
                this.setLoadSelect(dataTemp);
                let options = [];
                const useList = field.dataFieldItem.type === 'select' ||
                    (field.dataFieldItem.type === 'input' && field.dataFieldItem.typeInput === 'radio');
                if (!useList) {
                    AkeelaDatasourceService.next(resolve, []);
                }
                else if (!isNullOrUndefined(field.dataFieldItemList)) { // los datos se encuentran en la lista de items
                    if (field.dataFieldItemList.listItems) {
                        if (field.dataFieldItemList.listItems.length > 0) {
                            options = field.dataFieldItemList.listItems.map(item => {
                                // MARIO:  09/07/2021 se estaba generando un bug en el modal de accionistas, el cual generaba que no se mostrara correctamente los campos del modal accionista
                                // const value = (item.item.name == "true") ? true : (item.item.name == "false" ? false : item.item.name);
                                const value = (this.getValObjectResult(field.dataFieldItemList.nameValueItem, item) === "true") ? true : (this.getValObjectResult(field.dataFieldItemList.nameValueItem, item) === "false" ? false : this.getValObjectResult(field.dataFieldItemList.nameValueItem, item));
                                return { value: value, label: this.i18nPipe.transform(item.name), item: item };
                            });
                            dataTemp = this.loadSelect$.getValue();
                            dataTemp[field.dataFieldItem.alternateName] = false;
                            this.setLoadSelect(dataTemp);
                            AkeelaDatasourceService.next(resolve, options);
                        }
                        else if (!isNullOrUndefined(field.jsEvents)) {
                            try {
                                this.ejecuteListJsEvents(field, resolve);
                            }
                            catch (e) {
                                console.error(e);
                            }
                        }
                    }
                }
                else if (!isNullOrUndefined(field.jsEvents)) {
                    try {
                        this.ejecuteListJsEvents(field, resolve);
                    }
                    catch (e) {
                        console.error(e);
                    }
                }
            }).pipe(share());
            // .pipe(share());
        }
        else {
            /*
            let dataTemp = this.loadSelect$.getValue();
            dataTemp[field.dataFieldItem.alternateName] = true;
            this.setLoadSelect(dataTemp);

            */
        }
        return this.urlObservableCache[observableName];
    }
    getValObjectResult(attributevalue, ThisObj) {
        const attribute = attributevalue.replace('this.', '').split('.');
        if (attribute.length > 1) {
            let prov;
            attribute.forEach((element, index) => {
                if (index === 0) {
                    prov = ThisObj[element];
                }
                else {
                    prov = prov[element];
                }
            });
            return prov;
        }
        else {
            return ThisObj[attributevalue.replace('this.', '')];
        }
    }
    setLoadSelect(loadSelect) {
        this.loadSelect$.next(loadSelect);
    }
    ejecuteListJsEvents(field, resolve) {
        if (field.jsEvents) {
            const jsEvents = JSON.parse(field.jsEvents);
            let urlEvent = jsEvents.find(event => event.e === 'url');
            if (isNullOrUndefined(urlEvent)) {
                urlEvent = jsEvents.find(event => event.e === 'output');
                if (isNullOrUndefined(urlEvent)) {
                    AkeelaDatasourceService.next(resolve, []);
                } /*else {
                urlEvent.f = OutputMockService.parsePropertyUrl(urlEvent.f);
            }*/
            }
            if (!isNullOrUndefined(urlEvent)) {
                if (!isNullOrUndefined(urlEvent.o)) {
                    if (!isNullOrUndefined(urlEvent.o.forceReload)) {
                        this.urlEventResults[urlEvent.f] = null;
                    }
                }
            }
            if ((!isNullOrUndefined(urlEvent) && isNullOrUndefined(this.urlEventResults[urlEvent.f]))) {
                let dataTemp = this.loadSelect$.getValue();
                dataTemp[field.dataFieldItem.alternateName] = true;
                this.setLoadSelect(dataTemp);
                // if (!isNullOrUndefined(urlEvent)) {
                this.akeelaWorkflowService.transactionData$.subscribe((transactionData) => {
                    //if (!isNullOrUndefined(transactionData)) {
                    this.transactionData = transactionData;
                    this.path.getPathService(urlEvent.f).subscribe(pathObject => {
                        var _a, _b;
                        const pathObjectAux = {};
                        // se tiene que reemplazar el path por el que viene en el js_event
                        // let jsEvent = JSON.parse(field.jsEvents).find(event => event.f === pathObject.url);
                        pathObjectAux.name = pathObject.name;
                        pathObjectAux.alternateName = pathObject.alternateName;
                        pathObjectAux.jsEvents = field.jsEvents;
                        pathObjectAux.url = pathObject.url;
                        pathObjectAux.httpMethod = pathObject.httpMethod;
                        pathObjectAux.obj = {
                            workflow: this.akeelaWorkflowService.currentWorkflow$.getValue(),
                            transactionNumber: this.akeelaWorkflowService.transactionNumber$.getValue(),
                            mtWorkflow: (_b = (_a = this.transactionData) === null || _a === void 0 ? void 0 : _a.plan) === null || _b === void 0 ? void 0 : _b.url
                        };
                        let params = null;
                        if (urlEvent.o.params) {
                            if (urlEvent.o.params.request) {
                                if (urlEvent.o.params.request.params) {
                                    params = null;
                                    for (const key of Object.keys(urlEvent.o.params.request.params)) {
                                        const param = urlEvent.o.params.request.params[key];
                                        const objectSplitThis = param.split('.');
                                        let aux = null;
                                        this.clientaudience = this.localStorage.getItem('clientaudience');
                                        if (isNullOrUndefined(aux)) {
                                            let i = 0, replace = false;
                                            objectSplitThis.forEach((element) => {
                                                if (i === 0) {
                                                    aux = this;
                                                }
                                                else {
                                                    if (!isNullOrUndefined(aux[element])) {
                                                        aux = aux[element];
                                                        replace = true;
                                                    }
                                                }
                                                i++;
                                            });
                                            if (!replace) {
                                                aux = null;
                                            }
                                        }
                                        if (key === 'activePlans') {
                                            aux = true;
                                        }
                                        if (aux === '') {
                                            aux = null;
                                        }
                                        if (pathObject.url.indexOf('?') === -1) {
                                            if (isNullOrUndefined(params) && pathObject.url.indexOf('?') === -1) {
                                                params = '?' + key + '=' + aux;
                                            }
                                            else {
                                                if (isNullOrUndefined(params)) {
                                                    params = '&' + key + '=' + aux;
                                                }
                                                else {
                                                    params = params + '&' + key + '=' + aux;
                                                }
                                            }
                                        }
                                        else {
                                            if (isNullOrUndefined(params) && pathObject.url.indexOf('?') === -1) {
                                                params = '?' + key + '=' + param;
                                            }
                                            else {
                                                if (isNullOrUndefined(params)) {
                                                    params = '&' + key + '=' + aux;
                                                }
                                                else {
                                                    params = params + '&' + key + '=' + aux;
                                                }
                                            }
                                        }
                                    }
                                    if (isNullOrUndefined(params)) {
                                        params = '';
                                    }
                                    pathObjectAux.url = pathObjectAux.url + params;
                                }
                            }
                        }
                        this.connection.connect(pathObjectAux, {}, true).subscribe(datasource => {
                            if (!isNullOrUndefined(urlEvent.o.excludeOptions)) {
                                const values_to_exclude = JSON.parse(this.localStorage.getItem(urlEvent.o.excludeOptions));
                                if (!isNullOrUndefined(values_to_exclude)) {
                                    let j = 0;
                                    for (const source of datasource) {
                                        for (let i = 0; i < values_to_exclude.length; i++) {
                                            if (Number(values_to_exclude[i]) === Number(source.value)) {
                                                datasource.splice(j, 1);
                                                datasource[j].status = false;
                                            }
                                        }
                                        j++;
                                    }
                                }
                                this.localStorage.setItem(urlEvent.o.excludeOptions + '_data', JSON.stringify(datasource));
                            }
                            this.urlEventResults[urlEvent.f] = datasource;
                            let dataTemp = this.loadSelect$.getValue();
                            dataTemp[field.dataFieldItem.alternateName] = false;
                            this.setLoadSelect(dataTemp);
                            AkeelaDatasourceService.next(resolve, datasource);
                        });
                    });
                });
            }
            else if (!isNullOrUndefined(urlEvent)) {
                let datasource = this.urlEventResults[urlEvent.f];
                if (!isNullOrUndefined(urlEvent)) {
                    if (!isNullOrUndefined(urlEvent.o)) {
                        if (!isNullOrUndefined(urlEvent.o.excludeOptions)) {
                            datasource = JSON.parse(this.localStorage.getItem(urlEvent.o.excludeOptions + '_data'));
                            if (urlEvent.o.excludeOptions.length > 0) {
                                const values_to_exclude = JSON.parse(this.localStorage.getItem(urlEvent.o.excludeOptions));
                                if (!isNullOrUndefined(values_to_exclude)) {
                                    let j = 0;
                                    for (const source of datasource) {
                                        for (let i = 0; i < values_to_exclude.length; i++) {
                                            if (Number(values_to_exclude[i]) === Number(source.value)) {
                                                datasource.splice(j, 1);
                                            }
                                        }
                                        j++;
                                    }
                                }
                            }
                        }
                    }
                }
                let dataTemp = this.loadSelect$.getValue();
                dataTemp[field.dataFieldItem.alternateName] = false;
                this.setLoadSelect(dataTemp);
                AkeelaDatasourceService.next(resolve, datasource);
            }
        }
    }
    updateDataSource(fieldEvent, alternateNameTemp, identifier, filterObj = null) {
        let dataTemp = this.loadSelect$.getValue();
        dataTemp[alternateNameTemp] = true;
        this.setLoadSelect(dataTemp);
        const observableName = identifier + '_datasource';
        this.urlObservableCache[observableName] = new Observable(resolve => {
            if (filterObj) {
                const urlPath = OutputMockService.parsePropertyUrl(filterObj.url);
                const obj = {
                    request: filterObj.params,
                    path: filterObj.params
                };
                this.httpService.executeRequest(urlPath, obj, true).subscribe((response) => {
                    const options = [];
                    if (!isNullOrUndefined(response)) {
                        for (const row of Object.keys(response)) {
                            options.push({
                                value: filterObj.jsEvent.o.fieldsData ? this._util.extractValueOfObject(response[row], filterObj.jsEvent.o.fieldsData.value) : response[row].identifier,
                                label: filterObj.jsEvent.o.fieldsData ? this.i18nPipe.transform(this._util.extractValueOfObject(response[row], filterObj.jsEvent.o.fieldsData.label)) : this.i18nPipe.transform(response[row].name)
                            });
                        }
                    }
                    let dataTemp = this.loadSelect$.getValue();
                    dataTemp[alternateNameTemp] = false;
                    this.setLoadSelect(dataTemp);
                    resolve.next(options);
                    resolve.complete();
                }, (error) => {
                    let dataTemp = this.loadSelect$.getValue();
                    dataTemp[alternateNameTemp] = false;
                    this.setLoadSelect(dataTemp);
                    resolve.next([]);
                    resolve.complete();
                });
            }
            else {
                let dataTemp = this.loadSelect$.getValue();
                dataTemp[alternateNameTemp] = false;
                this.setLoadSelect(dataTemp);
                resolve.next([]);
                resolve.complete();
            }
        }).pipe(share());
    }
}
/** @nocollapse */ AkeelaDatasourceService.ɵfac = function AkeelaDatasourceService_Factory(t) { return new (t || AkeelaDatasourceService)(ɵɵinject(AkeelaWorkflowService), ɵɵinject(I18nPipe), ɵɵinject(AkeelaConnectionService), ɵɵinject(PathService), ɵɵinject(HttpService), ɵɵinject(UtilsService), ɵɵinject(LocalService), ɵɵinject(AuthService)); };
/** @nocollapse */ AkeelaDatasourceService.ɵprov = ɵɵdefineInjectable({ token: AkeelaDatasourceService, factory: AkeelaDatasourceService.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AkeelaDatasourceService, [{
        type: Injectable
    }], function () { return [{ type: AkeelaWorkflowService }, { type: I18nPipe }, { type: AkeelaConnectionService }, { type: PathService }, { type: HttpService }, { type: UtilsService }, { type: LocalService }, { type: AuthService }]; }, null); })();

class AkeelaEventService {
    getEvents(field) {
        var _a;
        const eventsArray = (_a = field === null || field === void 0 ? void 0 : field.alternateName) === null || _a === void 0 ? void 0 : _a.split(';');
        const events = {};
        if (eventsArray) {
            eventsArray.forEach(event => {
                const eventArray = event.split('=');
                events[eventArray[0]] = eventArray[1];
            });
        }
        return events;
    }
    getEvent(field, eventName) {
        const events = this.getEvents(field);
        let event = '';
        if (!isNullOrUndefined(events['UNIQUE_EVENT'])) {
            event = events['UNIQUE_EVENT'];
        }
        else {
            event = events[eventName];
        }
        return event;
    }
}
/** @nocollapse */ AkeelaEventService.ɵfac = function AkeelaEventService_Factory(t) { return new (t || AkeelaEventService)(); };
/** @nocollapse */ AkeelaEventService.ɵprov = ɵɵdefineInjectable({ token: AkeelaEventService, factory: AkeelaEventService.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AkeelaEventService, [{
        type: Injectable
    }], null, null); })();

class AkeelaValidatorService {
    getErrors(form, fieldName) {
        const fieldItemIdentifier = AkeelaFormService.getFieldIdentifier(fieldName);
    }
    isValid(form, fieldName) {
        const fieldItemIdentifier = AkeelaFormService.getFieldIdentifier(fieldName);
        if (isNullOrUndefined(form.get(fieldItemIdentifier))) {
            return true;
        }
        return form.get(fieldItemIdentifier).valid && !form.get(fieldItemIdentifier).pristine;
    }
    isInvalid(form, fieldName) {
        const fieldItemIdentifier = AkeelaFormService.getFieldIdentifier(fieldName);
        if (isNullOrUndefined(form.get(fieldItemIdentifier))) {
            return false;
        }
        return form.get(fieldItemIdentifier).invalid && !form.get(fieldItemIdentifier).pristine;
    }
    hasRequiredError(form, fieldName) {
        const fieldItemIdentifier = AkeelaFormService.getFieldIdentifier(fieldName);
        if (!form.get(fieldItemIdentifier).errors) {
            return false;
        }
        return form.get(fieldItemIdentifier).errors.required
            && !form.get(fieldItemIdentifier).pristine;
    }
    hasMaxError(form, fieldName) {
        const fieldItemIdentifier = AkeelaFormService.getFieldIdentifier(fieldName);
        if (!form.get(fieldItemIdentifier).errors) {
            return false;
        }
        return form.get(fieldItemIdentifier).errors.max &&
            !form.get(fieldItemIdentifier).pristine;
    }
    hasMinError(form, fieldName) {
        const fieldItemIdentifier = AkeelaFormService.getFieldIdentifier(fieldName);
        if (!form.get(fieldItemIdentifier).errors) {
            return false;
        }
        return form.get(fieldItemIdentifier).errors.min && !form.get(fieldItemIdentifier).pristine;
    }
    hasPatternError(form, fieldName) {
        const fieldItemIdentifier = AkeelaFormService.getFieldIdentifier(fieldName);
        if (!form.get(fieldItemIdentifier).errors) {
            return false;
        }
        return form.get(fieldItemIdentifier).errors.pattern && !form.get(fieldItemIdentifier).pristine;
    }
    validatePattern(event, field) {
        console.log('validando');
        console.log(event);
        if (!isNullOrUndefined(field.dataFieldItem.pattern)) {
            const _pattern = new RegExp(field.dataFieldItem.pattern);
            const inputChar = String.fromCharCode(event.which);
            console.log(event.key);
            console.log(_pattern.test(inputChar));
            return !!_pattern.test(inputChar);
        }
    }
    hasMaxLengthError(form, fieldName) {
        const fieldItemIdentifier = AkeelaFormService.getFieldIdentifier(fieldName);
        if (!form.get(fieldItemIdentifier).errors) {
            return false;
        }
        return form.get(fieldItemIdentifier).errors.maxlength && !form.get(fieldItemIdentifier).pristine;
    }
    hasMinLengthError(form, fieldName) {
        const fieldItemIdentifier = AkeelaFormService.getFieldIdentifier(fieldName);
        if (!form.get(fieldItemIdentifier).errors) {
            return false;
        }
        return form.get(fieldItemIdentifier).errors.minlength && !form.get(fieldItemIdentifier).pristine;
    }
    hasEmailError(form, fieldName) {
        const fieldItemIdentifier = AkeelaFormService.getFieldIdentifier(fieldName);
        if (!form.get(fieldItemIdentifier).errors) {
            return false;
        }
        return form.get(fieldItemIdentifier).errors.email && !form.get(fieldItemIdentifier).pristine;
    }
    hasPasswordDistinctError(form, fieldName) {
        const fieldItemIdentifier = AkeelaFormService.getFieldIdentifier(fieldName);
        if (!form.get(fieldItemIdentifier).errors) {
            return false;
        }
        return form.get(fieldItemIdentifier).errors.passwordDistinct && !form.get(fieldItemIdentifier).pristine;
    }
    hasValidateDateError(form, fieldName) {
        const fieldItemIdentifier = AkeelaFormService.getFieldIdentifier(fieldName);
        if (!form.get(fieldItemIdentifier).errors) {
            return false;
        }
        return form.get(fieldItemIdentifier).errors.ValidateDate && !form.get(fieldItemIdentifier).pristine;
    }
    hasValidateDateUpperError(form, fieldName) {
        const fieldItemIdentifier = AkeelaFormService.getFieldIdentifier(fieldName);
        if (!form.get(fieldItemIdentifier).errors) {
            return false;
        }
        return form.get(fieldItemIdentifier).errors.ValidateDateUpper && !form.get(fieldItemIdentifier).pristine;
    }
    hasValidateDateLowerError(form, fieldName) {
        const fieldItemIdentifier = AkeelaFormService.getFieldIdentifier(fieldName);
        if (!form.get(fieldItemIdentifier).errors) {
            return false;
        }
        return form.get(fieldItemIdentifier).errors.ValidateDateLower && !form.get(fieldItemIdentifier).pristine;
    }
    hasValidationError(form, fieldName) {
        const fieldItemIdentifier = AkeelaFormService.getFieldIdentifier(fieldName);
        if (!form.get(fieldItemIdentifier).errors) {
            return false;
        }
        return form.get(fieldItemIdentifier).errors.existe && !form.get(fieldItemIdentifier).pristine;
    }
    hasValidationExistError(form, fieldName) {
        const fieldItemIdentifier = AkeelaFormService.getFieldIdentifier(fieldName);
        if (!form.get(fieldItemIdentifier).errors) {
            return false;
        }
        return form.get(fieldItemIdentifier).errors.valid && !form.get(fieldItemIdentifier).pristine;
    }
    hasValidateDate18Error(form, fieldName) {
        const fieldItemIdentifier = AkeelaFormService.getFieldIdentifier(fieldName);
        if (!form.get(fieldItemIdentifier).errors) {
            return false;
        }
        return form.get(fieldItemIdentifier).errors.ValidateDate18 && !form.get(fieldItemIdentifier).pristine;
    }
    hasValidatePhoneError(form, fieldName) {
        const fieldItemIdentifier = AkeelaFormService.getFieldIdentifier(fieldName);
        let dd = form.get(fieldItemIdentifier).errors;
        if (!form.get(fieldItemIdentifier).errors) {
            return false;
        }
        return form.get(fieldItemIdentifier).errors.ValidatePhone && !form.get(fieldItemIdentifier).pristine;
    }
    hasValidateEmailError(form, fieldName) {
        const fieldItemIdentifier = AkeelaFormService.getFieldIdentifier(fieldName);
        let dd = form.get(fieldItemIdentifier).errors;
        if (!form.get(fieldItemIdentifier).errors) {
            return false;
        }
        return form.get(fieldItemIdentifier).errors.ValidateEmail && !form.get(fieldItemIdentifier).pristine;
    }
    hasValidateRangeValueProductError(form, fieldName) {
        const fieldItemIdentifier = AkeelaFormService.getFieldIdentifier(fieldName);
        let dd = form.get(fieldItemIdentifier).errors;
        if (!form.get(fieldItemIdentifier).errors) {
            return false;
        }
        return (form.get(fieldItemIdentifier).errors.ValidateRangeValueProduct && !form.get(fieldItemIdentifier).pristine) ? form.get(fieldItemIdentifier).errors.ValidateRangeValueProduct : null;
    }
}
/** @nocollapse */ AkeelaValidatorService.ɵfac = function AkeelaValidatorService_Factory(t) { return new (t || AkeelaValidatorService)(); };
/** @nocollapse */ AkeelaValidatorService.ɵprov = ɵɵdefineInjectable({ token: AkeelaValidatorService, factory: AkeelaValidatorService.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AkeelaValidatorService, [{
        type: Injectable
    }], null, null); })();

const VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => MultiSelectComponent),
    multi: true
};
class MultiSelectComponent {
    constructor() {
        this.options = [];
        this.dropdownSettings = {
            singleSelection: false,
            idField: 'value',
            textField: 'label',
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            itemsShowLimit: 3,
            allowSearchFilter: false,
            enableCheckAll: false
        };
        this.onChange = (_) => { };
        this.onTouch = () => { };
    }
    ngOnInit() {
    }
    ngOnChanges(changes) {
        if (!isNullOrUndefined(changes.options)) {
            this.updateValue();
        }
    }
    onChangeValue(event) {
        // this.value = event.value;
        const valueArr = this.value.map((value) => value.value);
        // if (event.target.value === []) {
        //     valueArr = [];
        // }
        this.onTouch();
        this.onChange(valueArr);
    }
    writeValue(value) {
        this.value = value || [];
        if (!(value instanceof Array)) {
            value = [value];
        }
        if (this.value.length > 0 && isNullOrUndefined(this.value[0]['value'])) {
            this.updateValue();
        }
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouch = fn;
    }
    setDisabledState(isDisabled) {
        this.isDisabled = isDisabled;
    }
    updateValue() {
        // filter only options active
        if (!isNullOrUndefined(this.options)) {
            this.options = this.options.filter(option => {
                return option.status === true;
            });
        }
        const selected = [];
        if (!isNullOrUndefined(this.value) && !isNullOrUndefined(this.options)) {
            this.value.forEach(item => {
                const optSelected = this.options.find(option => option.value === item);
                if (!isNullOrUndefined(optSelected)) {
                    selected.push(optSelected);
                }
            });
            this.value = selected;
        }
    }
}
/** @nocollapse */ MultiSelectComponent.ɵfac = function MultiSelectComponent_Factory(t) { return new (t || MultiSelectComponent)(); };
/** @nocollapse */ MultiSelectComponent.ɵcmp = ɵɵdefineComponent({ type: MultiSelectComponent, selectors: [["akeela-multi-select"]], inputs: { options: "options", placeholder: "placeholder" }, features: [ɵɵProvidersFeature([VALUE_ACCESSOR]), ɵɵNgOnChangesFeature], decls: 1, vars: 4, consts: [[3, "placeholder", "data", "ngModel", "settings", "ngModelChange", "onSelect", "onSelectAll", "onDeSelect", "onDeSelectAll"]], template: function MultiSelectComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "ng-multiselect-dropdown", 0);
        ɵɵlistener("ngModelChange", function MultiSelectComponent_Template_ng_multiselect_dropdown_ngModelChange_0_listener($event) { return ctx.value = $event; })("onSelect", function MultiSelectComponent_Template_ng_multiselect_dropdown_onSelect_0_listener($event) { return ctx.onChangeValue($event); })("onSelectAll", function MultiSelectComponent_Template_ng_multiselect_dropdown_onSelectAll_0_listener($event) { return ctx.onChangeValue($event); })("onDeSelect", function MultiSelectComponent_Template_ng_multiselect_dropdown_onDeSelect_0_listener($event) { return ctx.onChangeValue($event); })("onDeSelectAll", function MultiSelectComponent_Template_ng_multiselect_dropdown_onDeSelectAll_0_listener($event) { return ctx.onChangeValue($event); });
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵproperty("placeholder", ctx.placeholder)("data", ctx.options)("ngModel", ctx.value)("settings", ctx.dropdownSettings);
    } }, directives: [MultiSelectComponent$1, NgControlStatus, NgModel, NativeElementInjectorDirective], styles: [""] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(MultiSelectComponent, [{
        type: Component,
        args: [{
                selector: 'akeela-multi-select',
                templateUrl: './multi-select.component.html',
                styleUrls: ['./multi-select.component.css'],
                providers: [VALUE_ACCESSOR]
            }]
    }], function () { return []; }, { options: [{
            type: Input
        }], placeholder: [{
            type: Input
        }] }); })();

function AkeelaSectionComponent_div_1_div_1_h4_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "h4", 10);
    ɵɵpipe(1, "i18n");
} if (rf & 2) {
    const ctx_r11 = ɵɵnextContext(3);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(1, 1, ctx_r11.section.sectionTitle), ɵɵsanitizeHtml);
} }
const _c0$3 = function (a0) { return { "dropdown-header-border": a0 }; };
function AkeelaSectionComponent_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r13 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 8);
    ɵɵlistener("click", function AkeelaSectionComponent_div_1_div_1_Template_div_click_0_listener() { ɵɵrestoreView(_r13); const ctx_r12 = ɵɵnextContext(2); return ctx_r12.isSectionOpened = !ctx_r12.isSectionOpened; });
    ɵɵtemplate(1, AkeelaSectionComponent_div_1_div_1_h4_1_Template, 2, 3, "h4", 9);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵɵnextContext(2);
    ɵɵproperty("ngClass", ɵɵpureFunction1(2, _c0$3, ctx_r4.isSectionOpened));
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r4.section == null ? null : ctx_r4.section.sectionTitle);
} }
function AkeelaSectionComponent_div_1_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" section: ", ctx_r5.section == null ? null : ctx_r5.section.alternateName, " ");
} }
function AkeelaSectionComponent_div_1_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "div", 11);
    ɵɵpipe(1, "i18n");
} if (rf & 2) {
    const description_r14 = ctx.$implicit;
    ɵɵclassMapInterpolate1("d-none ", description_r14 == null ? null : description_r14.cssClass, "");
    ɵɵclassProp("d-block", description_r14 && (description_r14 == null ? null : description_r14.direction) == "top");
    ɵɵproperty("innerHTML", ɵɵpipeBind1(1, 6, description_r14 == null ? null : description_r14.i18n), ɵɵsanitizeHtml);
} }
function AkeelaSectionComponent_div_1_div_6_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainer(0);
} }
const _c1 = function (a0) { return { sub_section: a0 }; };
function AkeelaSectionComponent_div_1_div_6_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵtemplate(1, AkeelaSectionComponent_div_1_div_6_ng_container_1_Template, 1, 0, "ng-container", 12);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = ɵɵnextContext(2);
    const _r2 = ɵɵreference(4);
    ɵɵclassMapInterpolate1("", ctx_r7.section == null ? null : ctx_r7.section.cssClass, "  pl-0 pr-0");
    ɵɵadvance(1);
    ɵɵproperty("ngTemplateOutlet", _r2)("ngTemplateOutletContext", ɵɵpureFunction1(5, _c1, ctx_r7.section));
} }
function AkeelaSectionComponent_div_1_ng_container_7_div_7_ng_container_1_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵtext(1);
    ɵɵelement(2, "br");
    ɵɵtext(3);
    ɵɵelement(4, "br");
    ɵɵtext(5);
    ɵɵelement(6, "br");
    ɵɵelementEnd();
} if (rf & 2) {
    const sub_section_r17 = ɵɵnextContext(2).$implicit;
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" sub_section: ", sub_section_r17 == null ? null : sub_section_r17.alternateName, " ");
    ɵɵadvance(2);
    ɵɵtextInterpolate1(" url: ", sub_section_r17 == null ? null : sub_section_r17.url, " ");
    ɵɵadvance(2);
    ɵɵtextInterpolate1(" componentName: ", sub_section_r17 == null ? null : sub_section_r17.componentName, " ");
} }
function AkeelaSectionComponent_div_1_ng_container_7_div_7_ng_container_1_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainer(0);
} }
function AkeelaSectionComponent_div_1_ng_container_7_div_7_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, AkeelaSectionComponent_div_1_ng_container_7_div_7_ng_container_1_div_1_Template, 7, 3, "div", 2);
    ɵɵtemplate(2, AkeelaSectionComponent_div_1_ng_container_7_div_7_ng_container_1_ng_container_2_Template, 1, 0, "ng-container", 12);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const sub_section_r17 = ɵɵnextContext().$implicit;
    const ctx_r18 = ɵɵnextContext(3);
    const _r2 = ɵɵreference(4);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r18.modeDebug);
    ɵɵadvance(1);
    ɵɵproperty("ngTemplateOutlet", _r2)("ngTemplateOutletContext", ɵɵpureFunction1(3, _c1, sub_section_r17));
} }
function AkeelaSectionComponent_div_1_ng_container_7_div_7_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵtemplate(1, AkeelaSectionComponent_div_1_ng_container_7_div_7_ng_container_1_Template, 3, 5, "ng-container", 2);
    ɵɵelementEnd();
} if (rf & 2) {
    const sub_section_r17 = ctx.$implicit;
    const ctx_r16 = ɵɵnextContext(3);
    ɵɵclassMapInterpolate1("", sub_section_r17 == null ? null : sub_section_r17.cssClass, "  pl-0 pr-0");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", !(ctx_r16.hideSections[sub_section_r17 == null ? null : sub_section_r17.alternateName] == true));
} }
function AkeelaSectionComponent_div_1_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "div", 13);
    ɵɵelementStart(2, "div");
    ɵɵelementStart(3, "div", 14);
    ɵɵelement(4, "img", 15);
    ɵɵelementEnd();
    ɵɵelementStart(5, "div", 16);
    ɵɵtext(6, "Cargado datos... ");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵtemplate(7, AkeelaSectionComponent_div_1_ng_container_7_div_7_Template, 2, 4, "div", 17);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r8 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵclassProp("d-none", !ctx_r8.sectionsLoading)("capa-sections", ctx_r8.sectionsLoading);
    ɵɵadvance(6);
    ɵɵproperty("ngForOf", ctx_r8.section == null ? null : ctx_r8.section.sections);
} }
function AkeelaSectionComponent_div_1_div_8_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "div", 11);
    ɵɵpipe(1, "i18n");
} if (rf & 2) {
    const description_r23 = ctx.$implicit;
    ɵɵclassMapInterpolate1("d-none ", description_r23 == null ? null : description_r23.cssClass, "");
    ɵɵclassProp("d-block", description_r23 && (description_r23 == null ? null : description_r23.direction) == "bottom");
    ɵɵproperty("innerHTML", ɵɵpipeBind1(1, 6, description_r23 == null ? null : description_r23.i18n), ɵɵsanitizeHtml);
} }
function AkeelaSectionComponent_div_1_div_9_div_9_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵelement(1, "span", 27);
    ɵɵpipe(2, "i18n");
    ɵɵelementEnd();
} if (rf & 2) {
    const sub_section_r26 = ɵɵnextContext(2).$implicit;
    ɵɵadvance(1);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(2, 1, sub_section_r26.sectionTitle), ɵɵsanitizeHtml);
} }
function AkeelaSectionComponent_div_1_div_9_div_9_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r34 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 24);
    ɵɵtemplate(1, AkeelaSectionComponent_div_1_div_9_div_9_div_1_div_1_Template, 3, 3, "div", 2);
    ɵɵelementStart(2, "div", 25);
    ɵɵlistener("click", function AkeelaSectionComponent_div_1_div_9_div_9_div_1_Template_div_click_2_listener() { ɵɵrestoreView(_r34); const ctx_r33 = ɵɵnextContext(4); ctx_r33.setBackUrl(); return ctx_r33.akeelaSectionService.hideModalSection(ctx_r33.section == null ? null : ctx_r33.section.alternateName); });
    ɵɵelement(3, "i", 26);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const sub_section_r26 = ɵɵnextContext().$implicit;
    ɵɵadvance(1);
    ɵɵproperty("ngIf", sub_section_r26 == null ? null : sub_section_r26.sectionTitle);
} }
function AkeelaSectionComponent_div_1_div_9_div_9_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵtext(1);
    ɵɵelement(2, "br");
    ɵɵtext(3);
    ɵɵelement(4, "br");
    ɵɵtext(5);
    ɵɵelement(6, "br");
    ɵɵelementEnd();
} if (rf & 2) {
    const sub_section_r26 = ɵɵnextContext().$implicit;
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" sub_section: ", sub_section_r26 == null ? null : sub_section_r26.alternateName, " ");
    ɵɵadvance(2);
    ɵɵtextInterpolate1(" url: ", sub_section_r26 == null ? null : sub_section_r26.url, " ");
    ɵɵadvance(2);
    ɵɵtextInterpolate1(" componentName: ", sub_section_r26 == null ? null : sub_section_r26.componentName, " ");
} }
function AkeelaSectionComponent_div_1_div_9_div_9_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainer(0);
} }
function AkeelaSectionComponent_div_1_div_9_div_9_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵtemplate(1, AkeelaSectionComponent_div_1_div_9_div_9_div_1_Template, 4, 1, "div", 23);
    ɵɵtemplate(2, AkeelaSectionComponent_div_1_div_9_div_9_div_2_Template, 7, 3, "div", 2);
    ɵɵtemplate(3, AkeelaSectionComponent_div_1_div_9_div_9_ng_container_3_Template, 1, 0, "ng-container", 12);
    ɵɵelementEnd();
} if (rf & 2) {
    const sub_section_r26 = ctx.$implicit;
    const i_r27 = ctx.index;
    const ctx_r24 = ɵɵnextContext(3);
    const _r2 = ɵɵreference(4);
    ɵɵclassMap(sub_section_r26 == null ? null : sub_section_r26.cssClass);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", i_r27 == 0);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r24.modeDebug);
    ɵɵadvance(1);
    ɵɵproperty("ngTemplateOutlet", _r2)("ngTemplateOutletContext", ɵɵpureFunction1(7, _c1, sub_section_r26));
} }
function AkeelaSectionComponent_div_1_div_9_div_10_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainer(0);
} }
function AkeelaSectionComponent_div_1_div_9_div_10_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵtemplate(1, AkeelaSectionComponent_div_1_div_9_div_10_ng_container_1_Template, 1, 0, "ng-container", 12);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r25 = ɵɵnextContext(3);
    const _r2 = ɵɵreference(4);
    ɵɵclassMapInterpolate1("", ctx_r25.section == null ? null : ctx_r25.section.cssClass, " ");
    ɵɵadvance(1);
    ɵɵproperty("ngTemplateOutlet", _r2)("ngTemplateOutletContext", ɵɵpureFunction1(5, _c1, ctx_r25.section));
} }
const _c2 = function (a0) { return { "z-index": a0 }; };
function AkeelaSectionComponent_div_1_div_9_Template(rf, ctx) { if (rf & 1) {
    const _r39 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 18);
    ɵɵelementStart(1, "div", 19);
    ɵɵelementStart(2, "div", 18);
    ɵɵelementStart(3, "div", 20);
    ɵɵelementStart(4, "div", 21);
    ɵɵlistener("click", function AkeelaSectionComponent_div_1_div_9_Template_div_click_4_listener() { ɵɵrestoreView(_r39); const ctx_r38 = ɵɵnextContext(2); ctx_r38.setBackUrl(); return ctx_r38.akeelaSectionService.hideModalSection(ctx_r38.section == null ? null : ctx_r38.section.alternateName); });
    ɵɵelementStart(5, "div", 22);
    ɵɵlistener("click", function AkeelaSectionComponent_div_1_div_9_Template_div_click_5_listener($event) { ɵɵrestoreView(_r39); return $event == null ? null : $event.stopPropagation(); });
    ɵɵelementStart(6, "div", 18);
    ɵɵelementStart(7, "div", 18);
    ɵɵelementContainerStart(8);
    ɵɵtemplate(9, AkeelaSectionComponent_div_1_div_9_div_9_Template, 4, 9, "div", 17);
    ɵɵelementContainerEnd();
    ɵɵtemplate(10, AkeelaSectionComponent_div_1_div_9_div_10_Template, 2, 7, "div", 1);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = ɵɵnextContext(2);
    ɵɵadvance(3);
    ɵɵproperty("ngStyle", ɵɵpureFunction1(3, _c2, ctx_r10.akeelaSectionService.getZindex(ctx_r10.section.alternateName)));
    ɵɵadvance(6);
    ɵɵproperty("ngForOf", ctx_r10.section == null ? null : ctx_r10.section.sections);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r10.useMainSection());
} }
function AkeelaSectionComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵtemplate(1, AkeelaSectionComponent_div_1_div_1_Template, 2, 4, "div", 4);
    ɵɵelementStart(2, "div");
    ɵɵtemplate(3, AkeelaSectionComponent_div_1_div_3_Template, 2, 1, "div", 2);
    ɵɵtemplate(4, AkeelaSectionComponent_div_1_div_4_Template, 2, 8, "div", 5);
    ɵɵelementStart(5, "div", 6);
    ɵɵtemplate(6, AkeelaSectionComponent_div_1_div_6_Template, 2, 7, "div", 1);
    ɵɵtemplate(7, AkeelaSectionComponent_div_1_ng_container_7_Template, 8, 5, "ng-container", 2);
    ɵɵelementEnd();
    ɵɵtemplate(8, AkeelaSectionComponent_div_1_div_8_Template, 2, 8, "div", 5);
    ɵɵelementEnd();
    ɵɵtemplate(9, AkeelaSectionComponent_div_1_div_9_Template, 11, 5, "div", 7);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵclassMapInterpolate1("ak-section col-12 ", ctx_r0.section == null ? null : ctx_r0.section.cssClass, "");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r0.section.additionalType == "list");
    ɵɵadvance(1);
    ɵɵclassProp("d-none", !((ctx_r0.section == null ? null : ctx_r0.section.additionalType) != "modal"));
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r0.modeDebug);
    ɵɵadvance(1);
    ɵɵproperty("ngForOf", ctx_r0.getJson(ctx_r0.section == null ? null : ctx_r0.section.description));
    ɵɵadvance(2);
    ɵɵproperty("ngIf", ctx_r0.useMainSection());
    ɵɵadvance(1);
    ɵɵproperty("ngIf", !ctx_r0.useMainSection());
    ɵɵadvance(1);
    ɵɵproperty("ngForOf", ctx_r0.getJson(ctx_r0.section == null ? null : ctx_r0.section.description));
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r0.akeelaSectionService.modalIsVisible(ctx_r0.section == null ? null : ctx_r0.section.alternateName) && (ctx_r0.section == null ? null : ctx_r0.section.additionalType) == "modal");
} }
function AkeelaSectionComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "div", 28);
    ɵɵelement(2, "div", 11);
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵɵnextContext();
    ɵɵadvance(2);
    ɵɵproperty("innerHTML", ctx_r1.isHtmlRightTemplete(ctx_r1.section == null ? null : ctx_r1.section.alternateName), ɵɵsanitizeHtml);
} }
function AkeelaSectionComponent_ng_template_3_div_0_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 34);
    ɵɵelement(1, "span", 11);
    ɵɵpipe(2, "i18n");
    ɵɵelementEnd();
} if (rf & 2) {
    const sub_section_r41 = ɵɵnextContext(2).sub_section;
    ɵɵadvance(1);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(2, 1, sub_section_r41.sectionTitle), ɵɵsanitizeHtml);
} }
function AkeelaSectionComponent_ng_template_3_div_0_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "div", 35);
    ɵɵpipe(1, "i18n");
} if (rf & 2) {
    const sub_section_r41 = ɵɵnextContext(2).sub_section;
    ɵɵproperty("innerHTML", ɵɵpipeBind1(1, 1, sub_section_r41.description), ɵɵsanitizeHtml);
} }
function AkeelaSectionComponent_ng_template_3_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 30);
    ɵɵtemplate(1, AkeelaSectionComponent_ng_template_3_div_0_div_1_Template, 3, 3, "div", 31);
    ɵɵpipe(2, "i18n");
    ɵɵtemplate(3, AkeelaSectionComponent_ng_template_3_div_0_div_3_Template, 2, 3, "div", 32);
    ɵɵpipe(4, "i18n");
    ɵɵelementContainer(5, 33);
    ɵɵelementEnd();
} if (rf & 2) {
    const sub_section_r41 = ɵɵnextContext().sub_section;
    const ctx_r42 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("ngIf", sub_section_r41 && ctx_r42.isNotNullOrUndefined(ɵɵpipeBind1(2, 3, sub_section_r41 == null ? null : sub_section_r41.sectionTitle)) && (ctx_r42.isFieldNotRequired || ctx_r42.isSectionNotRequired[sub_section_r41.identifier] && !ctx_r42.isFieldNotRequired));
    ɵɵadvance(2);
    ɵɵproperty("ngIf", sub_section_r41 && ctx_r42.isNotNullOrUndefined(ɵɵpipeBind1(4, 5, sub_section_r41 == null ? null : sub_section_r41.description)) && !sub_section_r41.hidden);
    ɵɵadvance(2);
    ɵɵproperty("ngTemplateOutlet", ctx_r42.templates[sub_section_r41 == null ? null : sub_section_r41.componentName]);
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 40);
    ɵɵelement(1, "span", 11);
    ɵɵpipe(2, "i18n");
    ɵɵelementEnd();
} if (rf & 2) {
    const sub_section_r41 = ɵɵnextContext(2).sub_section;
    ɵɵadvance(1);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(2, 1, sub_section_r41.sectionTitle), ɵɵsanitizeHtml);
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "div", 41);
    ɵɵpipe(1, "i18n");
} if (rf & 2) {
    const sub_section_r41 = ɵɵnextContext(2).sub_section;
    ɵɵproperty("innerHTML", ɵɵpipeBind1(1, 1, sub_section_r41.description), ɵɵsanitizeHtml);
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 50);
    ɵɵelement(1, "span", 11);
    ɵɵpipe(2, "i18n");
    ɵɵelementEnd();
} if (rf & 2) {
    const field_r55 = ɵɵnextContext(3).$implicit;
    ɵɵadvance(1);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(2, 1, field_r55 == null ? null : field_r55.dataFieldItem == null ? null : field_r55.dataFieldItem.label), ɵɵsanitizeHtml);
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵelement(1, "br");
    ɵɵtext(2);
    ɵɵelement(3, "br");
    ɵɵtext(4);
    ɵɵelement(5, "br");
    ɵɵelement(6, "br");
    ɵɵtext(7);
    ɵɵelement(8, "br");
    ɵɵelement(9, "br");
    ɵɵtext(10);
    ɵɵelement(11, "br");
    ɵɵelement(12, "br");
    ɵɵtext(13);
    ɵɵelement(14, "br");
    ɵɵelement(15, "br");
    ɵɵtext(16);
    ɵɵelement(17, "br");
    ɵɵelement(18, "br");
    ɵɵtext(19);
    ɵɵelement(20, "br");
    ɵɵtext(21);
    ɵɵelement(22, "br");
    ɵɵelement(23, "br");
    ɵɵtext(24);
    ɵɵelement(25, "br");
    ɵɵelementEnd();
} if (rf & 2) {
    const field_r55 = ɵɵnextContext(3).$implicit;
    const sub_section_r41 = ɵɵnextContext(2).sub_section;
    const ctx_r59 = ɵɵnextContext();
    ɵɵadvance(2);
    ɵɵtextInterpolate1("id_attr : ", field_r55.dataFieldItem.identifier, " ");
    ɵɵadvance(2);
    ɵɵtextInterpolate1("id : ", field_r55.identifier, " ");
    ɵɵadvance(3);
    ɵɵtextInterpolate1("orderAttribute : ", field_r55.orderAttribute, " ");
    ɵɵadvance(3);
    ɵɵtextInterpolate1(" name : ", field_r55.dataFieldItem.name, " ");
    ɵɵadvance(3);
    ɵɵtextInterpolate1(" alternateName : ", field_r55.dataFieldItem.alternateName, " ");
    ɵɵadvance(3);
    ɵɵtextInterpolate1(" label : ", field_r55 == null ? null : field_r55.dataFieldItem == null ? null : field_r55.dataFieldItem.label, " ");
    ɵɵadvance(3);
    ɵɵtextInterpolate1("jsEvents : ", field_r55.jsEvents, " ");
    ɵɵadvance(2);
    ɵɵtextInterpolate1("pattern : ", field_r55 == null ? null : field_r55.dataFieldItem == null ? null : field_r55.dataFieldItem.pattern, " ");
    ɵɵadvance(3);
    ɵɵtextInterpolate1("status : ", ctx_r59.getGroup(sub_section_r41.identifier, field_r55).status, " ");
} }
const _c3 = function (a0, a1) { return { "error": a0, "valid": a1 }; };
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r109 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 51);
    ɵɵelementStart(1, "input", 58);
    ɵɵlistener("keyup", function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_1_Template_input_keyup_1_listener($event) { ɵɵrestoreView(_r109); const field_r55 = ɵɵnextContext(4).$implicit; const sub_section_r41 = ɵɵnextContext(2).sub_section; const ctx_r108 = ɵɵnextContext(); return ctx_r108.call_fn($event, sub_section_r41.identifier, field_r55); })("change", function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_1_Template_input_change_1_listener($event) { ɵɵrestoreView(_r109); const field_r55 = ɵɵnextContext(4).$implicit; const sub_section_r41 = ɵɵnextContext(2).sub_section; const ctx_r112 = ɵɵnextContext(); return ctx_r112.call_fn($event, sub_section_r41.identifier, field_r55); })("click", function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_1_Template_input_click_1_listener($event) { ɵɵrestoreView(_r109); const field_r55 = ɵɵnextContext(4).$implicit; const sub_section_r41 = ɵɵnextContext(2).sub_section; const ctx_r115 = ɵɵnextContext(); return ctx_r115.call_fn($event, sub_section_r41.identifier, field_r55); });
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const field_r55 = ɵɵnextContext(4).$implicit;
    const sub_section_r41 = ɵɵnextContext(2).sub_section;
    const ctx_r69 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵclassMapInterpolate1("form-control ", field_r55.cssClassValue ? field_r55.cssClassValue : "", "");
    ɵɵproperty("type", "hidden")("formControlName", ctx_r69.getFieldIdentifier(field_r55.dataFieldItem.alternateName))("hidden", field_r55.hidden)("readOnly", field_r55.readonlyValue)("ngClass", ɵɵpureFunction2(10, _c3, ctx_r69.Validator.isInvalid(ctx_r69.getGroup(sub_section_r41.identifier, field_r55), ctx_r69.getFieldIdentifier(field_r55.dataFieldItem.alternateName)), ctx_r69.Validator.isValid(ctx_r69.getGroup(sub_section_r41.identifier, field_r55), ctx_r69.getFieldIdentifier(field_r55.dataFieldItem.alternateName))))("name", ctx_r69.getFieldIdentifier(field_r55.dataFieldItem.alternateName));
    ɵɵattribute("placeholder", field_r55.dataFieldItem.placeholder && ctx_r69.getGroup(sub_section_r41.identifier, field_r55).status != "DISABLED" ? field_r55.dataFieldItem.placeholder : null);
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 59);
    ɵɵelement(1, "span", 60);
    ɵɵpipe(2, "i18n");
    ɵɵelementEnd();
} if (rf & 2) {
    const field_r55 = ɵɵnextContext(4).$implicit;
    ɵɵadvance(1);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(2, 1, field_r55.defaultProperty), ɵɵsanitizeHtml);
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "div", 61);
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_4_span_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "span", 68);
    ɵɵelement(1, "span", 11);
    ɵɵpipe(2, "i18n");
    ɵɵelementEnd();
} if (rf & 2) {
    ɵɵadvance(1);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(2, 1, "i18n-form-label-require"), ɵɵsanitizeHtml);
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_4_span_5_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "span", 68);
    ɵɵelement(1, "span", 11);
    ɵɵpipe(2, "i18n");
    ɵɵelementEnd();
} if (rf & 2) {
    ɵɵadvance(1);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(2, 1, "i18n-form-label-optional"), ɵɵsanitizeHtml);
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_4_div_7_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 69);
    ɵɵelement(1, "span", 70);
    ɵɵpipe(2, "i18n");
    ɵɵelementEnd();
} if (rf & 2) {
    const field_r55 = ɵɵnextContext(5).$implicit;
    ɵɵadvance(1);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(2, 1, field_r55 == null ? null : field_r55.dataFieldItem == null ? null : field_r55.dataFieldItem.inputGroupLeft), ɵɵsanitizeHtml);
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_4_div_9_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 71);
    ɵɵelement(1, "span", 70);
    ɵɵpipe(2, "i18n");
    ɵɵelementEnd();
} if (rf & 2) {
    const field_r55 = ɵɵnextContext(5).$implicit;
    ɵɵadvance(1);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(2, 1, field_r55 == null ? null : field_r55.dataFieldItem == null ? null : field_r55.dataFieldItem.inputGroupRight), ɵɵsanitizeHtml);
} }
const _c4 = function (a0) { return { "input-group": a0 }; };
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r128 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 51);
    ɵɵelementStart(1, "label", 62);
    ɵɵelement(2, "span", 11);
    ɵɵpipe(3, "i18n");
    ɵɵtemplate(4, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_4_span_4_Template, 3, 3, "span", 63);
    ɵɵtemplate(5, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_4_span_5_Template, 3, 3, "span", 63);
    ɵɵelementEnd();
    ɵɵelementStart(6, "div", 64);
    ɵɵtemplate(7, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_4_div_7_Template, 3, 3, "div", 65);
    ɵɵelementStart(8, "input", 66);
    ɵɵlistener("keyup", function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_4_Template_input_keyup_8_listener($event) { ɵɵrestoreView(_r128); const field_r55 = ɵɵnextContext(4).$implicit; const sub_section_r41 = ɵɵnextContext(2).sub_section; const ctx_r127 = ɵɵnextContext(); return ctx_r127.call_fn($event, sub_section_r41.identifier, field_r55); })("change", function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_4_Template_input_change_8_listener($event) { ɵɵrestoreView(_r128); const field_r55 = ɵɵnextContext(4).$implicit; const sub_section_r41 = ɵɵnextContext(2).sub_section; const ctx_r131 = ɵɵnextContext(); return ctx_r131.call_fn($event, sub_section_r41.identifier, field_r55); })("click", function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_4_Template_input_click_8_listener($event) { ɵɵrestoreView(_r128); const field_r55 = ɵɵnextContext(4).$implicit; const sub_section_r41 = ɵɵnextContext(2).sub_section; const ctx_r134 = ɵɵnextContext(); return ctx_r134.call_fn($event, sub_section_r41.identifier, field_r55); });
    ɵɵelementEnd();
    ɵɵtemplate(9, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_4_div_9_Template, 3, 3, "div", 67);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const field_r55 = ɵɵnextContext(4).$implicit;
    const sub_section_r41 = ɵɵnextContext(2).sub_section;
    const ctx_r72 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵclassMapInterpolate1("", field_r55.cssClassLabel ? field_r55.cssClassLabel : "", " font-weight-normal");
    ɵɵproperty("hidden", field_r55.hidden);
    ɵɵadvance(1);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(3, 22, field_r55.dataFieldItem.label), ɵɵsanitizeHtml);
    ɵɵadvance(2);
    ɵɵproperty("ngIf", field_r55.valueRequired && (ctx_r72.hiddeFieldOptional == null ? null : ctx_r72.hiddeFieldOptional.active) && (ctx_r72.hiddeFieldOptional == null ? null : ctx_r72.hiddeFieldOptional.type) == "require");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", !field_r55.valueRequired && (ctx_r72.hiddeFieldOptional == null ? null : ctx_r72.hiddeFieldOptional.active) && (ctx_r72.hiddeFieldOptional == null ? null : ctx_r72.hiddeFieldOptional.type) == "optional");
    ɵɵadvance(1);
    ɵɵproperty("ngClass", ɵɵpureFunction1(24, _c4, (field_r55 == null ? null : field_r55.dataFieldItem == null ? null : field_r55.dataFieldItem.inputGroupLeft) || (field_r55 == null ? null : field_r55.dataFieldItem == null ? null : field_r55.dataFieldItem.inputGroupRight) || true));
    ɵɵadvance(1);
    ɵɵproperty("ngIf", field_r55 == null ? null : field_r55.dataFieldItem == null ? null : field_r55.dataFieldItem.inputGroupLeft);
    ɵɵadvance(1);
    ɵɵclassMapInterpolate1("form-control ", field_r55.cssClassValue ? field_r55.cssClassValue : "", "");
    ɵɵproperty("type", "text")("formControlName", ctx_r72.getFieldIdentifier(field_r55.dataFieldItem.alternateName))("options", ctx_r72.currency)("hidden", field_r55.hidden)("readOnly", field_r55.readonlyValue)("ngClass", ɵɵpureFunction2(26, _c3, ctx_r72.Validator.isInvalid(ctx_r72.getGroup(sub_section_r41.identifier, field_r55), ctx_r72.getFieldIdentifier(field_r55.dataFieldItem.alternateName)), ctx_r72.Validator.isValid(ctx_r72.getGroup(sub_section_r41.identifier, field_r55), ctx_r72.getFieldIdentifier(field_r55.dataFieldItem.alternateName))))("name", ctx_r72.getFieldIdentifier(field_r55.dataFieldItem.alternateName));
    ɵɵattribute("maxlength", field_r55.dataFieldItem.length && field_r55.dataFieldItem.length.maxValue ? field_r55.dataFieldItem.length.maxValue : null)("placeholder", field_r55.dataFieldItem.placeholder && ctx_r72.getGroup(sub_section_r41.identifier, field_r55).status != "DISABLED" ? field_r55.dataFieldItem.placeholder : null);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", field_r55 == null ? null : field_r55.dataFieldItem == null ? null : field_r55.dataFieldItem.inputGroupRight);
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_5_span_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "span", 68);
    ɵɵelement(1, "span", 11);
    ɵɵpipe(2, "i18n");
    ɵɵelementEnd();
} if (rf & 2) {
    ɵɵadvance(1);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(2, 1, "i18n-form-label-require"), ɵɵsanitizeHtml);
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_5_span_5_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "span", 68);
    ɵɵelement(1, "span", 11);
    ɵɵpipe(2, "i18n");
    ɵɵelementEnd();
} if (rf & 2) {
    ɵɵadvance(1);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(2, 1, "i18n-form-label-optional"), ɵɵsanitizeHtml);
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_5_div_7_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 69);
    ɵɵelement(1, "span", 70);
    ɵɵpipe(2, "i18n");
    ɵɵelementEnd();
} if (rf & 2) {
    const field_r55 = ɵɵnextContext(5).$implicit;
    ɵɵadvance(1);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(2, 1, field_r55 == null ? null : field_r55.dataFieldItem == null ? null : field_r55.dataFieldItem.inputGroupLeft), ɵɵsanitizeHtml);
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_5_div_9_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 71);
    ɵɵelement(1, "span", 70);
    ɵɵpipe(2, "i18n");
    ɵɵelementEnd();
} if (rf & 2) {
    const field_r55 = ɵɵnextContext(5).$implicit;
    ɵɵadvance(1);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(2, 1, field_r55 == null ? null : field_r55.dataFieldItem == null ? null : field_r55.dataFieldItem.inputGroupRight), ɵɵsanitizeHtml);
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r146 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 51);
    ɵɵelementStart(1, "label", 62);
    ɵɵelement(2, "span", 11);
    ɵɵpipe(3, "i18n");
    ɵɵtemplate(4, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_5_span_4_Template, 3, 3, "span", 63);
    ɵɵtemplate(5, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_5_span_5_Template, 3, 3, "span", 63);
    ɵɵelementEnd();
    ɵɵelementStart(6, "div", 64);
    ɵɵtemplate(7, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_5_div_7_Template, 3, 3, "div", 65);
    ɵɵelementStart(8, "input", 72);
    ɵɵlistener("keyup", function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_5_Template_input_keyup_8_listener($event) { ɵɵrestoreView(_r146); const field_r55 = ɵɵnextContext(4).$implicit; const sub_section_r41 = ɵɵnextContext(2).sub_section; const ctx_r145 = ɵɵnextContext(); return ctx_r145.call_fn($event, sub_section_r41.identifier, field_r55); })("change", function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_5_Template_input_change_8_listener($event) { ɵɵrestoreView(_r146); const field_r55 = ɵɵnextContext(4).$implicit; const sub_section_r41 = ɵɵnextContext(2).sub_section; const ctx_r149 = ɵɵnextContext(); return ctx_r149.call_fn($event, sub_section_r41.identifier, field_r55); })("click", function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_5_Template_input_click_8_listener($event) { ɵɵrestoreView(_r146); const field_r55 = ɵɵnextContext(4).$implicit; const sub_section_r41 = ɵɵnextContext(2).sub_section; const ctx_r152 = ɵɵnextContext(); return ctx_r152.call_fn($event, sub_section_r41.identifier, field_r55); })("keypress", function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_5_Template_input_keypress_8_listener($event) { ɵɵrestoreView(_r146); const ctx_r155 = ɵɵnextContext(7); return ctx_r155.numberOnly($event); });
    ɵɵelementEnd();
    ɵɵtemplate(9, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_5_div_9_Template, 3, 3, "div", 67);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const field_r55 = ɵɵnextContext(4).$implicit;
    const sub_section_r41 = ɵɵnextContext(2).sub_section;
    const ctx_r73 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵclassMapInterpolate1("", field_r55.cssClassLabel ? field_r55.cssClassLabel : "", " font-weight-normal");
    ɵɵproperty("hidden", field_r55.hidden);
    ɵɵadvance(1);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(3, 21, field_r55.dataFieldItem.label), ɵɵsanitizeHtml);
    ɵɵadvance(2);
    ɵɵproperty("ngIf", field_r55.valueRequired && (ctx_r73.hiddeFieldOptional == null ? null : ctx_r73.hiddeFieldOptional.active) && (ctx_r73.hiddeFieldOptional == null ? null : ctx_r73.hiddeFieldOptional.type) == "require");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", !field_r55.valueRequired && (ctx_r73.hiddeFieldOptional == null ? null : ctx_r73.hiddeFieldOptional.active) && (ctx_r73.hiddeFieldOptional == null ? null : ctx_r73.hiddeFieldOptional.type) == "optional");
    ɵɵadvance(1);
    ɵɵproperty("ngClass", ɵɵpureFunction1(23, _c4, (field_r55 == null ? null : field_r55.dataFieldItem == null ? null : field_r55.dataFieldItem.inputGroupLeft) || (field_r55 == null ? null : field_r55.dataFieldItem == null ? null : field_r55.dataFieldItem.inputGroupRight) || true));
    ɵɵadvance(1);
    ɵɵproperty("ngIf", field_r55 == null ? null : field_r55.dataFieldItem == null ? null : field_r55.dataFieldItem.inputGroupLeft);
    ɵɵadvance(1);
    ɵɵclassMapInterpolate1("form-control ", field_r55.cssClassValue ? field_r55.cssClassValue : "", "");
    ɵɵproperty("type", "text")("formControlName", ctx_r73.getFieldIdentifier(field_r55.dataFieldItem.alternateName))("hidden", field_r55.hidden)("readOnly", field_r55.readonlyValue)("ngClass", ɵɵpureFunction2(25, _c3, ctx_r73.Validator.isInvalid(ctx_r73.getGroup(sub_section_r41.identifier, field_r55), ctx_r73.getFieldIdentifier(field_r55.dataFieldItem.alternateName)), ctx_r73.Validator.isValid(ctx_r73.getGroup(sub_section_r41.identifier, field_r55), ctx_r73.getFieldIdentifier(field_r55.dataFieldItem.alternateName))))("name", ctx_r73.getFieldIdentifier(field_r55.dataFieldItem.alternateName));
    ɵɵattribute("maxlength", field_r55.dataFieldItem.length && field_r55.dataFieldItem.length.maxValue ? field_r55.dataFieldItem.length.maxValue : null)("placeholder", field_r55.dataFieldItem.placeholder && ctx_r73.getGroup(sub_section_r41.identifier, field_r55).status !== "DISABLED" ? field_r55.dataFieldItem.placeholder : null);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", field_r55 == null ? null : field_r55.dataFieldItem == null ? null : field_r55.dataFieldItem.inputGroupRight);
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_6_span_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "span", 68);
    ɵɵelement(1, "span", 11);
    ɵɵpipe(2, "i18n");
    ɵɵelementEnd();
} if (rf & 2) {
    ɵɵadvance(1);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(2, 1, "i18n-form-label-require"), ɵɵsanitizeHtml);
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_6_span_5_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "span", 68);
    ɵɵelement(1, "span", 11);
    ɵɵpipe(2, "i18n");
    ɵɵelementEnd();
} if (rf & 2) {
    ɵɵadvance(1);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(2, 1, "i18n-form-label-optional"), ɵɵsanitizeHtml);
} }
const _c5 = function (a0) { return { mask: a0, modelClean: true }; };
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r161 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 51);
    ɵɵelementStart(1, "label", 62);
    ɵɵelement(2, "span", 11);
    ɵɵpipe(3, "i18n");
    ɵɵtemplate(4, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_6_span_4_Template, 3, 3, "span", 63);
    ɵɵtemplate(5, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_6_span_5_Template, 3, 3, "span", 63);
    ɵɵelementEnd();
    ɵɵelementStart(6, "input", 73);
    ɵɵlistener("keyup", function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_6_Template_input_keyup_6_listener($event) { ɵɵrestoreView(_r161); const field_r55 = ɵɵnextContext(4).$implicit; const sub_section_r41 = ɵɵnextContext(2).sub_section; const ctx_r160 = ɵɵnextContext(); return ctx_r160.call_fn($event, sub_section_r41.identifier, field_r55); })("change", function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_6_Template_input_change_6_listener($event) { ɵɵrestoreView(_r161); const field_r55 = ɵɵnextContext(4).$implicit; const sub_section_r41 = ɵɵnextContext(2).sub_section; const ctx_r164 = ɵɵnextContext(); return ctx_r164.call_fn($event, sub_section_r41.identifier, field_r55); })("click", function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_6_Template_input_click_6_listener($event) { ɵɵrestoreView(_r161); const field_r55 = ɵɵnextContext(4).$implicit; const sub_section_r41 = ɵɵnextContext(2).sub_section; const ctx_r167 = ɵɵnextContext(); return ctx_r167.call_fn($event, sub_section_r41.identifier, field_r55); });
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const field_r55 = ɵɵnextContext(4).$implicit;
    const sub_section_r41 = ɵɵnextContext(2).sub_section;
    const ctx_r74 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵclassMapInterpolate1("", field_r55.cssClassLabel ? field_r55.cssClassLabel : "", " font-weight-normal");
    ɵɵproperty("hidden", field_r55.hidden);
    ɵɵadvance(1);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(3, 18, field_r55.dataFieldItem.label), ɵɵsanitizeHtml);
    ɵɵadvance(2);
    ɵɵproperty("ngIf", field_r55.valueRequired && (ctx_r74.hiddeFieldOptional == null ? null : ctx_r74.hiddeFieldOptional.active) && (ctx_r74.hiddeFieldOptional == null ? null : ctx_r74.hiddeFieldOptional.type) == "require");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", !field_r55.valueRequired && (ctx_r74.hiddeFieldOptional == null ? null : ctx_r74.hiddeFieldOptional.active) && (ctx_r74.hiddeFieldOptional == null ? null : ctx_r74.hiddeFieldOptional.type) == "optional");
    ɵɵadvance(1);
    ɵɵclassMapInterpolate1("form-control ", field_r55.cssClassValue ? field_r55.cssClassValue : "", "");
    ɵɵproperty("type", "text")("formControlName", ctx_r74.getFieldIdentifier(field_r55.dataFieldItem.alternateName))("textMask", ɵɵpureFunction1(20, _c5, ctx_r74.mask_year))("hidden", field_r55.hidden)("readOnly", field_r55.readonlyValue)("ngClass", ɵɵpureFunction2(22, _c3, ctx_r74.Validator.isInvalid(ctx_r74.getGroup(sub_section_r41.identifier, field_r55), ctx_r74.getFieldIdentifier(field_r55.dataFieldItem.alternateName)), ctx_r74.Validator.isValid(ctx_r74.getGroup(sub_section_r41.identifier, field_r55), ctx_r74.getFieldIdentifier(field_r55.dataFieldItem.alternateName))))("name", ctx_r74.getFieldIdentifier(field_r55.dataFieldItem.alternateName));
    ɵɵattribute("placeholder", field_r55.dataFieldItem.placeholder && ctx_r74.getGroup(sub_section_r41.identifier, field_r55).status !== "DISABLED" ? field_r55.dataFieldItem.placeholder : null);
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_7_span_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "span", 68);
    ɵɵelement(1, "span", 11);
    ɵɵpipe(2, "i18n");
    ɵɵelementEnd();
} if (rf & 2) {
    ɵɵadvance(1);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(2, 1, "i18n-form-label-require"), ɵɵsanitizeHtml);
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_7_span_5_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "span", 68);
    ɵɵelement(1, "span", 11);
    ɵɵpipe(2, "i18n");
    ɵɵelementEnd();
} if (rf & 2) {
    ɵɵadvance(1);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(2, 1, "i18n-form-label-optional"), ɵɵsanitizeHtml);
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r175 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 51);
    ɵɵelementStart(1, "label", 62);
    ɵɵelement(2, "span", 11);
    ɵɵpipe(3, "i18n");
    ɵɵtemplate(4, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_7_span_4_Template, 3, 3, "span", 63);
    ɵɵtemplate(5, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_7_span_5_Template, 3, 3, "span", 63);
    ɵɵelementEnd();
    ɵɵelementStart(6, "input", 58);
    ɵɵlistener("keyup", function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_7_Template_input_keyup_6_listener($event) { ɵɵrestoreView(_r175); const field_r55 = ɵɵnextContext(4).$implicit; const sub_section_r41 = ɵɵnextContext(2).sub_section; const ctx_r174 = ɵɵnextContext(); return ctx_r174.call_fn($event, sub_section_r41.identifier, field_r55); })("change", function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_7_Template_input_change_6_listener($event) { ɵɵrestoreView(_r175); const field_r55 = ɵɵnextContext(4).$implicit; const sub_section_r41 = ɵɵnextContext(2).sub_section; const ctx_r178 = ɵɵnextContext(); return ctx_r178.call_fn($event, sub_section_r41.identifier, field_r55); })("click", function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_7_Template_input_click_6_listener($event) { ɵɵrestoreView(_r175); const field_r55 = ɵɵnextContext(4).$implicit; const sub_section_r41 = ɵɵnextContext(2).sub_section; const ctx_r181 = ɵɵnextContext(); return ctx_r181.call_fn($event, sub_section_r41.identifier, field_r55); });
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const field_r55 = ɵɵnextContext(4).$implicit;
    const sub_section_r41 = ɵɵnextContext(2).sub_section;
    const ctx_r75 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵclassMapInterpolate1("", field_r55.cssClassLabel ? field_r55.cssClassLabel : "", " font-weight-normal");
    ɵɵproperty("hidden", field_r55.hidden);
    ɵɵadvance(1);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(3, 17, field_r55.dataFieldItem.label), ɵɵsanitizeHtml);
    ɵɵadvance(2);
    ɵɵproperty("ngIf", field_r55.valueRequired && (ctx_r75.hiddeFieldOptional == null ? null : ctx_r75.hiddeFieldOptional.active) && (ctx_r75.hiddeFieldOptional == null ? null : ctx_r75.hiddeFieldOptional.type) == "require");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", !field_r55.valueRequired && (ctx_r75.hiddeFieldOptional == null ? null : ctx_r75.hiddeFieldOptional.active) && (ctx_r75.hiddeFieldOptional == null ? null : ctx_r75.hiddeFieldOptional.type) == "optional");
    ɵɵadvance(1);
    ɵɵclassMapInterpolate1("form-control  ", field_r55.cssClassValue ? field_r55.cssClassValue : "", "");
    ɵɵproperty("type", "text")("formControlName", ctx_r75.getFieldIdentifier(field_r55.dataFieldItem.alternateName))("hidden", field_r55.hidden)("readOnly", field_r55.readonlyValue)("ngClass", ɵɵpureFunction2(19, _c3, ctx_r75.Validator.isInvalid(ctx_r75.getGroup(sub_section_r41.identifier, field_r55), ctx_r75.getFieldIdentifier(field_r55.dataFieldItem.alternateName)), ctx_r75.Validator.isValid(ctx_r75.getGroup(sub_section_r41.identifier, field_r55), ctx_r75.getFieldIdentifier(field_r55.dataFieldItem.alternateName))))("name", ctx_r75.getFieldIdentifier(field_r55.dataFieldItem.alternateName));
    ɵɵattribute("placeholder", field_r55.dataFieldItem.placeholder && ctx_r75.getGroup(sub_section_r41.identifier, field_r55).status !== "DISABLED" ? field_r55.dataFieldItem.placeholder : null);
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_8_span_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "span", 68);
    ɵɵelement(1, "span", 11);
    ɵɵpipe(2, "i18n");
    ɵɵelementEnd();
} if (rf & 2) {
    ɵɵadvance(1);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(2, 1, "i18n-form-label-require"), ɵɵsanitizeHtml);
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_8_span_5_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "span", 68);
    ɵɵelement(1, "span", 11);
    ɵɵpipe(2, "i18n");
    ɵɵelementEnd();
} if (rf & 2) {
    ɵɵadvance(1);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(2, 1, "i18n-form-label-optional"), ɵɵsanitizeHtml);
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r189 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 51);
    ɵɵelementStart(1, "label", 62);
    ɵɵelement(2, "span", 11);
    ɵɵpipe(3, "i18n");
    ɵɵtemplate(4, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_8_span_4_Template, 3, 3, "span", 63);
    ɵɵtemplate(5, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_8_span_5_Template, 3, 3, "span", 63);
    ɵɵelementEnd();
    ɵɵelementStart(6, "input", 58);
    ɵɵlistener("keyup", function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_8_Template_input_keyup_6_listener($event) { ɵɵrestoreView(_r189); const field_r55 = ɵɵnextContext(4).$implicit; const sub_section_r41 = ɵɵnextContext(2).sub_section; const ctx_r188 = ɵɵnextContext(); return ctx_r188.call_fn($event, sub_section_r41.identifier, field_r55); })("change", function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_8_Template_input_change_6_listener($event) { ɵɵrestoreView(_r189); const field_r55 = ɵɵnextContext(4).$implicit; const sub_section_r41 = ɵɵnextContext(2).sub_section; const ctx_r192 = ɵɵnextContext(); return ctx_r192.call_fn($event, sub_section_r41.identifier, field_r55); })("click", function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_8_Template_input_click_6_listener($event) { ɵɵrestoreView(_r189); const field_r55 = ɵɵnextContext(4).$implicit; const sub_section_r41 = ɵɵnextContext(2).sub_section; const ctx_r195 = ɵɵnextContext(); return ctx_r195.call_fn($event, sub_section_r41.identifier, field_r55); });
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const field_r55 = ɵɵnextContext(4).$implicit;
    const sub_section_r41 = ɵɵnextContext(2).sub_section;
    const ctx_r76 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵclassMapInterpolate1("", field_r55.cssClassLabel ? field_r55.cssClassLabel : "", " font-weight-normal");
    ɵɵproperty("hidden", field_r55.hidden);
    ɵɵadvance(1);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(3, 17, field_r55.dataFieldItem.label), ɵɵsanitizeHtml);
    ɵɵadvance(2);
    ɵɵproperty("ngIf", field_r55.valueRequired && (ctx_r76.hiddeFieldOptional == null ? null : ctx_r76.hiddeFieldOptional.active) && (ctx_r76.hiddeFieldOptional == null ? null : ctx_r76.hiddeFieldOptional.type) == "require");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", !field_r55.valueRequired && (ctx_r76.hiddeFieldOptional == null ? null : ctx_r76.hiddeFieldOptional.active) && (ctx_r76.hiddeFieldOptional == null ? null : ctx_r76.hiddeFieldOptional.type) == "optional");
    ɵɵadvance(1);
    ɵɵclassMapInterpolate1("form-control  ", field_r55.cssClassValue ? field_r55.cssClassValue : "", "");
    ɵɵproperty("type", "text")("formControlName", ctx_r76.getFieldIdentifier(field_r55.dataFieldItem.alternateName))("hidden", field_r55.hidden)("readOnly", field_r55.readonlyValue)("ngClass", ɵɵpureFunction2(19, _c3, ctx_r76.Validator.isInvalid(ctx_r76.getGroup(sub_section_r41.identifier, field_r55), ctx_r76.getFieldIdentifier(field_r55.dataFieldItem.alternateName)), ctx_r76.Validator.isValid(ctx_r76.getGroup(sub_section_r41.identifier, field_r55), ctx_r76.getFieldIdentifier(field_r55.dataFieldItem.alternateName))))("name", ctx_r76.getFieldIdentifier(field_r55.dataFieldItem.alternateName));
    ɵɵattribute("placeholder", field_r55.dataFieldItem.placeholder && ctx_r76.getGroup(sub_section_r41.identifier, field_r55).status != "DISABLED" ? field_r55.dataFieldItem.placeholder : null);
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_9_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 51);
    ɵɵelement(1, "label", 74);
    ɵɵpipe(2, "i18n");
    ɵɵelement(3, "br");
    ɵɵelementEnd();
} if (rf & 2) {
    const field_r55 = ɵɵnextContext(4).$implicit;
    ɵɵadvance(1);
    ɵɵclassMapInterpolate1("", field_r55.cssClassLabel ? field_r55.cssClassLabel : "", " ");
    ɵɵproperty("innerHTML", ɵɵpipeBind1(2, 5, field_r55.dataFieldItem.label), ɵɵsanitizeHtml)("hidden", field_r55.hidden);
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_10_span_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "span", 68);
    ɵɵelement(1, "span", 11);
    ɵɵpipe(2, "i18n");
    ɵɵelementEnd();
} if (rf & 2) {
    ɵɵadvance(1);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(2, 1, "i18n-form-label-require"), ɵɵsanitizeHtml);
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_10_span_5_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "span", 68);
    ɵɵelement(1, "span", 11);
    ɵɵpipe(2, "i18n");
    ɵɵelementEnd();
} if (rf & 2) {
    ɵɵadvance(1);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(2, 1, "i18n-form-label-optional"), ɵɵsanitizeHtml);
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_10_Template(rf, ctx) { if (rf & 1) {
    const _r204 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 51);
    ɵɵelementStart(1, "label", 62);
    ɵɵelement(2, "span", 11);
    ɵɵpipe(3, "i18n");
    ɵɵtemplate(4, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_10_span_4_Template, 3, 3, "span", 63);
    ɵɵtemplate(5, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_10_span_5_Template, 3, 3, "span", 63);
    ɵɵelementEnd();
    ɵɵelementStart(6, "input", 75);
    ɵɵlistener("keyup", function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_10_Template_input_keyup_6_listener($event) { ɵɵrestoreView(_r204); const field_r55 = ɵɵnextContext(4).$implicit; const sub_section_r41 = ɵɵnextContext(2).sub_section; const ctx_r203 = ɵɵnextContext(); return ctx_r203.call_fn($event, sub_section_r41.identifier, field_r55); })("change", function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_10_Template_input_change_6_listener($event) { ɵɵrestoreView(_r204); const field_r55 = ɵɵnextContext(4).$implicit; const sub_section_r41 = ɵɵnextContext(2).sub_section; const ctx_r207 = ɵɵnextContext(); return ctx_r207.call_fn($event, sub_section_r41.identifier, field_r55); })("click", function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_10_Template_input_click_6_listener($event) { ɵɵrestoreView(_r204); const field_r55 = ɵɵnextContext(4).$implicit; const sub_section_r41 = ɵɵnextContext(2).sub_section; const ctx_r210 = ɵɵnextContext(); return ctx_r210.call_fn($event, sub_section_r41.identifier, field_r55); });
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const field_r55 = ɵɵnextContext(4).$implicit;
    const sub_section_r41 = ɵɵnextContext(2).sub_section;
    const ctx_r78 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵclassMapInterpolate1("", field_r55.cssClassLabel ? field_r55.cssClassLabel : "", " font-weight-normal");
    ɵɵproperty("hidden", field_r55.hidden);
    ɵɵadvance(1);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(3, 16, field_r55.dataFieldItem.label), ɵɵsanitizeHtml);
    ɵɵadvance(2);
    ɵɵproperty("ngIf", field_r55.valueRequired && (ctx_r78.hiddeFieldOptional == null ? null : ctx_r78.hiddeFieldOptional.active) && (ctx_r78.hiddeFieldOptional == null ? null : ctx_r78.hiddeFieldOptional.type) == "require");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", !field_r55.valueRequired && (ctx_r78.hiddeFieldOptional == null ? null : ctx_r78.hiddeFieldOptional.active) && (ctx_r78.hiddeFieldOptional == null ? null : ctx_r78.hiddeFieldOptional.type) == "optional");
    ɵɵadvance(1);
    ɵɵclassMapInterpolate1("form-control  ", field_r55.cssClassValue ? field_r55.cssClassValue : "", "");
    ɵɵproperty("type", "text")("formControlName", ctx_r78.getFieldIdentifier(field_r55.dataFieldItem.alternateName))("ngClass", ɵɵpureFunction2(18, _c3, ctx_r78.Validator.isInvalid(ctx_r78.getGroup(sub_section_r41.identifier, field_r55), ctx_r78.getFieldIdentifier(field_r55.dataFieldItem.alternateName)), ctx_r78.Validator.isValid(ctx_r78.getGroup(sub_section_r41.identifier, field_r55), ctx_r78.getFieldIdentifier(field_r55.dataFieldItem.alternateName))))("name", ctx_r78.getFieldIdentifier(field_r55.dataFieldItem.alternateName))("readOnly", field_r55.readonlyValue);
    ɵɵattribute("placeholder", field_r55.dataFieldItem.placeholder && ctx_r78.getGroup(sub_section_r41.identifier, field_r55).status != "DISABLED" ? field_r55.dataFieldItem.placeholder : null);
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_11_span_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "span", 68);
    ɵɵelement(1, "span", 11);
    ɵɵpipe(2, "i18n");
    ɵɵelementEnd();
} if (rf & 2) {
    ɵɵadvance(1);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(2, 1, "i18n-form-label-require"), ɵɵsanitizeHtml);
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_11_span_5_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "span", 68);
    ɵɵelement(1, "span", 11);
    ɵɵpipe(2, "i18n");
    ɵɵelementEnd();
} if (rf & 2) {
    ɵɵadvance(1);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(2, 1, "i18n-form-label-optional"), ɵɵsanitizeHtml);
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_11_div_8_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r222 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "button", 80);
    ɵɵlistener("click", function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_11_div_8_button_1_Template_button_click_0_listener() { ɵɵrestoreView(_r222); const field_r55 = ɵɵnextContext(6).$implicit; const sub_section_r41 = ɵɵnextContext(2).sub_section; const ctx_r220 = ɵɵnextContext(); return ctx_r220.showValidateTel(sub_section_r41, field_r55); });
    ɵɵtext(1, "Validar");
    ɵɵelementEnd();
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_11_div_8_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "span", 81);
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_11_div_8_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 71);
    ɵɵtemplate(1, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_11_div_8_button_1_Template, 2, 0, "button", 78);
    ɵɵtemplate(2, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_11_div_8_span_2_Template, 1, 0, "span", 79);
    ɵɵelementEnd();
} if (rf & 2) {
    const field_r55 = ɵɵnextContext(5).$implicit;
    const ctx_r217 = ɵɵnextContext(3);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", !ctx_r217.tlfValidates[ctx_r217.getValueField(field_r55)]);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r217.tlfValidates[ctx_r217.getValueField(field_r55)]);
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_11_Template(rf, ctx) { if (rf & 1) {
    const _r226 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 51);
    ɵɵelementStart(1, "label", 62);
    ɵɵelement(2, "span", 11);
    ɵɵpipe(3, "i18n");
    ɵɵtemplate(4, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_11_span_4_Template, 3, 3, "span", 63);
    ɵɵtemplate(5, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_11_span_5_Template, 3, 3, "span", 63);
    ɵɵelementEnd();
    ɵɵelementStart(6, "div", 76);
    ɵɵelementStart(7, "input", 77);
    ɵɵlistener("keyup", function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_11_Template_input_keyup_7_listener($event) { ɵɵrestoreView(_r226); const field_r55 = ɵɵnextContext(4).$implicit; const sub_section_r41 = ɵɵnextContext(2).sub_section; const ctx_r225 = ɵɵnextContext(); return ctx_r225.call_fn($event, sub_section_r41.identifier, field_r55); })("change", function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_11_Template_input_change_7_listener($event) { ɵɵrestoreView(_r226); const field_r55 = ɵɵnextContext(4).$implicit; const sub_section_r41 = ɵɵnextContext(2).sub_section; const ctx_r229 = ɵɵnextContext(); return ctx_r229.call_fn($event, sub_section_r41.identifier, field_r55); })("click", function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_11_Template_input_click_7_listener($event) { ɵɵrestoreView(_r226); const field_r55 = ɵɵnextContext(4).$implicit; const sub_section_r41 = ɵɵnextContext(2).sub_section; const ctx_r232 = ɵɵnextContext(); return ctx_r232.call_fn($event, sub_section_r41.identifier, field_r55); });
    ɵɵelementEnd();
    ɵɵtemplate(8, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_11_div_8_Template, 3, 2, "div", 67);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const field_r55 = ɵɵnextContext(4).$implicit;
    const sub_section_r41 = ɵɵnextContext(2).sub_section;
    const ctx_r79 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵclassMapInterpolate1("", field_r55.cssClassLabel ? field_r55.cssClassLabel : "", " font-weight-normal");
    ɵɵproperty("hidden", field_r55.hidden);
    ɵɵadvance(1);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(3, 16, field_r55.dataFieldItem.label), ɵɵsanitizeHtml);
    ɵɵadvance(2);
    ɵɵproperty("ngIf", field_r55.valueRequired && (ctx_r79.hiddeFieldOptional == null ? null : ctx_r79.hiddeFieldOptional.active) && (ctx_r79.hiddeFieldOptional == null ? null : ctx_r79.hiddeFieldOptional.type) == "require");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", !field_r55.valueRequired && (ctx_r79.hiddeFieldOptional == null ? null : ctx_r79.hiddeFieldOptional.active) && (ctx_r79.hiddeFieldOptional == null ? null : ctx_r79.hiddeFieldOptional.type) == "optional");
    ɵɵadvance(2);
    ɵɵclassMapInterpolate1("form-control  ", field_r55.cssClassValue ? field_r55.cssClassValue : "", " text-lowercase");
    ɵɵproperty("type", "text")("formControlName", ctx_r79.getFieldIdentifier(field_r55.dataFieldItem.alternateName))("ngClass", ɵɵpureFunction2(18, _c3, ctx_r79.Validator.isInvalid(ctx_r79.getGroup(sub_section_r41.identifier, field_r55), ctx_r79.getFieldIdentifier(field_r55.dataFieldItem.alternateName)), ctx_r79.Validator.isValid(ctx_r79.getGroup(sub_section_r41.identifier, field_r55), ctx_r79.getFieldIdentifier(field_r55.dataFieldItem.alternateName))))("name", ctx_r79.getFieldIdentifier(field_r55.dataFieldItem.alternateName));
    ɵɵattribute("placeholder", field_r55.dataFieldItem.placeholder && ctx_r79.getGroup(sub_section_r41.identifier, field_r55).status != "DISABLED" ? field_r55.dataFieldItem.placeholder : null);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", !ctx_r79.Validator.hasPatternError(ctx_r79.getGroup(sub_section_r41.identifier, field_r55), ctx_r79.getFieldIdentifier(field_r55.dataFieldItem.alternateName)) && !ctx_r79.Validator.hasRequiredError(ctx_r79.getGroup(sub_section_r41.identifier, field_r55), ctx_r79.getFieldIdentifier(field_r55.dataFieldItem.alternateName)) && !ctx_r79.Validator.hasMinError(ctx_r79.getGroup(sub_section_r41.identifier, field_r55), ctx_r79.getFieldIdentifier(field_r55.dataFieldItem.alternateName)) && !ctx_r79.Validator.hasMaxError(ctx_r79.getGroup(sub_section_r41.identifier, field_r55), ctx_r79.getFieldIdentifier(field_r55.dataFieldItem.alternateName)) && !ctx_r79.getGroup(sub_section_r41.identifier, field_r55).get(ctx_r79.getFieldIdentifier(field_r55.dataFieldItem.alternateName)).pristine);
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_12_span_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "span", 68);
    ɵɵelement(1, "span", 11);
    ɵɵpipe(2, "i18n");
    ɵɵelementEnd();
} if (rf & 2) {
    ɵɵadvance(1);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(2, 1, "i18n-form-label-require"), ɵɵsanitizeHtml);
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_12_span_5_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "span", 68);
    ɵɵelement(1, "span", 11);
    ɵɵpipe(2, "i18n");
    ɵɵelementEnd();
} if (rf & 2) {
    ɵɵadvance(1);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(2, 1, "i18n-form-label-optional"), ɵɵsanitizeHtml);
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_12_Template(rf, ctx) { if (rf & 1) {
    const _r240 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 51);
    ɵɵelementStart(1, "label", 62);
    ɵɵelement(2, "span", 11);
    ɵɵpipe(3, "i18n");
    ɵɵtemplate(4, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_12_span_4_Template, 3, 3, "span", 63);
    ɵɵtemplate(5, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_12_span_5_Template, 3, 3, "span", 63);
    ɵɵelementEnd();
    ɵɵelementStart(6, "input", 77);
    ɵɵlistener("keyup", function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_12_Template_input_keyup_6_listener($event) { ɵɵrestoreView(_r240); const field_r55 = ɵɵnextContext(4).$implicit; const sub_section_r41 = ɵɵnextContext(2).sub_section; const ctx_r239 = ɵɵnextContext(); return ctx_r239.call_fn($event, sub_section_r41.identifier, field_r55); })("change", function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_12_Template_input_change_6_listener($event) { ɵɵrestoreView(_r240); const field_r55 = ɵɵnextContext(4).$implicit; const sub_section_r41 = ɵɵnextContext(2).sub_section; const ctx_r243 = ɵɵnextContext(); return ctx_r243.call_fn($event, sub_section_r41.identifier, field_r55); })("click", function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_12_Template_input_click_6_listener($event) { ɵɵrestoreView(_r240); const field_r55 = ɵɵnextContext(4).$implicit; const sub_section_r41 = ɵɵnextContext(2).sub_section; const ctx_r246 = ɵɵnextContext(); return ctx_r246.call_fn($event, sub_section_r41.identifier, field_r55); });
    ɵɵelementEnd();
    ɵɵelementStart(7, "div", 82);
    ɵɵelementStart(8, "a", 83);
    ɵɵlistener("click", function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_12_Template_a_click_8_listener() { ɵɵrestoreView(_r240); const field_r55 = ɵɵnextContext(4).$implicit; const sub_section_r41 = ɵɵnextContext(2).sub_section; const ctx_r249 = ɵɵnextContext(); return ctx_r249.call_suggestion(sub_section_r41.identifier, field_r55); });
    ɵɵtext(9, "Sugerencia");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const field_r55 = ɵɵnextContext(4).$implicit;
    const sub_section_r41 = ɵɵnextContext(2).sub_section;
    const ctx_r80 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵclassMapInterpolate1("", field_r55.cssClassLabel ? field_r55.cssClassLabel : "", " font-weight-normal");
    ɵɵproperty("hidden", field_r55.hidden);
    ɵɵadvance(1);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(3, 15, field_r55.dataFieldItem.label), ɵɵsanitizeHtml);
    ɵɵadvance(2);
    ɵɵproperty("ngIf", field_r55.valueRequired && (ctx_r80.hiddeFieldOptional == null ? null : ctx_r80.hiddeFieldOptional.active) && (ctx_r80.hiddeFieldOptional == null ? null : ctx_r80.hiddeFieldOptional.type) == "require");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", !field_r55.valueRequired && (ctx_r80.hiddeFieldOptional == null ? null : ctx_r80.hiddeFieldOptional.active) && (ctx_r80.hiddeFieldOptional == null ? null : ctx_r80.hiddeFieldOptional.type) == "optional");
    ɵɵadvance(1);
    ɵɵclassMapInterpolate1("form-control  ", field_r55.cssClassValue ? field_r55.cssClassValue : "", " text-lowercase");
    ɵɵproperty("type", "text")("formControlName", ctx_r80.getFieldIdentifier(field_r55.dataFieldItem.alternateName))("ngClass", ɵɵpureFunction2(17, _c3, ctx_r80.Validator.isInvalid(ctx_r80.getGroup(sub_section_r41.identifier, field_r55), ctx_r80.getFieldIdentifier(field_r55.dataFieldItem.alternateName)), ctx_r80.Validator.isValid(ctx_r80.getGroup(sub_section_r41.identifier, field_r55), ctx_r80.getFieldIdentifier(field_r55.dataFieldItem.alternateName))))("name", ctx_r80.getFieldIdentifier(field_r55.dataFieldItem.alternateName));
    ɵɵattribute("placeholder", field_r55.dataFieldItem.placeholder && ctx_r80.getGroup(sub_section_r41.identifier, field_r55).status != "DISABLED" ? field_r55.dataFieldItem.placeholder : null);
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_13_span_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "span", 68);
    ɵɵelement(1, "span", 11);
    ɵɵpipe(2, "i18n");
    ɵɵelementEnd();
} if (rf & 2) {
    ɵɵadvance(1);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(2, 1, "i18n-form-label-require"), ɵɵsanitizeHtml);
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_13_span_5_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "span", 68);
    ɵɵelement(1, "span", 11);
    ɵɵpipe(2, "i18n");
    ɵɵelementEnd();
} if (rf & 2) {
    ɵɵadvance(1);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(2, 1, "i18n-form-label-optional"), ɵɵsanitizeHtml);
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_13_Template(rf, ctx) { if (rf & 1) {
    const _r257 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 51);
    ɵɵelementStart(1, "label", 62);
    ɵɵelement(2, "span", 11);
    ɵɵpipe(3, "i18n");
    ɵɵtemplate(4, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_13_span_4_Template, 3, 3, "span", 63);
    ɵɵtemplate(5, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_13_span_5_Template, 3, 3, "span", 63);
    ɵɵelementEnd();
    ɵɵelementStart(6, "input", 58);
    ɵɵlistener("keyup", function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_13_Template_input_keyup_6_listener($event) { ɵɵrestoreView(_r257); const field_r55 = ɵɵnextContext(4).$implicit; const sub_section_r41 = ɵɵnextContext(2).sub_section; const ctx_r256 = ɵɵnextContext(); return ctx_r256.call_fn($event, sub_section_r41.identifier, field_r55); })("change", function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_13_Template_input_change_6_listener($event) { ɵɵrestoreView(_r257); const field_r55 = ɵɵnextContext(4).$implicit; const sub_section_r41 = ɵɵnextContext(2).sub_section; const ctx_r260 = ɵɵnextContext(); return ctx_r260.call_fn($event, sub_section_r41.identifier, field_r55); })("click", function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_13_Template_input_click_6_listener($event) { ɵɵrestoreView(_r257); const field_r55 = ɵɵnextContext(4).$implicit; const sub_section_r41 = ɵɵnextContext(2).sub_section; const ctx_r263 = ɵɵnextContext(); return ctx_r263.call_fn($event, sub_section_r41.identifier, field_r55); });
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const field_r55 = ɵɵnextContext(4).$implicit;
    const sub_section_r41 = ɵɵnextContext(2).sub_section;
    const ctx_r81 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵclassMapInterpolate1("", field_r55.cssClassLabel ? field_r55.cssClassLabel : "", " font-weight-normal");
    ɵɵproperty("hidden", field_r55.hidden);
    ɵɵadvance(1);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(3, 17, field_r55.dataFieldItem.label), ɵɵsanitizeHtml);
    ɵɵadvance(2);
    ɵɵproperty("ngIf", field_r55.valueRequired && (ctx_r81.hiddeFieldOptional == null ? null : ctx_r81.hiddeFieldOptional.active) && (ctx_r81.hiddeFieldOptional == null ? null : ctx_r81.hiddeFieldOptional.type) == "require");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", !field_r55.valueRequired && (ctx_r81.hiddeFieldOptional == null ? null : ctx_r81.hiddeFieldOptional.active) && (ctx_r81.hiddeFieldOptional == null ? null : ctx_r81.hiddeFieldOptional.type) == "optional");
    ɵɵadvance(1);
    ɵɵclassMapInterpolate1("form-control  ", field_r55.cssClassValue ? field_r55.cssClassValue : "", "");
    ɵɵproperty("type", "text")("formControlName", ctx_r81.getFieldIdentifier(field_r55.dataFieldItem.alternateName))("hidden", field_r55.hidden)("readOnly", field_r55.readonlyValue)("ngClass", ɵɵpureFunction2(19, _c3, ctx_r81.Validator.isInvalid(ctx_r81.getGroup(sub_section_r41.identifier, field_r55), ctx_r81.getFieldIdentifier(field_r55.dataFieldItem.alternateName)), ctx_r81.Validator.isValid(ctx_r81.getGroup(sub_section_r41.identifier, field_r55), ctx_r81.getFieldIdentifier(field_r55.dataFieldItem.alternateName))))("name", ctx_r81.getFieldIdentifier(field_r55.dataFieldItem.alternateName));
    ɵɵattribute("placeholder", field_r55.dataFieldItem.placeholder && ctx_r81.getGroup(sub_section_r41.identifier, field_r55).status != "DISABLED" ? field_r55.dataFieldItem.placeholder : null);
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_14_span_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "span", 68);
    ɵɵelement(1, "span", 11);
    ɵɵpipe(2, "i18n");
    ɵɵelementEnd();
} if (rf & 2) {
    ɵɵadvance(1);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(2, 1, "i18n-form-label-require"), ɵɵsanitizeHtml);
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_14_span_5_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "span", 68);
    ɵɵelement(1, "span", 11);
    ɵɵpipe(2, "i18n");
    ɵɵelementEnd();
} if (rf & 2) {
    ɵɵadvance(1);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(2, 1, "i18n-form-label-optional"), ɵɵsanitizeHtml);
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_14_div_7_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "div", 86);
    ɵɵpipe(1, "i18n");
} if (rf & 2) {
    const field_r55 = ɵɵnextContext(5).$implicit;
    const sub_section_r41 = ɵɵnextContext(2).sub_section;
    ɵɵproperty("innerHTML", field_r55.valueFields[sub_section_r41.identifier][field_r55.dataFieldItem.alternateName] ? field_r55.valueFields[sub_section_r41.identifier][field_r55.dataFieldItem.alternateName] : field_r55.defaultValue ? field_r55.defaultValue : ɵɵpipeBind1(1, 1, "--"), ɵɵsanitizeHtml);
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_14_Template(rf, ctx) { if (rf & 1) {
    const _r274 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 51);
    ɵɵelementStart(1, "label", 62);
    ɵɵelement(2, "span", 11);
    ɵɵpipe(3, "i18n");
    ɵɵtemplate(4, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_14_span_4_Template, 3, 3, "span", 63);
    ɵɵtemplate(5, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_14_span_5_Template, 3, 3, "span", 63);
    ɵɵelementEnd();
    ɵɵelementStart(6, "input", 84);
    ɵɵlistener("keyup", function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_14_Template_input_keyup_6_listener($event) { ɵɵrestoreView(_r274); const field_r55 = ɵɵnextContext(4).$implicit; const sub_section_r41 = ɵɵnextContext(2).sub_section; const ctx_r273 = ɵɵnextContext(); return ctx_r273.call_fn($event, sub_section_r41.identifier, field_r55); })("change", function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_14_Template_input_change_6_listener($event) { ɵɵrestoreView(_r274); const field_r55 = ɵɵnextContext(4).$implicit; const sub_section_r41 = ɵɵnextContext(2).sub_section; const ctx_r277 = ɵɵnextContext(); return ctx_r277.call_fn($event, sub_section_r41.identifier, field_r55); })("click", function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_14_Template_input_click_6_listener($event) { ɵɵrestoreView(_r274); const field_r55 = ɵɵnextContext(4).$implicit; const sub_section_r41 = ɵɵnextContext(2).sub_section; const ctx_r280 = ɵɵnextContext(); return ctx_r280.call_fn($event, sub_section_r41.identifier, field_r55); });
    ɵɵelementEnd();
    ɵɵtemplate(7, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_14_div_7_Template, 2, 3, "div", 85);
    ɵɵelementEnd();
} if (rf & 2) {
    const field_r55 = ɵɵnextContext(4).$implicit;
    const sub_section_r41 = ɵɵnextContext(2).sub_section;
    const ctx_r82 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵclassMapInterpolate1("", field_r55.cssClassLabel ? field_r55.cssClassLabel : "", " font-weight-normal");
    ɵɵproperty("hidden", field_r55.hidden);
    ɵɵadvance(1);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(3, 16, field_r55.dataFieldItem.label), ɵɵsanitizeHtml);
    ɵɵadvance(2);
    ɵɵproperty("ngIf", field_r55.valueRequired && (ctx_r82.hiddeFieldOptional == null ? null : ctx_r82.hiddeFieldOptional.active) && (ctx_r82.hiddeFieldOptional == null ? null : ctx_r82.hiddeFieldOptional.type) == "require");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", !field_r55.valueRequired && (ctx_r82.hiddeFieldOptional == null ? null : ctx_r82.hiddeFieldOptional.active) && (ctx_r82.hiddeFieldOptional == null ? null : ctx_r82.hiddeFieldOptional.type) == "optional");
    ɵɵadvance(1);
    ɵɵclassMapInterpolate1("form-control ", field_r55.cssClassValue ? field_r55.cssClassValue : "", "");
    ɵɵproperty("type", "date")("formControlName", ctx_r82.getFieldIdentifier(field_r55.dataFieldItem.alternateName))("ngClass", ɵɵpureFunction2(18, _c3, ctx_r82.Validator.isInvalid(ctx_r82.getGroup(sub_section_r41.identifier, field_r55), ctx_r82.getFieldIdentifier(field_r55.dataFieldItem.alternateName)), ctx_r82.Validator.isValid(ctx_r82.getGroup(sub_section_r41.identifier, field_r55), ctx_r82.getFieldIdentifier(field_r55.dataFieldItem.alternateName))))("name", ctx_r82.getFieldIdentifier(field_r55.dataFieldItem.alternateName));
    ɵɵattribute("placeholder", field_r55.dataFieldItem.placeholder && ctx_r82.getGroup(sub_section_r41.identifier, field_r55).status != "DISABLED" ? field_r55.dataFieldItem.placeholder : null);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", field_r55.disabledAllDiv);
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_15_Template(rf, ctx) { if (rf & 1) {
    const _r286 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 51);
    ɵɵelementStart(1, "label", 87);
    ɵɵelement(2, "small", 88);
    ɵɵpipe(3, "i18n");
    ɵɵelementStart(4, "input", 89);
    ɵɵlistener("click", function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_15_Template_input_click_4_listener($event) { ɵɵrestoreView(_r286); const field_r55 = ɵɵnextContext(4).$implicit; const sub_section_r41 = ɵɵnextContext(2).sub_section; const ctx_r285 = ɵɵnextContext(); return ctx_r285.onClickCheckbox($event, sub_section_r41.identifier, field_r55); });
    ɵɵelementEnd();
    ɵɵelement(5, "span", 90);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const field_r55 = ɵɵnextContext(4).$implicit;
    const ctx_r83 = ɵɵnextContext(3);
    ɵɵadvance(1);
    ɵɵproperty("hidden", field_r55.hidden || ctx_r83.hideCheckboxReadonlyMode[field_r55.dataFieldItem.alternateName] && !ctx_r83.getFieldValue(field_r55.dataFieldItem.alternateName) && ctx_r83.readonlyMode);
    ɵɵadvance(1);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(3, 9, field_r55.dataFieldItem.label), ɵɵsanitizeHtml);
    ɵɵadvance(2);
    ɵɵclassMap(field_r55.cssClassValue ? field_r55.cssClassValue : "");
    ɵɵproperty("value", field_r55.defaultValue)("hidden", field_r55.hidden)("readOnly", field_r55.readonlyValue)("formControlName", ctx_r83.getFieldIdentifier(field_r55.dataFieldItem.alternateName));
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_16_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    const _r294 = ɵɵgetCurrentView();
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "input", 93);
    ɵɵlistener("click", function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_16_ng_container_4_Template_input_click_1_listener($event) { ɵɵrestoreView(_r294); const lst_r291 = ctx.$implicit; const field_r55 = ɵɵnextContext(5).$implicit; const sub_section_r41 = ɵɵnextContext(2).sub_section; const ctx_r293 = ɵɵnextContext(); return ctx_r293.setValueRadio($event, sub_section_r41.identifier, field_r55, ctx_r293.defaultValueRadio(lst_r291.value)); });
    ɵɵelementEnd();
    ɵɵelement(2, "label", 94);
    ɵɵpipe(3, "i18n");
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const lst_r291 = ctx.$implicit;
    const field_r55 = ɵɵnextContext(5).$implicit;
    const ctx_r290 = ɵɵnextContext(3);
    ɵɵadvance(1);
    ɵɵproperty("formControlName", ctx_r290.getFieldIdentifier(field_r55.dataFieldItem.alternateName))("value", ctx_r290.defaultValueRadio(lst_r291.value))("checked", ctx_r290.defaultValueRadio(field_r55.defaultValue) == ctx_r290.defaultValueRadio(lst_r291.value) || ctx_r290.defaultValueRadio(lst_r291.value) == ctx_r290.defaultValueRadio(ctx_r290.getFieldValue(field_r55.dataFieldItem.alternateName)))("hidden", field_r55.hidden)("readOnly", field_r55.readonlyValue);
    ɵɵadvance(1);
    ɵɵclassMapInterpolate1("form-check-label ", field_r55.cssClassValue ? field_r55.cssClassValue : "", "");
    ɵɵproperty("innerHTML", ɵɵpipeBind1(3, 10, lst_r291 == null ? null : lst_r291.label), ɵɵsanitizeHtml)("hidden", field_r55.hidden);
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_16_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 51);
    ɵɵelement(1, "label", 91);
    ɵɵpipe(2, "i18n");
    ɵɵelementStart(3, "div", 92);
    ɵɵtemplate(4, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_16_ng_container_4_Template, 4, 12, "ng-container", 39);
    ɵɵpipe(5, "async");
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const field_r55 = ɵɵnextContext(4).$implicit;
    const ctx_r84 = ɵɵnextContext(3);
    ɵɵadvance(1);
    ɵɵclassMapInterpolate2("", field_r55.cssClassLabel ? field_r55.cssClassLabel : "", " ", field_r55.valueRequired ? "font-weight-bold " : "font-weight-normal", "");
    ɵɵproperty("innerHTML", ɵɵpipeBind1(2, 7, field_r55.dataFieldItem.label), ɵɵsanitizeHtml)("hidden", field_r55.hidden);
    ɵɵadvance(3);
    ɵɵproperty("ngForOf", ɵɵpipeBind1(5, 9, ctx_r84.akeelaDatasource.selectDatasource(field_r55)));
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_17_span_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "span", 68);
    ɵɵelement(1, "span", 11);
    ɵɵpipe(2, "i18n");
    ɵɵelementEnd();
} if (rf & 2) {
    ɵɵadvance(1);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(2, 1, "i18n-form-label-require"), ɵɵsanitizeHtml);
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_17_span_5_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "span", 68);
    ɵɵelement(1, "span", 11);
    ɵɵpipe(2, "i18n");
    ɵɵelementEnd();
} if (rf & 2) {
    ɵɵadvance(1);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(2, 1, "i18n-form-label-optional"), ɵɵsanitizeHtml);
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_17_div_7_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 69);
    ɵɵelement(1, "span", 70);
    ɵɵpipe(2, "i18n");
    ɵɵelementEnd();
} if (rf & 2) {
    const field_r55 = ɵɵnextContext(5).$implicit;
    ɵɵadvance(1);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(2, 1, field_r55 == null ? null : field_r55.dataFieldItem == null ? null : field_r55.dataFieldItem.inputGroupLeft), ɵɵsanitizeHtml);
} }
const _c6 = function (a0, a1) { return { " fa-eye": a0, "fa-eye-slash": a1 }; };
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_17_div_9_Template(rf, ctx) { if (rf & 1) {
    const _r307 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 96);
    ɵɵlistener("click", function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_17_div_9_Template_div_click_0_listener() { ɵɵrestoreView(_r307); const field_r55 = ɵɵnextContext(5).$implicit; const ctx_r305 = ɵɵnextContext(3); return ctx_r305.changeviewPassword(field_r55.dataFieldItem.alternateName); });
    ɵɵelement(1, "span", 97);
    ɵɵelementEnd();
} if (rf & 2) {
    const field_r55 = ɵɵnextContext(5).$implicit;
    const ctx_r302 = ɵɵnextContext(3);
    ɵɵadvance(1);
    ɵɵproperty("ngClass", ɵɵpureFunction2(1, _c6, ctx_r302.objectypeInputPass[field_r55.dataFieldItem.alternateName], !ctx_r302.objectypeInputPass[field_r55.dataFieldItem.alternateName]));
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_17_div_10_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 71);
    ɵɵelement(1, "span", 70);
    ɵɵpipe(2, "i18n");
    ɵɵelementEnd();
} if (rf & 2) {
    const field_r55 = ɵɵnextContext(5).$implicit;
    ɵɵadvance(1);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(2, 1, field_r55 == null ? null : field_r55.dataFieldItem == null ? null : field_r55.dataFieldItem.inputGroupRight), ɵɵsanitizeHtml);
} }
const _c7 = function (a0, a1, a2) { return { "password": a0, "error": a1, "valid": a2 }; };
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_17_Template(rf, ctx) { if (rf & 1) {
    const _r311 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 51);
    ɵɵelementStart(1, "label", 62);
    ɵɵelement(2, "span", 11);
    ɵɵpipe(3, "i18n");
    ɵɵtemplate(4, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_17_span_4_Template, 3, 3, "span", 63);
    ɵɵtemplate(5, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_17_span_5_Template, 3, 3, "span", 63);
    ɵɵelementEnd();
    ɵɵelementStart(6, "div", 64);
    ɵɵtemplate(7, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_17_div_7_Template, 3, 3, "div", 65);
    ɵɵelementStart(8, "input", 58);
    ɵɵlistener("keyup", function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_17_Template_input_keyup_8_listener($event) { ɵɵrestoreView(_r311); const field_r55 = ɵɵnextContext(4).$implicit; const sub_section_r41 = ɵɵnextContext(2).sub_section; const ctx_r310 = ɵɵnextContext(); return ctx_r310.call_fn($event, sub_section_r41.identifier, field_r55); })("change", function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_17_Template_input_change_8_listener($event) { ɵɵrestoreView(_r311); const field_r55 = ɵɵnextContext(4).$implicit; const sub_section_r41 = ɵɵnextContext(2).sub_section; const ctx_r314 = ɵɵnextContext(); return ctx_r314.call_fn($event, sub_section_r41.identifier, field_r55); })("click", function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_17_Template_input_click_8_listener($event) { ɵɵrestoreView(_r311); const field_r55 = ɵɵnextContext(4).$implicit; const sub_section_r41 = ɵɵnextContext(2).sub_section; const ctx_r317 = ɵɵnextContext(); return ctx_r317.call_fn($event, sub_section_r41.identifier, field_r55); });
    ɵɵelementEnd();
    ɵɵtemplate(9, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_17_div_9_Template, 2, 4, "div", 95);
    ɵɵtemplate(10, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_17_div_10_Template, 3, 3, "div", 67);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const field_r55 = ɵɵnextContext(4).$implicit;
    const sub_section_r41 = ɵɵnextContext(2).sub_section;
    const ctx_r85 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵclassMapInterpolate1("", field_r55.cssClassLabel ? field_r55.cssClassLabel : "", " font-weight-normal");
    ɵɵproperty("hidden", field_r55.hidden);
    ɵɵadvance(1);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(3, 22, field_r55.dataFieldItem.label), ɵɵsanitizeHtml);
    ɵɵadvance(2);
    ɵɵproperty("ngIf", field_r55.valueRequired && (ctx_r85.hiddeFieldOptional == null ? null : ctx_r85.hiddeFieldOptional.active) && (ctx_r85.hiddeFieldOptional == null ? null : ctx_r85.hiddeFieldOptional.type) == "require");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", !field_r55.valueRequired && (ctx_r85.hiddeFieldOptional == null ? null : ctx_r85.hiddeFieldOptional.active) && (ctx_r85.hiddeFieldOptional == null ? null : ctx_r85.hiddeFieldOptional.type) == "optional");
    ɵɵadvance(1);
    ɵɵproperty("ngClass", ɵɵpureFunction1(24, _c4, (field_r55 == null ? null : field_r55.dataFieldItem == null ? null : field_r55.dataFieldItem.inputGroupLeft) || (field_r55 == null ? null : field_r55.dataFieldItem == null ? null : field_r55.dataFieldItem.inputGroupRight) || field_r55.dataFieldItem.typeInput == "password"));
    ɵɵadvance(1);
    ɵɵproperty("ngIf", field_r55 == null ? null : field_r55.dataFieldItem == null ? null : field_r55.dataFieldItem.inputGroupLeft);
    ɵɵadvance(1);
    ɵɵclassMapInterpolate1("form-control ", field_r55.cssClassValue ? field_r55.cssClassValue : "", "");
    ɵɵproperty("type", field_r55.dataFieldItem.typeInput == "password" || field_r55.dataFieldItem.typeInput == "password-confirm" ? !ctx_r85.objectypeInputPass[field_r55.dataFieldItem.alternateName] ? field_r55.dataFieldItem.typeInput : "text" : field_r55.dataFieldItem.typeInput)("formControlName", ctx_r85.getFieldIdentifier(field_r55.dataFieldItem.alternateName))("hidden", field_r55.hidden)("readOnly", field_r55.readonlyValue)("ngClass", ɵɵpureFunction3(26, _c7, field_r55.dataFieldItem.typeInput == "password" || field_r55.dataFieldItem.typeInput == "password-confirm", ctx_r85.Validator.isInvalid(ctx_r85.getGroup(sub_section_r41.identifier, field_r55), ctx_r85.getFieldIdentifier(field_r55.dataFieldItem.alternateName)), ctx_r85.Validator.isValid(ctx_r85.getGroup(sub_section_r41.identifier, field_r55), ctx_r85.getFieldIdentifier(field_r55.dataFieldItem.alternateName))))("name", ctx_r85.getFieldIdentifier(field_r55.dataFieldItem.alternateName));
    ɵɵattribute("maxlength", field_r55.dataFieldItem.length && field_r55.dataFieldItem.length.maxValue ? field_r55.dataFieldItem.length.maxValue : null)("placeholder", field_r55.dataFieldItem.placeholder ? field_r55.dataFieldItem.placeholder : null);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", field_r55.dataFieldItem.typeInput == "password" || field_r55.dataFieldItem.typeInput == "password-confirm");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", field_r55 == null ? null : field_r55.dataFieldItem == null ? null : field_r55.dataFieldItem.inputGroupRight);
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_18_span_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "span", 68);
    ɵɵelement(1, "span", 11);
    ɵɵpipe(2, "i18n");
    ɵɵelementEnd();
} if (rf & 2) {
    ɵɵadvance(1);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(2, 1, "i18n-form-label-require"), ɵɵsanitizeHtml);
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_18_span_5_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "span", 68);
    ɵɵelement(1, "span", 11);
    ɵɵpipe(2, "i18n");
    ɵɵelementEnd();
} if (rf & 2) {
    ɵɵadvance(1);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(2, 1, "i18n-form-label-optional"), ɵɵsanitizeHtml);
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_18_div_8_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r329 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "button", 80);
    ɵɵlistener("click", function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_18_div_8_button_1_Template_button_click_0_listener() { ɵɵrestoreView(_r329); const field_r55 = ɵɵnextContext(6).$implicit; const sub_section_r41 = ɵɵnextContext(2).sub_section; const ctx_r327 = ɵɵnextContext(); return ctx_r327.showValidateEmail(sub_section_r41, field_r55); });
    ɵɵtext(1, "Validar");
    ɵɵelementEnd();
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_18_div_8_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "span", 81);
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_18_div_8_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 71);
    ɵɵtemplate(1, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_18_div_8_button_1_Template, 2, 0, "button", 78);
    ɵɵtemplate(2, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_18_div_8_span_2_Template, 1, 0, "span", 79);
    ɵɵelementEnd();
} if (rf & 2) {
    const field_r55 = ɵɵnextContext(5).$implicit;
    const ctx_r324 = ɵɵnextContext(3);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", !ctx_r324.emailValidates[ctx_r324.getValueField(field_r55)]);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r324.emailValidates[ctx_r324.getValueField(field_r55)]);
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_18_Template(rf, ctx) { if (rf & 1) {
    const _r333 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 51);
    ɵɵelementStart(1, "label", 62);
    ɵɵelement(2, "span", 11);
    ɵɵpipe(3, "i18n");
    ɵɵtemplate(4, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_18_span_4_Template, 3, 3, "span", 63);
    ɵɵtemplate(5, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_18_span_5_Template, 3, 3, "span", 63);
    ɵɵelementEnd();
    ɵɵelementStart(6, "div", 76);
    ɵɵelementStart(7, "input", 77);
    ɵɵlistener("keyup", function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_18_Template_input_keyup_7_listener($event) { ɵɵrestoreView(_r333); const field_r55 = ɵɵnextContext(4).$implicit; const sub_section_r41 = ɵɵnextContext(2).sub_section; const ctx_r332 = ɵɵnextContext(); return ctx_r332.call_fn($event, sub_section_r41.identifier, field_r55); })("change", function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_18_Template_input_change_7_listener($event) { ɵɵrestoreView(_r333); const field_r55 = ɵɵnextContext(4).$implicit; const sub_section_r41 = ɵɵnextContext(2).sub_section; const ctx_r336 = ɵɵnextContext(); return ctx_r336.call_fn($event, sub_section_r41.identifier, field_r55); })("click", function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_18_Template_input_click_7_listener($event) { ɵɵrestoreView(_r333); const field_r55 = ɵɵnextContext(4).$implicit; const sub_section_r41 = ɵɵnextContext(2).sub_section; const ctx_r339 = ɵɵnextContext(); return ctx_r339.call_fn($event, sub_section_r41.identifier, field_r55); });
    ɵɵelementEnd();
    ɵɵtemplate(8, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_18_div_8_Template, 3, 2, "div", 67);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const field_r55 = ɵɵnextContext(4).$implicit;
    const sub_section_r41 = ɵɵnextContext(2).sub_section;
    const ctx_r86 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵclassMapInterpolate1("", field_r55.cssClassLabel ? field_r55.cssClassLabel : "", " font-weight-normal");
    ɵɵproperty("hidden", field_r55.hidden);
    ɵɵadvance(1);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(3, 16, field_r55.dataFieldItem.label), ɵɵsanitizeHtml);
    ɵɵadvance(2);
    ɵɵproperty("ngIf", field_r55.valueRequired && (ctx_r86.hiddeFieldOptional == null ? null : ctx_r86.hiddeFieldOptional.active) && (ctx_r86.hiddeFieldOptional == null ? null : ctx_r86.hiddeFieldOptional.type) == "require");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", !field_r55.valueRequired && (ctx_r86.hiddeFieldOptional == null ? null : ctx_r86.hiddeFieldOptional.active) && (ctx_r86.hiddeFieldOptional == null ? null : ctx_r86.hiddeFieldOptional.type) == "optional");
    ɵɵadvance(2);
    ɵɵclassMapInterpolate1("form-control  ", field_r55.cssClassValue ? field_r55.cssClassValue : "", " text-lowercase");
    ɵɵproperty("type", "text")("formControlName", ctx_r86.getFieldIdentifier(field_r55.dataFieldItem.alternateName))("ngClass", ɵɵpureFunction2(18, _c3, ctx_r86.Validator.isInvalid(ctx_r86.getGroup(sub_section_r41.identifier, field_r55), ctx_r86.getFieldIdentifier(field_r55.dataFieldItem.alternateName)), ctx_r86.Validator.isValid(ctx_r86.getGroup(sub_section_r41.identifier, field_r55), ctx_r86.getFieldIdentifier(field_r55.dataFieldItem.alternateName))))("name", ctx_r86.getFieldIdentifier(field_r55.dataFieldItem.alternateName));
    ɵɵattribute("placeholder", field_r55.dataFieldItem.placeholder && ctx_r86.getGroup(sub_section_r41.identifier, field_r55).status != "DISABLED" ? field_r55.dataFieldItem.placeholder : null);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", !ctx_r86.Validator.hasPatternError(ctx_r86.getGroup(sub_section_r41.identifier, field_r55), ctx_r86.getFieldIdentifier(field_r55.dataFieldItem.alternateName)) && !ctx_r86.Validator.hasRequiredError(ctx_r86.getGroup(sub_section_r41.identifier, field_r55), ctx_r86.getFieldIdentifier(field_r55.dataFieldItem.alternateName)) && !ctx_r86.Validator.hasMinError(ctx_r86.getGroup(sub_section_r41.identifier, field_r55), ctx_r86.getFieldIdentifier(field_r55.dataFieldItem.alternateName)) && !ctx_r86.Validator.hasMaxError(ctx_r86.getGroup(sub_section_r41.identifier, field_r55), ctx_r86.getFieldIdentifier(field_r55.dataFieldItem.alternateName)) && !ctx_r86.getGroup(sub_section_r41.identifier, field_r55).get(ctx_r86.getFieldIdentifier(field_r55.dataFieldItem.alternateName)).pristine);
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_19_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 98);
    ɵɵelement(1, "span", 99);
    ɵɵpipe(2, "i18n");
    ɵɵelementEnd();
} if (rf & 2) {
    const field_r55 = ɵɵnextContext(4).$implicit;
    ɵɵadvance(1);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(2, 1, field_r55 == null ? null : field_r55.dataFieldItem == null ? null : field_r55.dataFieldItem.tooltip), ɵɵsanitizeHtml);
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_20_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 100);
    ɵɵelementStart(1, "div", 101);
    ɵɵelementStart(2, "div", 102);
    ɵɵelement(3, "i");
    ɵɵtext(4, " Entre 8 y 12 car\u00E1cteres. ");
    ɵɵelementEnd();
    ɵɵelementStart(5, "div", 102);
    ɵɵelement(6, "i");
    ɵɵtext(7, " Debe contener n\u00FAmeros. ");
    ɵɵelementEnd();
    ɵɵelementStart(8, "div", 102);
    ɵɵelement(9, "i");
    ɵɵtext(10, " Debe contener letr\u00E1s may\u00FAsculas y min\u00FAsculas. ");
    ɵɵelementEnd();
    ɵɵelementStart(11, "div", 102);
    ɵɵelement(12, "i");
    ɵɵtext(13, " Debe contener car\u00E1cteres especiales. ");
    ɵɵelementEnd();
    ɵɵelementStart(14, "div", 102);
    ɵɵelement(15, "i");
    ɵɵtext(16, " No debe contener: M\u00E1s de 3 caracteres consecutivos iguales (alfab\u00E9ticos, num\u00E9ricos o especiales). ");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const field_r55 = ɵɵnextContext(4).$implicit;
    const ctx_r88 = ɵɵnextContext(3);
    ɵɵadvance(3);
    ɵɵclassMapInterpolate1("fas fa-", ctx_r88.validateMinMaxLen(ctx_r88.getFieldValue(field_r55.dataFieldItem.alternateName)) ? "check-" : "", "circle");
    ɵɵclassProp("checked", ctx_r88.validateMinMaxLen(ctx_r88.getFieldValue(field_r55.dataFieldItem.alternateName)))("uncheck", !ctx_r88.validateMinMaxLen(ctx_r88.getFieldValue(field_r55.dataFieldItem.alternateName)));
    ɵɵadvance(3);
    ɵɵclassMapInterpolate1("fas fa-", ctx_r88.validateExistsNumber(ctx_r88.getFieldValue(field_r55.dataFieldItem.alternateName)) ? "check-" : "", "circle");
    ɵɵclassProp("checked", ctx_r88.validateExistsNumber(ctx_r88.getFieldValue(field_r55.dataFieldItem.alternateName)))("uncheck", !ctx_r88.validateExistsNumber(ctx_r88.getFieldValue(field_r55.dataFieldItem.alternateName)));
    ɵɵadvance(3);
    ɵɵclassMapInterpolate1("fas fa-", ctx_r88.validateUpperAndLowerLetter(ctx_r88.getFieldValue(field_r55.dataFieldItem.alternateName)) ? "check-" : "", "circle");
    ɵɵclassProp("checked", ctx_r88.validateUpperAndLowerLetter(ctx_r88.getFieldValue(field_r55.dataFieldItem.alternateName)))("uncheck", !ctx_r88.validateUpperAndLowerLetter(ctx_r88.getFieldValue(field_r55.dataFieldItem.alternateName)));
    ɵɵadvance(3);
    ɵɵclassMapInterpolate1("fas fa-", ctx_r88.validateSpecialCharacters(ctx_r88.getFieldValue(field_r55.dataFieldItem.alternateName)) ? "check-" : "", "circle");
    ɵɵclassProp("checked", ctx_r88.validateSpecialCharacters(ctx_r88.getFieldValue(field_r55.dataFieldItem.alternateName)))("uncheck", !ctx_r88.validateSpecialCharacters(ctx_r88.getFieldValue(field_r55.dataFieldItem.alternateName)));
    ɵɵadvance(3);
    ɵɵclassMapInterpolate1("fas fa-", ctx_r88.validateConsecutive(ctx_r88.getFieldValue(field_r55.dataFieldItem.alternateName)) ? "check-" : "", "circle");
    ɵɵclassProp("checked", ctx_r88.validateConsecutive(ctx_r88.getFieldValue(field_r55.dataFieldItem.alternateName)))("uncheck", !ctx_r88.validateConsecutive(ctx_r88.getFieldValue(field_r55.dataFieldItem.alternateName)));
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_22_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 103);
    ɵɵtext(1, " Campo requerido. ");
    ɵɵelementEnd();
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_22_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 51);
    ɵɵtemplate(1, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_22_div_1_Template, 2, 0, "div", 57);
    ɵɵelementEnd();
} if (rf & 2) {
    const field_r55 = ɵɵnextContext(4).$implicit;
    const sub_section_r41 = ɵɵnextContext(2).sub_section;
    const ctx_r89 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r89.Validator.hasRequiredError(ctx_r89.getGroup(sub_section_r41.identifier, field_r55), ctx_r89.getFieldIdentifier(field_r55.dataFieldItem.alternateName)));
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_23_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 103);
    ɵɵtext(1);
    ɵɵpipe(2, "numberI18n");
    ɵɵpipe(3, "number");
    ɵɵelementEnd();
} if (rf & 2) {
    const field_r55 = ɵɵnextContext(5).$implicit;
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" Monto m\u00E1ximo \"", ɵɵpipeBind2(2, 1, ɵɵpipeBind2(3, 4, field_r55.maxValue, "1.2-2"), "es"), "\" ");
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_23_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 51);
    ɵɵtemplate(1, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_23_div_1_Template, 4, 7, "div", 57);
    ɵɵelementEnd();
} if (rf & 2) {
    const field_r55 = ɵɵnextContext(4).$implicit;
    const sub_section_r41 = ɵɵnextContext(2).sub_section;
    const ctx_r90 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r90.Validator.hasMaxError(ctx_r90.getGroup(sub_section_r41.identifier, field_r55), ctx_r90.getFieldIdentifier(field_r55.dataFieldItem.alternateName)));
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_24_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 103);
    ɵɵtext(1);
    ɵɵpipe(2, "numberI18n");
    ɵɵpipe(3, "number");
    ɵɵelementEnd();
} if (rf & 2) {
    const field_r55 = ɵɵnextContext(5).$implicit;
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" Monto m\u00EDnimo \"", ɵɵpipeBind2(2, 1, ɵɵpipeBind2(3, 4, field_r55.minValue, "1.2-2"), "es"), "\" ");
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_24_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 51);
    ɵɵtemplate(1, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_24_div_1_Template, 4, 7, "div", 57);
    ɵɵelementEnd();
} if (rf & 2) {
    const field_r55 = ɵɵnextContext(4).$implicit;
    const sub_section_r41 = ɵɵnextContext(2).sub_section;
    const ctx_r91 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r91.Validator.hasMinError(ctx_r91.getGroup(sub_section_r41.identifier, field_r55), ctx_r91.getFieldIdentifier(field_r55.dataFieldItem.alternateName)));
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_25_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 103);
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const field_r55 = ɵɵnextContext(5).$implicit;
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" Valor m\u00E1ximo \"", field_r55.maxValue, "\" ");
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_25_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 51);
    ɵɵtemplate(1, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_25_div_1_Template, 2, 1, "div", 57);
    ɵɵelementEnd();
} if (rf & 2) {
    const field_r55 = ɵɵnextContext(4).$implicit;
    const sub_section_r41 = ɵɵnextContext(2).sub_section;
    const ctx_r92 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r92.Validator.hasMaxError(ctx_r92.getGroup(sub_section_r41.identifier, field_r55), ctx_r92.getFieldIdentifier(field_r55.dataFieldItem.alternateName)));
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_26_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 103);
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const field_r55 = ɵɵnextContext(5).$implicit;
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" Valor m\u00EDnimo \"", field_r55.minValue, "\" ");
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_26_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 51);
    ɵɵtemplate(1, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_26_div_1_Template, 2, 1, "div", 57);
    ɵɵelementEnd();
} if (rf & 2) {
    const field_r55 = ɵɵnextContext(4).$implicit;
    const sub_section_r41 = ɵɵnextContext(2).sub_section;
    const ctx_r93 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r93.Validator.hasMinError(ctx_r93.getGroup(sub_section_r41.identifier, field_r55), ctx_r93.getFieldIdentifier(field_r55.dataFieldItem.alternateName)));
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_ng_container_27_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 103);
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const field_r55 = ɵɵnextContext(6).$implicit;
    const sub_section_r41 = ɵɵnextContext(2).sub_section;
    const ctx_r366 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" M\u00E1ximo \"", ctx_r366.getGroup(sub_section_r41.identifier, field_r55).get(ctx_r366.getFieldIdentifier(field_r55.dataFieldItem.alternateName)).errors == null ? null : ctx_r366.getGroup(sub_section_r41.identifier, field_r55).get(ctx_r366.getFieldIdentifier(field_r55.dataFieldItem.alternateName)).errors.maxlength.requiredLength, " caracteres\" ");
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_ng_container_27_div_1_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 103);
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const field_r55 = ɵɵnextContext(6).$implicit;
    const sub_section_r41 = ɵɵnextContext(2).sub_section;
    const ctx_r367 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" M\u00EDnimo \"", ctx_r367.getGroup(sub_section_r41.identifier, field_r55).get(ctx_r367.getFieldIdentifier(field_r55.dataFieldItem.alternateName)).errors == null ? null : ctx_r367.getGroup(sub_section_r41.identifier, field_r55).get(ctx_r367.getFieldIdentifier(field_r55.dataFieldItem.alternateName)).errors.minlength.requiredLength, " caracteres\" ");
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_ng_container_27_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 51);
    ɵɵtemplate(1, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_ng_container_27_div_1_div_1_Template, 2, 1, "div", 57);
    ɵɵtemplate(2, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_ng_container_27_div_1_div_2_Template, 2, 1, "div", 57);
    ɵɵelementEnd();
} if (rf & 2) {
    const field_r55 = ɵɵnextContext(5).$implicit;
    const sub_section_r41 = ɵɵnextContext(2).sub_section;
    const ctx_r365 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r365.Validator.hasMaxLengthError(ctx_r365.getGroup(sub_section_r41.identifier, field_r55), ctx_r365.getFieldIdentifier(field_r55.dataFieldItem.alternateName)));
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r365.Validator.hasMinLengthError(ctx_r365.getGroup(sub_section_r41.identifier, field_r55), ctx_r365.getFieldIdentifier(field_r55.dataFieldItem.alternateName)));
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_ng_container_27_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_ng_container_27_div_1_Template, 3, 2, "div", 47);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const field_r55 = ɵɵnextContext(4).$implicit;
    ɵɵadvance(1);
    ɵɵproperty("ngIf", field_r55 == null ? null : field_r55.dataFieldItem == null ? null : field_r55.dataFieldItem.length);
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_28_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 103);
    ɵɵtext(1, " Correo Invalido ");
    ɵɵelementEnd();
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_28_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 51);
    ɵɵtemplate(1, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_28_div_1_Template, 2, 0, "div", 57);
    ɵɵelementEnd();
} if (rf & 2) {
    const field_r55 = ɵɵnextContext(4).$implicit;
    const sub_section_r41 = ɵɵnextContext(2).sub_section;
    const ctx_r95 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r95.Validator.hasEmailError(ctx_r95.getGroup(sub_section_r41.identifier, field_r55), ctx_r95.getFieldIdentifier(field_r55.dataFieldItem.alternateName)));
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_ng_container_29_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 103);
    ɵɵelement(1, "span", 11);
    ɵɵpipe(2, "i18n");
    ɵɵelementEnd();
} if (rf & 2) {
    const field_r55 = ɵɵnextContext(6).$implicit;
    ɵɵadvance(1);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(2, 1, field_r55 == null ? null : field_r55.dataFieldItem == null ? null : field_r55.dataFieldItem.patternLabel), ɵɵsanitizeHtml);
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_ng_container_29_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 51);
    ɵɵtemplate(1, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_ng_container_29_div_1_div_1_Template, 3, 3, "div", 57);
    ɵɵelementEnd();
} if (rf & 2) {
    const field_r55 = ɵɵnextContext(5).$implicit;
    const sub_section_r41 = ɵɵnextContext(2).sub_section;
    const ctx_r378 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r378.Validator.hasPatternError(ctx_r378.getGroup(sub_section_r41.identifier, field_r55), ctx_r378.getFieldIdentifier(field_r55.dataFieldItem.alternateName)));
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_ng_container_29_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_ng_container_29_div_1_Template, 2, 1, "div", 47);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const field_r55 = ɵɵnextContext(4).$implicit;
    const sub_section_r41 = ɵɵnextContext(2).sub_section;
    const ctx_r96 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r96.Validator.hasPatternError(ctx_r96.getGroup(sub_section_r41.identifier, field_r55), ctx_r96.getFieldIdentifier(field_r55.dataFieldItem.alternateName)));
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_30_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 103);
    ɵɵtext(1, " Las contrase\u00F1as no coinciden. ");
    ɵɵelementEnd();
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_31_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 103);
    ɵɵtext(1, " Debe ser mayor de 18 a\u00F1os ");
    ɵɵelementEnd();
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_32_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 103);
    ɵɵtext(1, " Debe validar el numero telef\u00F3nico ");
    ɵɵelementEnd();
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_33_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 103);
    ɵɵtext(1, " Debe validar el Correo electr\u00F3nico ");
    ɵɵelementEnd();
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_34_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 103);
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const field_r55 = ɵɵnextContext(4).$implicit;
    const sub_section_r41 = ɵɵnextContext(2).sub_section;
    const ctx_r101 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ctx_r101.Validator.hasValidateRangeValueProductError(ctx_r101.getGroup(sub_section_r41.identifier, field_r55), ctx_r101.getFieldIdentifier(field_r55.dataFieldItem.alternateName)), " ");
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_35_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 103);
    ɵɵtext(1, " El a\u00F1o debe ser mayor a 1900 ");
    ɵɵelementEnd();
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_36_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 103);
    ɵɵtext(1, " La fecha no puede ser mayor a la fecha actual. ");
    ɵɵelementEnd();
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_37_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 103);
    ɵɵtext(1, " La fecha no puede ser menor a la fecha actual. ");
    ɵɵelementEnd();
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_38_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 103);
    ɵɵtext(1, " Ya esta registrado. ");
    ɵɵelementEnd();
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_39_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 103);
    ɵɵtext(1);
    ɵɵpipe(2, "i18n");
    ɵɵelementEnd();
} if (rf & 2) {
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ɵɵpipeBind1(2, 1, "@i18n-text-error-bussiness-not-exist"), " ");
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_40_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 103);
    ɵɵtext(1, " Verificando existencia... ");
    ɵɵelement(2, "i", 104);
    ɵɵelementEnd();
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 51);
    ɵɵtemplate(1, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_1_Template, 2, 13, "div", 47);
    ɵɵtemplate(2, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_2_Template, 3, 3, "div", 52);
    ɵɵtemplate(3, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_3_Template, 1, 0, "div", 53);
    ɵɵtemplate(4, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_4_Template, 10, 29, "div", 54);
    ɵɵtemplate(5, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_5_Template, 10, 28, "div", 47);
    ɵɵtemplate(6, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_6_Template, 7, 25, "div", 47);
    ɵɵtemplate(7, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_7_Template, 7, 22, "div", 47);
    ɵɵtemplate(8, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_8_Template, 7, 22, "div", 47);
    ɵɵtemplate(9, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_9_Template, 4, 7, "div", 47);
    ɵɵtemplate(10, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_10_Template, 7, 21, "div", 47);
    ɵɵtemplate(11, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_11_Template, 9, 21, "div", 47);
    ɵɵtemplate(12, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_12_Template, 10, 20, "div", 47);
    ɵɵtemplate(13, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_13_Template, 7, 22, "div", 47);
    ɵɵtemplate(14, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_14_Template, 8, 21, "div", 47);
    ɵɵtemplate(15, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_15_Template, 6, 11, "div", 47);
    ɵɵtemplate(16, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_16_Template, 6, 11, "div", 47);
    ɵɵtemplate(17, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_17_Template, 11, 30, "div", 54);
    ɵɵtemplate(18, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_18_Template, 9, 21, "div", 47);
    ɵɵtemplate(19, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_19_Template, 3, 3, "div", 55);
    ɵɵtemplate(20, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_20_Template, 17, 35, "div", 56);
    ɵɵelementStart(21, "div");
    ɵɵtemplate(22, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_22_Template, 2, 1, "div", 47);
    ɵɵtemplate(23, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_23_Template, 2, 1, "div", 47);
    ɵɵtemplate(24, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_24_Template, 2, 1, "div", 47);
    ɵɵtemplate(25, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_25_Template, 2, 1, "div", 47);
    ɵɵtemplate(26, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_26_Template, 2, 1, "div", 47);
    ɵɵtemplate(27, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_ng_container_27_Template, 2, 1, "ng-container", 2);
    ɵɵtemplate(28, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_28_Template, 2, 1, "div", 47);
    ɵɵtemplate(29, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_ng_container_29_Template, 2, 1, "ng-container", 2);
    ɵɵtemplate(30, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_30_Template, 2, 0, "div", 57);
    ɵɵtemplate(31, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_31_Template, 2, 0, "div", 57);
    ɵɵtemplate(32, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_32_Template, 2, 0, "div", 57);
    ɵɵtemplate(33, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_33_Template, 2, 0, "div", 57);
    ɵɵtemplate(34, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_34_Template, 2, 1, "div", 57);
    ɵɵtemplate(35, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_35_Template, 2, 0, "div", 57);
    ɵɵtemplate(36, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_36_Template, 2, 0, "div", 57);
    ɵɵtemplate(37, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_37_Template, 2, 0, "div", 57);
    ɵɵtemplate(38, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_38_Template, 2, 0, "div", 57);
    ɵɵtemplate(39, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_39_Template, 3, 3, "div", 57);
    ɵɵtemplate(40, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_div_40_Template, 3, 0, "div", 57);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const field_r55 = ɵɵnextContext(3).$implicit;
    const sub_section_r41 = ɵɵnextContext(2).sub_section;
    const ctx_r60 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("ngIf", field_r55.dataFieldItem.typeInput == "hiddenValue" || field_r55.dataFieldItem.typeInput == "hiddenProperty");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", field_r55.dataFieldItem.typeInput == "hiddenProperty");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", field_r55.dataFieldItem.typeInput == "hiddenValue");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", field_r55.dataFieldItem.typeInput == "mount" || field_r55.dataFieldItem.typeInput == "list-mount");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", field_r55.dataFieldItem.typeInput == "integer");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", field_r55.dataFieldItem.typeInput == "year");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", field_r55.dataFieldItem.typeInput == "rif");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", field_r55.dataFieldItem.typeInput == "identifier");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", field_r55.dataFieldItem.typeInput == "search");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", field_r55.dataFieldItem.typeInput == "tel");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", field_r55.dataFieldItem.typeInput == "telValidate");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", field_r55.dataFieldItem.typeInput == "textWithLinkSuggestion");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", field_r55.dataFieldItem.typeInput == "passport");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", field_r55.dataFieldItem.typeInput == "date");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", field_r55.dataFieldItem.typeInput == "checkbox");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", field_r55.dataFieldItem.typeInput == "radio");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", field_r55.dataFieldItem.typeInput == "password-confirm" || field_r55.dataFieldItem.typeInput == "password" || field_r55.dataFieldItem.typeInput == "email" || field_r55.dataFieldItem.typeInput == "text" || field_r55.dataFieldItem.typeInput == "number" || field_r55.dataFieldItem.typeInput == "hidden");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", field_r55.dataFieldItem.typeInput == "emailValidate");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", field_r55 == null ? null : field_r55.dataFieldItem == null ? null : field_r55.dataFieldItem.tooltip);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", field_r55.dataFieldItem.typeInput === "password" && !ctx_r60.validateIfConfirm(field_r55));
    ɵɵadvance(1);
    ɵɵclassMap(field_r55.cssClassValidation);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", field_r55.valueRequired);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", field_r55.maxValue && field_r55.dataFieldItem.typeInput === "mount");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", field_r55.minValue && field_r55.dataFieldItem.typeInput === "mount");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", field_r55.maxValue && field_r55.dataFieldItem.typeInput !== "mount");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", field_r55.minValue && field_r55.dataFieldItem.typeInput !== "mount");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", field_r55.dataFieldItem.typeInput !== "password" || field_r55.dataFieldItem.typeInput !== "password-confirm");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", field_r55.dataFieldItem.typeInput == "email");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", field_r55.dataFieldItem.typeInput !== "password" || field_r55.dataFieldItem.typeInput !== "password-confirm");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r60.Validator.hasPasswordDistinctError(ctx_r60.getGroup(sub_section_r41.identifier, field_r55), ctx_r60.getFieldIdentifier(field_r55.dataFieldItem.alternateName)));
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r60.Validator.hasValidateDate18Error(ctx_r60.getGroup(sub_section_r41.identifier, field_r55), ctx_r60.getFieldIdentifier(field_r55.dataFieldItem.alternateName)));
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r60.Validator.hasValidatePhoneError(ctx_r60.getGroup(sub_section_r41.identifier, field_r55), ctx_r60.getFieldIdentifier(field_r55.dataFieldItem.alternateName)));
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r60.Validator.hasValidateEmailError(ctx_r60.getGroup(sub_section_r41.identifier, field_r55), ctx_r60.getFieldIdentifier(field_r55.dataFieldItem.alternateName)));
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r60.Validator.hasValidateRangeValueProductError(ctx_r60.getGroup(sub_section_r41.identifier, field_r55), ctx_r60.getFieldIdentifier(field_r55.dataFieldItem.alternateName)));
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r60.Validator.hasValidateDateError(ctx_r60.getGroup(sub_section_r41.identifier, field_r55), ctx_r60.getFieldIdentifier(field_r55.dataFieldItem.alternateName)));
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r60.Validator.hasValidateDateUpperError(ctx_r60.getGroup(sub_section_r41.identifier, field_r55), ctx_r60.getFieldIdentifier(field_r55.dataFieldItem.alternateName)));
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r60.Validator.hasValidateDateLowerError(ctx_r60.getGroup(sub_section_r41.identifier, field_r55), ctx_r60.getFieldIdentifier(field_r55.dataFieldItem.alternateName)));
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r60.Validator.hasValidationError(ctx_r60.getGroup(sub_section_r41.identifier, field_r55), ctx_r60.getFieldIdentifier(field_r55.dataFieldItem.alternateName)));
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r60.Validator.hasValidationExistError(ctx_r60.getGroup(sub_section_r41.identifier, field_r55), ctx_r60.getFieldIdentifier(field_r55.dataFieldItem.alternateName)));
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r60.getGroup(sub_section_r41.identifier, field_r55).get(ctx_r60.getFieldIdentifier(field_r55.dataFieldItem.alternateName)).pending && !ctx_r60.getGroup(sub_section_r41.identifier, field_r55).get(ctx_r60.getFieldIdentifier(field_r55.dataFieldItem.alternateName)).pristine);
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_4_span_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "span", 68);
    ɵɵelement(1, "span", 11);
    ɵɵpipe(2, "i18n");
    ɵɵelementEnd();
} if (rf & 2) {
    ɵɵadvance(1);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(2, 1, "i18n-form-label-require"), ɵɵsanitizeHtml);
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_4_span_5_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "span", 68);
    ɵɵelement(1, "span", 11);
    ɵɵpipe(2, "i18n");
    ɵɵelementEnd();
} if (rf & 2) {
    ɵɵadvance(1);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(2, 1, "i18n-form-label-optional"), ɵɵsanitizeHtml);
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_4_div_8_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 98);
    ɵɵelement(1, "span", 99);
    ɵɵpipe(2, "i18n");
    ɵɵelementEnd();
} if (rf & 2) {
    const field_r55 = ɵɵnextContext(4).$implicit;
    ɵɵadvance(1);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(2, 1, field_r55 == null ? null : field_r55.dataFieldItem == null ? null : field_r55.dataFieldItem.tooltip), ɵɵsanitizeHtml);
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_4_div_10_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 103);
    ɵɵtext(1, " Campo requerido. ");
    ɵɵelementEnd();
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_4_div_10_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 51);
    ɵɵtemplate(1, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_4_div_10_div_1_Template, 2, 0, "div", 57);
    ɵɵelementEnd();
} if (rf & 2) {
    const field_r55 = ɵɵnextContext(4).$implicit;
    const sub_section_r41 = ɵɵnextContext(2).sub_section;
    const ctx_r392 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r392.Validator.hasRequiredError(ctx_r392.getGroup(sub_section_r41.identifier, field_r55), ctx_r392.getFieldIdentifier(field_r55.dataFieldItem.alternateName)));
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_4_div_11_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 103);
    ɵɵelement(1, "span", 11);
    ɵɵpipe(2, "i18n");
    ɵɵelementEnd();
} if (rf & 2) {
    const field_r55 = ɵɵnextContext(5).$implicit;
    ɵɵadvance(1);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(2, 1, field_r55 == null ? null : field_r55.dataFieldItem == null ? null : field_r55.dataFieldItem.patternLabel), ɵɵsanitizeHtml);
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_4_div_11_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 51);
    ɵɵtemplate(1, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_4_div_11_div_1_Template, 3, 3, "div", 57);
    ɵɵelementEnd();
} if (rf & 2) {
    const field_r55 = ɵɵnextContext(4).$implicit;
    const sub_section_r41 = ɵɵnextContext(2).sub_section;
    const ctx_r393 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r393.Validator.hasPatternError(ctx_r393.getGroup(sub_section_r41.identifier, field_r55), ctx_r393.getFieldIdentifier(field_r55.dataFieldItem.alternateName)));
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r403 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 51);
    ɵɵelementStart(1, "label", 62);
    ɵɵelement(2, "span", 11);
    ɵɵpipe(3, "i18n");
    ɵɵtemplate(4, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_4_span_4_Template, 3, 3, "span", 63);
    ɵɵtemplate(5, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_4_span_5_Template, 3, 3, "span", 63);
    ɵɵelementEnd();
    ɵɵelementStart(6, "textarea", 105);
    ɵɵlistener("keyup", function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_4_Template_textarea_keyup_6_listener($event) { ɵɵrestoreView(_r403); const field_r55 = ɵɵnextContext(3).$implicit; const sub_section_r41 = ɵɵnextContext(2).sub_section; const ctx_r402 = ɵɵnextContext(); return ctx_r402.call_fn($event, sub_section_r41.identifier, field_r55); })("change", function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_4_Template_textarea_change_6_listener($event) { ɵɵrestoreView(_r403); const field_r55 = ɵɵnextContext(3).$implicit; const sub_section_r41 = ɵɵnextContext(2).sub_section; const ctx_r406 = ɵɵnextContext(); return ctx_r406.call_fn($event, sub_section_r41.identifier, field_r55); })("click", function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_4_Template_textarea_click_6_listener($event) { ɵɵrestoreView(_r403); const field_r55 = ɵɵnextContext(3).$implicit; const sub_section_r41 = ɵɵnextContext(2).sub_section; const ctx_r409 = ɵɵnextContext(); return ctx_r409.call_fn($event, sub_section_r41.identifier, field_r55); });
    ɵɵtext(7, "                        ");
    ɵɵelementEnd();
    ɵɵtemplate(8, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_4_div_8_Template, 3, 3, "div", 55);
    ɵɵelementStart(9, "div");
    ɵɵtemplate(10, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_4_div_10_Template, 2, 1, "div", 47);
    ɵɵelementEnd();
    ɵɵtemplate(11, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_4_div_11_Template, 2, 1, "div", 47);
    ɵɵelementEnd();
} if (rf & 2) {
    const field_r55 = ɵɵnextContext(3).$implicit;
    const sub_section_r41 = ɵɵnextContext(2).sub_section;
    const ctx_r61 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵclassMapInterpolate1("", field_r55.cssClassLabel ? field_r55.cssClassLabel : "", " font-weight-normal");
    ɵɵproperty("hidden", field_r55.hidden);
    ɵɵadvance(1);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(3, 21, field_r55.dataFieldItem.label), ɵɵsanitizeHtml);
    ɵɵadvance(2);
    ɵɵproperty("ngIf", field_r55.valueRequired && (ctx_r61.hiddeFieldOptional == null ? null : ctx_r61.hiddeFieldOptional.active) && (ctx_r61.hiddeFieldOptional == null ? null : ctx_r61.hiddeFieldOptional.type) == "require");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", !field_r55.valueRequired && (ctx_r61.hiddeFieldOptional == null ? null : ctx_r61.hiddeFieldOptional.active) && (ctx_r61.hiddeFieldOptional == null ? null : ctx_r61.hiddeFieldOptional.type) == "optional");
    ɵɵadvance(1);
    ɵɵclassMapInterpolate1("form-control ", field_r55.cssClassValue ? field_r55.cssClassValue : "", "");
    ɵɵproperty("formControlName", ctx_r61.getFieldIdentifier(field_r55.dataFieldItem.alternateName))("ngClass", ɵɵpureFunction2(23, _c3, ctx_r61.Validator.isInvalid(ctx_r61.getGroup(sub_section_r41.identifier, field_r55), ctx_r61.getFieldIdentifier(field_r55.dataFieldItem.alternateName)), ctx_r61.Validator.isValid(ctx_r61.getGroup(sub_section_r41.identifier, field_r55), ctx_r61.getFieldIdentifier(field_r55.dataFieldItem.alternateName))))("hidden", field_r55.hidden)("name", ctx_r61.getFieldIdentifier(field_r55.dataFieldItem.alternateName));
    ɵɵattribute("placeholder", field_r55.dataFieldItem.placeholder ? field_r55.dataFieldItem.placeholder : null);
    ɵɵadvance(2);
    ɵɵproperty("ngIf", field_r55 == null ? null : field_r55.dataFieldItem == null ? null : field_r55.dataFieldItem.tooltip);
    ɵɵadvance(1);
    ɵɵclassMap(field_r55.cssClassValidation);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", field_r55.valueRequired);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r61.Validator.hasPatternError(ctx_r61.getGroup(sub_section_r41.identifier, field_r55), ctx_r61.getFieldIdentifier(field_r55.dataFieldItem.alternateName)));
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_5_div_1_span_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "span", 68);
    ɵɵelement(1, "span", 11);
    ɵɵpipe(2, "i18n");
    ɵɵelementEnd();
} if (rf & 2) {
    ɵɵadvance(1);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(2, 1, "i18n-form-label-require"), ɵɵsanitizeHtml);
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_5_div_1_span_5_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "span", 68);
    ɵɵelement(1, "span", 11);
    ɵɵpipe(2, "i18n");
    ɵɵelementEnd();
} if (rf & 2) {
    ɵɵadvance(1);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(2, 1, "i18n-form-label-optional"), ɵɵsanitizeHtml);
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_5_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 51);
    ɵɵelementStart(1, "label", 62);
    ɵɵelement(2, "span", 11);
    ɵɵpipe(3, "i18n");
    ɵɵtemplate(4, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_5_div_1_span_4_Template, 3, 3, "span", 63);
    ɵɵtemplate(5, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_5_div_1_span_5_Template, 3, 3, "span", 63);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const field_r55 = ɵɵnextContext(4).$implicit;
    const ctx_r414 = ɵɵnextContext(3);
    ɵɵadvance(1);
    ɵɵclassMapInterpolate2("", field_r55.cssClassLabel ? field_r55.cssClassLabel : "", " ", field_r55.dataFieldItem.typeInput == "selectButton" ? "mb-2" : "", " font-weight-normal");
    ɵɵproperty("hidden", field_r55.hidden);
    ɵɵadvance(1);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(3, 8, field_r55.dataFieldItem.label), ɵɵsanitizeHtml);
    ɵɵadvance(2);
    ɵɵproperty("ngIf", field_r55.valueRequired && (ctx_r414.hiddeFieldOptional == null ? null : ctx_r414.hiddeFieldOptional.active) && (ctx_r414.hiddeFieldOptional == null ? null : ctx_r414.hiddeFieldOptional.type) == "require");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", !field_r55.valueRequired && (ctx_r414.hiddeFieldOptional == null ? null : ctx_r414.hiddeFieldOptional.active) && (ctx_r414.hiddeFieldOptional == null ? null : ctx_r414.hiddeFieldOptional.type) == "optional");
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_5_div_2_span_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "span", 68);
    ɵɵelement(1, "span", 11);
    ɵɵpipe(2, "i18n");
    ɵɵelementEnd();
} if (rf & 2) {
    ɵɵadvance(1);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(2, 1, "i18n-form-label-require"), ɵɵsanitizeHtml);
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_5_div_2_span_5_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "span", 68);
    ɵɵelement(1, "span", 11);
    ɵɵpipe(2, "i18n");
    ɵɵelementEnd();
} if (rf & 2) {
    ɵɵadvance(1);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(2, 1, "i18n-form-label-optional"), ɵɵsanitizeHtml);
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_5_div_2_div_7_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 103);
    ɵɵtext(1, " Campo requerido. ");
    ɵɵelementEnd();
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_5_div_2_div_7_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 51);
    ɵɵtemplate(1, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_5_div_2_div_7_div_1_Template, 2, 0, "div", 57);
    ɵɵelementEnd();
} if (rf & 2) {
    const field_r55 = ɵɵnextContext(5).$implicit;
    const sub_section_r41 = ɵɵnextContext(2).sub_section;
    const ctx_r428 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r428.Validator.hasRequiredError(ctx_r428.getGroup(sub_section_r41.identifier, field_r55), ctx_r428.getFieldIdentifier(field_r55.dataFieldItem.alternateName)));
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_5_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 51);
    ɵɵelementStart(1, "div", 62);
    ɵɵelement(2, "span", 11);
    ɵɵpipe(3, "i18n");
    ɵɵtemplate(4, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_5_div_2_span_4_Template, 3, 3, "span", 63);
    ɵɵtemplate(5, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_5_div_2_span_5_Template, 3, 3, "span", 63);
    ɵɵelementEnd();
    ɵɵelementStart(6, "div");
    ɵɵtemplate(7, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_5_div_2_div_7_Template, 2, 1, "div", 47);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const field_r55 = ɵɵnextContext(4).$implicit;
    const ctx_r415 = ɵɵnextContext(3);
    ɵɵadvance(1);
    ɵɵclassMapInterpolate2("", field_r55.cssClassLabel ? field_r55.cssClassLabel : "", " ", field_r55.dataFieldItem.typeInput == "selectButton" ? "mb-2" : "", " mb-3 mt-3 label-form-btn");
    ɵɵproperty("hidden", field_r55.hidden);
    ɵɵadvance(1);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(3, 12, field_r55.dataFieldItem.label), ɵɵsanitizeHtml);
    ɵɵadvance(2);
    ɵɵproperty("ngIf", field_r55.valueRequired && (ctx_r415.hiddeFieldOptional == null ? null : ctx_r415.hiddeFieldOptional.active) && (ctx_r415.hiddeFieldOptional == null ? null : ctx_r415.hiddeFieldOptional.type) == "require");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", !field_r55.valueRequired && (ctx_r415.hiddeFieldOptional == null ? null : ctx_r415.hiddeFieldOptional.active) && (ctx_r415.hiddeFieldOptional == null ? null : ctx_r415.hiddeFieldOptional.type) == "optional");
    ɵɵadvance(1);
    ɵɵclassMap(field_r55.cssClassValidation);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", field_r55.valueRequired);
} }
const _c8 = function (a0, a1) { return { "error": a0, "active": a1 }; };
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_5_div_3_button_3_Template(rf, ctx) { if (rf & 1) {
    const _r440 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "button", 113);
    ɵɵlistener("click", function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_5_div_3_button_3_Template_button_click_0_listener() { ɵɵrestoreView(_r440); const lst_r437 = ctx.$implicit; const field_r55 = ɵɵnextContext(5).$implicit; const ctx_r438 = ɵɵnextContext(3); return ctx_r438.setButtonOptionsToggle(field_r55.dataFieldItem.alternateName, lst_r437, field_r55.dataFieldItem.typeInput); });
    ɵɵelement(1, "span", 11);
    ɵɵpipe(2, "i18n");
    ɵɵelementEnd();
} if (rf & 2) {
    const lst_r437 = ctx.$implicit;
    const field_r55 = ɵɵnextContext(5).$implicit;
    const sub_section_r41 = ɵɵnextContext(2).sub_section;
    const ctx_r433 = ɵɵnextContext();
    ɵɵproperty("disabled", ctx_r433.getStatusField(field_r55.dataFieldItem.alternateName) == "DISABLED")("ngClass", ɵɵpureFunction2(5, _c8, ctx_r433.Validator.isInvalid(ctx_r433.getGroup(sub_section_r41.identifier, field_r55), ctx_r433.getFieldIdentifier(field_r55.dataFieldItem.alternateName)), ctx_r433.getButtonActiveMultiple(field_r55.dataFieldItem.alternateName, lst_r437, field_r55.dataFieldItem.typeInput, field_r55)));
    ɵɵadvance(1);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(2, 3, lst_r437 == null ? null : lst_r437.label), ɵɵsanitizeHtml);
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_5_div_3_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 114);
    ɵɵelementStart(1, "div");
    ɵɵtext(2, " Cargando... ");
    ɵɵelement(3, "i", 115);
    ɵɵelementEnd();
    ɵɵelementEnd();
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_5_div_3_option_11_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "option", 116);
    ɵɵpipe(1, "async");
    ɵɵtext(2);
    ɵɵpipe(3, "i18n");
    ɵɵelementEnd();
} if (rf & 2) {
    const lst_r443 = ctx.$implicit;
    const field_r55 = ɵɵnextContext(5).$implicit;
    const sub_section_r41 = ɵɵnextContext(2).sub_section;
    const ctx_r435 = ɵɵnextContext();
    ɵɵproperty("selected", ctx_r435.getSelected(ctx_r435.getFieldValue(field_r55.dataFieldItem.alternateName), lst_r443.value, ɵɵpipeBind1(1, 3, ctx_r435.akeelaDatasource.selectDatasource(field_r55)), field_r55, sub_section_r41.identifier))("ngValue", lst_r443.value);
    ɵɵadvance(2);
    ɵɵtextInterpolate1(" ", ɵɵpipeBind1(3, 5, lst_r443 == null ? null : lst_r443.label), " ");
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_5_div_3_i_13_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "i", 117);
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_5_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r447 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div");
    ɵɵelementStart(1, "div");
    ɵɵelementStart(2, "div", 18);
    ɵɵtemplate(3, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_5_div_3_button_3_Template, 3, 8, "button", 107);
    ɵɵpipe(4, "async");
    ɵɵelementEnd();
    ɵɵtemplate(5, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_5_div_3_div_5_Template, 4, 0, "div", 108);
    ɵɵpipe(6, "async");
    ɵɵpipe(7, "async");
    ɵɵelementEnd();
    ɵɵelementStart(8, "select", 109);
    ɵɵlistener("change", function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_5_div_3_Template_select_change_8_listener($event) { ɵɵrestoreView(_r447); const field_r55 = ɵɵnextContext(4).$implicit; const sub_section_r41 = ɵɵnextContext(2).sub_section; const ctx_r446 = ɵɵnextContext(); return ctx_r446.call_fn($event, sub_section_r41.identifier, field_r55); });
    ɵɵelementStart(9, "option", 110);
    ɵɵtext(10);
    ɵɵelementEnd();
    ɵɵtemplate(11, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_5_div_3_option_11_Template, 4, 7, "option", 111);
    ɵɵpipe(12, "async");
    ɵɵelementEnd();
    ɵɵtemplate(13, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_5_div_3_i_13_Template, 1, 0, "i", 112);
    ɵɵelementEnd();
} if (rf & 2) {
    const field_r55 = ɵɵnextContext(4).$implicit;
    const sub_section_r41 = ɵɵnextContext(2).sub_section;
    const ctx_r416 = ɵɵnextContext();
    var tmp_2_0 = null;
    ɵɵclassMap(field_r55.cssClassValue);
    ɵɵadvance(3);
    ɵɵproperty("ngForOf", ɵɵpipeBind1(4, 15, ctx_r416.akeelaDatasource.selectDatasource(field_r55)));
    ɵɵadvance(2);
    ɵɵproperty("ngIf", ctx_r416.loadSelect[field_r55.dataFieldItem.alternateName] || ɵɵpipeBind1(6, 17, ctx_r416.akeelaDatasource.selectDatasource(field_r55)) && ((tmp_2_0 = ɵɵpipeBind1(7, 19, ctx_r416.akeelaDatasource.selectDatasource(field_r55))) == null ? null : tmp_2_0.length) < 1);
    ɵɵadvance(3);
    ɵɵclassMapInterpolate1("d-none form-control ng-pristine ng-invalid ng-touched  ", field_r55.cssClassValue ? field_r55.cssClassValue : "", "");
    ɵɵproperty("formControlName", ctx_r416.getFieldIdentifier(field_r55.dataFieldItem.alternateName))("hidden", field_r55.hidden)("ngClass", ɵɵpureFunction2(23, _c3, ctx_r416.Validator.isInvalid(ctx_r416.getGroup(sub_section_r41.identifier, field_r55), ctx_r416.getFieldIdentifier(field_r55.dataFieldItem.alternateName)), ctx_r416.Validator.isValid(ctx_r416.getGroup(sub_section_r41.identifier, field_r55), ctx_r416.getFieldIdentifier(field_r55.dataFieldItem.alternateName))))("name", ctx_r416.getFieldIdentifier(field_r55.dataFieldItem.alternateName));
    ɵɵadvance(2);
    ɵɵtextInterpolate1("", ctx_r416.readonlyMode ? "" : "Seleccione", " ");
    ɵɵadvance(1);
    ɵɵproperty("ngForOf", ɵɵpipeBind1(12, 21, ctx_r416.akeelaDatasource.selectDatasource(field_r55)));
    ɵɵadvance(2);
    ɵɵproperty("ngIf", ctx_r416.loadSelect[field_r55.dataFieldItem.alternateName]);
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_5_div_4_div_2_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "span", 121);
    ɵɵelement(1, "i");
    ɵɵelementEnd();
} if (rf & 2) {
    const lst_r455 = ɵɵnextContext().$implicit;
    const ctx_r457 = ɵɵnextContext(8);
    var tmp_0_0 = null;
    ɵɵadvance(1);
    ɵɵclassMapInterpolate1("", ((tmp_0_0 = ctx_r457.getJson(lst_r455 == null ? null : lst_r455.item == null ? null : lst_r455.item.image == null ? null : lst_r455.item.image.contentUrl)) == null ? null : tmp_0_0.cssClassIcon) ? (tmp_0_0 = ctx_r457.getJson(lst_r455 == null ? null : lst_r455.item == null ? null : lst_r455.item.image == null ? null : lst_r455.item.image.contentUrl)) == null ? null : tmp_0_0.cssClassIcon : "fas fa-circle", "  pr-2 ");
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_5_div_4_div_2_span_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "span", 121);
    ɵɵelement(1, "img", 122);
    ɵɵelementEnd();
} if (rf & 2) {
    const lst_r455 = ɵɵnextContext().$implicit;
    const ctx_r458 = ɵɵnextContext(8);
    ɵɵadvance(1);
    ɵɵproperty("src", ctx_r458.getCurrencyImg(lst_r455 == null ? null : lst_r455.value), ɵɵsanitizeUrl);
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_5_div_4_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r463 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div");
    ɵɵelementStart(1, "button", 119);
    ɵɵlistener("click", function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_5_div_4_div_2_Template_button_click_1_listener($event) { ɵɵrestoreView(_r463); const lst_r455 = ctx.$implicit; const field_r55 = ɵɵnextContext(5).$implicit; const sub_section_r41 = ɵɵnextContext(2).sub_section; const ctx_r461 = ɵɵnextContext(); ctx_r461.setButtonOptionsToggle(field_r55.dataFieldItem.alternateName, lst_r455, field_r55.dataFieldItem.typeInput); return ctx_r461.changeEventCall_fn($event, sub_section_r41.identifier, field_r55, "change"); });
    ɵɵtemplate(2, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_5_div_4_div_2_span_2_Template, 2, 3, "span", 120);
    ɵɵtemplate(3, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_5_div_4_div_2_span_3_Template, 2, 1, "span", 120);
    ɵɵelement(4, "span", 11);
    ɵɵpipe(5, "i18n");
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const lst_r455 = ctx.$implicit;
    const l_r456 = ctx.count;
    const field_r55 = ɵɵnextContext(5).$implicit;
    const sub_section_r41 = ɵɵnextContext(2).sub_section;
    const ctx_r452 = ɵɵnextContext();
    ɵɵclassMapInterpolate1("", (lst_r455 == null ? null : lst_r455.item == null ? null : lst_r455.item.additionalType) ? lst_r455 == null ? null : lst_r455.item == null ? null : lst_r455.item.additionalType : (lst_r455 == null ? null : lst_r455.value) == "BS" || (lst_r455 == null ? null : lst_r455.value) == "USD" || (lst_r455 == null ? null : lst_r455.value) == "EUR" || (lst_r455 == null ? null : lst_r455.value) == "COP" || (lst_r455 == null ? null : lst_r455.value) == "BRL" ? "col-12 col-md-6" : " col-12 col-md-6 ", "  mb-3");
    ɵɵadvance(1);
    ɵɵclassProp("error", ctx_r452.Validator.isInvalid(ctx_r452.getGroup(sub_section_r41.identifier, field_r55), ctx_r452.getFieldIdentifier(field_r55.dataFieldItem.alternateName)))("active", ctx_r452.getButtonActive(field_r55.dataFieldItem.alternateName, lst_r455, field_r55.dataFieldItem.typeInput, field_r55, l_r456));
    ɵɵproperty("disabled", ctx_r452.getStatusField(field_r55.dataFieldItem.alternateName) == "DISABLED");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", (lst_r455 == null ? null : lst_r455.item == null ? null : lst_r455.item.image == null ? null : lst_r455.item.image.contentUrl) && ctx_r452.getJson(lst_r455 == null ? null : lst_r455.item == null ? null : lst_r455.item.image == null ? null : lst_r455.item.image.contentUrl).type == "icon");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", !(lst_r455 == null ? null : lst_r455.item == null ? null : lst_r455.item.image == null ? null : lst_r455.item.image.contentUrl) && ((lst_r455 == null ? null : lst_r455.value) == "BS" || (lst_r455 == null ? null : lst_r455.value) == "USD" || (lst_r455 == null ? null : lst_r455.value) == "EUR" || (lst_r455 == null ? null : lst_r455.value) == "COP" || (lst_r455 == null ? null : lst_r455.value) == "BRL"));
    ɵɵadvance(1);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(5, 11, lst_r455 == null ? null : lst_r455.label), ɵɵsanitizeHtml);
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_5_div_4_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 114);
    ɵɵelementStart(1, "div");
    ɵɵtext(2, " Cargando... ");
    ɵɵelement(3, "i", 115);
    ɵɵelementEnd();
    ɵɵelementEnd();
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_5_div_4_option_10_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "option", 116);
    ɵɵpipe(1, "async");
    ɵɵtext(2);
    ɵɵpipe(3, "i18n");
    ɵɵelementEnd();
} if (rf & 2) {
    const lst_r467 = ctx.$implicit;
    const field_r55 = ɵɵnextContext(5).$implicit;
    const sub_section_r41 = ɵɵnextContext(2).sub_section;
    const ctx_r454 = ɵɵnextContext();
    ɵɵproperty("selected", ctx_r454.getSelected(ctx_r454.getFieldValue(field_r55.dataFieldItem.alternateName), lst_r467.value, ɵɵpipeBind1(1, 3, ctx_r454.akeelaDatasource.selectDatasource(field_r55)), field_r55, sub_section_r41.identifier))("ngValue", lst_r467.value);
    ɵɵadvance(2);
    ɵɵtextInterpolate1(" ", ɵɵpipeBind1(3, 5, lst_r467 == null ? null : lst_r467.label), " ");
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_5_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r471 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div");
    ɵɵelementStart(1, "div", 0);
    ɵɵtemplate(2, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_5_div_4_div_2_Template, 6, 13, "div", 17);
    ɵɵpipe(3, "async");
    ɵɵtemplate(4, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_5_div_4_div_4_Template, 4, 0, "div", 108);
    ɵɵpipe(5, "async");
    ɵɵpipe(6, "async");
    ɵɵelementEnd();
    ɵɵelementStart(7, "select", 118);
    ɵɵlistener("change", function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_5_div_4_Template_select_change_7_listener($event) { ɵɵrestoreView(_r471); const field_r55 = ɵɵnextContext(4).$implicit; const sub_section_r41 = ɵɵnextContext(2).sub_section; const ctx_r470 = ɵɵnextContext(); return ctx_r470.call_fn($event, sub_section_r41.identifier, field_r55); });
    ɵɵelementStart(8, "option", 110);
    ɵɵtext(9);
    ɵɵelementEnd();
    ɵɵtemplate(10, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_5_div_4_option_10_Template, 4, 7, "option", 111);
    ɵɵpipe(11, "async");
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const field_r55 = ɵɵnextContext(4).$implicit;
    const sub_section_r41 = ɵɵnextContext(2).sub_section;
    const ctx_r417 = ɵɵnextContext();
    var tmp_2_0 = null;
    ɵɵclassMap(field_r55.cssClassValue);
    ɵɵadvance(2);
    ɵɵproperty("ngForOf", ɵɵpipeBind1(3, 14, ctx_r417.akeelaDatasource.selectDatasource(field_r55)));
    ɵɵadvance(2);
    ɵɵproperty("ngIf", ctx_r417.loadSelect[field_r55.dataFieldItem.alternateName] || ɵɵpipeBind1(5, 16, ctx_r417.akeelaDatasource.selectDatasource(field_r55)) && ((tmp_2_0 = ɵɵpipeBind1(6, 18, ctx_r417.akeelaDatasource.selectDatasource(field_r55))) == null ? null : tmp_2_0.length) < 1);
    ɵɵadvance(3);
    ɵɵclassMapInterpolate1("d-none form-control ng-pristine ng-invalid ng-touched  ", field_r55.cssClassValue ? field_r55.cssClassValue : "", "");
    ɵɵproperty("formControlName", ctx_r417.getFieldIdentifier(field_r55.dataFieldItem.alternateName))("hidden", field_r55.hidden)("ngClass", ɵɵpureFunction2(22, _c3, ctx_r417.Validator.isInvalid(ctx_r417.getGroup(sub_section_r41.identifier, field_r55), ctx_r417.getFieldIdentifier(field_r55.dataFieldItem.alternateName)), ctx_r417.Validator.isValid(ctx_r417.getGroup(sub_section_r41.identifier, field_r55), ctx_r417.getFieldIdentifier(field_r55.dataFieldItem.alternateName))))("name", ctx_r417.getFieldIdentifier(field_r55.dataFieldItem.alternateName));
    ɵɵadvance(2);
    ɵɵtextInterpolate1("", ctx_r417.readonlyMode ? "" : "Seleccione", " ");
    ɵɵadvance(1);
    ɵɵproperty("ngForOf", ɵɵpipeBind1(11, 20, ctx_r417.akeelaDatasource.selectDatasource(field_r55)));
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_5_div_5_div_2_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "span", 121);
    ɵɵelement(1, "i");
    ɵɵelementEnd();
} if (rf & 2) {
    const lst_r479 = ɵɵnextContext().$implicit;
    const ctx_r481 = ɵɵnextContext(8);
    var tmp_0_0 = null;
    ɵɵadvance(1);
    ɵɵclassMapInterpolate1("", ((tmp_0_0 = ctx_r481.getJson(lst_r479 == null ? null : lst_r479.item == null ? null : lst_r479.item.image == null ? null : lst_r479.item.image.contentUrl)) == null ? null : tmp_0_0.cssClassIcon) ? (tmp_0_0 = ctx_r481.getJson(lst_r479 == null ? null : lst_r479.item == null ? null : lst_r479.item.image == null ? null : lst_r479.item.image.contentUrl)) == null ? null : tmp_0_0.cssClassIcon : "fas fa-circle", "  pr-2 ");
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_5_div_5_div_2_span_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "span", 121);
    ɵɵelement(1, "img", 122);
    ɵɵelementEnd();
} if (rf & 2) {
    const lst_r479 = ɵɵnextContext().$implicit;
    const ctx_r482 = ɵɵnextContext(8);
    ɵɵadvance(1);
    ɵɵproperty("src", ctx_r482.getCurrencyImg(lst_r479 == null ? null : lst_r479.value), ɵɵsanitizeUrl);
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_5_div_5_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r487 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div");
    ɵɵelementStart(1, "div", 123);
    ɵɵlistener("click", function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_5_div_5_div_2_Template_div_click_1_listener($event) { ɵɵrestoreView(_r487); const lst_r479 = ctx.$implicit; const field_r55 = ɵɵnextContext(5).$implicit; const sub_section_r41 = ɵɵnextContext(2).sub_section; const ctx_r485 = ɵɵnextContext(); ctx_r485.setButtonOptionsToggle(field_r55.dataFieldItem.alternateName, lst_r479, field_r55.dataFieldItem.typeInput); return ctx_r485.changeEventCall_fn($event, sub_section_r41.identifier, field_r55, "change"); });
    ɵɵtemplate(2, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_5_div_5_div_2_span_2_Template, 2, 3, "span", 120);
    ɵɵtemplate(3, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_5_div_5_div_2_span_3_Template, 2, 1, "span", 120);
    ɵɵelement(4, "span", 11);
    ɵɵpipe(5, "i18n");
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const lst_r479 = ctx.$implicit;
    const l_r480 = ctx.count;
    const field_r55 = ɵɵnextContext(5).$implicit;
    const sub_section_r41 = ɵɵnextContext(2).sub_section;
    const ctx_r476 = ɵɵnextContext();
    ɵɵclassMap(field_r55.cssClassValue);
    ɵɵadvance(1);
    ɵɵclassProp("error", ctx_r476.Validator.isInvalid(ctx_r476.getGroup(sub_section_r41.identifier, field_r55), ctx_r476.getFieldIdentifier(field_r55.dataFieldItem.alternateName)))("active", ctx_r476.getButtonActive(field_r55.dataFieldItem.alternateName, lst_r479, field_r55.dataFieldItem.typeInput, field_r55, l_r480));
    ɵɵattribute("disabled", ctx_r476.getStatusField(field_r55.dataFieldItem.alternateName) == "DISABLED");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", (lst_r479 == null ? null : lst_r479.item == null ? null : lst_r479.item.image == null ? null : lst_r479.item.image.contentUrl) && ctx_r476.getJson(lst_r479 == null ? null : lst_r479.item == null ? null : lst_r479.item.image == null ? null : lst_r479.item.image.contentUrl).type == "icon");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", !(lst_r479 == null ? null : lst_r479.item == null ? null : lst_r479.item.image == null ? null : lst_r479.item.image.contentUrl) && ((lst_r479 == null ? null : lst_r479.value) == "BS" || (lst_r479 == null ? null : lst_r479.value) == "USD" || (lst_r479 == null ? null : lst_r479.value) == "EUR" || (lst_r479 == null ? null : lst_r479.value) == "COP" || (lst_r479 == null ? null : lst_r479.value) == "BRL"));
    ɵɵadvance(1);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(5, 11, lst_r479 == null ? null : lst_r479.label), ɵɵsanitizeHtml);
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_5_div_5_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 114);
    ɵɵelementStart(1, "div");
    ɵɵtext(2, " Cargando... ");
    ɵɵelement(3, "i", 115);
    ɵɵelementEnd();
    ɵɵelementEnd();
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_5_div_5_option_10_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "option", 116);
    ɵɵpipe(1, "async");
    ɵɵtext(2);
    ɵɵpipe(3, "i18n");
    ɵɵelementEnd();
} if (rf & 2) {
    const lst_r491 = ctx.$implicit;
    const field_r55 = ɵɵnextContext(5).$implicit;
    const sub_section_r41 = ɵɵnextContext(2).sub_section;
    const ctx_r478 = ɵɵnextContext();
    ɵɵproperty("selected", ctx_r478.getSelected(ctx_r478.getFieldValue(field_r55.dataFieldItem.alternateName), lst_r491.value, ɵɵpipeBind1(1, 3, ctx_r478.akeelaDatasource.selectDatasource(field_r55)), field_r55, sub_section_r41.identifier))("ngValue", lst_r491.value);
    ɵɵadvance(2);
    ɵɵtextInterpolate1(" ", ɵɵpipeBind1(3, 5, lst_r491 == null ? null : lst_r491.label), " ");
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_5_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r495 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div");
    ɵɵelementStart(1, "div", 0);
    ɵɵtemplate(2, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_5_div_5_div_2_Template, 6, 13, "div", 17);
    ɵɵpipe(3, "async");
    ɵɵtemplate(4, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_5_div_5_div_4_Template, 4, 0, "div", 108);
    ɵɵpipe(5, "async");
    ɵɵpipe(6, "async");
    ɵɵelementEnd();
    ɵɵelementStart(7, "select", 118);
    ɵɵlistener("change", function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_5_div_5_Template_select_change_7_listener($event) { ɵɵrestoreView(_r495); const field_r55 = ɵɵnextContext(4).$implicit; const sub_section_r41 = ɵɵnextContext(2).sub_section; const ctx_r494 = ɵɵnextContext(); return ctx_r494.call_fn($event, sub_section_r41.identifier, field_r55); });
    ɵɵelementStart(8, "option", 110);
    ɵɵtext(9);
    ɵɵelementEnd();
    ɵɵtemplate(10, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_5_div_5_option_10_Template, 4, 7, "option", 111);
    ɵɵpipe(11, "async");
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const field_r55 = ɵɵnextContext(4).$implicit;
    const sub_section_r41 = ɵɵnextContext(2).sub_section;
    const ctx_r418 = ɵɵnextContext();
    var tmp_1_0 = null;
    ɵɵadvance(2);
    ɵɵproperty("ngForOf", ɵɵpipeBind1(3, 11, ctx_r418.akeelaDatasource.selectDatasource(field_r55)));
    ɵɵadvance(2);
    ɵɵproperty("ngIf", ctx_r418.loadSelect[field_r55.dataFieldItem.alternateName] || ɵɵpipeBind1(5, 13, ctx_r418.akeelaDatasource.selectDatasource(field_r55)) && ((tmp_1_0 = ɵɵpipeBind1(6, 15, ctx_r418.akeelaDatasource.selectDatasource(field_r55))) == null ? null : tmp_1_0.length) < 1);
    ɵɵadvance(3);
    ɵɵclassMapInterpolate1("d-none form-control ng-pristine ng-invalid ng-touched  ", field_r55.cssClassValue ? field_r55.cssClassValue : "", "");
    ɵɵproperty("formControlName", ctx_r418.getFieldIdentifier(field_r55.dataFieldItem.alternateName))("hidden", field_r55.hidden)("ngClass", ɵɵpureFunction2(19, _c3, ctx_r418.Validator.isInvalid(ctx_r418.getGroup(sub_section_r41.identifier, field_r55), ctx_r418.getFieldIdentifier(field_r55.dataFieldItem.alternateName)), ctx_r418.Validator.isValid(ctx_r418.getGroup(sub_section_r41.identifier, field_r55), ctx_r418.getFieldIdentifier(field_r55.dataFieldItem.alternateName))))("name", ctx_r418.getFieldIdentifier(field_r55.dataFieldItem.alternateName));
    ɵɵadvance(2);
    ɵɵtextInterpolate1("", ctx_r418.readonlyMode ? "" : "Seleccione", " ");
    ɵɵadvance(1);
    ɵɵproperty("ngForOf", ɵɵpipeBind1(11, 17, ctx_r418.akeelaDatasource.selectDatasource(field_r55)));
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_5_div_6_option_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "option", 116);
    ɵɵpipe(1, "async");
    ɵɵtext(2);
    ɵɵpipe(3, "i18n");
    ɵɵelementEnd();
} if (rf & 2) {
    const lst_r502 = ctx.$implicit;
    const field_r55 = ɵɵnextContext(5).$implicit;
    const sub_section_r41 = ɵɵnextContext(2).sub_section;
    const ctx_r500 = ɵɵnextContext();
    ɵɵproperty("selected", ctx_r500.getSelected(ctx_r500.getFieldValue(field_r55.dataFieldItem.alternateName), lst_r502.value, ɵɵpipeBind1(1, 3, ctx_r500.akeelaDatasource.selectDatasource(field_r55)), field_r55, sub_section_r41.identifier))("ngValue", lst_r502.value);
    ɵɵadvance(2);
    ɵɵtextInterpolate1(" ", ɵɵpipeBind1(3, 5, lst_r502 == null ? null : lst_r502.label), " ");
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_5_div_6_i_6_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "i", 117);
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_5_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r506 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 51);
    ɵɵelementStart(1, "select", 118);
    ɵɵlistener("change", function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_5_div_6_Template_select_change_1_listener($event) { ɵɵrestoreView(_r506); const field_r55 = ɵɵnextContext(4).$implicit; const sub_section_r41 = ɵɵnextContext(2).sub_section; const ctx_r505 = ɵɵnextContext(); return ctx_r505.call_fn($event, sub_section_r41.identifier, field_r55); });
    ɵɵelementStart(2, "option", 110);
    ɵɵtext(3);
    ɵɵelementEnd();
    ɵɵtemplate(4, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_5_div_6_option_4_Template, 4, 7, "option", 111);
    ɵɵpipe(5, "async");
    ɵɵelementEnd();
    ɵɵtemplate(6, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_5_div_6_i_6_Template, 1, 0, "i", 112);
    ɵɵelementEnd();
} if (rf & 2) {
    const field_r55 = ɵɵnextContext(4).$implicit;
    const sub_section_r41 = ɵɵnextContext(2).sub_section;
    const ctx_r419 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵclassMapInterpolate1("form-control ng-pristine ng-invalid ng-touched  ", field_r55.cssClassValue ? field_r55.cssClassValue : "", "");
    ɵɵproperty("formControlName", ctx_r419.getFieldIdentifier(field_r55.dataFieldItem.alternateName))("hidden", field_r55.hidden)("ngClass", ɵɵpureFunction2(12, _c3, ctx_r419.Validator.isInvalid(ctx_r419.getGroup(sub_section_r41.identifier, field_r55), ctx_r419.getFieldIdentifier(field_r55.dataFieldItem.alternateName)), ctx_r419.Validator.isValid(ctx_r419.getGroup(sub_section_r41.identifier, field_r55), ctx_r419.getFieldIdentifier(field_r55.dataFieldItem.alternateName))))("name", ctx_r419.getFieldIdentifier(field_r55.dataFieldItem.alternateName));
    ɵɵadvance(2);
    ɵɵtextInterpolate1("", ctx_r419.readonlyMode ? "" : "Seleccione", " ");
    ɵɵadvance(1);
    ɵɵproperty("ngForOf", ɵɵpipeBind1(5, 10, ctx_r419.akeelaDatasource.selectDatasource(field_r55)));
    ɵɵadvance(2);
    ɵɵproperty("ngIf", ctx_r419.loadSelect[field_r55.dataFieldItem.alternateName]);
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_5_div_7_i_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "i", 126);
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_5_div_7_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 51);
    ɵɵelement(1, "akeela-multi-select", 124);
    ɵɵpipe(2, "async");
    ɵɵtemplate(3, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_5_div_7_i_3_Template, 1, 0, "i", 125);
    ɵɵelementEnd();
} if (rf & 2) {
    const field_r55 = ɵɵnextContext(4).$implicit;
    const sub_section_r41 = ɵɵnextContext(2).sub_section;
    const ctx_r420 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("placeholder", "Seleccione")("options", ɵɵpipeBind1(2, 6, ctx_r420.akeelaDatasource.selectDatasource(field_r55)))("formControlName", ctx_r420.getFieldIdentifier(field_r55.dataFieldItem.alternateName))("hidden", field_r55.hidden)("ngClass", ɵɵpureFunction2(8, _c3, ctx_r420.Validator.isInvalid(ctx_r420.getGroup(sub_section_r41.identifier, field_r55), ctx_r420.getFieldIdentifier(field_r55.dataFieldItem.alternateName)), ctx_r420.Validator.isValid(ctx_r420.getGroup(sub_section_r41.identifier, field_r55), ctx_r420.getFieldIdentifier(field_r55.dataFieldItem.alternateName))));
    ɵɵadvance(2);
    ɵɵproperty("ngIf", ctx_r420.loadSelect[field_r55.dataFieldItem.alternateName]);
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_5_div_8_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 98);
    ɵɵelement(1, "span", 99);
    ɵɵpipe(2, "i18n");
    ɵɵelementEnd();
} if (rf & 2) {
    const field_r55 = ɵɵnextContext(4).$implicit;
    ɵɵadvance(1);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(2, 1, field_r55 == null ? null : field_r55.dataFieldItem == null ? null : field_r55.dataFieldItem.tooltip), ɵɵsanitizeHtml);
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_5_div_9_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 103);
    ɵɵtext(1, " Campo requerido. ");
    ɵɵelementEnd();
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_5_div_9_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 51);
    ɵɵtemplate(1, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_5_div_9_div_1_div_1_Template, 2, 0, "div", 57);
    ɵɵelementEnd();
} if (rf & 2) {
    const field_r55 = ɵɵnextContext(5).$implicit;
    const sub_section_r41 = ɵɵnextContext(2).sub_section;
    const ctx_r515 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r515.Validator.hasRequiredError(ctx_r515.getGroup(sub_section_r41.identifier, field_r55), ctx_r515.getFieldIdentifier(field_r55.dataFieldItem.alternateName)));
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_5_div_9_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵtemplate(1, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_5_div_9_div_1_Template, 2, 1, "div", 54);
    ɵɵelementEnd();
} if (rf & 2) {
    const field_r55 = ɵɵnextContext(4).$implicit;
    ɵɵclassMap(field_r55.cssClassValidation);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", field_r55.valueRequired);
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 51);
    ɵɵtemplate(1, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_5_div_1_Template, 6, 10, "div", 47);
    ɵɵtemplate(2, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_5_div_2_Template, 8, 14, "div", 47);
    ɵɵtemplate(3, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_5_div_3_Template, 14, 26, "div", 1);
    ɵɵtemplate(4, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_5_div_4_Template, 12, 25, "div", 1);
    ɵɵtemplate(5, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_5_div_5_Template, 12, 22, "div", 2);
    ɵɵtemplate(6, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_5_div_6_Template, 7, 15, "div", 47);
    ɵɵtemplate(7, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_5_div_7_Template, 4, 11, "div", 47);
    ɵɵtemplate(8, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_5_div_8_Template, 3, 3, "div", 106);
    ɵɵtemplate(9, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_5_div_9_Template, 2, 4, "div", 1);
    ɵɵelementEnd();
} if (rf & 2) {
    const field_r55 = ɵɵnextContext(3).$implicit;
    ɵɵadvance(1);
    ɵɵproperty("ngIf", field_r55.dataFieldItem.typeInput != "selectMultipleButton" && field_r55.dataFieldItem.typeInput != "selectButton" && field_r55.dataFieldItem.typeInput != "selectButtonCssFields" || field_r55.dataFieldItem.typeInput == "multi");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", field_r55.dataFieldItem.typeInput == "selectMultipleButton" || field_r55.dataFieldItem.typeInput == "selectButton" || field_r55.dataFieldItem.typeInput == "selectButtonCssFields");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", field_r55.dataFieldItem.typeInput == "selectMultipleButton");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", field_r55.dataFieldItem.typeInput == "selectButton");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", field_r55.dataFieldItem.typeInput == "selectButtonCssFields");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", field_r55.dataFieldItem.typeInput != "selectMultipleButton" && field_r55.dataFieldItem.typeInput != "selectButton" && field_r55.dataFieldItem.typeInput != "selectButtonCssFields" && field_r55.dataFieldItem.typeInput != "multi");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", field_r55.dataFieldItem.typeInput === "multi");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", field_r55 == null ? null : field_r55.dataFieldItem == null ? null : field_r55.dataFieldItem.tooltip);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", field_r55.dataFieldItem.typeInput != "selectMultipleButton" && field_r55.dataFieldItem.typeInput != "selectButton" || field_r55.dataFieldItem.typeInput == "multi");
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_6_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r525 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 128);
    ɵɵlistener("click", function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_6_div_1_Template_div_click_0_listener($event) { ɵɵrestoreView(_r525); const field_r55 = ɵɵnextContext(4).$implicit; const sub_section_r41 = ɵɵnextContext(2).sub_section; const ctx_r524 = ɵɵnextContext(); return ctx_r524.call_fn($event, sub_section_r41.identifier, field_r55); });
    ɵɵelement(1, "i");
    ɵɵelementEnd();
} if (rf & 2) {
    const field_r55 = ɵɵnextContext(4).$implicit;
    ɵɵadvance(1);
    ɵɵclassMapInterpolate1("", field_r55.cssClassValue ? field_r55.cssClassValue : "", " ");
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_6_div_2_span_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "span", 68);
    ɵɵelement(1, "span", 11);
    ɵɵpipe(2, "i18n");
    ɵɵelementEnd();
} if (rf & 2) {
    ɵɵadvance(1);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(2, 1, "i18n-form-label-require"), ɵɵsanitizeHtml);
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_6_div_2_span_5_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "span", 68);
    ɵɵelement(1, "span", 11);
    ɵɵpipe(2, "i18n");
    ɵɵelementEnd();
} if (rf & 2) {
    ɵɵadvance(1);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(2, 1, "i18n-form-label-optional"), ɵɵsanitizeHtml);
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_6_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 51);
    ɵɵelementStart(1, "label", 62);
    ɵɵelement(2, "span", 11);
    ɵɵpipe(3, "i18n");
    ɵɵtemplate(4, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_6_div_2_span_4_Template, 3, 3, "span", 63);
    ɵɵtemplate(5, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_6_div_2_span_5_Template, 3, 3, "span", 63);
    ɵɵelementEnd();
    ɵɵelement(6, "div", 11);
    ɵɵpipe(7, "numberI18n");
    ɵɵpipe(8, "number");
    ɵɵpipe(9, "numberI18n");
    ɵɵpipe(10, "number");
    ɵɵelementEnd();
} if (rf & 2) {
    const field_r55 = ɵɵnextContext(4).$implicit;
    const ctx_r522 = ɵɵnextContext(3);
    ɵɵadvance(1);
    ɵɵclassMapInterpolate1("", field_r55.cssClassLabel ? field_r55.cssClassLabel : "", " font-weight-normal");
    ɵɵproperty("hidden", field_r55.hidden);
    ɵɵadvance(1);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(3, 11, field_r55.dataFieldItem.label), ɵɵsanitizeHtml);
    ɵɵadvance(2);
    ɵɵproperty("ngIf", field_r55.valueRequired && (ctx_r522.hiddeFieldOptional == null ? null : ctx_r522.hiddeFieldOptional.active) && (ctx_r522.hiddeFieldOptional == null ? null : ctx_r522.hiddeFieldOptional.type) == "require");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", !field_r55.valueRequired && (ctx_r522.hiddeFieldOptional == null ? null : ctx_r522.hiddeFieldOptional.active) && (ctx_r522.hiddeFieldOptional == null ? null : ctx_r522.hiddeFieldOptional.type) == "optional");
    ɵɵadvance(1);
    ɵɵclassMapInterpolate1("", field_r55.cssClassValue ? field_r55.cssClassValue : "", " ");
    ɵɵproperty("innerHTML", field_r55.defaultValue ? ɵɵpipeBind1(7, 13, ɵɵpipeBind2(8, 15, field_r55.defaultValue, "1.2-2")) : ɵɵpipeBind1(9, 18, ɵɵpipeBind2(10, 20, "0", "1.2-2")), ɵɵsanitizeHtml);
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_6_div_3_label_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "label", 130);
    ɵɵpipe(1, "i18n");
} if (rf & 2) {
    const field_r55 = ɵɵnextContext(5).$implicit;
    ɵɵclassMap(field_r55.cssClassLabel ? field_r55.cssClassLabel : "");
    ɵɵproperty("innerHTML", ɵɵpipeBind1(1, 4, field_r55.dataFieldItem.label), ɵɵsanitizeHtml);
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_6_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 51);
    ɵɵtemplate(1, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_6_div_3_label_1_Template, 2, 6, "label", 129);
    ɵɵelement(2, "div", 11);
    ɵɵpipe(3, "i18n");
    ɵɵelementEnd();
} if (rf & 2) {
    const field_r55 = ɵɵnextContext(4).$implicit;
    ɵɵadvance(1);
    ɵɵproperty("ngIf", field_r55.dataFieldItem.type != "button");
    ɵɵadvance(1);
    ɵɵclassMapInterpolate1("", field_r55.cssClassValue ? field_r55.cssClassValue : "", " ");
    ɵɵproperty("innerHTML", field_r55.defaultValue ? ɵɵpipeBind1(3, 5, field_r55.defaultValue) : "--", ɵɵsanitizeHtml);
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_6_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 51);
    ɵɵtemplate(1, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_6_div_1_Template, 2, 3, "div", 127);
    ɵɵtemplate(2, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_6_div_2_Template, 11, 23, "div", 54);
    ɵɵtemplate(3, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_6_div_3_Template, 4, 7, "div", 54);
    ɵɵelementEnd();
} if (rf & 2) {
    const field_r55 = ɵɵnextContext(3).$implicit;
    ɵɵadvance(1);
    ɵɵproperty("ngIf", (field_r55 == null ? null : field_r55.dataFieldItem == null ? null : field_r55.dataFieldItem.typeInput) == "icon");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", (field_r55 == null ? null : field_r55.dataFieldItem == null ? null : field_r55.dataFieldItem.typeInput) == "mount");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", field_r55.dataFieldItem.typeInput == "text");
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_7_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r542 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "button", 137);
    ɵɵlistener("click", function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_7_button_1_Template_button_click_0_listener() { ɵɵrestoreView(_r542); const ctx_r541 = ɵɵnextContext(7); return ctx_r541.redirectSection(ctx_r541.transitionsWfs[ctx_r541.sectionName] == null ? null : ctx_r541.transitionsWfs[ctx_r541.sectionName].back == null ? null : ctx_r541.transitionsWfs[ctx_r541.sectionName].back.wf, ctx_r541.transitionsWfs[ctx_r541.sectionName] == null ? null : ctx_r541.transitionsWfs[ctx_r541.sectionName].back == null ? null : ctx_r541.transitionsWfs[ctx_r541.sectionName].back.stage, ctx_r541.transitionsWfs[ctx_r541.sectionName] == null ? null : ctx_r541.transitionsWfs[ctx_r541.sectionName].back == null ? null : ctx_r541.transitionsWfs[ctx_r541.sectionName].back.step, ctx_r541.transitionsWfs[ctx_r541.sectionName] == null ? null : ctx_r541.transitionsWfs[ctx_r541.sectionName].back == null ? null : ctx_r541.transitionsWfs[ctx_r541.sectionName].back.section); });
    ɵɵelement(1, "span", 138);
    ɵɵtext(2, " Atr\u00E1s ");
    ɵɵelementEnd();
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_7_button_2_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "span", 11);
    ɵɵpipe(1, "i18n");
} if (rf & 2) {
    ɵɵproperty("innerHTML", ɵɵpipeBind1(1, 1, "@i18n-text-button-continue"), ɵɵsanitizeHtml);
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_7_button_2_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "span", 143);
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_7_button_2_span_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "span", 11);
    ɵɵpipe(1, "i18n");
} if (rf & 2) {
    ɵɵproperty("innerHTML", ɵɵpipeBind1(1, 1, "Guardar"), ɵɵsanitizeHtml);
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_7_button_2_span_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "span", 144);
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_7_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r548 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "button", 139);
    ɵɵlistener("click", function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_7_button_2_Template_button_click_0_listener($event) { ɵɵrestoreView(_r548); const field_r55 = ɵɵnextContext(4).$implicit; const sub_section_r41 = ɵɵnextContext(2).sub_section; const ctx_r547 = ɵɵnextContext(); return ctx_r547.validate_before_call_fn($event, sub_section_r41.identifier, field_r55); });
    ɵɵtemplate(1, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_7_button_2_span_1_Template, 2, 3, "span", 140);
    ɵɵtemplate(2, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_7_button_2_span_2_Template, 1, 0, "span", 141);
    ɵɵtemplate(3, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_7_button_2_span_3_Template, 2, 3, "span", 140);
    ɵɵtemplate(4, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_7_button_2_span_4_Template, 1, 0, "span", 142);
    ɵɵelementEnd();
} if (rf & 2) {
    const field_r55 = ɵɵnextContext(4).$implicit;
    const ctx_r537 = ɵɵnextContext(3);
    ɵɵclassProp("d-none", field_r55.dataFieldItem.actionStatus == "LOADING");
    ɵɵproperty("disabled", field_r55.dataFieldItem.actionStatus == "LOADING" || ctx_r537.readonlyMode)("hidden", field_r55.hidden || ctx_r537.readonlyMode);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", !ctx_r537.notWorkflowfluid);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", !ctx_r537.notWorkflowfluid);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r537.notWorkflowfluid);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r537.notWorkflowfluid);
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_7_button_3_Template(rf, ctx) { if (rf & 1) {
    const _r553 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "button", 139);
    ɵɵlistener("click", function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_7_button_3_Template_button_click_0_listener($event) { ɵɵrestoreView(_r553); const field_r55 = ɵɵnextContext(4).$implicit; const sub_section_r41 = ɵɵnextContext(2).sub_section; const ctx_r552 = ɵɵnextContext(); return ctx_r552.validate_before_call_fn($event, sub_section_r41.identifier, field_r55); });
    ɵɵelementStart(1, "span");
    ɵɵtext(2, "Continuar");
    ɵɵelementEnd();
    ɵɵelement(3, "span", 143);
    ɵɵelementEnd();
} if (rf & 2) {
    const field_r55 = ɵɵnextContext(4).$implicit;
    const ctx_r538 = ɵɵnextContext(3);
    ɵɵclassProp("d-none", field_r55.dataFieldItem.actionStatus == "LOADING");
    ɵɵproperty("disabled", field_r55.dataFieldItem.actionStatus == "LOADING" || ctx_r538.readonlyMode)("hidden", field_r55.hidden || ctx_r538.readonlyMode);
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_7_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 145);
    ɵɵelementStart(1, "div", 146);
    ɵɵtext(2);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r539 = ɵɵnextContext(7);
    ɵɵadvance(2);
    ɵɵtextInterpolate1(" Auto-guardando en ", ctx_r539.autoSaveTimeTemp, " ");
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_7_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 147);
    ɵɵelement(1, "div", 103);
    ɵɵelementEnd();
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_7_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 131);
    ɵɵtemplate(1, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_7_button_1_Template, 3, 0, "button", 132);
    ɵɵtemplate(2, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_7_button_2_Template, 5, 8, "button", 133);
    ɵɵtemplate(3, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_7_button_3_Template, 4, 4, "button", 134);
    ɵɵtemplate(4, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_7_div_4_Template, 3, 1, "div", 135);
    ɵɵtemplate(5, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_7_div_5_Template, 2, 0, "div", 136);
    ɵɵelementEnd();
} if (rf & 2) {
    const field_r55 = ɵɵnextContext(3).$implicit;
    const ctx_r64 = ɵɵnextContext(3);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", (ctx_r64.transitionsWfs[ctx_r64.sectionName] == null ? null : ctx_r64.transitionsWfs[ctx_r64.sectionName].back) != null && (ctx_r64.section == null ? null : ctx_r64.section.additionalType) != "modal");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", !((ctx_r64.section == null ? null : ctx_r64.section.additionalType) != "modal" && (field_r55.dataFieldItem.actionStatus == "SUCCESS" || ctx_r64.section.status == "COMPLETED" || ctx_r64.status == "COMPLETED") && ctx_r64.forms.pristine));
    ɵɵadvance(1);
    ɵɵproperty("ngIf", (ctx_r64.section == null ? null : ctx_r64.section.additionalType) != "modal" && (field_r55.dataFieldItem.actionStatus == "SUCCESS" || ctx_r64.section.status == "COMPLETED" || ctx_r64.status == "COMPLETED") && ctx_r64.forms.pristine);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", field_r55.dataFieldItem.actionStatus != "LOADING" && ctx_r64.autoSaveTimeTemp > 0);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", !ctx_r64.forms.pristine && !ctx_r64.forms.valid && ctx_r64.setSubmit);
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_8_span_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "span");
    ɵɵelement(1, "i", 150);
    ɵɵelementEnd();
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r560 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 148);
    ɵɵelementStart(1, "button", 149);
    ɵɵlistener("click", function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_8_Template_button_click_1_listener($event) { ɵɵrestoreView(_r560); const field_r55 = ɵɵnextContext(3).$implicit; const sub_section_r41 = ɵɵnextContext(2).sub_section; const ctx_r559 = ɵɵnextContext(); return ctx_r559.call_fn($event, sub_section_r41.identifier, field_r55); });
    ɵɵelement(2, "span", 11);
    ɵɵpipe(3, "i18n");
    ɵɵtemplate(4, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_8_span_4_Template, 2, 0, "span", 2);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const field_r55 = ɵɵnextContext(3).$implicit;
    const sub_section_r41 = ɵɵnextContext(2).sub_section;
    const ctx_r65 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵclassMapInterpolate1("btn btn-outline-secondary ak-section-btn-add  ", field_r55.cssClassValue ? field_r55.cssClassValue : "", " px-3 btn ");
    ɵɵproperty("disabled", ctx_r65.alternativeReadonly[sub_section_r41.name] || ctx_r65.loadReadonly[ctx_r65.section.alternateName])("hidden", field_r55.hidden || ctx_r65.readonlyMode);
    ɵɵadvance(1);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(3, 7, field_r55.dataFieldItem.label), ɵɵsanitizeHtml);
    ɵɵadvance(2);
    ɵɵproperty("ngIf", ctx_r65.loadReadonly[ctx_r65.section.alternateName]);
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 45);
    ɵɵtemplate(1, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_1_Template, 3, 3, "div", 46);
    ɵɵtemplate(2, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_2_Template, 26, 9, "div", 2);
    ɵɵtemplate(3, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_3_Template, 41, 42, "div", 47);
    ɵɵtemplate(4, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_4_Template, 12, 26, "div", 47);
    ɵɵtemplate(5, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_5_Template, 10, 9, "div", 47);
    ɵɵtemplate(6, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_6_Template, 4, 3, "div", 47);
    ɵɵtemplate(7, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_7_Template, 6, 5, "div", 48);
    ɵɵtemplate(8, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_div_8_Template, 5, 9, "div", 49);
    ɵɵelementEnd();
} if (rf & 2) {
    const field_r55 = ɵɵnextContext(2).$implicit;
    const sub_section_r41 = ɵɵnextContext(2).sub_section;
    const ctx_r57 = ɵɵnextContext();
    ɵɵclassMap((field_r55 == null ? null : field_r55.cssClass) ? field_r55.cssClass : "");
    ɵɵproperty("formGroup", ctx_r57.getFormGroup(sub_section_r41.identifier, field_r55));
    ɵɵadvance(1);
    ɵɵproperty("ngIf", field_r55.dataFieldItem.type == "label");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r57.modeDebug);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", field_r55.dataFieldItem.type == "input");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", field_r55.dataFieldItem.type === "textarea");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", field_r55.dataFieldItem.type == "select");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", field_r55.dataFieldItem.type == "div");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", field_r55.dataFieldItem.type == "button");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", field_r55.dataFieldItem.type == "button-add");
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0, 43);
    ɵɵtemplate(1, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_div_1_Template, 9, 12, "div", 44);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const field_r55 = ɵɵnextContext().$implicit;
    ɵɵadvance(1);
    ɵɵproperty("ngIf", !field_r55.hidden);
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_ng_container_1_Template, 2, 1, "ng-container", 42);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const field_r55 = ctx.$implicit;
    const ctx_r51 = ɵɵnextContext(3);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", (field_r55.dataFieldItem.type != "label" && field_r55.dataFieldItem.type != "select" && field_r55.dataFieldItem.type != "input" && field_r55.dataFieldItem.type != "textarea" || field_r55.valueRequired == true || field_r55.dataFieldItem.typeInput == "selectButton" || field_r55.dataFieldItem.typeInput == "selectButtonCssFields" || field_r55.valueRequired == false && ctx_r51.isFieldNotRequired) && ctx_r51.notfield);
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_div_8_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵelementStart(1, "pre");
    ɵɵtext(2);
    ɵɵpipe(3, "json");
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r52 = ɵɵnextContext(3);
    ɵɵadvance(2);
    ɵɵtextInterpolate1("forms: ", ɵɵpipeBind1(3, 1, ctx_r52.forms == null ? null : ctx_r52.forms.getRawValue()), "");
} }
function AkeelaSectionComponent_ng_template_3_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, AkeelaSectionComponent_ng_template_3_ng_container_1_div_1_Template, 3, 3, "div", 36);
    ɵɵpipe(2, "i18n");
    ɵɵtemplate(3, AkeelaSectionComponent_ng_template_3_ng_container_1_div_3_Template, 2, 3, "div", 37);
    ɵɵpipe(4, "i18n");
    ɵɵelementStart(5, "form", 38);
    ɵɵelementStart(6, "div", 0);
    ɵɵtemplate(7, AkeelaSectionComponent_ng_template_3_ng_container_1_ng_container_7_Template, 2, 1, "ng-container", 39);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵtemplate(8, AkeelaSectionComponent_ng_template_3_ng_container_1_div_8_Template, 4, 3, "div", 2);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const sub_section_r41 = ɵɵnextContext().sub_section;
    const ctx_r43 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("ngIf", sub_section_r41 && ctx_r43.isNotNullOrUndefined(ɵɵpipeBind1(2, 5, sub_section_r41 == null ? null : sub_section_r41.sectionTitle)) && (ctx_r43.isFieldNotRequired || ctx_r43.isSectionNotRequired[sub_section_r41.identifier] && !ctx_r43.isFieldNotRequired) && (ctx_r43.section == null ? null : ctx_r43.section.additionalType) != "modal");
    ɵɵadvance(2);
    ɵɵproperty("ngIf", sub_section_r41 && ctx_r43.isNotNullOrUndefined(ɵɵpipeBind1(4, 7, sub_section_r41 == null ? null : sub_section_r41.description)) && !sub_section_r41.hidden);
    ɵɵadvance(2);
    ɵɵproperty("formGroup", ctx_r43.getGroup(sub_section_r41 == null ? null : sub_section_r41.identifier));
    ɵɵadvance(2);
    ɵɵproperty("ngForOf", sub_section_r41 == null ? null : sub_section_r41.fields);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r43.modeDebug);
} }
function AkeelaSectionComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵtemplate(0, AkeelaSectionComponent_ng_template_3_div_0_Template, 6, 7, "div", 29);
    ɵɵtemplate(1, AkeelaSectionComponent_ng_template_3_ng_container_1_Template, 9, 9, "ng-container", 2);
} if (rf & 2) {
    const sub_section_r41 = ctx.sub_section;
    ɵɵproperty("ngIf", sub_section_r41 && (sub_section_r41 == null ? null : sub_section_r41.componentName) && !(sub_section_r41 == null ? null : sub_section_r41.hidden));
    ɵɵadvance(1);
    ɵɵproperty("ngIf", sub_section_r41 && !(sub_section_r41 == null ? null : sub_section_r41.componentName) && !(sub_section_r41 == null ? null : sub_section_r41.hidden));
} }
class AkeelaSectionComponent {
    constructor(akeelaFormService, akeelaStepService, akeelaSectionService, akeelaStageService, akeelaWorkflowService, akeelaDatamodel, akeelaDatasource, config, Validator, templateService, eventService, route, urlService, _jsonService, 
    //  private _entityTableService: EntityTableService,
    creditService, conditionService, httpService, _auth, _alert, _akAlert, _pathService, localStorage, routeUtilsService, i18n, router) {
        this.akeelaFormService = akeelaFormService;
        this.akeelaStepService = akeelaStepService;
        this.akeelaSectionService = akeelaSectionService;
        this.akeelaStageService = akeelaStageService;
        this.akeelaWorkflowService = akeelaWorkflowService;
        this.akeelaDatamodel = akeelaDatamodel;
        this.akeelaDatasource = akeelaDatasource;
        this.config = config;
        this.Validator = Validator;
        this.templateService = templateService;
        this.eventService = eventService;
        this.route = route;
        this.urlService = urlService;
        this._jsonService = _jsonService;
        this.creditService = creditService;
        this.conditionService = conditionService;
        this.httpService = httpService;
        this._auth = _auth;
        this._alert = _alert;
        this._akAlert = _akAlert;
        this._pathService = _pathService;
        this.localStorage = localStorage;
        this.routeUtilsService = routeUtilsService;
        this.i18n = i18n;
        this.router = router;
        this.templates = {};
        this.callFn = new EventEmitter();
        this.initloadDataModel = false;
        this.mask_tlf = !isNullOrUndefined(this.config.mask) ? (!isNullOrUndefined(this.config.mask.telephone) ? Mask.getMask(this.config.mask.telephone) : Mask.mask_tlf) : Mask.mask_tlf;
        this.mask_rif = Mask.mask_rif;
        this.mask_identification = Mask.mask_identification;
        this.mask_passport = Mask.mask_passport;
        this.mask_date = Mask.mask_date;
        this.mask_year = Mask.mask_year;
        this.currency = this.config.currency;
        this.aux_value_input = '';
        this.loadSelect = {};
        this.dropdownSettings = {
            singleSelection: false,
            idField: 'value',
            textField: 'label',
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            itemsShowLimit: 3,
            allowSearchFilter: false
        };
        this.loading = false;
        this.queryParams = null;
        this.readonlyMode = false;
        this.clientaudience = null;
        this.listSelectUne = {};
        this.subscriptions = [];
        this.typeInputPass = true;
        this.objectypeInputPass = {};
        this.hideCheckbox = {};
        this.isSectionNotRequired = [];
        this.isFielsNotRequired = false;
        this.notfield = false;
        this.autoSaveTime = 15000; // 15 segundos
        this.autoSaveTimeTemp = 0;
        this.autoSaveActivetemp = null;
        this.autoSaveActive = null;
        this.ifAutoSave = true;
        this.loadingAutoSave = null;
        this.sectionsLoading = true;
        this.hideSections = {};
        this.readonly = false;
        this.transitionsWfs = [];
        this.workflowStatus = {};
        this.hiddeFieldOptional = { active: false, type: "optional" };
        this.separateDialCode = true;
        this.SearchCountryField = SearchCountryField;
        this.CountryISO = CountryISO;
        this.PhoneNumberFormat = PhoneNumberFormat;
        this.preferredCountries = [CountryISO.UnitedStates, CountryISO.UnitedKingdom];
        this.tlfValidates = {};
        this.emailValidates = {};
        this.call_suggestion = (sectionIdentifier, field) => {
            const subSection = this.section.sections.find(_subSection => _subSection.identifier === sectionIdentifier);
            const sectionForm = this.section.sections.find(_subSection => _subSection.identifier !== sectionIdentifier);
            const sectionName = this.section.sections.find(_subSection => _subSection.identifier === sectionIdentifier).name;
            let obj = field.jsEvents ? field.jsEvents : null;
            obj = JSON.parse(obj);
            //let obj = JSON.parse('[{"e":"trigger","sub_e":"","f":"suggest","o":{"value":"homeAddress.addressLocality2.identifier", "endpoint": "app_properties$postalCodes_by_parish$get"}}]');
            if (!isNullOrUndefined(obj)) {
                if (obj.length > 0) {
                    for (const fn of obj) {
                        if (fn.f === "suggest") {
                            this.akeelaWorkflowService.setShowSuggestion({
                                id: this.getValuesFromKey2(fn.o["value"], this.forms.value),
                                endpoint: fn.o["endpoint"]
                            });
                        }
                    }
                }
            }
            // console.log(this.getValuesFromKey2('homeAddress.addressLocality2.identifier', this.forms.value));
        };
        this.showValidateTel = (section, field) => {
            let control = this.akeelaFormService.getControl(this.forms, field.dataFieldItem.alternateName);
            if (control === null || control === void 0 ? void 0 : control.value) {
                this.akeelaWorkflowService.setShowValidateTel(control === null || control === void 0 ? void 0 : control.value);
            }
            let objTlfValidatesWfReq = this.akeelaWorkflowService.tlfValidatesWfReq$.getValue();
            let item = {};
            let temp = [];
            if (objTlfValidatesWfReq) {
                temp = objTlfValidatesWfReq === null || objTlfValidatesWfReq === void 0 ? void 0 : objTlfValidatesWfReq.filter(item => {
                    if ((item === null || item === void 0 ? void 0 : item.num) !== (control === null || control === void 0 ? void 0 : control.value)) {
                        return true;
                    }
                    else {
                        item = item;
                        return false;
                    }
                });
            }
            item['num'] = control === null || control === void 0 ? void 0 : control.value;
            item['name'] = field.dataFieldItem.alternateName;
            this.akeelaWorkflowService.setTlfValidatesWfReq([temp, item]);
        };
        this.showValidateEmail = (section, field) => {
            let control = this.akeelaFormService.getControl(this.forms, field.dataFieldItem.alternateName);
            if (control === null || control === void 0 ? void 0 : control.value) {
                this.akeelaWorkflowService.setShowValidateEmail(control === null || control === void 0 ? void 0 : control.value);
            }
            let objEmailValidatesWfReq = this.akeelaWorkflowService.emailValidatesWfReq$.getValue();
            let item = {};
            let temp = [];
            if (objEmailValidatesWfReq) {
                temp = objEmailValidatesWfReq === null || objEmailValidatesWfReq === void 0 ? void 0 : objEmailValidatesWfReq.filter(item => {
                    if ((item === null || item === void 0 ? void 0 : item.num) !== (control === null || control === void 0 ? void 0 : control.value)) {
                        return true;
                    }
                    else {
                        item = item;
                        return false;
                    }
                });
            }
            item['email'] = control === null || control === void 0 ? void 0 : control.value;
            item['name'] = field.dataFieldItem.alternateName;
            this.akeelaWorkflowService.setEmailValidatesWfReq([temp, item]);
        };
        this.getValueField = (field) => {
            let tmp;
            let control = this.akeelaFormService.getControl(this.forms, field.dataFieldItem.alternateName);
            if (control === null || control === void 0 ? void 0 : control.value) {
                tmp = control === null || control === void 0 ? void 0 : control.value;
            }
            return tmp;
        };
        this.validateMinMaxLen = (input_value) => {
            return (input_value.length >= 8 && input_value.length <= 12 ? true : false);
        };
        this.validateExistsNumber = (input_value) => {
            return ((input_value.replace(/[^0-9]/g, "").length == 0) ? false : true);
        };
        this.validateUpperAndLowerLetter = (input_value) => {
            return ((input_value.replace(/[^A-Z]/g, "").length == 0) || (input_value.replace(/[^a-z]/g, "").length == 0) ? false : true);
        };
        this.validateSpecialCharacters = (input_value) => {
            return ((input_value.toLowerCase().replace(/[^!@#$%^&*()+={}/|:;<>,.?-_]/g, "").length == 0) ? false : true);
        };
        this.validateConsecutive = (input_value) => {
            return (/^(?!.*([A-Za-z0-9!@#$%^&*()+={}/|:;<>,.?-_\s])\1{3})[A-Za-z!@#$%^&*()+={}/|:;<>,.?-_\s0-9]+$/.test(input_value)) ? true : false;
        };
        this.validateIfConfirm = (field) => {
            if (field) {
                if (field.dataFieldItem.name.includes('confirmPassword')) {
                    return true;
                }
            }
            return false;
        };
        this.mask_tlf_new = {
            guide: true,
            showMask: true,
            mask: ['+', /[0-9]/, /[0-9]/, ' ', '(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]
        };
        this.autoSaveTime = this.config.autoSaveTime;
        this.ifAutoSave = this.config.autoSave;
        this.isSectionOpened = this.config.initiallyOpenSections;
        this.isFieldNotRequired = false;
    }
    onItemSelect(event) {
    }
    ngAfterViewInit() {
        this.setWfFormFields();
        setTimeout(() => {
            this.templates = this.templateService.getTemplates();
        }, 1);
        this.setReadonlyMode(this.akeelaStepService.currentStepMode$.getValue());
        /*   if(this.akeelaWorkflowService.currentWorkflowActive$.getValue() == 'CLIENT_DATA'){
           }*/
        this.subscription_transaction_data = this.akeelaWorkflowService.transactionData$.subscribe((transactionData) => {
            // Juan se coloco  
            // this.loadDataModel(true); //dentro de la condicion
            if (!isNullOrUndefined(transactionData)) {
                this.loadDataModelTransaction(true);
                this.transactionData = transactionData;
                //Para Secciones que requieran ejecutar un jsEvent luego de ser renderizadas
                //Ej: [AccountOpening] Ocultar Ente Publico en Datos de Constitucion
                this.triggerSectionEvent();
            }
            else {
                if (!this.initloadDataModel) {
                    this.loadDataModel(true);
                    this.initloadDataModel = true;
                }
                // this.loadNested();
            }
        });
    }
    datos() {
        console.log(this.forms);
    }
    ngOnInit() {
        this.notWorkflowfluid = this.localStorage.getItem('notWorkflowfluid');
        this.route.queryParams.subscribe(params => {
            this.sectionName = null;
            if (params === null || params === void 0 ? void 0 : params.section) {
                this.sectionName = params === null || params === void 0 ? void 0 : params.section;
            }
        });
        this.akeelaWorkflowService.wfTransitions$.subscribe((transitionsWfs) => {
            this.transitionsWfs = transitionsWfs;
        });
        this.akeelaStepService.currentStepMode$.subscribe((readonly) => {
            if (!isNullOrUndefined(readonly)) {
                this.readonly = readonly;
            }
        });
        this.akeelaWorkflowService.hideSections$.subscribe(hideSections => {
            this.hideSections = hideSections;
        });
        this.akeelaDatasource.loadSelect$.subscribe(loadSelect => {
            this.loadSelect = loadSelect;
        });
        this.akeelaWorkflowService.hiddeFieldOptional$.subscribe((resp) => {
            if (resp === null || resp === void 0 ? void 0 : resp.active) {
                this.hiddeFieldOptional = resp;
            }
        });
        this.isFieldNotRequired = false;
        this.akeelaWorkflowService.fieldsNotRequired$.subscribe((fieldsNotRequired) => {
            if (!isNullOrUndefined(fieldsNotRequired)) {
                this.isFieldNotRequired = fieldsNotRequired;
            }
        });
        this.akeelaWorkflowService.worflowEvents$.next(null);
        this.modeDebug = this.localStorage.getItem('modeDebug');
        this.alternativeReadonly = [];
        this.loadReadonly = {};
        this.workflow = this.akeelaWorkflowService.currentWorkflow$.getValue();
        this.session = this._auth.getSession();
        this.subscription_query_params = this.route.queryParams.subscribe(queryParams => {
            this.figure = this.creditService.figure$.getValue();
            this.audience = this.routeUtilsService.getAudience(queryParams);
            this.role = this.routeUtilsService.getRole(queryParams);
            this.profile = this.routeUtilsService.getProfile(queryParams);
            this.queryParams = queryParams;
        });
        this.subscriptions.push(this.akeelaSectionService.background$.subscribe((active) => {
            if (active !== null) {
                this.background = active;
            }
        }));
        // data transaction...
        this.subscription_transaction_data = this.akeelaWorkflowService.transactionData$.subscribe((transactionData) => {
            var _a;
            if (!isNullOrUndefined(transactionData)) {
                this.transactionData = transactionData;
                this.mtWorkflow = (_a = transactionData === null || transactionData === void 0 ? void 0 : transactionData.plan) === null || _a === void 0 ? void 0 : _a.url;
                setTimeout(() => {
                    //    this.sectionsLoading = false;
                }, 800);
            }
        });
        this.subscriptions.push(this.akeelaWorkflowService.transactionNumber.subscribe((transactionNumber) => {
            if (!isNullOrUndefined(transactionNumber)) {
                this.transactionNumber = transactionNumber;
            }
            else {
                // this.sectionsLoading = false;
            }
        }));
        // función realizada para validar el modo del formulario (enable ó disable)
        this.subscriptions.push(this.akeelaStepService.currentStepMode$.subscribe((readonly) => {
            this.setReadonlyMode(readonly);
        }));
        if (this.index === 1) { // expandimos la primera subsección
            this.isSectionOpened = true;
        }
        // se crean los formularios para cada una de las subsecciones.
        // console.log('configurando los forms');
        this.forms = this.akeelaFormService.createFormGroups(this.section);
        //  console.log(this.forms);
        this.subscriptions.push(this.forms.statusChanges.subscribe(value => {
        }));
        this.section.sections.forEach(subSection => {
            let temp = false;
            subSection.fields.forEach(field => {
                this.notfield = true;
                //validar si hay algun campo obligatorio en la seccion para mostrar el titulo
                if (field.valueRequired == true || field.dataFieldItem.typeInput == 'selectButton') {
                    temp = true;
                }
                //validar si hay algun campo no obligatorio en la seccion 
                if ((isNullOrUndefined(field.valueRequired) || field.valueRequired == false) && field.dataFieldItem.typeInput != 'selectButton' && (field.dataFieldItem.type == 'select' || field.dataFieldItem.type == 'input' || field.dataFieldItem.type == 'textarea')) {
                    this.isFielsNotRequired = true;
                }
                //llena los condicionales
                //  if (field.dataFieldItemDepend && !this.akeelaStepService.currentStepMode$.getValue()) {
                if (field.dataFieldItemDepend) {
                    this.conditionService.applyDependCondition(this.forms, field);
                }
                setTimeout(() => {
                    //Se deshabilitan los Select con readOnly = true, yq eu HTML no lo hace por defecto.
                    if (field.readonlyValue && field.dataFieldItem.type === 'select') {
                        let control = this.akeelaFormService.getControl(this.forms, field.dataFieldItem.alternateName);
                        control.disable();
                    }
                }, 1);
            });
            this.isSectionNotRequired[subSection.identifier] = temp;
        });
        // observamos los cambios sobre los formularios, en caso de cambio, se activa el botón submit
        this.section.sections.forEach(subSection => {
            this.getGroup(subSection.identifier).valueChanges.subscribe(() => {
                if (!this.getGroup(subSection.identifier).pristine && !this.sectionsLoading) {
                    this.updateStatus(subSection, '');
                    this.showSubmitButton(subSection, true);
                    if (this.ifAutoSave && this.forms.valid) {
                        this.section.sections.forEach(subSection => {
                            subSection.fields.forEach(field => {
                                if (field.dataFieldItem.alternateName == 'botonAutoSave') {
                                    if (!isNullOrUndefined(this.autoSaveActive)) {
                                        clearTimeout(this.autoSaveActive);
                                    }
                                    this.autoSaveActive = setTimeout(() => {
                                        this.autoSave();
                                    }, this.autoSaveTime);
                                    clearInterval(this.autoSaveActivetemp);
                                    this.autoSaveTimeTemp = (this.autoSaveTime / 1000);
                                    this.autoSaveActivetemp = setInterval(() => { this.checkTime(); }, 1000);
                                }
                            });
                        });
                    }
                    else {
                        this.autoSaveTimeTemp = 0;
                        clearTimeout(this.autoSaveActive);
                        clearInterval(this.autoSaveActivetemp);
                    }
                }
            });
        });
        // subscribimos a los cambios sobre el modelo de datos, para el caso que vanga valores desde base de datos
        // estos valores se puedan mostrar correctamente en los formularios.
        this.datamodelSubscription = this.akeelaDatamodel.datamodel.subscribe(value => {
            this.section.sections.forEach(subSection => {
                //Esta distincion se hace para que no cargue los formularios de Modales
                //ya que ellos deben cerrarse, esto para el caso de PEP se estaba cargando sus datos sobre formularios
                //diferentes. Ej: Al guardar un PEP, sus valores se seteaban en formulario de Representante Legal.
                if (!isNullOrUndefined(subSection.isRelatedTo) && subSection.isRelatedTo.additionalType !== 'modal') {
                    this.getGroup(subSection.identifier).patchValue(value);
                }
            });
        });
        // external dataset... Se reciben desde componentes externos, data de formularios en secciones
        this.subscriptions.push(this.akeelaSectionService.externalUpdateSectionForm$.subscribe((data) => {
            if (!isNullOrUndefined(data)) {
                if (this.section.alternateName === data.section) {
                    this.forms.patchValue(data.response);
                }
            }
        }));
        // funcion externa para mostrar/ocultar seccion desde fuera del componente, solo con su código
        this.subscriptions.push(this.akeelaWorkflowService.hiddenSection$.subscribe((obj) => {
            if (obj) {
                this.setHiddenSection(obj.code, obj.hidden);
            }
        }));
        // external reset form... Se vacian los valores una sección de form
        this.subscriptions.push(this.akeelaSectionService.externalResetSectionForm$.subscribe((section) => {
            if (!isNullOrUndefined(section)) {
                if (this.section.alternateName === section) {
                    this.forms.reset();
                }
            }
        }));
        this.subscriptions.push(this.akeelaSectionService.resetModalForm(this.section.alternateName).subscribe(value => {
            if (value) {
                this.forms.reset(this.akeelaFormService.defaultValues[this.section.identifier]);
            }
        }));
        this.subscriptions.push(this.akeelaSectionService.getModalFormValue(this.section.alternateName).subscribe(value => {
            this.setWfFormFields();
            if (!isNullOrUndefined(value) && !(Object.keys(value).length === 0)) {
                /************* dfutrille esto debe borrarse para que venga del backend correctamente */
                if (!isNullOrUndefined(value.applicantType)) {
                    if (value.applicantType === "NATURAL") {
                        value.applicantType = "2";
                    }
                    else if (value.applicantType === "LEGAL") {
                        value.applicantType = "3";
                    }
                }
                else {
                    if (!isNullOrUndefined(value.personContact) && !isNullOrUndefined(value.personContact.identifier)) {
                        value.applicantType = "2";
                    }
                    else if (!isNullOrUndefined(value.organizationContact) && !isNullOrUndefined(value.organizationContact.identifier)) {
                        value.applicantType = "3";
                    }
                }
                /************* dfutrille */
                Object.keys(value).forEach((key) => {
                    if (isNullOrUndefined(value[key])) {
                        delete value[key];
                    }
                });
                let disableWhenUpdate;
                if (!isNullOrUndefined(value.disableWhenUpdate)) {
                    disableWhenUpdate = value.disableWhenUpdate;
                }
                disableWhenUpdate = 'organization.address.addressType.identifier';
                delete value['disableWhenUpdate'];
                this.forms.patchValue(value);
                this.loadNested();
                setTimeout(() => {
                    if (!isNullOrUndefined(disableWhenUpdate)) {
                        const control = this.akeelaFormService.getControl(this.forms, disableWhenUpdate);
                        // Mario: Agrego este caso, para inhabilitar campos via: disableWhenUpdate
                        // El valor anterior de este condicional es enable, pero este caso funciona es con disable
                        if (!isNullOrUndefined(control)) {
                            if (this.localStorage.getItem('modalFormModeUpdate')) {
                                control.enable();
                                // control.disable();
                            }
                            else {
                                control.enable();
                            }
                        }
                        if ((!isNullOrUndefined(value.organization) && !isNullOrUndefined(value.organization.identifier))
                            ||
                                (!isNullOrUndefined(value.organizationContact) && !isNullOrUndefined(value.organizationContact.identifier))
                            ||
                                (!isNullOrUndefined(value.person) && !isNullOrUndefined(value.person.identifier))
                            ||
                                (!isNullOrUndefined(value.personContact) && !isNullOrUndefined(value.personContact.identifier))) {
                            // if (this.localStorage.getItem('modalFormModeUpdate')) {
                            //     control.enable();
                            //     //control.disable();
                            // } else {
                            //     control.enable();
                            // }
                            if (!isNullOrUndefined(control)) {
                                control.disable();
                            }
                        }
                        else {
                        }
                    }
                }, 20);
            }
            else {
                this.akeelaSectionService.resetModalForm(this.section.alternateName).next(true);
            }
        }));
        this.subscriptions.push(this.akeelaWorkflowService.worflowEvents$.subscribe((response) => {
            var _a, _b;
            if ((response === null || response === void 0 ? void 0 : response.action) === 'receive_formValidationEvent') {
                let sectionForm = this.section.sections.find(s_section => s_section.identifier === response.response.sectionIdentifier);
                if (!isNullOrUndefined(sectionForm)) {
                    let type = (_a = response === null || response === void 0 ? void 0 : response.response) === null || _a === void 0 ? void 0 : _a.type;
                    let result = (_b = response === null || response === void 0 ? void 0 : response.response) === null || _b === void 0 ? void 0 : _b.result;
                    if (type == 'constitutionData' && result) {
                        this.formValidationEventDelete = 'registryLastUpdate';
                    }
                    this.call_fn(response.response.event, response.response.sectionIdentifier, response.response.field);
                }
            }
        }));
        this.subscriptions.push(this.akeelaSectionService.sumSharePercentage$.subscribe(response => {
            if (!isNullOrUndefined(this.localStorage.getItem('isShareholderPrincipal'))) {
                if (this.localStorage.getItem('isShareholderPrincipal')) {
                    this.alternativeReadonly['section.shareholders.shareholdersButtons'] = response < 100 ? false : true;
                }
            }
        }));
        this.akeelaWorkflowService.wfFormFields$.subscribe((response) => {
            this.setWfFormFields();
        });
        this.subscriptions.push(this.akeelaWorkflowService.workflowStatus$.subscribe((data) => {
            var _a, _b, _c;
            if (!isNullOrUndefined(data)) {
                this.workflowStatus = data;
                let stageCode = this.akeelaStageService.currentStage$.getValue();
                let stepCode = this.akeelaStepService.currentStep$.getValue();
                let sectionCode = this.section;
                this.compleatSection = (_c = (_b = (_a = (this.workflowStatus[stageCode])) === null || _a === void 0 ? void 0 : _a.steps[stepCode]) === null || _b === void 0 ? void 0 : _b.sections[sectionCode === null || sectionCode === void 0 ? void 0 : sectionCode.alternateName]) === null || _c === void 0 ? void 0 : _c.state;
                stageCode;
                // (this.workflowStatus[stageCode])?.steps[stageCode]?.sections[stepCode]?.state == 'COMPLETED'
            }
        }));
        this.akeelaWorkflowService.tlfValidates$.subscribe((response) => {
            this.tlfValidates = response;
            let action = [];
            let temp;
            let obj2 = this.akeelaWorkflowService.tlfValidatesWfReq$.getValue();
            if (obj2) {
                action = obj2.map((obj) => {
                    if (response[obj['num']]) {
                        obj['valid'] = true;
                        temp = obj['name'];
                    }
                    return obj;
                });
            }
            this.akeelaWorkflowService.setTlfValidatesWfReq(action);
            this.tlfValidatesWfReq = action;
            if (temp) {
                let controlField = this.akeelaFormService.getControl(this.forms, temp);
                if (controlField) {
                    controlField.updateValueAndValidity();
                }
            }
        });
        this.akeelaWorkflowService.emailValidates$.subscribe((response) => {
            this.emailValidates = response;
            let action = [];
            let temp;
            let obj2 = this.akeelaWorkflowService.emailValidatesWfReq$.getValue();
            if (obj2) {
                action = obj2.map((obj) => {
                    if (response[obj['email']]) {
                        obj['valid'] = true;
                        temp = obj['name'];
                    }
                    return obj;
                });
            }
            this.akeelaWorkflowService.setEmailValidatesWfReq(action);
            this.emailValidatesWfReq = action;
            if (temp) {
                let controlField = this.akeelaFormService.getControl(this.forms, temp);
                if (controlField) {
                    controlField.updateValueAndValidity();
                }
            }
        });
    }
    checkTime() {
        if (this.autoSaveTimeTemp > 0) {
            this.autoSaveTimeTemp--;
        }
        else {
            clearTimeout(this.autoSaveActivetemp);
        }
    }
    setWfFormFields() {
        this.wfFormFields = this.akeelaWorkflowService.wfFormFields$.getValue();
        if (this.wfFormFields.length > 0) {
            this.section.sections.forEach(subSection => {
                subSection.fields.forEach(field => {
                    let temp = this.wfFormFields.filter(item => item.name === field.dataFieldItem.alternateName);
                    if (temp.length > 0) {
                        let control = this.akeelaFormService.getControl(this.forms, field.dataFieldItem.alternateName);
                        if (control) {
                            this.akeelaDatasource.updateDataSource(field, temp, this.getIdentifierSectionDatasource(subSection.identifier, temp), null);
                            control.setValue(temp[0].value);
                            control.patchValue(temp[0].value);
                            if (!isNullOrUndefined(temp[0].disabled)) {
                                setTimeout(() => {
                                    if (temp[0].disabled) {
                                        control.disable();
                                    }
                                    else {
                                        control.enable();
                                    }
                                }, 50);
                            }
                            if (temp[0].temp) {
                                this.akeelaWorkflowService.deleteWfFormField(field.dataFieldItem.alternateName);
                                this.wfFormFields = this.akeelaWorkflowService.wfFormFields$.getValue();
                            }
                        }
                    }
                });
            });
        }
    }
    autoSave() {
        this.section.sections.forEach(subSection => {
            subSection.fields.forEach(field => {
                if (field.dataFieldItem.alternateName == 'botonAutoSave') {
                    const event = new Event('click');
                    this.call_fn(event, subSection.identifier, field);
                    //  this.akeelaWorkflowService.setSaveSectios(true);
                }
            });
        });
        clearTimeout(this.autoSaveActive);
    }
    ngOnDestroy() {
        if (this.subscriptions) {
            // prevent memory leak when component destroyed
            this.subscriptions.forEach(s => s.unsubscribe());
        }
        if (this.datamodelSubscription) {
            this.datamodelSubscription.unsubscribe();
        }
        if (this.workflowEventsSubscription) {
            this.workflowEventsSubscription.unsubscribe();
        }
        if (this.subscription_transaction_data) {
            this.subscription_transaction_data.unsubscribe();
        }
        if (this.subscription_query_params) {
            this.subscription_query_params.unsubscribe();
        }
        if (this.subscriptionsUrlGet) {
            this.subscriptionsUrlGet.unsubscribe();
        }
        if (this.subscriptionsUrlGetObj) {
            this.subscriptionsUrlGetObj.unsubscribe();
        }
        if (this.subscriptions) {
            // prevent memory leak when component destroyed
            this.subscriptions.forEach(s => s.unsubscribe());
        }
    }
    loadDataModelTransaction(force) {
        this.clearfile = true;
        // this.transactionNumber = RouteUtilsService.getTransactionNumber(queryParams);
        this.figure = this.creditService.figure$.getValue();
        this.audience = this.routeUtilsService.getAudience(this.queryParams);
        this.role = this.routeUtilsService.getRole(this.queryParams);
        this.profile = this.routeUtilsService.getProfile(this.queryParams);
        if (!isNullOrUndefined(this.transactionData)) {
            if (!isNullOrUndefined(this.section.urlGet)) {
                // MARIO: parametros cable, los agregue mientras se reciben directo de BD...
                // La solución es agregar un nuevo campo de parametros a la tabla wf_section
                // recordar ajustar
                let params = {
                    path: {
                        creditNumber: this.transactionNumber,
                        transactionNumber: this.transactionNumber,
                        idTransaction: this.transactionData.identifier,
                        figure: this.figure,
                        identifierPerson: this.getidentifierPerson()
                    },
                    request: {
                        role: this.role
                    }
                };
                // MARIO: se agrega este caso puntual, voy a comentarle a Joa que se necesita un nuevo campo y lo elimino, mientras para integrar el módulo de entrevista, se agrega
                if (this.section.urlGet === 'interview$interviews_transaction$get') {
                    params = {
                        path: {},
                        request: {
                            idTransaction: this.transactionData.identifier
                        }
                    };
                }
                // **************************/
                if (this.subscriptionsUrlGet) {
                    this.subscriptionsUrlGet.unsubscribe();
                }
                if (this.section.urlGet) {
                    this.subscriptionsUrlGet = this.akeelaDatamodel.getDataModel(this.section.urlGet, params, force)
                        .subscribe(response => {
                        this.sectionsLoading = false;
                        // CABLE INCOMES Y EXPENSES PRECARGA
                        switch (this.section.urlGet) {
                            case 'financial$income$get':
                                response = this.filterSum(response, 'income');
                                break;
                            case 'financial$expenses$get':
                                response = this.filterSum(response, 'expenses');
                                break;
                        }
                        // ...
                        const form = this.forms;
                        this.section.status = '';
                        if (response) {
                            this.cleanNull(response);
                            form.patchValue(response);
                        }
                        else {
                            this.forms.reset(this.akeelaFormService.defaultValues[this.section.identifier]);
                        }
                        this.loadNested();
                        this.section.sections.forEach(subSection => {
                            subSection.fields.forEach(field => {
                                if (field.dataFieldItemDepend) {
                                    this.conditionService.applyDependCondition2(this.forms, field);
                                }
                                setTimeout(() => {
                                    //Se deshabilitan los Select con readOnly = true, yq eu HTML no lo hace por defecto.
                                    if (field.readonlyValue && field.dataFieldItem.type === 'select') {
                                        let control = this.akeelaFormService.getControl(this.forms, field.dataFieldItem.alternateName);
                                        // control.disable();
                                    }
                                }, 30);
                            });
                        });
                    }, error => {
                        if (error.status !== 422) {
                            this.section.status = '';
                            this.forms.reset();
                            this.sectionsLoading = false;
                        }
                    });
                }
                else {
                    this.sectionsLoading = false;
                }
            }
            else {
                this.sectionsLoading = false;
                this.loadNested();
            }
        }
        else {
            this.sectionsLoading = false;
            this.loadNested();
        }
    }
    loadDataModel(force) {
        this.clientIdentifier = this.localStorage.getItem('clientIdentifier');
        this.clientName = this.localStorage.getItem('clientName');
        this.clearfile = true;
        this.figure = this.creditService.figure$.getValue();
        this.audience = this.routeUtilsService.getAudience(this.queryParams);
        this.role = this.routeUtilsService.getRole(this.queryParams);
        this.profile = this.routeUtilsService.getProfile(this.queryParams);
        const form = this.forms;
        // form.patchValue({});
        if (!isNullOrUndefined(this.section.urlGet)) {
            let params = {
                path: {},
                request: {
                    role: this.role
                }
            };
            if (this.subscriptionsUrlGet) {
                this.subscriptionsUrlGet.unsubscribe();
            }
            if (this.subscriptionsUrlGetObj) {
                this.subscriptionsUrlGetObj.unsubscribe();
            }
            this.subscriptionsUrlGetObj = this.akeelaDatamodel.getDataModelObj(this.section.urlGet, params, force)
                .subscribe((response) => {
                if (!isNullOrUndefined(response === null || response === void 0 ? void 0 : response.additionalType)) {
                    const jsonData = JSON.parse(response.additionalType);
                    if (!isNullOrUndefined(jsonData)) {
                        let rep = this.getObjectReplaceParams(jsonData);
                        params = {
                            path: {},
                            request: rep === null || rep === void 0 ? void 0 : rep.params
                        };
                        this.subscriptionsUrlGet = this.akeelaDatamodel.getDataModel(this.section.urlGet, params, force)
                            .subscribe(response => {
                            this.data_model = response;
                            console.log(this.data_model);
                            const form = this.forms;
                            this.section.status = '';
                            if (response) {
                                this.cleanNull(response);
                                form.patchValue(response);
                            }
                            else {
                                this.forms.reset(this.akeelaFormService.defaultValues[this.section.identifier]);
                            }
                            this.loadNested();
                            this.section.sections.forEach(subSection => {
                                subSection.fields.forEach(field => {
                                    if (field.dataFieldItemDepend) {
                                        this.conditionService.applyDependCondition2(this.forms, field);
                                    }
                                    setTimeout(() => {
                                        //Se deshabilitan los Select con readOnly = true, yq eu HTML no lo hace por defecto.
                                        if (field.readonlyValue && field.dataFieldItem.type === 'select') {
                                            let control = this.akeelaFormService.getControl(this.forms, field.dataFieldItem.alternateName);
                                            // control.disable();
                                        }
                                    }, 30);
                                });
                            });
                            setTimeout(() => {
                                this.sectionsLoading = false;
                            }, 5);
                        }, error => {
                            if (error.status !== 422) {
                                this.section.status = '';
                                this.forms.reset();
                                //  this.sectionsLoading = false;
                            }
                        });
                    }
                    else {
                        this.sectionsLoading = false;
                        this.loadNested();
                    }
                }
                else {
                    this.sectionsLoading = false;
                    this.loadNested();
                }
            }, error => {
            });
        }
        else {
            this.sectionsLoading = false;
            this.loadNested();
        }
    }
    loadNested() {
        this.session = this._auth.getSession();
        this.clearfile = false;
        this.section.sections.forEach(subSection => {
            if (subSection.fields) {
                subSection.fields.forEach(field => {
                    this.executeChangeEvent(field, subSection.identifier);
                });
            }
        });
        this.clearfile = true;
    }
    executeChangeEvent(field, sectionIdentifier) {
        if (!isNullOrUndefined(field.jsEvents)) {
            const jsEvents = JSON.parse(field.jsEvents);
            if (!isNullOrUndefined(jsEvents)) {
                let btnExecute = jsEvents.find(event => event.execute_btn);
                if (field.dataFieldItem.type === 'select' && (isNullOrUndefined(field.dataFieldItem.typeInput) || !isNullOrUndefined(btnExecute))) {
                    const changeEvent = jsEvents.find(event => event.e === 'change');
                    if (!isNullOrUndefined(changeEvent)) {
                        const event = new Event('change');
                        this.call_fn(event, sectionIdentifier, field);
                    }
                }
            }
        }
        if (field.dataFieldItem.type === 'input' && !(field.dataFieldItem.typeInput == 'radio') && !(field.dataFieldItem.typeInput == 'checkbox')) {
            if (!isNullOrUndefined(field.jsEvents)) {
                const jsEvents = JSON.parse(field.jsEvents);
                if (!isNullOrUndefined(jsEvents)) {
                    this.call_fn(event, sectionIdentifier, field);
                }
            }
        }
        if (!isNullOrUndefined(field.jsEvents)) {
            const jsEvents = JSON.parse(field.jsEvents);
            const changeEvent = jsEvents.find(event => event.e === 'input');
            if (!isNullOrUndefined(changeEvent)) {
                const event = { type: 'input' };
                this.call_fn(event, sectionIdentifier, field);
            }
        }
    }
    filterSum(response, type) {
        const aux = [];
        let sum = 0;
        const indexString = 'total' + type.charAt(0).toUpperCase() + type.slice(1);
        if (response[type]) {
            response[type].forEach(obj => {
                if (obj.dataFieldItem.alternateName) {
                    aux[obj.dataFieldItem.alternateName] = obj.propertyValue.value;
                    sum += obj.propertyValue.value;
                }
            });
        }
        aux[indexString] = sum;
        response = Object.assign({}, aux);
        return response;
    }
    setReadonlyMode(readonly) {
        this.readonlyMode = readonly;
        this.section.sections.forEach(subSection => {
            if (readonly) {
                this.akeelaFormService.setDisableFormGroup(this.getGroup(subSection.identifier));
            }
            else {
                this.akeelaFormService.setEnableFormGroup(this.getGroup(subSection.identifier));
            }
        });
    }
    setLoadReadonlySection(name) {
        this.loadReadonly = {};
        this.loadReadonly[name] = true;
    }
    getJson(json) {
        if (!isNullOrUndefined(json)) {
            try {
                return JSON.parse(json);
            }
            catch (e) {
                return null;
            }
        }
        return null;
    }
    call_fn(event, sectionIdentifier, field) {
        this.aux_value_input = '';
        const subSection = this.section.sections.find(_subSection => _subSection.identifier === sectionIdentifier);
        const sectionForm = this.section.sections.find(_subSection => _subSection.identifier !== sectionIdentifier);
        const sectionName = this.section.sections.find(_subSection => _subSection.identifier === sectionIdentifier).name;
        const obj = field.jsEvents ? field.jsEvents : null;
        this.clientUsername = this.localStorage.getItem('clientUsername');
        this.clientIdentifier = this.localStorage.getItem('clientIdentifier');
        this.stageCode = this.akeelaStageService.currentStage$.getValue();
        this.stepCode = this.akeelaStepService.currentStep$.getValue();
        if (!isNullOrUndefined(sectionForm)) {
            this.sectionCode = sectionForm.alternateName;
        }
        if (obj) {
            const data = JSON.parse(obj);
            if (data.length > 0) {
                for (const fn of data) {
                    fn.o['sectionIdentifier'] = sectionIdentifier;
                    fn.o['listName'] = field.dataFieldItem.alternateName;
                    fn.o['field'] = field;
                    if (fn.o.loadReadonly) {
                        this.setLoadReadonlySection(sectionForm.isRelatedTo.alternateName);
                    }
                    field.dataFieldItem.actionStatus = 'LOADING';
                    if (fn.e === event.type) {
                        // emito el valor de un evento, cuando se require, por el o.get:
                        if (!isNullOrUndefined(fn.o.emitValueFromEvent)) {
                            let control = this.akeelaFormService.getControl(this.forms, fn.o.field.dataFieldItem.alternateName);
                            if (fn.o.emitValueFromEvent.identifierField === field.identifier) {
                                const object = {
                                    value: event.target ? event.target.value : null,
                                    valueControl: control ? control.value : null,
                                    field: field,
                                    target: fn.o.emitValueFromEvent
                                };
                                this.akeelaWorkflowService.worflowEvents$.next(object);
                            }
                        }
                        if (fn.sub_e === 'url') {
                            const params = {};
                            for (const key of Object.keys(fn.o)) {
                                if (key !== 'listNameRelated' && key !== 'fieldsReset' &&
                                    key !== 'fieldsData' && key !== 'field' && key !== 'sectionIdentifier' && key !== 'fieldsrequired') {
                                    const objectSplit = fn.o[key].split('.');
                                    const objectSplitThis = fn.o[key].split('.');
                                    let aux = null;
                                    //Enable readOnly Selects - AQUI MARIO
                                    let fieldsToSearch = this.findFieldToSearchSameSectionLevel(sectionIdentifier);
                                    let readOnlySelects = this.findControlListToEnableToogle(fieldsToSearch);
                                    this.enableControlList(readOnlySelects);
                                    const form = this.forms.value;
                                    if (!isNullOrUndefined(form)) {
                                        let i = 0;
                                        objectSplit.forEach((element) => {
                                            if (i === 0) {
                                                if (!isNullOrUndefined(form[element])) {
                                                    aux = form[element];
                                                }
                                            }
                                            else {
                                                if (!isNullOrUndefined(aux)) {
                                                    if (!isNullOrUndefined(aux[element])) {
                                                        aux = aux[element];
                                                    }
                                                }
                                            }
                                            i++;
                                        });
                                    }
                                    // Mario: Si no consigue el valor en el form, lo busca en el contexto this.
                                    if (isNullOrUndefined(aux)) {
                                        if (isNullOrUndefined(this.localStorage.getItem('clientaudience'))) {
                                            this.localStorage.setItem('clientaudience', this.localStorage.getItem('audience'));
                                        }
                                        this.clientaudience = this.localStorage.getItem('clientaudience');
                                        let i = 0, replace = false;
                                        objectSplitThis.forEach((element) => {
                                            if (i === 0) {
                                                aux = this;
                                            }
                                            else {
                                                if (!isNullOrUndefined(aux[element])) {
                                                    aux = aux[element];
                                                    replace = true;
                                                }
                                            }
                                            i++;
                                        });
                                        if (!replace) {
                                            aux = null;
                                        }
                                    }
                                    // Mario: 07022023
                                    if (isNullOrUndefined(aux) && objectSplitThis.length === 1) {
                                        aux = objectSplitThis[0];
                                    }
                                    //****************/
                                    params[key] = aux;
                                    //Disable readOnly Selects
                                    this.disableControlList(readOnlySelects);
                                }
                                else if (key == 'fieldsReset' && this.clearfile) {
                                    Object.keys(fn.o[key]).forEach((index) => {
                                        let temp = fn.o[key][index];
                                        let control = this.akeelaFormService.getControl(this.forms, temp);
                                        if (control) {
                                            this.akeelaDatasource.updateDataSource(field, temp, this.getIdentifierSectionDatasource(sectionName, temp), null);
                                            control.setValue('');
                                            control.patchValue('');
                                        }
                                    });
                                }
                            }
                            // tslint:disable-next-line:no-shadowed-variable
                            const obj = {
                                url: fn.f,
                                params: params,
                                jsEvent: fn
                            };
                            /*   console.log('***********************************');
                               console.log(obj);*/
                            let temp = obj;
                            if (fn.o.fieldsrequired) {
                                for (let element of Object.keys(fn.o.fieldsrequired)) {
                                    let control = this.akeelaFormService.getControl(this.forms, fn.o.fieldsrequired[element]);
                                    if ((isNullOrUndefined(control) || control.value == '')) {
                                        if (element != 'listNameRelated') {
                                            temp = null;
                                        }
                                    }
                                }
                                ;
                            }
                            // console.log("fn.o.fieldsrequired :", fn.o.fieldsrequired);
                            //   console.log("temp: ", temp);
                            this.akeelaDatasource.updateDataSource(field, fn.o.listNameRelated, this.getIdentifierSectionDatasource(sectionName, fn.o.listNameRelated), temp);
                            this.aux_form = this.forms.value;
                        }
                        else if (fn.sub_e === 'validation') {
                            this.aux_value_input = event.target.value;
                        }
                        else if (fn.sub_e === 'validationPassword') {
                            this.aux_value_input = event.target.value;
                        }
                        else if (fn.sub_e === 'output') {
                            this.akeelaWorkflowService.worflowEvents$.next({
                                value: event.target ? event.target.value : null
                            });
                        }
                        else if (typeof this[fn.f] === 'function') {
                            this[fn.f](fn);
                            fn.o.field.dataFieldItem.actionStatus = '';
                        }
                        else {
                            console.log('function no definida:', fn.f);
                        }
                    }
                    else {
                        if (fn.sub_e === 'output') {
                            this.akeelaWorkflowService.worflowEvents$.next({
                                value: fn ? fn.o : null,
                                action: fn ? fn.o.action : null,
                                text: event.target.value
                            });
                        }
                    }
                }
            }
        }
    }
    actionSections(fn) {
        // Mario: example js_events
        // [{"e":"change","sub_e":"","f":"actionSections","o":{"attrDepend":"applicantType","case":[{"valueDepend":"2","actions":[{"action":"hide","sections":["SHAREHOLDERS_MODAL_LEGAL_FIELDS"]},{"action":"show","sections":["SHAREHOLDERS_MODAL_NATURAL_FIELDS","SHAREHOLDERS_MODAL_PEP"]}]},{"valueDepend":"3","actions":[{"action":"hide","sections":["SHAREHOLDERS_MODAL_NATURAL_FIELDS","SHAREHOLDERS_MODAL_PEP"]},{"action":"show","sections":["SHAREHOLDERS_MODAL_LEGAL_FIELDS"]}]}]}}]
        const attrValue = this.getFieldValue(fn.o.attrDepend);
        const action = fn.o.case.filter((obj) => {
            return obj.valueDepend.toString() === attrValue.toString();
        });
        if (!isNullOrUndefined(action)) {
            for (const depend of action[0].actions) {
                if (depend.action === 'hide') {
                    for (const section of depend.sections) {
                        this.setHiddenSection(section, true);
                    }
                }
                if (depend.action === 'show') {
                    for (const section of depend.sections) {
                        this.setHiddenSection(section, false);
                    }
                }
            }
        }
    }
    findFieldToSearchFatherSectionLevel(sectionIdentifier) {
        let fieldsToSearch = [];
        this.section.sections.forEach((_section) => {
            if (_section.isRelatedTo.identifier === sectionIdentifier) {
                fieldsToSearch = fieldsToSearch.concat(_section.fields);
            }
        });
        return fieldsToSearch;
    }
    findFieldToSearchSameSectionLevel(sectionIdentifier) {
        let fieldsToSearch = [];
        this.section.sections.forEach((_section) => {
            if (_section.identifier === sectionIdentifier) {
                fieldsToSearch = fieldsToSearch.concat(_section.fields);
            }
        });
        return fieldsToSearch;
    }
    findControlListToEnableToogle(fieldsToSearch) {
        // MARIO: 21/06/2021 se agrego la condición || this.readonly para solventar el tema de que no se precargan los valores en formularios dependientes y en modo readonly
        return fieldsToSearch.
            filter(_field => (_field.readonlyValue && _field.dataFieldItem.type === 'select') || this.readonly).
            map((_field) => {
            return this.akeelaFormService.getControl(this.forms, _field.dataFieldItem.alternateName);
        });
    }
    enableControlList(controlList) {
        controlList.forEach((controlName) => {
            controlName.enable();
        });
    }
    disableControlList(controlList) {
        controlList.forEach((controlName) => {
            controlName.disable();
        });
    }
    numberOnly(event) {
        const charCode = (event.which) ? event.which : event.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
            return false;
        }
        return true;
    }
    getValidatorFn(fn) {
        return (control) => {
            return new Promise((resolve, reject) => {
                const fn_aux = fn;
                fn = this.getObjectReplaceParams(fn);
                const params = {
                    request: fn.params,
                    path: {},
                    body: {}
                };
                fn = fn_aux;
                this.subscriptions.push(this.httpService.executeRequest(fn_aux.f, params).subscribe((data) => {
                    if (data) {
                        resolve({ existe: data });
                    }
                    else {
                        resolve(null);
                    }
                }));
            });
        };
    }
    validationPasswordFn(fn) { }
    ;
    getIdentifierSectionDatasource(sectionName, fieldIdentifier) {
        let identifier = null;
        this.section.sections.forEach((_section) => {
            if (_section.name === sectionName) {
                _section.fields.forEach((_field) => {
                    if (_field.dataFieldItem.alternateName === fieldIdentifier) {
                        identifier = _field.identifier;
                    }
                });
            }
        });
        return identifier;
    }
    getGroup(sectionIdentifier, field) {
        // const sectionName = this.section.sections.find(subSection => subSection.identifier === sectionIdentifier).name;
        // let formGroup: AbstractControl = this.forms.get(AkeelaFormService.getFieldIdentifier(sectionName)) as FormGroup;
        let formGroup = this.forms;
        if (!isNullOrUndefined(field)) {
            const prefixField = AkeelaFormService.getPrefixFieldIdentifier(field.dataFieldItem.alternateName);
            prefixField.forEach(groupName => {
                if (isNullOrUndefined(formGroup)) {
                }
                else if (!isNullOrUndefined(formGroup.get(groupName))) {
                    formGroup = formGroup.get(groupName);
                }
            });
        }
        return formGroup || new FormGroup({});
    }
    getFormGroup(sectionIdentifier, field) {
        return this.getGroup(sectionIdentifier, field);
    }
    clearUnderscore(data) {
        if (data) {
            return data.replace(new RegExp('_', 'g'), '');
        }
        return data;
    }
    updateStatus(subSection, statusCode) {
        subSection = subSection;
        subSection.status = statusCode;
        this.section.status = this.section.sections
            .filter(_subSection => _subSection.status !== 'COMPLETED').length === 0 ? 'COMPLETED' : '';
    }
    showSubmitButton(subSection, show) {
        if (subSection.submitButton) {
            // no se debe ocultar el boton al guardar solo cuando el estado del form sea no
            // subSection.submitButton.hidden = !show;
        }
    }
    submitForma(fn) {
        var _a, _b;
        let preventSubmit = false;
        const fn_aux = fn;
        this.setSubmit = true;
        if (this.forms.valid) {
            if ((this.compleatSection == 'COMPLETED') && (this.forms.pristine && !((_a = fn === null || fn === void 0 ? void 0 : fn.o) === null || _a === void 0 ? void 0 : _a.pristineFalse)) && ((_b = this.section) === null || _b === void 0 ? void 0 : _b.additionalType) != 'modal') {
                fn.o.field.dataFieldItem.actionStatus = '';
                this.setRedirectSectionSection();
                return;
            }
            //if (false) {
            const subSection = this.section.sections.find(_subSection => _subSection.identifier === fn.o.sectionIdentifier);
            let sectionForm = this.section.sections.find(s_section => s_section.identifier !== fn.o.sectionIdentifier);
            if (!sectionForm) {
                sectionForm = this.section.sections.find(s_section => s_section.identifier === fn.o.sectionIdentifier);
            }
            //Limpia claves identifiers que tengan valor "newIdetifier", para guardar registros nuevos.
            //Esto se hace para diferenciar registros nuevos de los que ya existen y tienen valor en la clave 'identifier'
            if (!isNullOrUndefined(fn.o.newIdentifierName) && fn.o.newIdentifierName) {
                this.cleanNewIdentifiers(fn.o.newIdentifierName);
            }
            // Enable readOnly Selects
            let fieldsToSearch = this.findFieldToSearchFatherSectionLevel(sectionForm.isRelatedTo.identifier);
            let readOnlySelects = this.findControlListToEnableToogle(fieldsToSearch);
            this.enableControlList(readOnlySelects);
            let data = {};
            if (fn.o.encrypt) {
                this.changeviewPasswordAll(false);
                // EXAMPLE: fn.o.encrypt : ['endUser.password', 'endUser.confirmPassword']
                //  console.log("this.forms.getRawValue()",this.forms.getRawValue());
                // console.log("this.forms.value",this.forms.value);
                data = this.fnEncrypt(this.setExternalData(this.forms.getRawValue()), fn.o.encrypt);
            }
            else {
                const control = this.akeelaFormService.getControl(this.forms, 'applicantType');
                let applicantType;
                if (!isNullOrUndefined(control)) {
                    applicantType = control.value;
                }
                data = this.setExternalData(this.forms.getRawValue());
                if (!isNullOrUndefined(applicantType)) {
                    data['applicantType'] = applicantType;
                }
            }
            if (fn.o.setNullIsValueEmpty) {
                // EXAMPLE: fn.o.setNullIsValueEmpty : ['organization.specialCategory.identifier']
                data = this.fnSetNullIfDataEmpty(this.setExternalData(this.forms.getRawValue()), fn.o.setNullIsValueEmpty);
            }
            // Mario: Juan me pidio que cambiara este por el siguiente
            // if (this.localStorage.getItem('ak-add-json')) {
            //     let tempJson = JSON.parse(this.localStorage.getItem("ak-add-json"));
            //     data = Object.assign(data, tempJson);
            // }
            if (this.localStorage.getItem('ak-add-json')) {
                const tempJson = JSON.parse(this.localStorage.getItem('ak-add-json'));
                data = Object.assign(data, tempJson);
            }
            if (this.localStorage.getItem('ak-add-json')) {
                const tempJson = JSON.parse(this.localStorage.getItem('ak-add-json'));
                data = Object.assign(data, tempJson);
            }
            // casos de select's que tienen que guardar su value null, si la bandera está activa, se setean los null de estar en el arreglo
            let urlBackend = '';
            if (this.section.url) {
                urlBackend = this.section.url;
            }
            else {
                this.section.sections
                    .filter(s_section => s_section.identifier !== fn.o['sectionIdentifier'] && !isNullOrUndefined(s_section.url))
                    .forEach(s_section => urlBackend = s_section.url);
            }
            const event = this.eventService.getEvent(fn.o.field);
            if (!isNullOrUndefined(fn.o.multiselectTransform)) {
                fn.o.objResult = data;
                fn.o.dataMultiselectTransform = data;
                fn.o.dataMultiselectTransform[fn.o.multiselectTransform.name] = [];
            }
            else {
                fn.o.objResult = data;
            }
            // TODO: para eliminar tambien**********************
            if (fn.o.fnSubSubmit === 'saveDestinationOfFunds') {
                fn.o = this.getObjectReplaceParams(fn);
                if (this.figure === 'ACCREDITED') {
                    fn.o.objResult.accredited = {
                        identifier: this.transactionData.accredited.identifier
                    };
                }
                else {
                    fn.o.objResult.guarantor = {
                        identifier: this.transactionData.guarantor.identifier
                    };
                }
                fn.o.objResult.creditDestinationOfFunds = [];
            }
            else if (fn.o.fnSubSubmit === 'saveBank') {
                fn.o = this.getObjectReplaceParams(fn);
                if (this.audience === 'NATURAL') {
                    fn.o.objResult.person = {
                        identifier: this.getidentifierPerson()
                    };
                }
                else {
                    fn.o.objResult.organization = {
                        identifier: this.getidentifierPerson()
                    };
                }
            }
            else if (fn.o.fnSubSubmit === 'saveIncome' || fn.o.fnSubSubmit === 'saveExpenses') {
                fn.o.objResult = {};
                fn.o.objResult[fn.o['fnSubSubmitSumParam']] = this.setParamsSum(fn, this.section, data);
                fn.o = this.getObjectReplaceParams(fn);
            }
            else {
                fn.o = this.getObjectReplaceParams(fn_aux);
            }
            // **********************************/
            // MULTISELECT OBJECT TRANSFORM
            if (!isNullOrUndefined(fn.o.multiselectTransform)) {
                if (!isNullOrUndefined(fn.o.dataMultiselectTransform[fn.o.multiselectTransform.name])) {
                    if (true) {
                        fn.o.objResult[fn.o.multiselectTransform.name] = [];
                        fn.o.objResult[fn.o.multiselectTransform.name] = this.createMultiselectParams(fn.o.dataMultiselectTransform[fn.o.multiselectTransform.nameSource], fn.o.multiselectTransform.content, fn.o.multiselectTransform.description, (!isNullOrUndefined(fn.o.multiselectTransform.key) ? fn.o.multiselectTransform.key : null), (!isNullOrUndefined(fn.o.multiselectTransform.value) ? fn.o.multiselectTransform.value : null));
                    }
                }
            }
            // ****************************
            // Verifica con el parametro needOrganizationOrPerson si necesita el valor de organization.identifier o person.identifier
            if (!isNullOrUndefined(fn.o.needOrganizationOrPerson) && fn.o.needOrganizationOrPerson) {
                if (this.audience === 'NATURAL') {
                    fn.o.objResult.person = {
                        identifier: this.getidentifierPerson()
                    };
                }
                else {
                    fn.o.objResult.organization = {
                        identifier: this.getidentifierPerson()
                    };
                }
            }
            //Verfica si debe eliminar el objeto person o organization dependiendo del valor definido en deleteOrganizationOrPerson
            //Por ahora usado en AccountOpening - ShareHolders para diferenciar NATURAL de LEGAL o vs.
            if (!isNullOrUndefined(fn.o.deleteOrganizationOrPerson)) {
                const conditionalName = fn.o.deleteOrganizationOrPerson.formControlName;
                const conditionalValueOrganization = fn.o.deleteOrganizationOrPerson.formControlValueOrganization;
                const formControlNameOrganization = fn.o.deleteOrganizationOrPerson.formControlNameOrganization;
                const formControlNamePerson = fn.o.deleteOrganizationOrPerson.formControlNamePerson;
                if (!isNullOrUndefined(fn.o.objResult[conditionalName])) {
                    if (fn.o.objResult[conditionalName] === conditionalValueOrganization) {
                        //Delete person Object
                        delete fn.o.objResult[formControlNamePerson];
                    }
                    else {
                        if (!fn.o.deleteOnlyPerson) {
                            delete fn.o.objResult[formControlNameOrganization];
                        }
                    }
                }
                else {
                    if (!isNullOrUndefined(fn.o.objResult.organization.identifier)) {
                        //Delete Person Object
                        delete fn.o.objResult[formControlNamePerson];
                    }
                    else {
                        delete fn.o.objResult[formControlNameOrganization];
                    }
                }
            }
            if (!isNullOrUndefined(fn.o.deleteFormKeys)) {
                this.deleteFormKeysFromObject(fn.o.deleteFormKeys, fn.o.objResult);
            }
            preventSubmit = this.preventSubmitCondition(fn);
            // Mario: validación por js_events de variables de sesión.
            if (!isNullOrUndefined(fn.o.validateExistAttrLocalStorage)) {
                if (isNullOrUndefined(this.localStorage.getItem(fn.o.validateExistAttrLocalStorage.key))) {
                    preventSubmit = true;
                    this.akeelaWorkflowService.worflowEvents$.next({
                        response: fn.o.validateExistAttrLocalStorage.response,
                        action: null,
                        forms: null,
                    });
                }
            }
            //Verifica si es un elemento para ser guardado previemente en memoria (caso de los PEP)
            //Solo para persona natural
            if (!isNullOrUndefined(fn.o.checkRelatedAndAdd) && !isNullOrUndefined(fn.o.objResult.person)) {
                if (!isNullOrUndefined(this.akeelaSectionService.getModalChildList(fn.o.checkRelatedAndAdd.event))) {
                    fn.o.objResult.person[fn.o.checkRelatedAndAdd.newKeyObject] = this.akeelaSectionService.getModalChildList(fn.o.checkRelatedAndAdd.event);
                }
            }
            fn.o.urlBackend = urlBackend;
            fn.o.event = event;
            fn.o.workflow = this.akeelaWorkflowService.currentWorkflow$.getValue();
            fn.o.stage = this.akeelaStageService.currentStage$.getValue();
            fn.o.step = this.akeelaStepService.currentStep$.getValue();
            fn.o.section = sectionForm.alternateName;
            // se cambian los valores...
            //
            // fn.o['objResult']['responseDescriptionIncomplete'] = 'Voy a mandar el incompleto';
            // fn.o['objResult']['responseDescriptionRejected'] = 'Voy a mandar el rechazado';
            // fn.o['replaceValue'] = { name: 'name', 'AC_INCOMPLETE': 'responseDescriptionIncomplete', 'AC_REJECTED': 'responseDescriptionRejected', nameNewKey: 'responseDescription' };
            if (!isNullOrUndefined(fn.o.replaceValue)) {
                if (!isNullOrUndefined(fn.o.replaceValue.nameNewKey)) {
                    if (!isNullOrUndefined(fn.o['replaceValue'][fn.o['objResult']['name']])) {
                        fn.o['objResult'][fn.o['replaceValue'].nameNewKey] = fn.o['objResult'][fn.o['replaceValue'][fn.o['objResult']['name']]];
                        delete fn.o['objResult'][fn.o['replaceValue']['AC_REJECTED']];
                        delete fn.o['objResult'][fn.o['replaceValue']['AC_INCOMPLETE']];
                    }
                }
            }
            // Juan : se  utiliza para eliminar de constitutionData el RegistryLastUpdate
            if (this.formValidationEventDelete) {
                delete data[this.formValidationEventDelete];
                delete fn.o.objResult[this.formValidationEventDelete];
            }
            if (!preventSubmit) {
                this.submitFormaMakeSave(fn, subSection, data, readOnlySelects);
            }
            else {
                //Submit evitado, se debe diferenciar por cada caso que haya evitado el submit
                this.preventSubmitActions(fn, subSection, data);
                // Showing Submit Button
                fn.o.field.dataFieldItem.actionStatus = '';
            }
        }
        else {
            fn.o.field.dataFieldItem.actionStatus = '';
            this.markFormGroupTouched(this.forms);
        }
    }
    fnSetNullIfDataEmpty(data, valuesToEncrypt) {
        if (!isNullOrUndefined(valuesToEncrypt)) {
            for (const value of valuesToEncrypt) {
                const indexs = value.split('.');
                if (indexs.length > 0) {
                    let auxiliar = data, i = 0;
                    for (const index of indexs) {
                        if (auxiliar[index]) {
                            auxiliar = auxiliar[index];
                        }
                        i++;
                    }
                    if (!isNullOrUndefined(auxiliar)) {
                        if (auxiliar === '' || auxiliar === 'null') {
                            data = this.replaceValue(data, value, null);
                        }
                    }
                }
            }
        }
        return data;
    }
    fnEncrypt(data, valuesToEncrypt) {
        if (!isNullOrUndefined(valuesToEncrypt)) {
            for (const value of valuesToEncrypt) {
                const indexs = value.split('.');
                if (indexs.length > 0) {
                    let auxiliar = data, i = 0;
                    for (const index of indexs) {
                        if (auxiliar[index]) {
                            auxiliar = auxiliar[index];
                        }
                        i++;
                    }
                    if (!isNullOrUndefined(auxiliar)) {
                        data = this.replaceValue(data, value, this._auth.encryptPassword(auxiliar));
                    }
                }
            }
        }
        return data;
    }
    replaceValue(data, key, value) {
        const elementos = key.split('.');
        let obj = {};
        let temp = {};
        const i = 0;
        for (let i = elementos.length - 1; i >= 0; i--) {
            if (i === (elementos.length - 1)) {
                obj = temp = {
                    [elementos[i]]: value
                };
            }
            else {
                obj = temp = {
                    [elementos[i]]: temp
                };
            }
        }
        return this._jsonService.mergeDeep(data, obj);
    }
    submitFormaMakeSave(fn, subSection, data, readOnlySelects) {
        this.autoSaveTimeTemp = 0;
        clearTimeout(this.autoSaveActive);
        clearInterval(this.autoSaveActivetemp);
        this.sectionsLoading = true;
        this.akeelaWorkflowService.setSaveSectios(true);
        this.disableControlList(readOnlySelects);
        this.subscriptions.push(this.akeelaFormService.save(fn.o).subscribe((response) => {
            // Verifica si hubo guardado de elementos en memoria y limpia la lista
            var _a, _b, _c, _d, _e, _f, _g;
            // se notifica que culminó el evento de guardar, por si es requerido por un componenter
            // En caso que se necesite devolver un action personalizado de envia en "fn.o.eventName"
            this.akeelaWorkflowService.worflowEvents$.next({
                response: response,
                action: fn.o.eventName ? fn.o.eventName : fn.o.fnSubSubmit,
                forms: this.forms,
            });
            this.sectionsLoading = false;
            this.localStorage.removeItem('ak-add-json');
            this.resetPristine(subSection);
            this.akeelaWorkflowService.setSaveSectios(false);
            //Esto se comento  por que no es necesario llamar a actualizar data de secciones por eso se comento, "this.loadDataModel(true);" Basicamente va al mismo lado pero con un obserable.
            /// this.akeelaDatamodel.updateDatamodel(data);
            this.updateStatus(subSection, 'COMPLETED');
            this.section.status = 'COMPLETED';
            subSection.submitButton = fn.o.field;
            this.showSubmitButton(subSection, false);
            if (this.section.additionalType === "modal"
                && this.akeelaSectionService.modalExist(this.section.alternateName)
                && this.akeelaSectionService.modalIsVisible(this.section.alternateName)) {
                this.akeelaSectionService.hideModalSection(this.section.alternateName);
            }
            /*
                        // evento para refrescar tablas entity afectadas
                        if (fn.o.fnUpdateEntityTable) {
                            fn.o.fnUpdateEntityTable.forEach(element => {
                                this._entityTableService.refresh$.next({
                                    identifier: element,
                                    entryParams: fn.o.objResult,
                                    response: response
                                });
                            });
                        }*/
            //Disable readOnly Selects
            this.disableControlList(readOnlySelects);
            // Solo para persona natural
            if (!isNullOrUndefined(fn.o.checkRelatedAndAdd) && !isNullOrUndefined(fn.o.objResult.person)) {
                this.akeelaSectionService.resetModalChildList(fn.o.checkRelatedAndAdd.event);
            }
            // this.loadDataModel(true);
            this.akeelaWorkflowService.setResetEstatus(true);
            //Verfica si debe forzar un actualización del transactionData
            //Por ahora usado en AccountOpening - Legal Representative.
            if (!isNullOrUndefined(fn.o.forceUpdateTransactionData)) {
                if (!isNullOrUndefined(response.transactionNumber)) {
                    this.akeelaWorkflowService.setResetEstatusStep(true);
                    // this.subscriptions.push(this.akeelaWorkflowService.setTransactionData().subscribe());
                }
            }
            // se manda fn.o?.notContinue cuando las secciones son dinamicas y se redireccionos desde WF componente del cliente
            //ejemplo buscar  this.continueSection = true;
            if (((_a = this.section) === null || _a === void 0 ? void 0 : _a.additionalType) != 'modal' && !((_b = fn.o) === null || _b === void 0 ? void 0 : _b.notContinue)) {
                this.setRedirectSectionSection();
            }
            if (((_c = fn === null || fn === void 0 ? void 0 : fn.o) === null || _c === void 0 ? void 0 : _c.redirect) && ((_e = (_d = fn === null || fn === void 0 ? void 0 : fn.o) === null || _d === void 0 ? void 0 : _d.redirect) === null || _e === void 0 ? void 0 : _e.url)) {
                this.redirectTo({ o: { url: (_g = (_f = fn === null || fn === void 0 ? void 0 : fn.o) === null || _f === void 0 ? void 0 : _f.redirect) === null || _g === void 0 ? void 0 : _g.url } });
            }
            fn.o.field.dataFieldItem.actionStatus = 'SUCCESS';
        }, (error) => {
            // Showing Submit Button 
            fn.o.field.dataFieldItem.actionStatus = '';
            this.sectionsLoading = false;
            this.akeelaWorkflowService.setSaveSectios(false);
            //Disable readOnly Selects
            this.disableControlList(readOnlySelects);
            this._alert.show(error);
        }));
    }
    setRedirectSectionSection() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        if (this.transitionsWfs && !this.notWorkflowfluid) {
            if ((_a = this.transitionsWfs[this.sectionName]) === null || _a === void 0 ? void 0 : _a.new) {
                this.redirectSection((_c = (_b = this.transitionsWfs[this.sectionName]) === null || _b === void 0 ? void 0 : _b.new) === null || _c === void 0 ? void 0 : _c.wf, (_e = (_d = this.transitionsWfs[this.sectionName]) === null || _d === void 0 ? void 0 : _d.new) === null || _e === void 0 ? void 0 : _e.stage, (_g = (_f = this.transitionsWfs[this.sectionName]) === null || _f === void 0 ? void 0 : _f.new) === null || _g === void 0 ? void 0 : _g.step, (_j = (_h = this.transitionsWfs[this.sectionName]) === null || _h === void 0 ? void 0 : _h.new) === null || _j === void 0 ? void 0 : _j.section);
            }
            else if ((_k = this.transitionsWfs[this.sectionName]) === null || _k === void 0 ? void 0 : _k.end) {
                this.redirectToUrl((_l = this.transitionsWfs[this.sectionName]) === null || _l === void 0 ? void 0 : _l.end);
            }
        }
    }
    preventSubmitCondition(fn) {
        let prevent = false;
        // CASO 1: evitado por fn.o.newChildObject | Verifica si es un elemento para ser guardado previemente en memoria (caso de los PEP)
        if (!isNullOrUndefined(fn.o.newChildObject)) {
            const fatherIdentifier = this.akeelaFormService.getControl(this.forms, fn.o.newChildObject.fatherIdentifier);
            if (!isNullOrUndefined(fatherIdentifier) && isNullOrUndefined(fatherIdentifier.value)) {
                prevent = true;
            }
        }
        // CASO 2: 
        // validar casos únicos, en los js_events
        // if (!isNullOrUndefined(fn.o.validateNoRepeat)) {
        // const validateNoRepeat= {
        //     storage: 'excludeOptionsDirectionsOnly',
        //     values:
        //         [
        //             {
        //                 value: 1,
        //                 msg: 'No se puede agregar más de una Dirección Principal'
        //             }
        //         ]
        // };
        // fn.o.objResult.organization.address.addressType.identifier
        if (!isNullOrUndefined(fn.o.validateNoRepeat)) {
            // valido si no está en edición...
            const me = !isNullOrUndefined(this.localStorage.getItem('modalFormModeUpdate')) ? this.localStorage.getItem('modalFormModeUpdate') : null;
            if (me === null) {
                let validateNoRepeat = fn.o.validateNoRepeat;
                if (!isNullOrUndefined(validateNoRepeat)) {
                    validateNoRepeat = JSON.parse(validateNoRepeat);
                    const restricted = this.localStorage.getItem(validateNoRepeat.storage);
                    let vti = this.getValuesFromKey(validateNoRepeat.model, fn.o.objResult);
                    if (vti.length > 0) {
                        vti = vti[0];
                    }
                    else {
                        vti = null;
                    }
                    if (!isNullOrUndefined(restricted) && !isNullOrUndefined(vti)) {
                        const arr_res = JSON.parse(restricted);
                        for (const ele of arr_res) {
                            for (const opt of validateNoRepeat.values) {
                                if ((opt.value).toString() === ele.toString() && vti.toString() === ele.toString()) {
                                    prevent = true;
                                    this._akAlert.show({
                                        title: 'Mensaje!',
                                        html: this.i18n.transform(opt.msg)
                                    });
                                }
                            }
                        }
                    }
                }
            }
        }
        return prevent;
    }
    preventSubmitActions(fn, subSection, data) {
        // CASO 1: evitado por fn.o.newChildObject | Agrega hijos temporales y oculta modal
        if (!isNullOrUndefined(fn.o.newChildObject)) {
            //se agrega en lista temporal para guardar luego
            if (isNullOrUndefined(fn.o.objResult.tempIdentifier) || fn.o.objResult.tempIdentifier === '') {
                fn.o.objResult.tempIdentifier = fn.o.newChildObject.childTempIdentifierPrefix + this.akeelaSectionService.countModalChildList(fn.o.newChildObject.event);
                this.akeelaSectionService.addModalChild(fn.o.newChildObject.event, fn.o.objResult);
            }
            else {
                this.akeelaSectionService.updateModalChild(fn.o.newChildObject.event, fn.o.objResult);
            }
            // se notifica que se agrego un elemento solo en memoria para ser guardado como padre
            this.akeelaWorkflowService.worflowEvents$.next({
                response: fn.o.objResult,
                action: fn.o.newChildObject.event
            });
            if (this.section.additionalType === "modal"
                && this.akeelaSectionService.modalExist(this.section.alternateName)
                && this.akeelaSectionService.modalIsVisible(this.section.alternateName)) {
                this.akeelaSectionService.hideModalSection(this.section.alternateName);
            }
        }
    }
    cleanNewIdentifiers(newIdentifierNames) {
        const values = newIdentifierNames.split(',');
        values.forEach((value) => {
            let control = this.akeelaFormService.getControl(this.forms, value);
            if (!isNullOrUndefined(control) && control.value === 'newIdentifier') {
                control.setValue(null);
                control.patchValue(null);
            }
        });
    }
    getValuesFromKey2(formKey, object) {
        const keys = formKey.split('.');
        let temp = object;
        let result = [];
        keys.forEach(function (key, i) {
            if (temp !== undefined) {
                if (i === keys.length - 1) {
                    result = temp[key];
                }
                else {
                    temp = temp[key];
                }
            }
        });
        return result;
    }
    getValuesFromKey(formKey, object) {
        const keys = formKey.split('.');
        let temp = object;
        let result = [];
        keys.forEach(function (key, i) {
            if (temp !== undefined) {
                if (i === keys.length - 1) {
                    result = Object.values(temp[key]);
                }
                else {
                    temp = temp[key];
                }
            }
        });
        return result;
    }
    deleteFormKeysFromObject(formKeys, object) {
        const keys = formKeys.split(',');
        let arrayValues = [];
        keys.forEach((key) => {
            //Antes de borrar verifica que todos los valores esten vacios, null, undefined
            arrayValues = this.getValuesFromKey(key, object);
            let isEmptyValues = true;
            arrayValues.forEach((value) => {
                if (!isNullOrUndefined(value) && value !== "" && value !== "newIdentifier") {
                    isEmptyValues = false;
                }
            });
            if (isEmptyValues) {
                this.deleteKeyFromObject(key, object);
            }
        });
    }
    deleteKeyFromObject(formKey, object) {
        const keys = formKey.split('.');
        let temp = object;
        keys.forEach(function (key, i) {
            if (!isNullOrUndefined(temp)) {
                if (i === keys.length - 1) {
                    delete temp[key];
                }
                else {
                    temp = temp[key];
                }
            }
        });
    }
    createMultiselectParams(obj, content, description, key, name) {
        let newObj = [], i = 0;
        if (!isNullOrUndefined(obj)) {
            if (obj[content]) {
                obj[content].forEach(element => {
                    if (obj[description + element]) {
                        if (!isNullOrUndefined(key) && !isNullOrUndefined(name)) {
                            newObj[i] = {};
                            newObj[i][key] = element;
                            newObj[i][name] = obj[description + element];
                        }
                        else {
                            newObj[i] = {
                                'identifier': element,
                                'description': obj[description + element] ? obj[description + element] : null
                            };
                        }
                    }
                    else {
                        if (!isNullOrUndefined(key) && !isNullOrUndefined(name)) {
                            newObj[i] = {};
                            newObj[i][key] = element;
                        }
                        else {
                            newObj[i] = {
                                'identifier': element
                            };
                        }
                    }
                    i++;
                });
            }
        }
        return newObj;
    }
    /*fn.o.objResult[fn.o.multiselectTransform.name] = this.createMultiselectParams(
                        fn.o.objResult[fn.o.multiselectTransform.name],
                        fn.o.multiselectTransform.content,
                        fn.o.multiselectTransform.description,
                        (!isNullOrUndefined(fn.o.multiselectTransform.key) ? fn.o.multiselectTransform.key : null),
                        (!isNullOrUndefined(fn.o.multiselectTransform.name) ? fn.o.multiselectTransform.name : null));*/
    // TODO: eliminar cuando se logre dinamizar el js_event, función cable
    getidentifierPerson() {
        if (!isNullOrUndefined(this.transactionData)) {
            if (!isNullOrUndefined(this.transactionData.organization) || !isNullOrUndefined(this.transactionData.person)) {
                return this.transactionData.organization ? this.transactionData.organization.identifier : this.transactionData.person.identifier;
            }
            else if (!isNullOrUndefined(this.transactionData)) {
                if (this.figure === 'ACCREDITED') {
                    return this.transactionData.accredited ? this.transactionData.accredited.identifier : null;
                }
                else if (this.figure === 'GUARANTOR') {
                    return this.transactionData.guarantor ? this.transactionData.guarantor.identifier : null;
                }
            }
        }
    }
    getObjectReplaceParams(fn) {
        const params_path = fn.o.params ? (fn.o.params.path ? fn.o.params.path : {}) : {};
        const params_body = fn.o.params ? (fn.o.params.body ? fn.o.params.body : {}) : {};
        const params_request = fn.o.params ? (fn.o.params.request ? fn.o.params.request : {}) : {};
        fn.o.params = {};
        // BODY JSON
        for (const element of Object.keys(params_body)) {
            const elementos = element.split('.');
            let obj = {};
            let temp;
            for (let i = elementos.length - 1; i >= 0; i--) {
                if (i === (elementos.length - 1)) {
                    obj = temp = {
                        [elementos[i]]: this.getValObjectResult(params_body[element])
                    };
                }
                else {
                    obj = temp = {
                        [elementos[i]]: temp
                    };
                }
            }
            if (isNullOrUndefined(obj.objResult)) {
                obj.objResult = {};
            }
            const aux = this._jsonService.mergeDeep(obj.objResult, obj); // Mario: para agregar elementos al body, en el caso de que fue requerido
            fn.o.objResult = this._jsonService.mergeDeep(fn.o.objResult, aux); // Mario: antes obj.objResult
        }
        // QUERY PARAMS
        for (const element of Object.keys(params_request)) {
            const elements = element.split('.');
            if (elements.length > 1) {
                elements.forEach((el, index) => {
                    fn.o[el];
                    if (element.split('.').length === index + 1) {
                        fn.o[el] = this.getValObjectResult(params_request[element]);
                    }
                });
            }
            else {
                if (isNullOrUndefined(fn.o[element])) {
                    fn.o[element] = {};
                }
                const params_i = params_request[element], i = 0;
                for (const param of Object.keys(params_i)) {
                    if (isNullOrUndefined(fn.o[element][param])) {
                        fn.o[element][param] = {};
                    }
                    fn.o[element][param] = this.getValObjectResult(params_i[param]);
                }
            }
        }
        // PATH PARAMS
        for (const element of Object.keys(params_path)) {
            const elements = element.split('.');
            if (elements.length > 1) {
                elements.forEach((el, index) => {
                    fn.o[el];
                    if (element.split('.').length === index + 1) {
                        fn.o[el] = this.getValObjectResult(params_path[element]);
                    }
                });
            }
            else {
                fn.o[element] = this.getValObjectResult(params_path[element]);
            }
        }
        return fn.o;
    }
    getValObjectResult(attributevalue) {
        if (attributevalue.startsWith('this.localStorage.')) {
            const index = attributevalue.replace('this.localStorage.', '');
            return !isNullOrUndefined(this.localStorage.getItem(index)) ? this.localStorage.getItem(index) : null;
        }
        else if (attributevalue.startsWith('this.')) {
            const attribute = attributevalue.replace('this.', '').split('.');
            if (attribute.length > 1) {
                let prov;
                attribute.forEach((element, index) => {
                    if (index === 0) {
                        if (!isNullOrUndefined(this[element])) {
                            prov = this[element];
                        }
                        else {
                            return null;
                        }
                    }
                    else {
                        if (!isNullOrUndefined(prov[element])) {
                            prov = prov[element];
                        }
                        else {
                            return null;
                        }
                    }
                });
                return prov;
            }
            else {
                return this[attributevalue.replace('this.', '')];
            }
        }
        else {
            return attributevalue;
        }
    }
    replaceVariableAttributes() {
    }
    setParamsSum(fn, section, data) {
        let i = 0;
        const objResult = [];
        section.sections.forEach((_section) => {
            _section.fields.forEach((_field) => {
                if (_field.dataFieldItem.type !== 'div' && !_field.readonlyValue) {
                    const identifier = _field.dataFieldItem.identifier;
                    if (identifier !== null) {
                        objResult[i] = {
                            'dataFieldItem': {
                                'identifier': identifier
                            },
                            'propertyValue': {
                                'value': data[_field.dataFieldItem.alternateName] ? data[_field.dataFieldItem.alternateName] : 0
                            }
                        };
                        i++;
                    }
                }
            });
        });
        return objResult;
    }
    lowestCurrentYear(fn) {
        let fecha = new Date();
        let ano = fecha.getFullYear() - 1;
        let control = this.akeelaFormService.getControl(this.forms, fn.o.listName);
        if (!isNullOrUndefined(control) && control.value != '') {
            let value = control.value.replace("_", "");
            if (value >= ano) {
                control.setValue(ano);
                control.patchValue(ano);
            }
        }
        // console.log("lowestCurrentYear",this.getGroup(fn.o.sectionIdentifier).get(fn.o.listName).value);
    }
    sumBasic(fn) {
        let sumBasicResult = 0;
        if (fn.o.elementSum) {
            fn.o.elementSum.forEach(value => {
                const fieldIdentifier = AkeelaFormService.getFieldIdentifier(value);
                if (this.getGroup(fn.o.sectionIdentifier).get(fieldIdentifier)) {
                    if (this.getGroup(fn.o.sectionIdentifier).get(fieldIdentifier).value < 0) {
                        this.getGroup(fn.o.sectionIdentifier).get(fieldIdentifier).setValue(0);
                        this.getGroup(fn.o.sectionIdentifier).get(fieldIdentifier).patchValue(0);
                    }
                    sumBasicResult += +this.getGroup(fn.o.sectionIdentifier).get(fieldIdentifier).value;
                }
            });
            if (fn.o.elementResult) {
                const resultIdentifier = AkeelaFormService.getFieldIdentifier(fn.o.elementResult);
                this.getGroup(fn.o.sectionIdentifier).get(resultIdentifier).setValue(sumBasicResult > 0 ? sumBasicResult : '');
                this.getGroup(fn.o.sectionIdentifier).get(resultIdentifier).patchValue(sumBasicResult > 0 ? sumBasicResult : '');
            }
        }
        sumBasicResult = 0;
        this.markFormGroupTouched(this.forms);
    }
    callService(fn) {
    }
    resetPristine(subSection) {
        this.getGroup(subSection.identifier).markAsPristine();
    }
    markFormGroupTouched(form) {
        Object.values(form.controls).forEach(control => {
            control.markAsDirty();
            if (control.controls) {
                this.markFormGroupTouched(control);
            }
        });
    }
    getFieldIdentifier(fieldName) {
        return AkeelaFormService.getFieldIdentifier(fieldName);
    }
    getFieldValue(fieldName) {
        const control = this.akeelaFormService.getControl(this.forms, fieldName);
        if (!isNullOrUndefined(control)) {
            return control.value;
        }
        return null;
    }
    useMainSection() {
        return !isNullOrUndefined(this.section.componentName) ||
            (!isNullOrUndefined(this.section.fields) && this.section.fields.length > 0);
    }
    cleanNull(obj) {
        if (isNullOrUndefined(obj)) {
            return obj;
        }
        Object.keys(obj).forEach(key => {
            if (!isNullOrUndefined(obj[key]) && typeof obj[key] === 'object') {
                this.cleanNull(obj[key]);
            }
            if (isNullOrUndefined(obj[key])) {
                delete obj[key];
            }
        });
    }
    sectionIsVisible(sectionName) {
        return this.akeelaSectionService.modalIsVisible(sectionName);
    }
    openModal(jsEventObject) {
        this.localStorage.removeItem('modalFormModeUpdate');
        const jsEvents = JSON.parse(jsEventObject.o.field.jsEvents);
        // Mario: Notifico que se abrio el modal
        if (!isNullOrUndefined(jsEvents)) {
            if (jsEvents.length > 0) {
                const next_resp = {
                    response: null,
                    action: jsEvents[0].f,
                    value: jsEvents[0].o.name
                };
                this.akeelaWorkflowService.worflowEvents$.next(next_resp);
            }
        }
        this.setWfFormFields();
        this.akeelaSectionService.addModalSection({ name: jsEventObject.o.name });
        this.akeelaSectionService.showModalSection(jsEventObject.o.name, true);
        if (!isNullOrUndefined(jsEventObject.o.disableWhenUpdate)) {
            this.akeelaSectionService.setModalFormValue(jsEventObject.o.name, { disableWhenUpdate: jsEventObject.o.disableWhenUpdate });
        }
        if (!isNullOrUndefined(jsEventObject.o.cleanModalFather)) {
            this.akeelaSectionService.setModalFather(null);
        }
        if (!isNullOrUndefined(jsEventObject.o.cleanModalChildList)) {
            this.akeelaSectionService.resetModalChildList(jsEventObject.o.cleanModalChildList);
        }
        if (!isNullOrUndefined(this.akeelaSectionService.getModalFather()) && !isNullOrUndefined(jsEventObject.o.appendModalFather)) {
            // const jsEvents: any[] = JSON.parse(field.jsEvents);
            //Aplicar padre del siguiente modal
            const father = {
                person: {
                    relatedTo: {
                        identifier: this.akeelaSectionService.getModalFather().person.identifier
                    }
                }
            };
            this.akeelaSectionService.setModalFormValue(jsEventObject.o.name, father);
        }
    }
    setHiddenSection(sectionCode, hidden) {
        this.section.sections
            .filter(subSection => subSection.alternateName === sectionCode)
            .forEach(subSection => {
            subSection.hidden = hidden;
            subSection.fields.forEach(field => {
                setTimeout(() => {
                    let control = this.akeelaFormService.getControl(this.forms, field.dataFieldItem.alternateName);
                    if (hidden || this.readonlyMode) {
                        control.disable();
                    }
                    else {
                        control.enable();
                    }
                }, 30);
            });
        });
    }
    triggerSectionEvent() {
        this.section.sections.forEach(subSection => {
            if (!isNullOrUndefined(subSection.jsEvents)) {
                if (subSection.jsEvents) {
                    const jsEvents = JSON.parse(subSection.jsEvents);
                    if (!isNullOrUndefined(jsEvents)) {
                        const assignEvent = jsEvents.find(event => event.e === 'triggerEvent');
                        if (!isNullOrUndefined(assignEvent)) {
                            const event = new Event(assignEvent.o.eventType);
                            const field = subSection.fields.find((field) => field.dataFieldItem.alternateName === assignEvent.o.attributeName);
                            this.call_fn(event, subSection.identifier, field);
                        }
                    }
                }
            }
        });
    }
    showSectionDepend(fn) {
        const control = this.akeelaFormService.getControl(this.forms, fn.o.listName);
        if (!isNullOrUndefined(control) && !isNullOrUndefined(control.value) && control.value !== "") {
            const sectionsToHide = fn.o[control.value].hide.split(',');
            const sectionsToShow = fn.o[control.value].show.split(',');
            sectionsToHide.forEach(sectionCode => this.setHiddenSection(sectionCode, true));
            sectionsToShow.forEach(sectionCode => this.setHiddenSection(sectionCode, false));
        }
    }
    showSectionsDependValue(fn) {
        const control = this.akeelaFormService.getControl(this.forms, fn.o.listName);
        if (!isNullOrUndefined(control) && !isNullOrUndefined(control.value) && control.value !== "") {
            if (fn.o.values[control.value]) {
                const sectionsToShow = fn.o.values[control.value].show.split(',');
                sectionsToShow.forEach(sectionCode => this.setHiddenSection(sectionCode, false));
            }
            else {
                const sectionsToHide = fn.o.hideSectios.split(',');
                sectionsToHide.forEach(sectionCode => this.setHiddenSection(sectionCode, true));
            }
        }
        else {
            const sectionsToHide = fn.o.hideSectios.split(',');
            sectionsToHide.forEach(sectionCode => this.setHiddenSection(sectionCode, true));
        }
    }
    //Esto es util para enviar eventos al client configurados desde un jsEvents,
    // Ejemplo de este caso es enviar un envento que avise al client para mostrar un Loading.
    sendEventToClient(fn) {
        var _a, _b;
        let obj = {
            response: fn.o.responseValue,
            action: fn.o.eventName,
        };
        if (!isNullOrUndefined(fn.o.field)) {
            let control = this.akeelaFormService.getControl(this.forms, fn.o.field.dataFieldItem.alternateName);
            obj = {
                response: (_a = fn === null || fn === void 0 ? void 0 : fn.o) === null || _a === void 0 ? void 0 : _a.responseValue,
                action: (_b = fn === null || fn === void 0 ? void 0 : fn.o) === null || _b === void 0 ? void 0 : _b.eventName,
                value: control === null || control === void 0 ? void 0 : control.value
            };
        }
        this.akeelaWorkflowService.worflowEvents$.next(obj);
    }
    resetMultiselectDepend(fn) {
        // const control = this.akeelaFormService.getControl(this.forms, fn.o.listName);
        // if (!isNullOrUndefined(control) && !isNullOrUndefined(control.value) && control.value === fn.o.valueToCompare) {
        const controlToReset = this.akeelaFormService.getControl(this.forms, fn.o.controlToReset);
        if (!isNullOrUndefined(controlToReset)) {
            controlToReset.setValue(null);
            controlToReset.patchValue(null);
        }
        // }
    }
    showSection(fn) {
        if (fn.o[this.forms.value[fn.o.listName]]) {
            if (!isNullOrUndefined(fn.o[this.forms.value[fn.o.listName]].hide) && !isNullOrUndefined(fn.o[this.forms.value[fn.o.listName]].show !== null)) {
                const sectionsToHide = fn.o[this.forms.value[fn.o.listName]].hide.split(',');
                const sectionsToShow = fn.o[this.forms.value[fn.o.listName]].show.split(',');
                sectionsToHide.forEach(sectionCode => this.setHiddenSection(sectionCode, true));
                sectionsToShow.forEach(sectionCode => this.setHiddenSection(sectionCode, false));
            }
        }
    }
    onClickCheckbox(event, sectionIdentifier, field) {
        if (!isNullOrUndefined(field.jsEvents)) {
            let control = this.akeelaFormService.getControl(this.forms, field.dataFieldItem.alternateName);
            control.setValue(event.target.checked);
            control.patchValue(event.target.checked);
        }
        this.call_fn(event, sectionIdentifier, field);
    }
    validate_before_call_fn(event, sectionIdentifier, field) {
        if (field.jsEvents) {
            const jsEvents = JSON.parse(field.jsEvents);
            if (!isNullOrUndefined(jsEvents)) {
                const customEvent = jsEvents.find(event => event.e === 'click');
                if (!isNullOrUndefined(customEvent)) {
                    // CASO 2: evitado por fn.o.formValidationEvent | No hace el submit y ejecuta un evento.
                    if (!isNullOrUndefined(customEvent.o.formValidationEvent)) {
                        // se notifica que se debe validar el formulario
                        console.log('Validando el enviar:');
                        console.log(customEvent);
                        this.akeelaWorkflowService.worflowEvents$.next({
                            response: {
                                //Valores para validar
                                fn: customEvent,
                                forms: this.forms,
                                //valores para el callback de call_fn()
                                event: event,
                                sectionIdentifier: sectionIdentifier,
                                field: field
                            },
                            action: customEvent.o.formValidationEvent
                        });
                    }
                    else {
                        this.call_fn(event, sectionIdentifier, field);
                    }
                }
                else { //si no tiene configurado un evento Click, continua la ejecucion
                    this.call_fn(event, sectionIdentifier, field);
                }
            }
            else { //si no tiene configurada jsEvents, continua la ejecucion
                this.call_fn(event, sectionIdentifier, field);
            }
        }
    }
    defautDataDependCurrency(fn) {
        let control = this.akeelaFormService.getControl(this.forms, fn.o.filedepend);
        if (control) {
            const params = {
                name: 'app_properties$currency_by_country_code$get',
                params: {
                    request: {
                        countryCode: control.value
                    },
                    path: {},
                    body: {}
                }
            };
            this.subscriptions.push(this.httpService.executeRequest(params.name, params.params, true).subscribe((response) => {
                let control2 = this.akeelaFormService.getControl(this.forms, fn.o.listName);
                control2.setValue(response.alternateName);
                control2.patchValue(response.alternateName);
                control2.disable();
            }));
        }
    }
    setConfigurationPercentage(fn) {
        // Mario: Regla para manejar los contadores, tomando en cuenta accionistas que pueden tener accionistas relacionados (dos niveles)
        let control = this.akeelaFormService.getControl(this.forms, fn.o.listName);
        let sumSharePercentage = this.akeelaSectionService.sumSharePercentage$.getValue();
        let sharePercentageField = this.akeelaSectionService.sharePercentageField$.getValue();
        let shareMaxPercentage = this.akeelaSectionService.shareMaxPercentage$.getValue();
        let temp = (control.value + (sumSharePercentage - (sharePercentageField ? sharePercentageField : 0)));
        if (temp > shareMaxPercentage) {
            if (sharePercentageField > 0) {
                let tmp = shareMaxPercentage - (sumSharePercentage - sharePercentageField);
                control.setValue(tmp);
                control.patchValue(tmp);
            }
            else {
                control.setValue(shareMaxPercentage - sumSharePercentage);
                control.patchValue(shareMaxPercentage - sumSharePercentage);
            }
        }
    }
    updateValueAndValidity(fn) {
        let controlField = this.akeelaFormService.getControl(this.forms, fn.o.listNameRelated);
        if (controlField) {
            controlField.updateValueAndValidity();
        }
    }
    setValueFieldTransaction(fn) {
        if (!isNullOrUndefined(this.transactionData)) {
            const control = this.akeelaFormService.getControl(this.forms, fn.o.listName);
            if (control.value.trim() === '') {
                let tmp = this._pathService.getValObjectResult(fn.o.fieldTransaction, this);
                if (fn.o.fieldTransaction.endsWith('Date')) {
                    tmp = this.akeelaFormService.replaceTimestampToString(tmp, 'yyyy-MM-dd');
                }
                if (tmp) {
                    control.setValue(tmp);
                    control.patchValue(tmp);
                }
            }
        }
    }
    defaultValueRadio(tmp) {
        if (tmp == 'true' || tmp === true) {
            return true;
        }
        else if (tmp == 'false' || tmp === false) {
            return false;
        }
        else {
            return null;
        }
    }
    getStatusField(value) {
        let control = this.akeelaFormService.getControl(this.forms, value);
        return control.status;
    }
    setValueRadio(event, subSection, field, value) {
        let control = this.akeelaFormService.getControl(this.forms, field.dataFieldItem.alternateName);
        control.setValue(value);
        control.patchValue(value);
        this.forms;
        this.validate_before_call_fn(event, subSection, field);
        this.section;
    }
    changeLower(fn) {
        let control = this.akeelaFormService.getControl(this.forms, fn.o.listName);
        if (!isNullOrUndefined(control) && control.value.trim() != '') {
            // let tmp = control.value.replaceAll("_", "");
            let tmp = control.value;
            control.setValue(tmp.toLowerCase());
            control.patchValue(tmp.toLowerCase());
        }
    }
    changeUpper(fn) {
        let control = this.akeelaFormService.getControl(this.forms, fn.o.listName);
        if (!isNullOrUndefined(control) && control.value.trim() != '') {
            if (control.value) {
                //let tmp = control.value.replaceAll("_", "");
                let tmp = control.value;
                control.setValue(tmp.toUpperCase());
                control.patchValue(tmp.toUpperCase());
            }
        }
    }
    viewPassword(fn) {
        this.typeInputPass = !(this.typeInputPass);
    }
    changeviewPassword(field) {
        this.objectypeInputPass[field] = !(this.objectypeInputPass[field]);
    }
    changeviewPasswordAll(data) {
        for (var key in this.objectypeInputPass) {
            if (this.objectypeInputPass.hasOwnProperty(key)) {
                this.objectypeInputPass[key] = data;
            }
        }
    }
    getSelected(d1, d2, list, field, subSection) {
        //list select count
        let control = this.akeelaFormService.getControl(this.forms, field.dataFieldItem.alternateName);
        //Mario 13/02/2023 caso revisando con Vin, esto lo debo descomentar, si algo falla revisar o quitar
        // if(!isNullOrUndefined(this.data_model)) {
        //     let control_current = this.getValObjectResult('this.data_model.'+field.dataFieldItem.alternateName);
        //     //let control_current = this.akeelaFormService.getControl(this.forms, field.dataFieldItem.alternateName);
        //     if(!isNullOrUndefined(control_current)){
        //             control.setValue(control_current);
        //             control.patchValue(control_current);
        //     }
        // }
        if (list) {
            if (((list === null || list === void 0 ? void 0 : list.length) > 0 && (list === null || list === void 0 ? void 0 : list.length) < 2) && !this.listSelectUne[field.dataFieldItem.alternateName]) {
                this.listSelectUne[field.dataFieldItem.alternateName] = true;
                if (control) {
                    control.setValue(d2);
                    control.patchValue(d2);
                }
                this.executeChangeEvent(field, subSection);
                return true;
            }
            else if (d1 === d2) {
                return true;
            }
        }
        else {
            if (this.listSelectUne[field.dataFieldItem.alternateName]) {
                if (d1 != '') {
                    return true;
                }
            }
        }
        return false;
    }
    hideCheckboxReadonlyMode(fn) {
        this.hideCheckboxReadonlyMode[fn.o.listName] = true;
    }
    minCurrentDateFocusOut(listName) {
        let control = this.akeelaFormService.getControl(this.forms, listName);
        const dateoll = new Date("1900-01-01");
        if (!isNullOrUndefined(control) && control.value != '') {
            const dateMinor = new Date(control.value);
            if (dateMinor.getTime() < dateoll.getTime()) {
                control.setValue('');
                control.patchValue('');
            }
        }
    }
    minCurrentDate(listName) {
        let control = this.akeelaFormService.getControl(this.forms, listName);
        const dateoll = new Date("1900-01-01");
        if (!isNullOrUndefined(control) && control.value != '') {
            const dateMinor = new Date(control.value);
            if (!(dateMinor.getTime() < dateoll.getTime())) {
                return true;
            }
            return false;
        }
    }
    setButtonOptionsMultipleToggle(name, { value }, type) {
        if (name !== this.localStorage.getItem('modalFormModeUpdate')) {
            let arr;
            let values = this.getFieldValue(name);
            let control = this.akeelaFormService.getControl(this.forms, name);
            if (type == 'selectMultipleButton' && !Array.isArray(values)) {
                values = values == '' ? [] : [values];
            }
            const resp = values.find(element => element == value);
            if (isNullOrUndefined(resp)) {
                arr = [...values, value];
            }
            else {
                arr = values.filter(function (ele) {
                    return (ele != value && ele != '');
                });
            }
            if (!isNullOrUndefined(arr)) {
                control.setValue(arr);
                control.patchValue(arr);
                control.markAsDirty();
            }
        }
        this.forms.markAsDirty();
    }
    setButtonOptionsToggle(name, { value }, type) {
        if (name !== this.localStorage.getItem('modalFormModeUpdate')) {
            let arr;
            let values = this.getFieldValue(name);
            let control = this.akeelaFormService.getControl(this.forms, name);
            if (type == 'selectMultipleButton' && !Array.isArray(values)) {
                values = values == '' ? [] : [values];
            }
            if (Array.isArray(values)) {
                const resp = values.find(element => element == value);
                if (isNullOrUndefined(resp)) {
                    arr = [...values, value];
                }
                else {
                    arr = values.filter(function (ele) {
                        return (ele != value && ele != '');
                    });
                }
                if (!isNullOrUndefined(arr)) {
                    control.setValue(arr);
                    control.patchValue(arr);
                    control.markAsDirty();
                }
            }
            else {
                control.setValue(value);
                control.patchValue(value);
                control.markAsDirty();
            }
        }
        this.forms.markAsDirty();
    }
    changeEventCall_fn({ target }, sectionIdentifier, field, newEvent) {
        this.call_fn({ type: newEvent, target }, sectionIdentifier, field);
    }
    getButtonActive(name, { value }, type, field, l) {
        const values = this.getFieldValue(name);
        if (Array.isArray(values)) {
            if (!isNullOrUndefined(values)) {
                if (values.length > 1) {
                    const resp = values.find(element => element === value);
                    if (!isNullOrUndefined(resp)) {
                        return true;
                    }
                    else {
                        return false;
                    }
                }
                else {
                    if (field.valueRequired) {
                        return true;
                    }
                    else {
                        return false;
                    }
                }
            }
            else {
                return false;
            }
        }
        else {
            if (l === 1) { // segun la longitud de la lista, si tiene un solo elemente por fecto se preselecciona
                return true;
            }
            else {
                return (values === value);
            }
            // al ser un solo valor, se va a agregar que se coloque por fecto
        }
    }
    getButtonActiveMultiple(name, { value }, type, field, l) {
        const values = this.getFieldValue(name);
        if (Array.isArray(values)) {
            if (!isNullOrUndefined(values)) {
                if (values.length > 0) {
                    const resp = values.find(element => element === value);
                    if (!isNullOrUndefined(resp)) {
                        return true;
                    }
                    else {
                        return false;
                    }
                }
            }
            else {
                return false;
            }
        }
        else {
            if (l === 1) { // segun la longitud de la lista, si tiene un solo elemente por fecto se preselecciona
                return true;
            }
            else {
                return (values === value);
            }
            // al ser un solo valor, se va a agregar que se coloque por fecto
        }
    }
    formatToDateTimeLocal() {
        const date = new Date();
        return date;
    }
    getCurrencyImg(code) {
        let dato = '';
        switch (code) {
            case 'EUR':
                dato = './assets/public/images/union-europea.png';
                break;
            case 'USD':
                dato = './assets/public/images/estados-unidos.png';
                break;
            case 'BS':
                dato = './assets/public/images/venezuela.png';
                break;
            case 'COP':
                dato = './assets/public/images/colombia.png';
                break;
            case 'BRL':
                dato = './assets/public/images/brasil.png';
                break;
        }
        return dato;
    }
    isNotNullOrUndefined(dato) {
        if (!isNullOrUndefined(dato) && dato.trim() != '') {
            return true;
        }
        return false;
    }
    refrechField(fn) {
        let control = this.akeelaFormService.getControl(this.forms, fn.o.fieldRelated);
        let x = control.value;
        control.setValue("");
        control.patchValue("");
        control.setValue(x);
        control.patchValue(x);
    }
    redirectTo(fn) {
        const queryParams = {
            role: this.localStorage.getItem('role'),
            profile: this.localStorage.getItem('profile'),
            audience: this.localStorage.getItem('audience'),
        };
        const prefixed = 'private';
        const url = fn.o.url;
        this.router.navigate([prefixed + '/' + url], { queryParams: queryParams });
    }
    redirectToUrl(url) {
        const queryParams = {
            role: this.localStorage.getItem('role'),
            profile: this.localStorage.getItem('profile'),
            audience: this.localStorage.getItem('audience'),
        };
        this.router.navigate([url], { queryParams: queryParams });
    }
    setBackUrl() {
        let temp = this.akeelaSectionService.backAndUrl$.getValue();
        if (temp) {
            this.router.navigateByUrl(this.router.createUrlTree([temp.url], {
                queryParams: temp.queryParams
            }));
        }
        this.akeelaSectionService.setBackAndUrl(null);
    }
    redirectSection(urlWf, stage, step, section) {
        const prefixed = 'private';
        let url = [urlWf + '/stages/' + stage + '/steps/' + step];
        const queryParams = {
            role: this.localStorage.getItem('role'),
            profile: this.localStorage.getItem('profile'),
            audience: this.localStorage.getItem('audience'),
            section: section,
        };
        this.router.navigate([prefixed + '/' + url], { queryParams: queryParams });
    }
    isHtmlRightTemplete(text) {
        var _a;
        let data = '@i18n-htmlRightTemplete-' + (text === null || text === void 0 ? void 0 : text.trim());
        let msg = (_a = this.i18n) === null || _a === void 0 ? void 0 : _a.transform(data);
        if (msg && msg != '@i18n-htmlRightTemplete-' + text) {
            return msg;
        }
        else {
            return false;
        }
    }
    setExternalData(json) {
        var _a, _b;
        let result = {};
        this.section;
        if (this.localStorage.getItem('externalDataForm')) {
            let dataCore = JSON.parse(this.localStorage.getItem('externalDataForm'));
            if (this.section.alternateName == (dataCore === null || dataCore === void 0 ? void 0 : dataCore.section)) {
                if ((dataCore === null || dataCore === void 0 ? void 0 : dataCore.type) == "person") {
                    let p1 = (_a = json === null || json === void 0 ? void 0 : json.endUser) === null || _a === void 0 ? void 0 : _a.person;
                    let p2 = (_b = dataCore === null || dataCore === void 0 ? void 0 : dataCore.data) === null || _b === void 0 ? void 0 : _b.person;
                    const customer = {
                        banked: false,
                        internetBanking: false
                    };
                    result = Object.assign(Object.assign({}, p1), p2);
                    json.endUser["person"] = Object.assign(Object.assign({}, result), { customer });
                }
            }
        }
        return json;
    }
}
/** @nocollapse */ AkeelaSectionComponent.ɵfac = function AkeelaSectionComponent_Factory(t) { return new (t || AkeelaSectionComponent)(ɵɵdirectiveInject(AkeelaFormService), ɵɵdirectiveInject(AkeelaStepService), ɵɵdirectiveInject(AkeelaSectionService), ɵɵdirectiveInject(AkeelaStageService), ɵɵdirectiveInject(AkeelaWorkflowService), ɵɵdirectiveInject(AkeelaDatamodelService), ɵɵdirectiveInject(AkeelaDatasourceService), ɵɵdirectiveInject(AkeelaWorkflowConfigService), ɵɵdirectiveInject(AkeelaValidatorService), ɵɵdirectiveInject(AkeelaTemplateService), ɵɵdirectiveInject(AkeelaEventService), ɵɵdirectiveInject(ActivatedRoute), ɵɵdirectiveInject(AkeelaUrlService), ɵɵdirectiveInject(JsonService), ɵɵdirectiveInject(CreditService), ɵɵdirectiveInject(AkeelaConditionService), ɵɵdirectiveInject(HttpService), ɵɵdirectiveInject(AuthService), ɵɵdirectiveInject(ErrorService), ɵɵdirectiveInject(AlertService), ɵɵdirectiveInject(PathService), ɵɵdirectiveInject(LocalService), ɵɵdirectiveInject(RouteUtilsService), ɵɵdirectiveInject(I18nPipe), ɵɵdirectiveInject(Router)); };
/** @nocollapse */ AkeelaSectionComponent.ɵcmp = ɵɵdefineComponent({ type: AkeelaSectionComponent, selectors: [["akeela-section"]], inputs: { section: "section", index: "index", status: "status", unique: "unique" }, outputs: { callFn: "callFn" }, decls: 5, vars: 2, consts: [[1, "row"], [3, "class", 4, "ngIf"], [4, "ngIf"], ["sectionForm", ""], ["class", " pt-md-2", 3, "ngClass", "click", 4, "ngIf"], [3, "class", "d-block", "innerHTML", 4, "ngFor", "ngForOf"], [1, "position-relative"], ["class", "", 4, "ngIf"], [1, "pt-md-2", 3, "ngClass", "click"], ["class", "w-100 flex-fill  title-section mb-3 ", 3, "innerHTML", 4, "ngIf"], [1, "w-100", "flex-fill", "title-section", "mb-3", 3, "innerHTML"], [3, "innerHTML"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "w-100", "text-center"], [1, "mt-3"], ["src", "./assets/public/images/loading.gif", "alt", ""], [1, "mt-2", "text-secondary"], [3, "class", 4, "ngFor", "ngForOf"], [1, ""], [1, "m-t-1"], [1, "ak-form-modal", "full-modal", "teme-gray", "compleat-modal", 3, "ngStyle"], [1, "body", "ml-2", "mr-2", 3, "click"], [1, "container", "bg-white", "mb-2", "radius", 3, "click"], ["class", "d-flex w-100  pt-3", 4, "ngIf"], [1, "d-flex", "w-100", "pt-3"], [1, "ml-auto", "text-right", 3, "click"], [1, "fas", "fa-times", 2, "font-size", "1.5rem"], [1, "sub-section", 3, "innerHTML"], [1, "d-none", "d-md-block", "col-md-4", "ak-border-left-box-right"], ["class", "d-flex flex-column animate__animated animate__fadeIn", 4, "ngIf"], [1, "d-flex", "flex-column", "animate__animated", "animate__fadeIn"], ["class", "w-100 mt-3 mb-3  sub-section", 4, "ngIf"], ["class", "w-100 mb-3 text-dark text-description", 3, "innerHTML", 4, "ngIf"], [1, "mt-3", 3, "ngTemplateOutlet"], [1, "w-100", "mt-3", "mb-3", "sub-section"], [1, "w-100", "mb-3", "text-dark", "text-description", 3, "innerHTML"], ["class", "w-100 mt-4 mb-3  sub-section animate__animated animate__fadeIn", 4, "ngIf"], ["class", "w-100 mb-3 mb-4 text-dark text-description", 3, "innerHTML", 4, "ngIf"], [1, "w-100", 3, "formGroup"], [4, "ngFor", "ngForOf"], [1, "w-100", "mt-4", "mb-3", "sub-section", "animate__animated", "animate__fadeIn"], [1, "w-100", "mb-3", "mb-4", "text-dark", "text-description", 3, "innerHTML"], ["class", "animate__animated animate__fadeIn", 4, "ngIf"], [1, "animate__animated", "animate__fadeIn"], [3, "class", "formGroup", 4, "ngIf"], [3, "formGroup"], ["style", "margin-bottom: -5px;", "class", "w-100 mt-4 text-secondary", 4, "ngIf"], ["class", "w-100", 4, "ngIf"], ["class", "text-left w-100 m-t-1 btn-section-save", 4, "ngIf"], ["class", "w-100 p-t-1 btn-section-add", 4, "ngIf"], [1, "w-100", "mt-4", "text-secondary", 2, "margin-bottom", "-5px"], [1, "w-100"], ["class", "w-100 font-weight-light", 4, "ngIf"], ["class", " c-label w-100 font-weight-light", 4, "ngIf"], ["class", "w-100 ", 4, "ngIf"], ["style", "line-height: 1rem", "class", "w-100 mb-2 mt-1  pl-1 pr-1", 4, "ngIf"], ["class", " small", 4, "ngIf"], ["class", "form-control-feedback help-block", 4, "ngIf"], ["autocomplete", "off", 3, "type", "formControlName", "hidden", "readOnly", "ngClass", "name", "keyup", "change", "click"], [1, "w-100", "font-weight-light"], [1, "c-label", 3, "innerHTML"], [1, "c-label", "w-100", "font-weight-light"], [2, "word-wrap", "break-word", 3, "hidden"], ["class", "fz-12", 4, "ngIf"], [3, "ngClass"], ["class", "input-group-prepend", 4, "ngIf"], ["autocomplete", "off", "inputmode", "numeric", "currencyMask", "", 3, "type", "formControlName", "options", "hidden", "readOnly", "ngClass", "name", "keyup", "change", "click"], ["class", "input-group-append", 4, "ngIf"], [1, "fz-12"], [1, "input-group-prepend"], [1, "input-group-text", 3, "innerHTML"], [1, "input-group-append"], ["autocomplete", "off", "inputmode", "numeric", 3, "type", "formControlName", "hidden", "readOnly", "ngClass", "name", "keyup", "change", "click", "keypress"], ["autocomplete", "off", "inputmode", "numeric", 3, "type", "formControlName", "textMask", "hidden", "readOnly", "ngClass", "name", "keyup", "change", "click"], ["for", "", 2, "word-wrap", "break-word", 3, "innerHTML", "hidden"], ["autocomplete", "off", 3, "type", "formControlName", "ngClass", "name", "readOnly", "keyup", "change", "click"], [1, "input-group"], ["autocomplete", "off", 3, "type", "formControlName", "ngClass", "name", "keyup", "change", "click"], ["class", " ml-2 btn btn-success", "type", "button", 3, "click", 4, "ngIf"], ["class", "fa fa-check text-success ml-2 mt-2", 4, "ngIf"], ["type", "button", 1, "ml-2", "btn", "btn-success", 3, "click"], [1, "fa", "fa-check", "text-success", "ml-2", "mt-2"], [1, "pt-2", "w-100", "form-control-feedback", "small", "text-secondary"], ["href", "javascript:void()", 3, "click"], ["data-date-format", "YYYY/MM/DD", "autocomplete", "off", 3, "type", "formControlName", "ngClass", "name", "keyup", "change", "click"], ["class", "c-label w-100 font-weight-light", 3, "innerHTML", 4, "ngIf"], [1, "c-label", "w-100", "font-weight-light", 3, "innerHTML"], [1, "container-checkbox", 3, "hidden"], [1, "conditions", 3, "innerHTML"], ["autocomplete", "off", "type", "checkbox", 3, "value", "hidden", "readOnly", "formControlName", "click"], [1, "checkmark"], [2, "word-wrap", "break-word", 3, "innerHTML", "hidden"], [1, "form-check", "form-check-inline"], ["autocomplete", "off", "type", "radio", 1, "form-check-input", 3, "formControlName", "value", "checked", "hidden", "readOnly", "click"], [3, "innerHTML", "hidden"], ["class", "input-group-append", 3, "click", 4, "ngIf"], [1, "input-group-append", 3, "click"], [1, "far", "input-group-text", "pt-2", 3, "ngClass"], [1, "w-100", "mb-2", "mt-1", "pl-1", "pr-1", 2, "line-height", "1rem"], [1, "form-control-feedback", "small", "text-secondary", 3, "innerHTML"], [1, "small"], [1, "row", "pt-2", "small"], [1, "col-12"], [1, "form-control-feedback", "help-block"], [1, "fa", "fa-circle-o-notch", "fa-spin"], [3, "formControlName", "ngClass", "hidden", "name", "keyup", "change", "click"], ["style", "line-height: 1rem", "class", "w-100 mb-2 mt-1 pl-1 pr-1 ", 4, "ngIf"], ["style", "min-width: 150px ;", "class", "btn base-style-option-button mb-3 mr-2", 3, "disabled", "ngClass", "click", 4, "ngFor", "ngForOf"], ["class", "text-secondary col-12", 4, "ngIf"], ["multiple", "", 3, "formControlName", "hidden", "ngClass", "name", "change"], ["value", ""], [3, "selected", "ngValue", 4, "ngFor", "ngForOf"], ["class", "fas fa-circle-notch fa-spin load-select text-primary", 4, "ngIf"], [1, "btn", "base-style-option-button", "mb-3", "mr-2", 2, "min-width", "150px", 3, "disabled", "ngClass", "click"], [1, "text-secondary", "col-12"], [1, "text-primary", "ml-1", "fas", "fa-circle-notch", "fa-spin"], [3, "selected", "ngValue"], [1, "fas", "fa-circle-notch", "fa-spin", "load-select", "text-primary"], [3, "formControlName", "hidden", "ngClass", "name", "change"], [1, "btn", "btn-block", "base-style-option-button", 3, "disabled", "click"], ["class", "pr-2 icon-boton", 4, "ngIf"], [1, "pr-2", "icon-boton"], [1, "img-left-boton", 3, "src"], [3, "click"], [3, "placeholder", "options", "formControlName", "hidden", "ngClass"], ["class", "fas fa-circle-notch fa-spin load-select-multiple text-primary", 4, "ngIf"], [1, "fas", "fa-circle-notch", "fa-spin", "load-select-multiple", "text-primary"], ["class", "w-100 ", 3, "click", 4, "ngIf"], [1, "w-100", 3, "click"], ["style", "word-wrap: break-word; ", 3, "class", "innerHTML", 4, "ngIf"], [2, "word-wrap", "break-word", 3, "innerHTML"], [1, "text-left", "w-100", "m-t-1", "btn-section-save"], ["class", "ak-btn-form btn btn-outline-dark mr-2", 3, "click", 4, "ngIf"], ["class", "ak-btn-form", "type", "button", "class", "btn btn-primary ", 3, "d-none", "disabled", "hidden", "click", 4, "ngIf"], ["type", "button", "class", "btn btn-primary ", 3, "d-none", "disabled", "hidden", "click", 4, "ngIf"], ["class", "w-100 text-left mb-3 mt-2", 4, "ngIf"], ["class", "w-100 text-right mb-3 mt-2", 4, "ngIf"], [1, "ak-btn-form", "btn", "btn-outline-dark", "mr-2", 3, "click"], [1, "fas", "fa-arrow-left", "mr-1"], ["type", "button", 1, "btn", "btn-primary", 3, "disabled", "hidden", "click"], [3, "innerHTML", 4, "ngIf"], ["class", "fas fa-arrow-right ml-1", 4, "ngIf"], ["class", "fas fa-save ml-1", 4, "ngIf"], [1, "fas", "fa-arrow-right", "ml-1"], [1, "fas", "fa-save", "ml-1"], [1, "w-100", "text-left", "mb-3", "mt-2"], [1, "form-control-feedback", "text-secondary", "help-block"], [1, "w-100", "text-right", "mb-3", "mt-2"], [1, "w-100", "p-t-1", "btn-section-add"], ["type", "button", 3, "disabled", "hidden", "click"], [1, "ml-2", "fas", "fa-circle-notch", "fa-spin"]], template: function AkeelaSectionComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", 0);
        ɵɵtemplate(1, AkeelaSectionComponent_div_1_Template, 10, 12, "div", 1);
        ɵɵtemplate(2, AkeelaSectionComponent_ng_container_2_Template, 3, 1, "ng-container", 2);
        ɵɵtemplate(3, AkeelaSectionComponent_ng_template_3_Template, 2, 2, "ng-template", null, 3, ɵɵtemplateRefExtractor);
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.section);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.isHtmlRightTemplete(ctx.section == null ? null : ctx.section.alternateName));
    } }, directives: [NgIf, NgForOf, NgClass, NgTemplateOutlet, NgStyle, ɵangular_packages_forms_forms_y, NgControlStatusGroup, FormGroupDirective, DefaultValueAccessor, NgControlStatus, FormControlName, NativeElementInjectorDirective, CurrencyMaskDirective, MaxLengthValidator, MaskedInputDirective, CheckboxControlValueAccessor, RadioControlValueAccessor, SelectMultipleControlValueAccessor, NgSelectOption, ɵangular_packages_forms_forms_x, SelectControlValueAccessor, MultiSelectComponent], pipes: [I18nPipe, AsyncPipe, NumberI18nPipe, DecimalPipe, JsonPipe], styles: ["[_nghost-%COMP%]{--ak-color-2:#466bb5;--ak-color-4:#039;--ak-section-dropdown-header-bb:#a6c6f3}*[_ngcontent-%COMP%]{--ak-color-check:var(--ak-color-1);--ak-color-title-section:#6c757d;--ak-color-title-section-selected:#6c757d}.ak-color-check[_ngcontent-%COMP%]{color:var(--ak-color-check)}.ak-check[_ngcontent-%COMP%]{color:#7ed321;font-size:.8rem;margin-left:20px;margin-top:14px;max-width:10px;position:absolute}.ak-section[_ngcontent-%COMP%]{background-color:transparent}.dropdown-header[_ngcontent-%COMP%]{box-sizing:border-box;cursor:pointer;height:auto;min-height:2rem;padding-left:0;padding-right:0;padding-top:12px;white-space:pre-line}.dropdown-header[_ngcontent-%COMP%]:hover{background-color:#fcfcfc}.dropdown-header[_ngcontent-%COMP%]   h4[_ngcontent-%COMP%]{margin-bottom:5px;padding-left:10px;padding-top:3px}.alert-danger[_ngcontent-%COMP%]{color:red}.full-modal[_ngcontent-%COMP%]{background-color:rgba(0,0,0,.5)!important;display:flex;flex:1;flex-direction:column;justify-content:center;overflow:auto;padding:50px 200px;right:0;top:0}@media (max-width:900px){.full-modal[_ngcontent-%COMP%]{padding:0}}.radius[_ngcontent-%COMP%]{border-radius:10px}.full-modal[_ngcontent-%COMP%]   .header[_ngcontent-%COMP%]{background:#fff;box-shadow:0 1px 0 rgba(0,0,0,.10196078);margin-bottom:0;min-height:3.3rem;padding:.7rem;position:static}.full-modal[_ngcontent-%COMP%]   .body[_ngcontent-%COMP%]{background-color:transparent;margin-top:0;overflow:auto}.title-section[_ngcontent-%COMP%]{color:var(--ak-color-title-section);margin-top:.3rem}.title-section.selected[_ngcontent-%COMP%]{color:var(--ak-color-title-section-selected)}.box-section[_ngcontent-%COMP%]{padding:0 40px}@media (max-width:768px){.box-section[_ngcontent-%COMP%]{padding:0}}.hr-grey[_ngcontent-%COMP%]{margin:0 20px 5px}.help-block[_ngcontent-%COMP%]{line-height:1rem}input[type=text][_ngcontent-%COMP%]:not(.password){text-transform:capitalize}[_ngcontent-%COMP%]::-moz-placeholder{text-transform:none}[_ngcontent-%COMP%]:-ms-input-placeholder{text-transform:none}[_ngcontent-%COMP%]::placeholder{text-transform:none}.offset-right-12[_ngcontent-%COMP%]{margin-right:100%}.offset-right-11[_ngcontent-%COMP%]{margin-right:91.66666667%}.offset-right-10[_ngcontent-%COMP%]{margin-right:83.33333333%}.offset-right-9[_ngcontent-%COMP%]{margin-right:75%}.offset-right-8[_ngcontent-%COMP%]{margin-right:66.66666667%}.offset-right-7[_ngcontent-%COMP%]{margin-right:58.33333333%}.offset-right-6[_ngcontent-%COMP%]{margin-right:50%}.offset-right-5[_ngcontent-%COMP%]{margin-right:41.66666667%}.offset-right-4[_ngcontent-%COMP%]{margin-right:33.33333333%}.offset-right-3[_ngcontent-%COMP%]{margin-right:25%}.offset-right-2[_ngcontent-%COMP%]{margin-right:16.66666667%}.offset-right-1[_ngcontent-%COMP%]{margin-right:8.33333333%}.offset-right-0[_ngcontent-%COMP%]{margin-right:0}@media (min-width:576px){.offset-sm-right-12[_ngcontent-%COMP%]{margin-right:100%}.offset-sm-right-11[_ngcontent-%COMP%]{margin-right:91.66666667%}.offset-sm-right-10[_ngcontent-%COMP%]{margin-right:83.33333333%}.offset-sm-right-9[_ngcontent-%COMP%]{margin-right:75%}.offset-sm-right-8[_ngcontent-%COMP%]{margin-right:66.66666667%}.offset-sm-right-7[_ngcontent-%COMP%]{margin-right:58.33333333%}.offset-sm-right-6[_ngcontent-%COMP%]{margin-right:50%}.offset-sm-right-5[_ngcontent-%COMP%]{margin-right:41.66666667%}.offset-sm-right-4[_ngcontent-%COMP%]{margin-right:33.33333333%}.offset-sm-right-3[_ngcontent-%COMP%]{margin-right:25%}.offset-sm-right-2[_ngcontent-%COMP%]{margin-right:16.66666667%}.offset-sm-right-1[_ngcontent-%COMP%]{margin-right:8.33333333%}.offset-sm-right-0[_ngcontent-%COMP%]{margin-right:0}}@media (min-width:768px){.offset-md-right-12[_ngcontent-%COMP%]{margin-right:100%}.offset-md-right-11[_ngcontent-%COMP%]{margin-right:91.66666667%}.offset-md-right-10[_ngcontent-%COMP%]{margin-right:83.33333333%}.offset-md-right-9[_ngcontent-%COMP%]{margin-right:75%}.offset-md-right-8[_ngcontent-%COMP%]{margin-right:66.66666667%}.offset-md-right-7[_ngcontent-%COMP%]{margin-right:58.33333333%}.offset-md-right-6[_ngcontent-%COMP%]{margin-right:50%}.offset-md-right-5[_ngcontent-%COMP%]{margin-right:41.66666667%}.offset-md-right-4[_ngcontent-%COMP%]{margin-right:33.33333333%}.offset-md-right-3[_ngcontent-%COMP%]{margin-right:25%}.offset-md-right-2[_ngcontent-%COMP%]{margin-right:16.66666667%}.offset-md-right-1[_ngcontent-%COMP%]{margin-right:8.33333333%}.offset-md-right-0[_ngcontent-%COMP%]{margin-right:0}}@media (min-width:992px){.offset-lg-right-12[_ngcontent-%COMP%]{margin-right:100%}.offset-lg-right-11[_ngcontent-%COMP%]{margin-right:91.66666667%}.offset-lg-right-10[_ngcontent-%COMP%]{margin-right:83.33333333%}.offset-lg-right-9[_ngcontent-%COMP%]{margin-right:75%}.offset-lg-right-8[_ngcontent-%COMP%]{margin-right:66.66666667%}.offset-lg-right-7[_ngcontent-%COMP%]{margin-right:58.33333333%}.offset-lg-right-6[_ngcontent-%COMP%]{margin-right:50%}.offset-lg-right-5[_ngcontent-%COMP%]{margin-right:41.66666667%}.offset-lg-right-4[_ngcontent-%COMP%]{margin-right:33.33333333%}.offset-lg-right-3[_ngcontent-%COMP%]{margin-right:25%}.offset-lg-right-2[_ngcontent-%COMP%]{margin-right:16.66666667%}.offset-lg-right-1[_ngcontent-%COMP%]{margin-right:8.33333333%}.offset-lg-right-0[_ngcontent-%COMP%]{margin-right:0}}@media (min-width:1200px){.offset-xl-right-12[_ngcontent-%COMP%]{margin-right:100%}.offset-xl-right-11[_ngcontent-%COMP%]{margin-right:91.66666667%}.offset-xl-right-10[_ngcontent-%COMP%]{margin-right:83.33333333%}.offset-xl-right-9[_ngcontent-%COMP%]{margin-right:75%}.offset-xl-right-8[_ngcontent-%COMP%]{margin-right:66.66666667%}.offset-xl-right-7[_ngcontent-%COMP%]{margin-right:58.33333333%}.offset-xl-right-6[_ngcontent-%COMP%]{margin-right:50%}.offset-xl-right-5[_ngcontent-%COMP%]{margin-right:41.66666667%}.offset-xl-right-4[_ngcontent-%COMP%]{margin-right:33.33333333%}.offset-xl-right-3[_ngcontent-%COMP%]{margin-right:25%}.offset-xl-right-2[_ngcontent-%COMP%]{margin-right:16.66666667%}.offset-xl-right-1[_ngcontent-%COMP%]{margin-right:8.33333333%}.offset-xl-right-0[_ngcontent-%COMP%]{margin-right:0}}.cursor-pounter[_ngcontent-%COMP%]{cursor:pointer}.section-box[_ngcontent-%COMP%]{box-shadow:0 0 8px -4px rgba(0,0,0,.59);margin-top:.7rem}.ak-badge-section[_ngcontent-%COMP%]{font-size:1.1rem}[_nghost-%COMP%]     .ak-badge{border-radius:50%;font-size:1.1rem;margin-right:1rem;position:relative;z-index:20}.sub-section[_ngcontent-%COMP%]{color:var(--ak-color-title-section);font-size:18px}.sub-section[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{font-size:8px;margin-top:5px;vertical-align:text-top}.position-ocutar[_ngcontent-%COMP%]{position:absolute;right:0}.icon-boton[_ngcontent-%COMP%]{font-size:14px}.img-left-boton[_ngcontent-%COMP%]{height:20px;width:20px}.capa-sections[_ngcontent-%COMP%]{background:hsl(0deg 0% 100%/53%);cursor:pointer;height:100%;position:absolute;width:100%;z-index:3}.capa-sections[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{width:60px}.btn-outline-secondary[_ngcontent-%COMP%]{background-color:#fff!important;border-color:#6c757d!important;color:#6c757d!important}.btn-outline-secondary[_ngcontent-%COMP%]:hover{background-color:#6c757d!important;border-color:#6c757d!important;color:#fff!important}.load-select[_ngcontent-%COMP%]{margin-right:21px!important}.load-select[_ngcontent-%COMP%], .select-multiple[_ngcontent-%COMP%]{color:#bbb;float:right;margin-top:-27px}.select-multiple[_ngcontent-%COMP%]{margin-right:45px!important}.dropdown-header-border[_ngcontent-%COMP%]{border-bottom:0 solid var(--ak-section-dropdown-header-bb)}.box-options-btn[_ngcontent-%COMP%]{margin-bottom:20px;max-height:202px;overflow-x:hidden;overflow-y:auto}.iti[_ngcontent-%COMP%]{width:100%}.uncheck[_ngcontent-%COMP%]{color:#e1e0e0}.checked[_ngcontent-%COMP%]{color:#4a9961}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AkeelaSectionComponent, [{
        type: Component,
        args: [{
                selector: 'akeela-section',
                templateUrl: './akeela-section.component.html',
                styleUrls: ['./akeela-section.component.css']
            }]
    }], function () { return [{ type: AkeelaFormService }, { type: AkeelaStepService }, { type: AkeelaSectionService }, { type: AkeelaStageService }, { type: AkeelaWorkflowService }, { type: AkeelaDatamodelService }, { type: AkeelaDatasourceService }, { type: AkeelaWorkflowConfigService }, { type: AkeelaValidatorService }, { type: AkeelaTemplateService }, { type: AkeelaEventService }, { type: ActivatedRoute }, { type: AkeelaUrlService }, { type: JsonService }, { type: CreditService }, { type: AkeelaConditionService }, { type: HttpService }, { type: AuthService }, { type: ErrorService }, { type: AlertService }, { type: PathService }, { type: LocalService }, { type: RouteUtilsService }, { type: I18nPipe }, { type: Router }]; }, { section: [{
            type: Input
        }], index: [{
            type: Input
        }], status: [{
            type: Input
        }], unique: [{
            type: Input
        }], callFn: [{
            type: Output
        }] }); })();

class AkeelaFilterPipe {
    transform(items, condition, value) {
        if (!items) {
            return items;
        }
        return items.filter(item => {
            if (condition === '===') {
                return item.additionalType === value;
            }
            else if (condition === '!==') {
                return item.additionalType !== value;
            }
        });
    }
}
/** @nocollapse */ AkeelaFilterPipe.ɵfac = function AkeelaFilterPipe_Factory(t) { return new (t || AkeelaFilterPipe)(); };
/** @nocollapse */ AkeelaFilterPipe.ɵpipe = ɵɵdefinePipe({ name: "akeelaFilter", type: AkeelaFilterPipe, pure: true });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AkeelaFilterPipe, [{
        type: Pipe,
        args: [{
                name: 'akeelaFilter'
            }]
    }], null, null); })();

function AkeelaStepComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 3);
    ɵɵelement(1, "br");
    ɵɵelement(2, "br");
    ɵɵelementStart(3, "div", 4);
    ɵɵelement(4, "img", 5);
    ɵɵelementEnd();
    ɵɵelement(5, "br");
    ɵɵelement(6, "br");
    ɵɵelementEnd();
} }
function AkeelaStepComponent_div_3_ng_container_3_div_1_akeela_section_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "akeela-section", 14);
} if (rf & 2) {
    const ctx_r10 = ɵɵnextContext();
    const i_section_r8 = ctx_r10.index;
    const section_r7 = ctx_r10.$implicit;
    const ctx_r9 = ɵɵnextContext(3);
    ɵɵproperty("index", i_section_r8 + 1)("unique", (ctx_r9.sections == null ? null : ctx_r9.sections.length) > 1 ? false : true)("section", section_r7)("status", ctx_r9.sectionsStatus && (ctx_r9.sectionsStatus[section_r7 == null ? null : section_r7.alternateName] == null ? null : ctx_r9.sectionsStatus[section_r7 == null ? null : section_r7.alternateName].state));
} }
function AkeelaStepComponent_div_3_ng_container_3_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 12);
    ɵɵtemplate(1, AkeelaStepComponent_div_3_ng_container_3_div_1_akeela_section_1_Template, 1, 4, "akeela-section", 13);
    ɵɵelementEnd();
} if (rf & 2) {
    const section_r7 = ctx.$implicit;
    const ctx_r5 = ɵɵnextContext(3);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", !ctx_r5.sectionName || (section_r7 == null ? null : section_r7.alternateName) == ctx_r5.sectionName);
} }
function AkeelaStepComponent_div_3_ng_container_3_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 12);
    ɵɵelement(1, "akeela-section", 14);
    ɵɵelementEnd();
} if (rf & 2) {
    const section_r11 = ctx.$implicit;
    const i_section_r12 = ctx.index;
    const ctx_r6 = ɵɵnextContext(3);
    ɵɵadvance(1);
    ɵɵproperty("index", i_section_r12 + 1)("unique", (ctx_r6.sections == null ? null : ctx_r6.sections.length) > 1 ? false : true)("section", section_r11)("status", ctx_r6.sectionsStatus && (ctx_r6.sectionsStatus[section_r11 == null ? null : section_r11.alternateName] == null ? null : ctx_r6.sectionsStatus[section_r11 == null ? null : section_r11.alternateName].state));
} }
function AkeelaStepComponent_div_3_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, AkeelaStepComponent_div_3_ng_container_3_div_1_Template, 2, 1, "div", 11);
    ɵɵpipe(2, "akeelaFilter");
    ɵɵtemplate(3, AkeelaStepComponent_div_3_ng_container_3_div_3_Template, 2, 4, "div", 11);
    ɵɵpipe(4, "akeelaFilter");
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵproperty("ngForOf", ɵɵpipeBind3(2, 2, ctx_r2.sections, "!==", "modal"));
    ɵɵadvance(2);
    ɵɵproperty("ngForOf", ɵɵpipeBind3(4, 6, ctx_r2.sections, "===", "modal"));
} }
function AkeelaStepComponent_div_3_akeela_footer_4_div_2_div_7_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵtext(1, " - ");
    ɵɵelement(2, "span", 25);
    ɵɵpipe(3, "i18n");
    ɵɵelementEnd();
} if (rf & 2) {
    const section_r15 = ɵɵnextContext().$implicit;
    ɵɵadvance(2);
    ɵɵproperty("innerHTML", ɵɵpipeBind1(3, 1, section_r15.sectionTitle), ɵɵsanitizeHtml);
} }
function AkeelaStepComponent_div_3_akeela_footer_4_div_2_div_7_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 24);
    ɵɵtemplate(1, AkeelaStepComponent_div_3_akeela_footer_4_div_2_div_7_div_1_Template, 4, 3, "div", 9);
    ɵɵelementEnd();
} if (rf & 2) {
    const section_r15 = ctx.$implicit;
    const ctx_r14 = ɵɵnextContext(4);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", (ctx_r14.sectionsStatus[section_r15 == null ? null : section_r15.alternateName] == null ? null : ctx_r14.sectionsStatus[section_r15 == null ? null : section_r15.alternateName].state) !== "COMPLETED");
} }
function AkeelaStepComponent_div_3_akeela_footer_4_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 17);
    ɵɵelementStart(1, "div", 18);
    ɵɵelement(2, "hr", 19);
    ɵɵelementStart(3, "h5", 20);
    ɵɵtext(4, " Complete las secciones faltantes ");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(5, "div", 21);
    ɵɵelementStart(6, "div", 22);
    ɵɵtemplate(7, AkeelaStepComponent_div_3_akeela_footer_4_div_2_div_7_Template, 2, 1, "div", 23);
    ɵɵpipe(8, "akeelaFilter");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r13 = ɵɵnextContext(3);
    ɵɵadvance(7);
    ɵɵproperty("ngForOf", ɵɵpipeBind3(8, 1, ctx_r13.sections, "!==", "modal"));
} }
function AkeelaStepComponent_div_3_akeela_footer_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "akeela-footer");
    ɵɵelementStart(1, "div", 15);
    ɵɵtemplate(2, AkeelaStepComponent_div_3_akeela_footer_4_div_2_Template, 9, 5, "div", 16);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵɵnextContext(2);
    ɵɵadvance(2);
    ɵɵproperty("ngIf", ctx_r3.stepStatus && (ctx_r3.stepStatus[ctx_r3.stepCode] == null ? null : ctx_r3.stepStatus[ctx_r3.stepCode].state) !== "COMPLETED" && ctx_r3.setSubmit);
} }
function AkeelaStepComponent_div_3_div_5_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainer(0);
} }
function AkeelaStepComponent_div_3_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 26);
    ɵɵtemplate(1, AkeelaStepComponent_div_3_div_5_ng_container_1_Template, 1, 0, "ng-container", 27);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵproperty("ngTemplateOutlet", ctx_r4.templates[ctx_r4.step == null ? null : ctx_r4.step.icono]);
} }
function AkeelaStepComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 6);
    ɵɵelementStart(1, "div", 7);
    ɵɵelementStart(2, "div", 8);
    ɵɵtemplate(3, AkeelaStepComponent_div_3_ng_container_3_Template, 5, 10, "ng-container", 9);
    ɵɵtemplate(4, AkeelaStepComponent_div_3_akeela_footer_4_Template, 3, 1, "akeela-footer", 9);
    ɵɵelementEnd();
    ɵɵtemplate(5, AkeelaStepComponent_div_3_div_5_Template, 2, 1, "div", 10);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵɵnextContext();
    ɵɵadvance(2);
    ɵɵclassProp("col-md-8", (ctx_r1.step == null ? null : ctx_r1.step.icono) && ctx_r1.templates[ctx_r1.step == null ? null : ctx_r1.step.icono]);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r1.sections.length > 0);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", (ctx_r1.step == null ? null : ctx_r1.step.canBeCompleted) && ctx_r1.showFooter && ctx_r1.step.alternateName !== "ACCOUNT_CONTRACT");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", (ctx_r1.step == null ? null : ctx_r1.step.icono) && ctx_r1.templates[ctx_r1.step == null ? null : ctx_r1.step.icono]);
} }
class AkeelaStepComponent {
    constructor(route, router, _httpService, routeUtils, workflowService, stageService, stepService, creditService, _path, templateService, localStorage) {
        this.route = route;
        this.router = router;
        this._httpService = _httpService;
        this.routeUtils = routeUtils;
        this.workflowService = workflowService;
        this.stageService = stageService;
        this.stepService = stepService;
        this.creditService = creditService;
        this._path = _path;
        this.templateService = templateService;
        this.localStorage = localStorage;
        this.sections = [];
        this.stepStatus = false;
        this.sectionsStatus = {};
        this.templates = {};
        this.subscriptions = [];
        this.onDestroy$ = new Subject();
        this.resetEstatusStep = false;
        this.transitionsWfs = [];
    }
    ngAfterViewInit() {
        setTimeout(() => {
            this.templates = this.templateService.getTemplates();
        }, 1);
    }
    ngOnInit() {
        this.stepService.setshowFooterStep(true);
        /*Comentado por Mario, 04 de Agosto del 2020:
          Este código causa en el componente una repetición constante de llamada de servicios y hace que comience a pestañar la aplicación en distintas funcionalidades
          Dejo este comentario acá, porque no se cual es el objetivo del código, y si puede afectar en algo o si tiene un equivalente que no cause el error
        */
        /*.pipe(
                mergeMap(params => this.route.queryParams
                    .pipe(
                        map(queryParams => {
                            return { ...params, ...queryParams };
                        })
                    )
                )
            )
        */
        this.route.queryParams.subscribe(params => {
            this.sectionName = null;
            if (params === null || params === void 0 ? void 0 : params.section) {
                this.sectionName = params === null || params === void 0 ? void 0 : params.section;
            }
        });
        this.route.params.subscribe(params => {
            this.role = this.routeUtils.getRole(params);
            this.audience = this.routeUtils.getAudience(params);
            this.profile = this.routeUtils.getProfile(params);
            if (this.inputWorkflowCode) {
                this.workflowCode = this.inputWorkflowCode;
            }
            else {
                this.workflowCode = this.route.pathFromRoot.map((path) => path.url.value.map(value => value.path)[0])[2];
            }
            if (this.inputStageCode) {
                this.stageCode = this.inputStageCode;
            }
            else {
                this.stageCode = this.route.pathFromRoot.map((path) => path.url.value.map(value => value.path))[3][1];
            }
            if (this.inputStepCode) {
                this.stepCode = this.inputStepCode;
            }
            else {
                this.stepCode = this.routeUtils.getStepCode(params);
            }
            // this.stepService.setCurrentStep(this.stepCode);
            this.transactionNumber = this.routeUtils.getTransactionNumber(params);
            this.subscription_transaction_number = this.workflowService.transactionNumber.subscribe((transactionNumber) => {
                this.transactionNumber = transactionNumber;
            });
            if (isNullOrUndefined(this.stepCode)) {
                this.getStep();
            }
            else {
                this.createStepSubscription();
            }
        });
        this.subscriptor_transaction_data = this.workflowService.transactionData$.subscribe((transactionData) => {
            if (!isNullOrUndefined(transactionData)) {
                this.transactionData = transactionData;
            }
        });
        this.workflowService.workflowStatus$.pipe(takeUntil(this.onDestroy$)).pipe(takeUntil(this.onDestroy$)).subscribe(workflowStatus => {
            var _a;
            this.sectionsStatus = {};
            if (!isNullOrUndefined(this.stageCode) && !(Object.keys(workflowStatus).length === 0)) {
                if (!isNullOrUndefined(this.stepCode) && !isNullOrUndefined(this.stageCode) && !(Object.keys(workflowStatus).length === 0)) {
                    if (!isNullOrUndefined(workflowStatus[this.stageCode])) {
                        this.stepStatus = workflowStatus[this.stageCode].steps;
                        if (!isNullOrUndefined(this.stepStatus[this.stepCode]) && !(Object.keys(this.stepStatus).length === 0)) {
                            this.sectionsStatus = (_a = this.stepStatus[this.stepCode]) === null || _a === void 0 ? void 0 : _a.sections;
                        }
                        else {
                            this.sectionsStatus = {};
                        }
                    }
                }
            }
        });
    }
    // routePromise() {
    //     return new Promise((resolve, reject) => {
    //     });
    // }
    getStep() {
        this.subscriptor_first_step = this.stepService.getFirstStep(this.workflowCode, this.stageCode, this.profile, this.role, this.audience)
            .subscribe((step) => {
            if (!isNullOrUndefined(step)) {
                this.stepCode = step.alternateName;
                this.gotoStep();
            }
        });
    }
    createStepSubscription() {
        this.resetEstatusStep = this.workflowService.resetEstatusStep$.getValue();
        if (this.resetEstatusStep == true) {
            this.subscriptions.push(this.workflowService.setTransactionData().subscribe());
            this.workflowService.setResetEstatusStep(false);
        }
        this.deleteStepSubscription();
        if (isNullOrUndefined(this.workflowCode) || isNullOrUndefined(this.stageCode)) {
            return;
        }
        this.sections = [];
        //  console.log("createStepSubscription'''''''");
        this.stepSubscription = this.stepService
            .getStep(this.workflowCode, this.stageCode, this.stepCode, this.profile, this.role, this.audience)
            .subscribe(_step => {
            this.stepService.setCurrentStep(_step.alternateName);
            this.step = _step;
            this.showFooter = _step.showFooter;
            this.stepService.setshowFooterStep(_step.showFooter);
            this.subscriptor_transaction_figure = this.creditService.figure$.subscribe(figure => {
                this.figure = figure;
            });
            //   this.getStepStatus();
            this.sections = this.step.sections;
            this.getStepStatus();
            //  console.log("createStepSubscription sections'''''''", this.sectionsStatus);
            if (!isNullOrUndefined(this.stepSubscription)) {
                this.stepSubscription.unsubscribe();
            }
        });
    }
    ngOnDestroy() {
        this.deleteStepSubscription();
    }
    get completed() {
        if (!this.sections) {
            return true;
        }
        return this.stepStatus;
        // no se retorna es estatus de la seccion del for sin no del servicio
        // return this.sections.filter(section => section.status !== 'COMPLETED').length === 0;
    }
    getStepStatus() {
        var _a;
        let workflowStatus = this.workflowService.workflowStatus$.getValue();
        if (!isNullOrUndefined(workflowStatus) && !isNullOrUndefined(this.stageCode) && !(Object.keys(workflowStatus).length === 0)) {
            if (!isNullOrUndefined(this.stepCode) && !isNullOrUndefined(this.stageCode) && !(Object.keys(workflowStatus).length === 0)) {
                if (!isNullOrUndefined(workflowStatus[this.stageCode])) {
                    this.stepStatus = workflowStatus[this.stageCode].steps;
                    if (!isNullOrUndefined(this.stepStatus) && !(Object.keys(this.stepStatus).length === 0)) {
                        this.sectionsStatus = (_a = this.stepStatus[this.stepCode]) === null || _a === void 0 ? void 0 : _a.sections;
                    }
                }
            }
        }
    }
    gotoStep() {
        const prefixed = this.route.routeConfig.path.indexOf('steps') >= 0 ? '../' : '';
        const uri = prefixed + AkeelaRoutes.step;
        const queryParams = {
            role: this.role,
            audience: this.audience,
            profile: this.profile
        };
        // MARIO - 05/DIC/2019
        // if (!isNullOrUndefined(this.transactionNumber)) {
        //     queryParams.transactionNumber = this.transactionNumber;
        // }
        this.router.navigate([uri, this.stepCode], { queryParams, relativeTo: this.route });
    }
    gotoNextStep(stepCode) {
        this.loading = true;
        if (this.stepStatus && this.stepStatus[stepCode].state == 'COMPLETED') {
            if (!(Object.keys(this.stepService.endpointTransitions.getValue()).length === 0)) {
                const paramsToTransition = this.getParamsToTransition(this.stepService.endpointTransitions.getValue());
                this._httpService.executeRequest(paramsToTransition.configuration.name, paramsToTransition.configuration.params).subscribe((config) => {
                    this.gotoNexStage(this.transactionNumber, config.nextStep.stageParentCode, config.nextStep.sections[0].codeStepParent);
                });
            }
            else {
                this.loading = false;
            }
        }
        else {
            this.loading = false;
            this.setSubmit = true;
        }
    }
    getParamsToTransition(endpointTransitions) {
        // TODO: CABLE, por ahora seteado para probar la transición del step1 al step 2
        this.event = 'ACCREDITED_RECORD_COMPLETED';
        const paramsData = this._path.getAdditionalType(this, endpointTransitions.additionalType);
        const params = {
            configuration: {
                name: endpointTransitions.name,
                params: paramsData.params
            }
        };
        return params;
    }
    getParamsToStep(endpointStepState) {
        this.event = 'DEFAULT_FLOW_EVENT';
        const paramsData = this._path.getAdditionalType(this, endpointStepState.additionalType);
        const params = {
            configuration: {
                name: endpointStepState.name,
                params: paramsData.params
            }
        };
        return params;
    }
    gotoNexStage(number, stage, step) {
        const prefixed = 'private';
        const queryParams = {
            role: this.role,
            audience: this.audience,
            profile: this.profile,
            transactionNumber: number
        };
        this.loading = false;
        this.router.navigate([prefixed, this.workflowCode, 'stages', stage, 'steps', step], { queryParams });
    }
    deleteStepSubscription() {
        if (this.subscriptions) {
            // prevent memory leak when component destroyed
            this.subscriptions.forEach(s => s.unsubscribe());
        }
        if (this.stepSubscription) {
            this.stepSubscription.unsubscribe();
        }
        if (this.resetEstatusSubscription) {
            this.resetEstatusSubscription.unsubscribe();
        }
        if (this.transactionDataSubscription) {
            this.transactionDataSubscription.unsubscribe();
        }
        if (this.endpointStepStateSubscription) {
            this.endpointStepStateSubscription.unsubscribe();
        }
        if (this.endpointSectionsStateSubscription) {
            this.endpointSectionsStateSubscription.unsubscribe();
        }
        if (this.subscription_transaction_number) {
            this.subscription_transaction_number.unsubscribe();
        }
        if (this.subscriptor_transaction_data) {
            this.subscriptor_transaction_data.unsubscribe();
        }
        if (this.subscriptor_show_footer) {
            this.subscriptor_show_footer.unsubscribe();
        }
        if (this.subscription_transitionsWfs) {
            this.subscription_transitionsWfs.unsubscribe();
        }
        if (this.subscriptor_first_step) {
            this.subscriptor_first_step.unsubscribe();
        }
        if (this.subscriptor_transaction_figure) {
            this.subscriptor_transaction_figure.unsubscribe();
        }
        // if (this.subscription_query_params) {
        //     this.subscription_query_params.unsubscribe();
        // }
    }
    isHtmlTemplete(text) {
        let result;
        let html = text === null || text === void 0 ? void 0 : text.includes("@i18n-htmlTemplete-");
        let component = text === null || text === void 0 ? void 0 : text.includes("ComponentRightTemplete");
        if (html || (!component && text != '')) {
            result = true;
        }
        return result;
    }
}
/** @nocollapse */ AkeelaStepComponent.ɵfac = function AkeelaStepComponent_Factory(t) { return new (t || AkeelaStepComponent)(ɵɵdirectiveInject(ActivatedRoute), ɵɵdirectiveInject(Router), ɵɵdirectiveInject(HttpService), ɵɵdirectiveInject(RouteUtilsService), ɵɵdirectiveInject(AkeelaWorkflowService), ɵɵdirectiveInject(AkeelaStageService), ɵɵdirectiveInject(AkeelaStepService), ɵɵdirectiveInject(CreditService), ɵɵdirectiveInject(PathService), ɵɵdirectiveInject(AkeelaTemplateService), ɵɵdirectiveInject(LocalService)); };
/** @nocollapse */ AkeelaStepComponent.ɵcmp = ɵɵdefineComponent({ type: AkeelaStepComponent, selectors: [["akeela-step"]], inputs: { inputWorkflowCode: "inputWorkflowCode", inputStageCode: "inputStageCode", inputStepCode: "inputStepCode", workflowCode: "workflowCode", stageCode: "stageCode", profile: "profile", role: "role", audience: "audience", stepCode: "stepCode", step: "step", sections: "sections", transactionNumber: "transactionNumber" }, decls: 4, vars: 2, consts: [[1, "animated"], ["class", "box", 4, "ngIf"], ["class", " pbs-1 animated fadIn ", 4, "ngIf"], [1, "box"], [1, "text-left"], ["src", "./assets/public/images/loading.gif", "alt", " "], [1, "pbs-1", "animated", "fadIn"], [1, "row"], [1, "col-12"], [4, "ngIf"], ["class", "col-12 col-md-4", "style", "border-left: 1px solid #eee;", 4, "ngIf"], ["class", "w-100", 4, "ngFor", "ngForOf"], [1, "w-100"], [3, "index", "unique", "section", "status", 4, "ngIf"], [3, "index", "unique", "section", "status"], [1, "p-b-1"], ["class", "w-100  mb-3 animate__animated animate__fadeIn", 4, "ngIf"], [1, "w-100", "mb-3", "animate__animated", "animate__fadeIn"], [1, ""], [1, "mt-3", "mb-2"], [1, "text-secondary", "pb-2"], [1, "col-12", "section-box", "p-2"], [1, "pl-2"], ["class", "w-100 text-danger pb-1", 4, "ngFor", "ngForOf"], [1, "w-100", "text-danger", "pb-1"], [3, "innerHTML"], [1, "col-12", "col-md-4", 2, "border-left", "1px solid #eee"], [4, "ngTemplateOutlet"]], template: function AkeelaStepComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelement(0, "akeela-header");
        ɵɵelementStart(1, "div", 0);
        ɵɵtemplate(2, AkeelaStepComponent_div_2_Template, 7, 0, "div", 1);
        ɵɵelementEnd();
        ɵɵtemplate(3, AkeelaStepComponent_div_3_Template, 6, 5, "div", 2);
    } if (rf & 2) {
        ɵɵadvance(2);
        ɵɵproperty("ngIf", ctx.sections.length < 1);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.step);
    } }, directives: [HeaderComponent, NgIf, NgForOf, AkeelaSectionComponent, FooterComponent, NgTemplateOutlet], pipes: [AkeelaFilterPipe, I18nPipe], styles: [""] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AkeelaStepComponent, [{
        type: Component,
        args: [{
                selector: 'akeela-step',
                templateUrl: './akeela-step.component.html',
                styleUrls: ['./akeela-step.component.css']
            }]
    }], function () { return [{ type: ActivatedRoute }, { type: Router }, { type: HttpService }, { type: RouteUtilsService }, { type: AkeelaWorkflowService }, { type: AkeelaStageService }, { type: AkeelaStepService }, { type: CreditService }, { type: PathService }, { type: AkeelaTemplateService }, { type: LocalService }]; }, { inputWorkflowCode: [{
            type: Input
        }], inputStageCode: [{
            type: Input
        }], inputStepCode: [{
            type: Input
        }], workflowCode: [{
            type: Input
        }], stageCode: [{
            type: Input
        }], profile: [{
            type: Input
        }], role: [{
            type: Input
        }], audience: [{
            type: Input
        }], stepCode: [{
            type: Input
        }], step: [{
            type: Input
        }], sections: [{
            type: Input
        }], transactionNumber: [{
            type: Input
        }] }); })();

class ContentDirective {
    constructor() {
    }
}
/** @nocollapse */ ContentDirective.ɵfac = function ContentDirective_Factory(t) { return new (t || ContentDirective)(); };
/** @nocollapse */ ContentDirective.ɵdir = ɵɵdefineDirective({ type: ContentDirective, selectors: [["", "akeela-content", ""]], inputs: { componentName: "componentName" } });
/*@__PURE__*/ (function () { ɵsetClassMetadata(ContentDirective, [{
        type: Directive,
        args: [{
                selector: '[akeela-content]'
            }]
    }], function () { return []; }, { componentName: [{
            type: Input
        }] }); })();

class AkeelaTemplateComponent {
    constructor(templateService) {
        this.templateService = templateService;
    }
    ngOnInit() {
    }
    ngAfterViewInit() {
        setTimeout(() => {
            this.contentsRef.forEach((item, index) => {
                const template = this.templatesRef.find((_template, templateIndex) => templateIndex === index);
                this.templateService.addTemplate(item.componentName, template);
            });
        }, 10);
    }
}
/** @nocollapse */ AkeelaTemplateComponent.ɵfac = function AkeelaTemplateComponent_Factory(t) { return new (t || AkeelaTemplateComponent)(ɵɵdirectiveInject(AkeelaTemplateService)); };
/** @nocollapse */ AkeelaTemplateComponent.ɵcmp = ɵɵdefineComponent({ type: AkeelaTemplateComponent, selectors: [["akeela-template"]], contentQueries: function AkeelaTemplateComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵɵcontentQuery(dirIndex, ContentDirective, false);
        ɵɵcontentQuery(dirIndex, ContentDirective, false, TemplateRef);
    } if (rf & 2) {
        var _t;
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.contentsRef = _t);
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.templatesRef = _t);
    } }, decls: 1, vars: 0, template: function AkeelaTemplateComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementContainer(0);
    } }, styles: [""] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AkeelaTemplateComponent, [{
        type: Component,
        args: [{
                selector: 'akeela-template',
                templateUrl: './akeela-template.component.html',
                styleUrls: ['./akeela-template.component.css']
            }]
    }], function () { return [{ type: AkeelaTemplateService }]; }, { contentsRef: [{
            type: ContentChildren,
            args: [ContentDirective]
        }], templatesRef: [{
            type: ContentChildren,
            args: [ContentDirective, { read: TemplateRef }]
        }] }); })();

const WorkflowRoutes = [
    {
        path: ':workflowCode',
        component: AkeelaWorkflowComponent,
        children: [
            {
                path: '',
                pathMatch: 'full',
                component: AkeelaStageComponent
            },
            {
                path: `${AkeelaRoutes.stage}/:stageCode`,
                component: AkeelaStageComponent,
                children: [
                    {
                        path: '',
                        pathMatch: 'full',
                        component: AkeelaStepComponent
                    },
                    {
                        path: `${AkeelaRoutes.step}/:stepCode`,
                        component: AkeelaStepComponent
                    }
                ]
            }
        ]
    }
];

class AkeelaWorkflowOptionsService {
    constructor() {
    }
}
/** @nocollapse */ AkeelaWorkflowOptionsService.ɵfac = function AkeelaWorkflowOptionsService_Factory(t) { return new (t || AkeelaWorkflowOptionsService)(); };
/** @nocollapse */ AkeelaWorkflowOptionsService.ɵprov = ɵɵdefineInjectable({ token: AkeelaWorkflowOptionsService, factory: AkeelaWorkflowOptionsService.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AkeelaWorkflowOptionsService, [{
        type: Injectable
    }], function () { return []; }, null); })();

class DatepickerLocaleService {
    constructor() {
        this.locales = {
            'en': {
                dayLabels: { su: 'Sun', mo: 'Mon', tu: 'Tue', we: 'Wed', th: 'Thu', fr: 'Fri', sa: 'Sat' },
                monthLabels: {
                    1: 'Jan',
                    2: 'Feb',
                    3: 'Mar',
                    4: 'Apr',
                    5: 'May',
                    6: 'Jun',
                    7: 'Jul',
                    8: 'Aug',
                    9: 'Sep',
                    10: 'Oct',
                    11: 'Nov',
                    12: 'Dec'
                },
                dateFormat: 'mm/dd/yyyy',
                todayBtnTxt: 'Today',
                firstDayOfWeek: 'mo',
                sunHighlight: true,
            },
            'he': {
                dayLabels: { su: 'רא', mo: 'שנ', tu: 'של', we: 'רב', th: 'חמ', fr: 'שי', sa: 'שב' },
                monthLabels: {
                    1: 'ינו',
                    2: 'פבר',
                    3: 'מרץ',
                    4: 'אפר',
                    5: 'מאי',
                    6: 'יונ',
                    7: 'יול',
                    8: 'אוג',
                    9: 'ספט',
                    10: 'אוק',
                    11: 'נוב',
                    12: 'דצמ'
                },
                dateFormat: 'dd/mm/yyyy',
                todayBtnTxt: 'היום',
                firstDayOfWeek: 'su',
                sunHighlight: false
            },
            'ja': {
                dayLabels: { su: '日', mo: '月', tu: '火', we: '水', th: '木', fr: '金', sa: '土' },
                monthLabels: {
                    1: '１月',
                    2: '２月',
                    3: '３月',
                    4: '４月',
                    5: '５月',
                    6: '６月',
                    7: '７月',
                    8: '８月',
                    9: '９月',
                    10: '１０月',
                    11: '１１月',
                    12: '１２月'
                },
                dateFormat: 'yyyy.mm.dd',
                todayBtnTxt: '今日',
                sunHighlight: false
            },
            'fr': {
                dayLabels: { su: 'Dim', mo: 'Lun', tu: 'Mar', we: 'Mer', th: 'Jeu', fr: 'Ven', sa: 'Sam' },
                monthLabels: {
                    1: 'Jan',
                    2: 'Fév',
                    3: 'Mar',
                    4: 'Avr',
                    5: 'Mai',
                    6: 'Juin',
                    7: 'Juil',
                    8: 'Aoû',
                    9: 'Sep',
                    10: 'Oct',
                    11: 'Nov',
                    12: 'Déc'
                },
                dateFormat: 'dd/mm/yyyy',
                todayBtnTxt: 'Aujourd\'hui',
                firstDayOfWeek: 'mo',
                sunHighlight: true,
            },
            'fr-ch': {
                dayLabels: { su: 'Dim', mo: 'Lun', tu: 'Mar', we: 'Mer', th: 'Jeu', fr: 'Ven', sa: 'Sam' },
                monthLabels: {
                    1: 'Jan',
                    2: 'Fév',
                    3: 'Mar',
                    4: 'Avr',
                    5: 'Mai',
                    6: 'Juin',
                    7: 'Juil',
                    8: 'Aoû',
                    9: 'Sep',
                    10: 'Oct',
                    11: 'Nov',
                    12: 'Déc'
                },
                dateFormat: 'dd.mm.yyyy',
                todayBtnTxt: 'Aujourd\'hui',
                firstDayOfWeek: 'mo',
                sunHighlight: true,
            },
            'fi': {
                dayLabels: { su: 'Su', mo: 'Ma', tu: 'Ti', we: 'Ke', th: 'To', fr: 'Pe', sa: 'La' },
                monthLabels: {
                    1: 'Tam',
                    2: 'Hel',
                    3: 'Maa',
                    4: 'Huh',
                    5: 'Tou',
                    6: 'Kes',
                    7: 'Hei',
                    8: 'Elo',
                    9: 'Syy',
                    10: 'Lok',
                    11: 'Mar',
                    12: 'Jou'
                },
                dateFormat: 'dd.mm.yyyy',
                todayBtnTxt: 'Tänään',
                firstDayOfWeek: 'mo',
                sunHighlight: true,
            },
            'es': {
                dayLabels: { su: 'Do', mo: 'Lu', tu: 'Ma', we: 'Mi', th: 'Ju', fr: 'Vi', sa: 'Sa' },
                monthLabels: {
                    1: 'Ene',
                    2: 'Feb',
                    3: 'Mar',
                    4: 'Abr',
                    5: 'May',
                    6: 'Jun',
                    7: 'Jul',
                    8: 'Ago',
                    9: 'Sep',
                    10: 'Oct',
                    11: 'Nov',
                    12: 'Dic'
                },
                dateFormat: 'dd.mm.yyyy',
                todayBtnTxt: 'Hoy',
                firstDayOfWeek: 'mo',
                sunHighlight: true,
            },
            'hu': {
                dayLabels: { su: 'Vas', mo: 'Hét', tu: 'Kedd', we: 'Sze', th: 'Csü', fr: 'Pén', sa: 'Szo' },
                monthLabels: {
                    1: 'Jan',
                    2: 'Feb',
                    3: 'Már',
                    4: 'Ápr',
                    5: 'Máj',
                    6: 'Jún',
                    7: 'Júl',
                    8: 'Aug',
                    9: 'Szep',
                    10: 'Okt',
                    11: 'Nov',
                    12: 'Dec'
                },
                dateFormat: 'yyyy-mm-dd',
                todayBtnTxt: 'Ma',
                firstDayOfWeek: 'mo',
                sunHighlight: true
            },
            'sv': {
                dayLabels: { su: 'Sön', mo: 'Mån', tu: 'Tis', we: 'Ons', th: 'Tor', fr: 'Fre', sa: 'Lör' },
                monthLabels: {
                    1: 'Jan',
                    2: 'Feb',
                    3: 'Mar',
                    4: 'Apr',
                    5: 'Maj',
                    6: 'Jun',
                    7: 'Jul',
                    8: 'Aug',
                    9: 'Sep',
                    10: 'Okt',
                    11: 'Nov',
                    12: 'Dec'
                },
                dateFormat: 'yyyy-mm-dd',
                todayBtnTxt: 'Idag',
                firstDayOfWeek: 'mo',
                sunHighlight: false
            },
            'nl': {
                dayLabels: { su: 'Zon', mo: 'Maa', tu: 'Din', we: 'Woe', th: 'Don', fr: 'Vri', sa: 'Zat' },
                monthLabels: {
                    1: 'Jan',
                    2: 'Feb',
                    3: 'Mar',
                    4: 'Apr',
                    5: 'Mei',
                    6: 'Jun',
                    7: 'Jul',
                    8: 'Aug',
                    9: 'Sep',
                    10: 'Okt',
                    11: 'Nov',
                    12: 'Dec'
                },
                dateFormat: 'dd-mm-yyyy',
                todayBtnTxt: 'Vandaag',
                firstDayOfWeek: 'mo',
                sunHighlight: false
            },
            'ru': {
                dayLabels: { su: 'Вс', mo: 'Пн', tu: 'Вт', we: 'Ср', th: 'Чт', fr: 'Пт', sa: 'Сб' },
                monthLabels: {
                    1: 'Янв',
                    2: 'Фев',
                    3: 'Март',
                    4: 'Апр',
                    5: 'Май',
                    6: 'Июнь',
                    7: 'Июль',
                    8: 'Авг',
                    9: 'Сент',
                    10: 'Окт',
                    11: 'Ноя',
                    12: 'Дек'
                },
                dateFormat: 'dd.mm.yyyy',
                todayBtnTxt: 'Сегодня',
                firstDayOfWeek: 'mo',
                sunHighlight: true
            },
            'uk': {
                dayLabels: { su: 'Нд', mo: 'Пн', tu: 'Вт', we: 'Ср', th: 'Чт', fr: 'Пт', sa: 'Сб' },
                monthLabels: {
                    1: 'Січ',
                    2: 'Лют',
                    3: 'Бер',
                    4: 'Кві',
                    5: 'Тра',
                    6: 'Чер',
                    7: 'Лип',
                    8: 'Сер',
                    9: 'Вер',
                    10: 'Жов',
                    11: 'Лис',
                    12: 'Гру'
                },
                dateFormat: 'dd.mm.yyyy',
                todayBtnTxt: 'Сьогодні',
                firstDayOfWeek: 'mo',
                sunHighlight: true
            },
            'no': {
                dayLabels: { su: 'Søn', mo: 'Man', tu: 'Tir', we: 'Ons', th: 'Tor', fr: 'Fre', sa: 'Lør' },
                monthLabels: {
                    1: 'Jan',
                    2: 'Feb',
                    3: 'Mar',
                    4: 'Apr',
                    5: 'Mai',
                    6: 'Jun',
                    7: 'Jul',
                    8: 'Aug',
                    9: 'Sep',
                    10: 'Okt',
                    11: 'Nov',
                    12: 'Des'
                },
                dateFormat: 'dd.mm.yyyy',
                todayBtnTxt: 'I dag',
                firstDayOfWeek: 'mo',
                sunHighlight: false
            },
            'tr': {
                dayLabels: { su: 'Paz', mo: 'Pzt', tu: 'Sal', we: 'Çar', th: 'Per', fr: 'Cum', sa: 'Cmt' },
                monthLabels: {
                    1: 'Oca',
                    2: 'Şub',
                    3: 'Mar',
                    4: 'Nis',
                    5: 'May',
                    6: 'Haz',
                    7: 'Tem',
                    8: 'Ağu',
                    9: 'Eyl',
                    10: 'Eki',
                    11: 'Kas',
                    12: 'Ara'
                },
                dateFormat: 'dd.mm.yyyy',
                todayBtnTxt: 'Bugün',
                firstDayOfWeek: 'mo',
                sunHighlight: false
            },
            'pt-br': {
                dayLabels: { su: 'Dom', mo: 'Seg', tu: 'Ter', we: 'Qua', th: 'Qui', fr: 'Sex', sa: 'Sab' },
                monthLabels: {
                    1: 'Jan',
                    2: 'Fev',
                    3: 'Mar',
                    4: 'Abr',
                    5: 'Mai',
                    6: 'Jun',
                    7: 'Jul',
                    8: 'Ago',
                    9: 'Set',
                    10: 'Out',
                    11: 'Nov',
                    12: 'Dez'
                },
                dateFormat: 'dd/mm/yyyy',
                todayBtnTxt: 'Hoje',
                firstDayOfWeek: 'su',
                sunHighlight: true
            },
            'de': {
                dayLabels: { su: 'So', mo: 'Mo', tu: 'Di', we: 'Mi', th: 'Do', fr: 'Fr', sa: 'Sa' },
                monthLabels: {
                    1: 'Jan',
                    2: 'Feb',
                    3: 'Mär',
                    4: 'Apr',
                    5: 'Mai',
                    6: 'Jun',
                    7: 'Jul',
                    8: 'Aug',
                    9: 'Sep',
                    10: 'Okt',
                    11: 'Nov',
                    12: 'Dez'
                },
                dateFormat: 'dd.mm.yyyy',
                todayBtnTxt: 'Heute',
                firstDayOfWeek: 'mo',
                sunHighlight: true
            },
            'de-ch': {
                dayLabels: { su: 'So', mo: 'Mo', tu: 'Di', we: 'Mi', th: 'Do', fr: 'Fr', sa: 'Sa' },
                monthLabels: {
                    1: 'Jan',
                    2: 'Feb',
                    3: 'Mär',
                    4: 'Apr',
                    5: 'Mai',
                    6: 'Jun',
                    7: 'Jul',
                    8: 'Aug',
                    9: 'Sep',
                    10: 'Okt',
                    11: 'Nov',
                    12: 'Dez'
                },
                dateFormat: 'dd.mm.yyyy',
                todayBtnTxt: 'Heute',
                firstDayOfWeek: 'mo',
                sunHighlight: true
            },
            'it': {
                dayLabels: { su: 'Dom', mo: 'Lun', tu: 'Mar', we: 'Mer', th: 'Gio', fr: 'Ven', sa: 'Sab' },
                monthLabels: {
                    1: 'Gen',
                    2: 'Feb',
                    3: 'Mar',
                    4: 'Apr',
                    5: 'Mag',
                    6: 'Giu',
                    7: 'Lug',
                    8: 'Ago',
                    9: 'Set',
                    10: 'Ott',
                    11: 'Nov',
                    12: 'Dic'
                },
                dateFormat: 'dd/mm/yyyy',
                todayBtnTxt: 'Oggi',
                firstDayOfWeek: 'mo',
                sunHighlight: true
            },
            'it-ch': {
                dayLabels: { su: 'Dom', mo: 'Lun', tu: 'Mar', we: 'Mer', th: 'Gio', fr: 'Ven', sa: 'Sab' },
                monthLabels: {
                    1: 'Gen',
                    2: 'Feb',
                    3: 'Mar',
                    4: 'Apr',
                    5: 'Mag',
                    6: 'Giu',
                    7: 'Lug',
                    8: 'Ago',
                    9: 'Set',
                    10: 'Ott',
                    11: 'Nov',
                    12: 'Dic'
                },
                dateFormat: 'dd.mm.yyyy',
                todayBtnTxt: 'Oggi',
                firstDayOfWeek: 'mo',
                sunHighlight: true
            },
            'pl': {
                dayLabels: { su: 'Nie', mo: 'Pon', tu: 'Wto', we: 'Śro', th: 'Czw', fr: 'Pią', sa: 'Sob' },
                monthLabels: {
                    1: 'Sty',
                    2: 'Lut',
                    3: 'Mar',
                    4: 'Kwi',
                    5: 'Maj',
                    6: 'Cze',
                    7: 'Lip',
                    8: 'Sie',
                    9: 'Wrz',
                    10: 'Paź',
                    11: 'Lis',
                    12: 'Gru'
                },
                dateFormat: 'yyyy-mm-dd',
                todayBtnTxt: 'Dzisiaj',
                firstDayOfWeek: 'mo',
                sunHighlight: true,
            },
            'my': {
                dayLabels: { su: 'တနင်္ဂနွေ', mo: 'တနင်္လာ', tu: 'အင်္ဂါ', we: 'ဗုဒ္ဓဟူး', th: 'ကြသပတေး', fr: 'သောကြာ', sa: 'စနေ' },
                monthLabels: {
                    1: 'ဇန်နဝါရီ',
                    2: 'ဖေဖော်ဝါရီ',
                    3: 'မတ်',
                    4: 'ဧပြီ',
                    5: 'မေ',
                    6: 'ဇွန်',
                    7: 'ဇူလိုင်',
                    8: 'ဩဂုတ်',
                    9: 'စက်တင်ဘာ',
                    10: 'အောက်တိုဘာ',
                    11: 'နိုဝင်ဘာ',
                    12: 'ဒီဇင်ဘာ'
                },
                dateFormat: 'yyyy-mm-dd',
                todayBtnTxt: 'ယနေ့',
                firstDayOfWeek: 'mo',
                sunHighlight: true,
            },
            'sk': {
                dayLabels: { su: 'Ne', mo: 'Po', tu: 'Ut', we: 'St', th: 'Št', fr: 'Pi', sa: 'So' },
                monthLabels: {
                    1: 'Jan',
                    2: 'Feb',
                    3: 'Mar',
                    4: 'Apr',
                    5: 'Máj',
                    6: 'Jún',
                    7: 'Júl',
                    8: 'Aug',
                    9: 'Sep',
                    10: 'Okt',
                    11: 'Nov',
                    12: 'Dec'
                },
                dateFormat: 'dd.mm.yyyy',
                todayBtnTxt: 'Dnes',
                firstDayOfWeek: 'mo',
                sunHighlight: true,
            },
            'sl': {
                dayLabels: { su: 'Ned', mo: 'Pon', tu: 'Tor', we: 'Sre', th: 'Čet', fr: 'Pet', sa: 'Sob' },
                monthLabels: {
                    1: 'Jan',
                    2: 'Feb',
                    3: 'Mar',
                    4: 'Apr',
                    5: 'Maj',
                    6: 'Jun',
                    7: 'Jul',
                    8: 'Avg',
                    9: 'Sep',
                    10: 'Okt',
                    11: 'Nov',
                    12: 'Dec'
                },
                dateFormat: 'dd. mm. yyyy',
                todayBtnTxt: 'Danes',
                firstDayOfWeek: 'mo',
                sunHighlight: true,
            },
            'zh-cn': {
                dayLabels: { su: '日', mo: '一', tu: '二', we: '三', th: '四', fr: '五', sa: '六' },
                monthLabels: {
                    1: '1月',
                    2: '2月',
                    3: '3月',
                    4: '4月',
                    5: '5月',
                    6: '6月',
                    7: '7月',
                    8: '8月',
                    9: '9月',
                    10: '10月',
                    11: '11月',
                    12: '12月'
                },
                dateFormat: 'yyyy-mm-dd',
                todayBtnTxt: '今天',
                firstDayOfWeek: 'mo',
                sunHighlight: true,
            },
            'ro': {
                dayLabels: { su: 'du', mo: 'lu', tu: 'ma', we: 'mi', th: 'jo', fr: 'vi', sa: 'sa' },
                monthLabels: {
                    1: 'ian',
                    2: 'feb',
                    3: 'mart',
                    4: 'apr',
                    5: 'mai',
                    6: 'iun',
                    7: 'iul',
                    8: 'aug',
                    9: 'sept',
                    10: 'oct',
                    11: 'nov',
                    12: 'dec'
                },
                dateFormat: 'dd.mm.yyyy',
                todayBtnTxt: 'Astăzi',
                firstDayOfWeek: 'mo',
                sunHighlight: true,
            },
            'ca': {
                dayLabels: { su: 'dg', mo: 'dl', tu: 'dt', we: 'dc', th: 'dj', fr: 'dv', sa: 'ds' },
                monthLabels: {
                    1: 'Gen',
                    2: 'Febr',
                    3: 'Març',
                    4: 'Abr',
                    5: 'Maig',
                    6: 'Juny',
                    7: 'Jul',
                    8: 'Ag',
                    9: 'Set',
                    10: 'Oct',
                    11: 'Nov',
                    12: 'Des'
                },
                dateFormat: 'dd.mm.yyyy',
                todayBtnTxt: 'Avui',
                firstDayOfWeek: 'mo',
                sunHighlight: true,
            },
            'id': {
                dayLabels: { su: 'Min', mo: 'Sen', tu: 'Sel', we: 'Rab', th: 'Kam', fr: 'Jum', sa: 'Sab' },
                monthLabels: {
                    1: 'Jan',
                    2: 'Feb',
                    3: 'Mar',
                    4: 'Apr',
                    5: 'Mei',
                    6: 'Jun',
                    7: 'Jul',
                    8: 'Ags',
                    9: 'Sep',
                    10: 'Okt',
                    11: 'Nov',
                    12: 'Des'
                },
                dateFormat: 'dd-mm-yyyy',
                todayBtnTxt: 'Hari ini',
                firstDayOfWeek: 'su',
                sunHighlight: true
            },
            'en-au': {
                dayLabels: { su: 'Sun', mo: 'Mon', tu: 'Tue', we: 'Wed', th: 'Thu', fr: 'Fri', sa: 'Sat' },
                monthLabels: {
                    1: 'Jan',
                    2: 'Feb',
                    3: 'Mar',
                    4: 'Apr',
                    5: 'May',
                    6: 'Jun',
                    7: 'Jul',
                    8: 'Aug',
                    9: 'Sep',
                    10: 'Oct',
                    11: 'Nov',
                    12: 'Dec'
                },
                dateFormat: 'dd/mm/yyyy',
                todayBtnTxt: 'Today',
                firstDayOfWeek: 'mo',
                sunHighlight: true
            },
            'am-et': {
                dayLabels: { su: 'እሑድ', mo: 'ሰኞ', tu: 'ማክሰኞ', we: 'ረቡዕ', th: 'ሐሙስ', fr: 'ዓርብ', sa: 'ቅዳሜ' },
                monthLabels: {
                    1: 'ጃንዩ',
                    2: 'ፌብሩ',
                    3: 'ማርች',
                    4: 'ኤፕረ',
                    5: 'ሜይ',
                    6: 'ጁን',
                    7: 'ጁላይ',
                    8: 'ኦገስ',
                    9: 'ሴፕቴ',
                    10: 'ኦክተ',
                    11: 'ኖቬም',
                    12: 'ዲሴም'
                },
                dateFormat: 'yyyy-mm-dd',
                todayBtnTxt: 'ዛሬ',
                firstDayOfWeek: 'mo',
                sunHighlight: true
            },
            'cs': {
                dayLabels: { su: 'Ne', mo: 'Po', tu: 'Út', we: 'St', th: 'Čt', fr: 'Pá', sa: 'So' },
                monthLabels: {
                    1: 'Led',
                    2: 'Úno',
                    3: 'Bře',
                    4: 'Dub',
                    5: 'Kvě',
                    6: 'Čvn',
                    7: 'Čvc',
                    8: 'Srp',
                    9: 'Zář',
                    10: 'Říj',
                    11: 'Lis',
                    12: 'Pro'
                },
                dateFormat: 'dd.mm.yyyy',
                todayBtnTxt: 'Dnes',
                firstDayOfWeek: 'mo',
                sunHighlight: true
            },
            'el': {
                dayLabels: { su: 'Κυρ', mo: 'Δευ', tu: 'Τρι', we: 'Τετ', th: 'Πεμ', fr: 'Παρ', sa: 'Σαβ' },
                monthLabels: {
                    1: 'Ιαν',
                    2: 'Φεβ',
                    3: 'Μαρ',
                    4: 'Απρ',
                    5: 'Μαι',
                    6: 'Ιουν',
                    7: 'Ιουλ',
                    8: 'Αυγ',
                    9: 'Σεπ',
                    10: 'Οκτ',
                    11: 'Νοε',
                    12: 'Δεκ'
                },
                dateFormat: 'dd/mm/yyyy',
                todayBtnTxt: 'Σήμερα',
                firstDayOfWeek: 'mo',
                sunHighlight: true
            },
            'kk': {
                dayLabels: { su: 'Жк', mo: 'Дс', tu: 'Сс', we: 'Ср', th: 'Бс', fr: 'Жм', sa: 'Сб' },
                monthLabels: {
                    1: 'Қаң',
                    2: 'Ақп',
                    3: 'Нау',
                    4: 'Сәу',
                    5: 'Мам',
                    6: 'Мау',
                    7: 'Шіл',
                    8: 'Там',
                    9: 'Қырк',
                    10: 'Қаз',
                    11: 'Қар',
                    12: 'Желт'
                },
                dateFormat: 'dd-mmm-yyyy',
                todayBtnTxt: 'Бүгін',
                firstDayOfWeek: 'mo',
                sunHighlight: true
            },
            'th': {
                dayLabels: { su: 'อา', mo: 'จ', tu: 'อ', we: 'พ', th: 'พฤ', fr: 'ศ', sa: 'ส' },
                monthLabels: {
                    1: 'ม.ค',
                    2: 'ก.พ.',
                    3: 'มี.ค.',
                    4: 'เม.ย.',
                    5: 'พ.ค.',
                    6: 'มิ.ย.',
                    7: 'ก.ค.',
                    8: 'ส.ค.',
                    9: 'ก.ย.',
                    10: 'ต.ค.',
                    11: 'พ.ย.',
                    12: 'ธ.ค.'
                },
                dateFormat: 'dd-mm-yyyy',
                todayBtnTxt: 'วันนี้',
                firstDayOfWeek: 'su',
                sunHighlight: true
            },
            'ko-kr': {
                dayLabels: { su: '일', mo: '월', tu: '화', we: '수', th: '목', fr: '금', sa: '토' },
                monthLabels: {
                    1: '1월',
                    2: '2월',
                    3: '3월',
                    4: '4월',
                    5: '5월',
                    6: '6월',
                    7: '7월',
                    8: '8월',
                    9: '9월',
                    10: '10월',
                    11: '11월',
                    12: '12월'
                },
                dateFormat: 'yyyy mm dd',
                todayBtnTxt: '오늘',
                firstDayOfWeek: 'su',
                sunHighlight: true
            },
            'da': {
                dayLabels: { su: 'Søn', mo: 'Man', tu: 'Tir', we: 'Ons', th: 'Tor', fr: 'Fre', sa: 'Lør' },
                monthLabels: {
                    1: 'Jan',
                    2: 'Feb',
                    3: 'Mar',
                    4: 'Apr',
                    5: 'Maj',
                    6: 'Jun',
                    7: 'Jul',
                    8: 'Aug',
                    9: 'Sep',
                    10: 'Okt',
                    11: 'Nov',
                    12: 'Dec'
                },
                dateFormat: 'dd-mm-yyyy',
                todayBtnTxt: 'I dag',
                firstDayOfWeek: 'mo',
                sunHighlight: true
            },
            'lt': {
                dayLabels: { su: 'Sk', mo: 'Pr', tu: 'An', we: 'Tr', th: 'Kt', fr: 'Pn', sa: 'Št' },
                monthLabels: {
                    1: 'Saus.',
                    2: 'Vas.',
                    3: 'Kov.',
                    4: 'Bal.',
                    5: 'Geg.',
                    6: 'Birž.',
                    7: 'Liep.',
                    8: 'Rugp.',
                    9: 'Rugs.',
                    10: 'Sapl.',
                    11: 'Lapkr.',
                    12: 'Gruod.'
                },
                dateFormat: 'yyyy-mm-dd',
                todayBtnTxt: 'Šianien',
                firstDayOfWeek: 'mo',
                sunHighlight: true
            },
            'vi': {
                dayLabels: { su: 'CN', mo: 'T2', tu: 'T3', we: 'T4', th: 'T5', fr: 'T6', sa: 'T7' },
                monthLabels: {
                    1: 'THG 1',
                    2: 'THG 2',
                    3: 'THG 3',
                    4: 'THG 4',
                    5: 'THG 5',
                    6: 'THG 6',
                    7: 'THG 7',
                    8: 'THG 8',
                    9: 'THG 9',
                    10: 'THG 10',
                    11: 'THG 11',
                    12: 'THG 12'
                },
                dateFormat: 'dd/mm/yyyy',
                todayBtnTxt: 'Hôm nay',
                firstDayOfWeek: 'mo',
                sunHighlight: true,
            },
            'bn': {
                dayLabels: { su: 'রবি', mo: 'সোম', tu: 'মঙ্গল', we: 'বুধ', th: 'বৃহঃ', fr: 'শুক্র', sa: 'শনি' },
                monthLabels: {
                    1: 'জানু',
                    2: 'ফেব্রু',
                    3: 'মার্চ',
                    4: 'এপ্রিল',
                    5: 'মে',
                    6: 'জুন',
                    7: 'জুলাই',
                    8: 'আগস্ট',
                    9: 'সেপ্টে',
                    10: 'অক্টো',
                    11: 'নভে',
                    12: 'ডিসে'
                },
                dateFormat: 'dd-mm-yyyy',
                todayBtnTxt: 'আজ',
                firstDayOfWeek: 'su',
                sunHighlight: true
            },
            'bg': {
                dayLabels: { su: 'нд', mo: 'пн', tu: 'вт', we: 'ср', th: 'чт', fr: 'пт', sa: 'сб' },
                monthLabels: {
                    1: 'яну.',
                    2: 'фев.',
                    3: 'март',
                    4: 'апр.',
                    5: 'май',
                    6: 'юни',
                    7: 'юли',
                    8: 'авг.',
                    9: 'сеп.',
                    10: 'окт.',
                    11: 'ное.',
                    12: 'дек.'
                },
                dateFormat: 'dd.mm.yyyy',
                todayBtnTxt: 'днес',
                firstDayOfWeek: 'mo',
                sunHighlight: true
            },
            'hr': {
                dayLabels: { su: 'Ne', mo: 'Po', tu: 'Ul', we: 'Sr', th: 'Če', fr: 'Pe', sa: 'Su' },
                monthLabels: {
                    1: 'Sij',
                    2: 'Vel',
                    3: 'Ožu',
                    4: 'Tra',
                    5: 'Svi',
                    6: 'Lip',
                    7: 'Srp',
                    8: 'Kol',
                    9: 'Ruj',
                    10: 'Lis',
                    11: 'Stu',
                    12: 'Pro'
                },
                dateFormat: 'dd.mm.yyyy.',
                todayBtnTxt: 'danas',
                firstDayOfWeek: 'su',
                sunHighlight: true
            },
            'ar': {
                dayLabels: { su: 'الأحد', mo: 'الاثنين', tu: 'الثلاثاء', we: 'الاربعاء', th: 'الخميس', fr: 'الجمعة', sa: 'السبت' },
                monthLabels: {
                    1: 'يناير',
                    2: 'فبراير',
                    3: 'مارس',
                    4: 'ابريل',
                    5: 'مايو',
                    6: 'يونيو',
                    7: 'يوليو',
                    8: 'أغسطس',
                    9: 'سبتمبر',
                    10: 'أكتوبر',
                    11: 'نوفمبر',
                    12: 'ديسمبر'
                },
                dateFormat: 'yyyy-mm-dd',
                todayBtnTxt: 'اليوم',
                firstDayOfWeek: 'sa',
                sunHighlight: true
            },
            'is': {
                dayLabels: { su: 'sun', mo: 'mán', tu: 'þri', we: 'mið', th: 'fim', fr: 'fös', sa: 'lau' },
                monthLabels: {
                    1: 'jan',
                    2: 'feb',
                    3: 'mar',
                    4: 'apr',
                    5: 'maí',
                    6: 'jún',
                    7: 'júl',
                    8: 'ágú',
                    9: 'sep',
                    10: 'okt',
                    11: 'nóv',
                    12: 'des'
                },
                dateFormat: 'dd.mm.yyyy',
                todayBtnTxt: 'Í dag',
                firstDayOfWeek: 'su',
                sunHighlight: true
            },
            'tw': {
                dayLabels: { su: '週日', mo: '週一', tu: '週二', we: '週三', th: '週四', fr: '週五', sa: '週六' },
                monthLabels: {
                    1: '一月',
                    2: '二月',
                    3: '三月',
                    4: '四月',
                    5: '五月',
                    6: '六月',
                    7: '七月',
                    8: '八月',
                    9: '九月',
                    10: '十月',
                    11: '十一月',
                    12: '十二月'
                },
                dateFormat: 'yyyy-mm-dd',
                todayBtnTxt: '今天',
                firstDayOfWeek: 'mo',
                sunHighlight: true
            }
        };
    }
    getLocaleOptions(locale) {
        if (locale && this.locales.hasOwnProperty(locale)) {
            // User given locale
            return this.locales[locale];
        }
        // Default: en
        return this.locales['en'];
    }
}
/** @nocollapse */ DatepickerLocaleService.ɵfac = function DatepickerLocaleService_Factory(t) { return new (t || DatepickerLocaleService)(); };
/** @nocollapse */ DatepickerLocaleService.ɵprov = ɵɵdefineInjectable({ token: DatepickerLocaleService, factory: DatepickerLocaleService.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(DatepickerLocaleService, [{
        type: Injectable
    }], null, null); })();

class AkeelaWorkflowStateService {
    constructor() { }
}
/** @nocollapse */ AkeelaWorkflowStateService.ɵfac = function AkeelaWorkflowStateService_Factory(t) { return new (t || AkeelaWorkflowStateService)(); };
/** @nocollapse */ AkeelaWorkflowStateService.ɵprov = ɵɵdefineInjectable({ token: AkeelaWorkflowStateService, factory: AkeelaWorkflowStateService.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AkeelaWorkflowStateService, [{
        type: Injectable
    }], function () { return []; }, null); })();

class AkeelaWorkflowModule {
    constructor(parentModule) {
        if (parentModule) {
            throw new Error('AkeelaMultiProductModule is already loaded. Import it in the AppModule only');
        }
    }
    static config(config) {
        return {
            ngModule: AkeelaWorkflowModule,
            providers: [
                { provide: AkeelaWorkflowConfig, useValue: config }
            ]
        };
    }
}
/** @nocollapse */ AkeelaWorkflowModule.ɵmod = ɵɵdefineNgModule({ type: AkeelaWorkflowModule });
/** @nocollapse */ AkeelaWorkflowModule.ɵinj = ɵɵdefineInjector({ factory: function AkeelaWorkflowModule_Factory(t) { return new (t || AkeelaWorkflowModule)(ɵɵinject(AkeelaWorkflowModule, 12)); }, providers: [
        AkeelaWorkflowConfigService,
        DatepickerLocaleService,
        AkeelaDatasourceService,
        AkeelaFormService,
        AkeelaValidatorService,
        MockService,
        AkeelaWorkflowOptionsService,
        AkeelaDatamodelService,
        AkeelaTemplateService,
        AkeelaWorkflowService,
        AkeelaWorkflowStructureService,
        AkeelaWorkflowStateService,
        AkeelaEventService,
        RouteUtilsService,
        JsonService,
        AkeelaConnectionService,
        AkeelaUrlService,
        AkeelaSectionService,
        AkeelaStepService,
        AkeelaStageService,
        LoadingService,
        AkeelaConditionService,
        UtilsService
    ], imports: [[
            AkeelaPropertiesModule,
            I18nModule,
            CommonModule,
            CurrencyMaskModule,
            FormsModule,
            HttpClientModule,
            MyDatePickerModule,
            ReactiveFormsModule,
            RouterModule.forChild([]),
            TextMaskModule,
            NgMultiSelectDropDownModule,
            AkeelaAuthModule,
            NgxIntlTelInputModule,
            BrowserAnimationsModule
        ]] });
__decorate([
    __param(0, Optional()),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [AkeelaWorkflowConfig]),
    __metadata("design:returntype", Object)
], AkeelaWorkflowModule, "config", null);
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(AkeelaWorkflowModule, { declarations: [AkeelaWorkflowComponent,
        ContentDirective,
        AkeelaStageComponent,
        AkeelaStepComponent,
        AkeelaSectionComponent,
        HeaderComponent,
        FooterComponent,
        AkeelaTemplateComponent,
        AkeelaFilterPipe,
        MultiSelectComponent], imports: [AkeelaPropertiesModule,
        I18nModule,
        CommonModule,
        CurrencyMaskModule,
        FormsModule,
        HttpClientModule,
        MyDatePickerModule,
        ReactiveFormsModule, RouterModule, TextMaskModule,
        NgMultiSelectDropDownModule,
        AkeelaAuthModule,
        NgxIntlTelInputModule,
        BrowserAnimationsModule], exports: [AkeelaWorkflowComponent,
        ContentDirective,
        AkeelaStageComponent,
        AkeelaStepComponent,
        AkeelaSectionComponent,
        HeaderComponent,
        FooterComponent,
        AkeelaTemplateComponent] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(AkeelaWorkflowModule, [{
        type: NgModule,
        args: [{
                imports: [
                    AkeelaPropertiesModule,
                    I18nModule,
                    CommonModule,
                    CurrencyMaskModule,
                    FormsModule,
                    HttpClientModule,
                    MyDatePickerModule,
                    ReactiveFormsModule,
                    RouterModule.forChild([]),
                    TextMaskModule,
                    NgMultiSelectDropDownModule,
                    AkeelaAuthModule,
                    NgxIntlTelInputModule,
                    BrowserAnimationsModule
                ],
                declarations: [
                    AkeelaWorkflowComponent,
                    ContentDirective,
                    AkeelaStageComponent,
                    AkeelaStepComponent,
                    AkeelaSectionComponent,
                    HeaderComponent,
                    FooterComponent,
                    AkeelaTemplateComponent,
                    AkeelaFilterPipe,
                    MultiSelectComponent
                ],
                exports: [
                    AkeelaWorkflowComponent,
                    ContentDirective,
                    AkeelaStageComponent,
                    AkeelaStepComponent,
                    AkeelaSectionComponent,
                    HeaderComponent,
                    FooterComponent,
                    AkeelaTemplateComponent
                ],
                providers: [
                    AkeelaWorkflowConfigService,
                    DatepickerLocaleService,
                    AkeelaDatasourceService,
                    AkeelaFormService,
                    AkeelaValidatorService,
                    MockService,
                    AkeelaWorkflowOptionsService,
                    AkeelaDatamodelService,
                    AkeelaTemplateService,
                    AkeelaWorkflowService,
                    AkeelaWorkflowStructureService,
                    AkeelaWorkflowStateService,
                    AkeelaEventService,
                    RouteUtilsService,
                    JsonService,
                    AkeelaConnectionService,
                    AkeelaUrlService,
                    AkeelaSectionService,
                    AkeelaStepService,
                    AkeelaStageService,
                    LoadingService,
                    AkeelaConditionService,
                    UtilsService
                ]
            }]
    }], function () { return [{ type: AkeelaWorkflowModule, decorators: [{
                type: Optional
            }, {
                type: SkipSelf
            }] }]; }, null); })();

/*
 * Public API Surface of akeela-workflow
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AkeelaDatamodelService, AkeelaRoutes, AkeelaSectionComponent, AkeelaSectionService, AkeelaStageComponent, AkeelaStageService, AkeelaStepComponent, AkeelaStepService, AkeelaTemplateComponent, AkeelaWorkflowComponent, AkeelaWorkflowModule, AkeelaWorkflowService, ContentDirective, FooterComponent, HeaderComponent, JsonService, RouteUtilsService, WorkflowRoutes };
//# sourceMappingURL=akeela-workflow.js.map
